(function() {
    'use strict';

    angular
        .module('sideApp', [
            'ngStorage', 
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler'];

    function run(stateHandler) {
        stateHandler.initialize();
    }
})();

(function () {
    'use strict';

    angular
        .module('sideApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function pageRibbon(ProfileService, $rootScope) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" >UADY</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('sideApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' ];

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
               '&j_password=' + encodeURIComponent(credentials.password) +
                //'&j_password=' +credentials.password +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('RevisionReporteOyOService', RevisionReporteOyOService);

    RevisionReporteOyOService.$inject = ['$resource'];

    function RevisionReporteOyOService ($resource) {
        var resourceUrl =  'apo/revisionreporteoo:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('RevisionReporteLibreService', RevisionReporteLibreService);

    RevisionReporteLibreService.$inject = ['$resource'];

    function RevisionReporteLibreService ($resource) {
        var resourceUrl =  'apo/revisionreporteli:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': { method:'POST' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('revision', {
            parent: 'app',
            url: '/revsionreporte?page&sort&search&type',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Revision reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/revision/misrevisionesevaluativos.html',
                    controller: 'RevisionEvaluativosController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                type: '1',
                indice : '1',
                ic : false,
                iic : '0',
                anio: '0',
                aniostr: '',
                modelo: '0',
                nivel: '0',
                centro: '0',
                ep: false
                
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        type: $stateParams.type,
                        indice: $stateParams.indice,
                        ic : $stateParams.ic,
                        iic : $stateParams.iic,
                        anio: $stateParams.anio,
                        aniostr: $stateParams.aniostr,
                        modelo: $stateParams.modelo,
                        nivel: $stateParams.nivel,
                        centro: $stateParams.centro,
                        ep: $stateParams.ep
                    };
                }]
            }
        })
        .state('revisionReporteOO', {
            parent: 'revision',
            url: '/revisionreporteoo/{id}',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoOO/reporteevaluativoOO.html',
                    controller: 'ReporteEvaluativoOOController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RevisionReporteOyOService','$state', function($stateParams, RevisionReporteOyOService,$state) {
              	  return RevisionReporteOyOService.get({id: $stateParams.id}).$promise;
                }]
            },
        })
		.state('revisionReporteLic', {
		    parent: 'revision',
		    url: '/revisionreporteLic/{id}',
		    data: {
		        authorities: ['RESPONSABLE_SIDE'],
		        pageTitle: 'Reporte Evaluativo'
		    },
		    views: {
		        'content@': {
		            templateUrl: 'app/reportes/reporteevaluativoLic/reporteevaluativoLic.html',
		            controller: 'ReporteEvaluativoLicController',
		            controllerAs: 'vm'
		        }
		    },
		    resolve: {
		        entity: ['$stateParams', 'ReporteEvaluativoLicService','$state', function($stateParams, ReporteEvaluativoLicService,$state) {
		          return ReporteEvaluativoLicService.getRevision({id: $stateParams.id}).$promise;
		        }]
		    },
		})
        .state('revisionReporteLI', {
            parent: 'revision',
            url: '/revisionreporteli/{id}',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoLI/reporteevaluativoLI.html',
                    controller: 'ReporteEvaluativoLIController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RevisionReporteLibreService','$state', function($stateParams, RevisionReporteLibreService,$state) {
              	  return RevisionReporteLibreService.get({id: $stateParams.id}).$promise;
                }]
            },

        })
        .state('revisionReporteCU', {
            parent: 'revision',
            url: '/revisionreportecu/{id}',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoCU/reporteevaluativoCU.html',
                    controller: 'ReporteEvaluativoCUController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoCUService','$state', function($stateParams, ReporteEvaluativoCUService,$state) {
              	  return ReporteEvaluativoCUService.getRevision({id: $stateParams.id}).$promise;
                }]
            },
        })
        .state('revisionReporteRegular', {
            parent: 'revision',
            url: '/revisionreporteregular/{id}',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoRegular/reporteevaluativoRegular.html',
                    controller: 'ReporteEvaluativoRegularController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoRegularService','$state', function($stateParams, ReporteEvaluativoRegularService,$state) {
              	  return ReporteEvaluativoRegularService.getRevision({id: $stateParams.id}).$promise;
                }]
            },
        })
        .state('revisionReporteVirtual', {
            parent: 'revision',
            url: '/revisionreportevirtual/{id}',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoVirtual/reporteevaluativoVirtual.html',
                    controller: 'ReporteEvaluativoVirtualController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoVirtualService','$state', function($stateParams, ReporteEvaluativoVirtualService,$state) {
              	  return ReporteEvaluativoVirtualService.getRevision({id: $stateParams.id}).$promise;
                }]
            },
        })
        .state('revisionReporteUAEV', {
            parent: 'revision',
            url: '/revisionreporteuaev/{id}',
            data: {
            	authorities: ['RESPONSABLE_SIDE'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoUAEV/reporteevaluativoUAEV.html',
                    controller: 'ReporteEvaluativoUAEVController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoUAEVService','$state', function($stateParams, ReporteEvaluativoUAEVService,$state) {
              	  return ReporteEvaluativoUAEVService.getRevision({id: $stateParams.id}).$promise;
                }]
            },
        })
		.state('revisionReporteBachillerato', {
		    parent: 'revision',
		    url: '/revisionreporteBachillerato/{id}',
		    data: {
		    	authorities: ['RESPONSABLE_SIDE'],
		        pageTitle: 'Reporte Evaluativo'
		    },
		    views: {
		        'content@': {
		            templateUrl: 'app/reportes/reporteevaluativoBachillerato/reporteevaluativoBachillerato.html',
		            controller: 'ReporteEvaluativoBachilleratoController',
		            controllerAs: 'vm'
		        }
		    },
		    resolve: {
		        entity: ['$stateParams', 'ReporteEvaluativoBachilleratoService','$state', function($stateParams, ReporteEvaluativoBachilleratoService,$state) {
		      	  return ReporteEvaluativoBachilleratoService.getRevision({id: $stateParams.id}).$promise;
		        }]
		    },
		})
		.state('revisionReporteMixtoPII', {
		    parent: 'revision',
		    url: '/revisionreporteMixtoPII/{id}',
		    data: {
		    	authorities: ['RESPONSABLE_SIDE'],
		        pageTitle: 'Reporte Evaluativo'
		    },
		    views: {
		        'content@': {
		            templateUrl: 'app/reportes/reporteevaluativoMixtoPII/reporteevaluativoMixtoPII.html',
		            controller: 'ReporteEvaluativoMixtoPIIController',
		            controllerAs: 'vm'
		        }
		    },
		    resolve: {
		        entity: ['$stateParams', 'ReporteEvaluativoMixtoPIIService','$state', function($stateParams, ReporteEvaluativoMixtoPIIService,$state) {
		      	  return ReporteEvaluativoMixtoPIIService.getRevision({id: $stateParams.id}).$promise;
		        }]
		    },
		})
    }

})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('RevisionEvaluativos', RevisionEvaluativos);

    RevisionEvaluativos.$inject = ['$resource'];

    function RevisionEvaluativos ($resource) {
        var resourceUrl =  'apo/revisionreportes:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro,:ep';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('RevisionEvaluativosController', RevisionEvaluativosController);

    RevisionEvaluativosController.$inject = ['$scope', '$state', 'RevisionEvaluativos', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ClasesAmbitoService','LoginService',
    	'AniosEscolares','InstitucionesClases','NivelesEducativosService','ModelosEducativosService','Periodos'];

    function RevisionEvaluativosController ($scope, $state, RevisionEvaluativos, ParseLinks, AlertService, pagingParams, paginationConstants,ClasesAmbitoService,LoginService,
    		AniosEscolares,InstitucionesClases,NivelesEducativosService,ModelosEducativosService,Periodos) {
        var vm = this;
        
       // vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        //vm.openDialog=openDialog;
     
        vm.indicePeriodo=pagingParams.indice;
        vm.intercurso=pagingParams.ic;
        vm.indiceIntercurso=pagingParams.iic;
        vm.search=search;
        vm.type=pagingParams.type;
        vm.currentSearch=pagingParams.search;
        vm.anioSeleccionado=pagingParams.anio;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.institucionSelected=pagingParams.centro;
        vm.evaluacionesPendientes=pagingParams.ep;
        cargarDropdrown();
        loadAll();
        vm.isNew = isNew;
        vm.limpiar = limpiar;
        
        
        
        $scope.$watchGroup(["vm.anioSeleccionado","vm.institucionSelected","vm.intercurso"],function(newValue,oldValue){        	
        	if (newValue != oldValue && vm.anioSeleccionado != null && vm.institucionSelected != null){
	        	vm.periodos = Periodos.query({
	            	anio: vm.anioSeleccionado,
	            	dep: vm.institucionSelected,
	            	ic: vm.intercurso
	            });
        	
	        	if(vm.intercurso == true){
	        		vm.indicePeriodo = 0;
	        	}else{
	        		vm.indiceIntercurso = 0;
	        	}
	        }
        });




        function loadAll () {
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null && vm.intercurso != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                });
        	}
        	
        	RevisionEvaluativos.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro:vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
				
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.wrappers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
       

//        function loadPage (page) {
//            vm.page = page;
//            vm.transition();
//        }
        
//        function openDialog () {
//        	var entity={tipo:null
//        	}
//        	ClasesAmbitoService.open(entity);
//        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            },onSuccess,{reload:false});
       	 function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.wrappers = data;
             vm.page = pagingParams.page;
         }
        }
        
        function isNew(){
        	if( vm.usuarios.evaluacion.id ==null )
        		return true;
        	else
        		return false;
        }
        
        function cargarDropdrown(){
        	vm.aniosEscolares=AniosEscolares.query();
        	vm.dependencias=InstitucionesClases.query();
        	vm.niveles=NivelesEducativosService.getAll();
        	vm.modelos=ModelosEducativosService.getAll();
        }
        
        function limpiar() {
        	vm.modeloSeleccionado=null;
        }
        
        function search(){
        	
        	if(vm.anioSeleccionado==null )
        		return ;
        	$state.transitionTo($state.$current, {
                page: 0,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                aniostr: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes
            },onSuccess);
            
            
        	 function onSuccess(data, headers) {
                 vm.links = ParseLinks.parse(headers('link'));
                 vm.totalItems = headers('X-Total-Count');
                 vm.queryCount = vm.totalItems;
                 vm.wrappers = data;
                 vm.page = pagingParams.page;
             }
        	
        }

    }
})();

(function() {
	'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reporteglobal', {
        	parent: 'app',
            url: '/reporteglobal?page&sort&search',
            data: {
            	authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                pageTitle: 'Portal Docente'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteGlobal/reporteglobal.html',
                    controller: 'ReporteGlobalController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                type: '1',
                indice : '1',
                ic: false,
                iic: '0',
                anio: '0',
                aniostr: '',
                modelo: '0',
                nivel: '0',
                centro: '0',
                ep: false
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        type: $stateParams.type,
                        indice: $stateParams.indice,
                        ic: $stateParams.ic,
                        iic: $stateParams.iic,
                        anio: $stateParams.anio,
                        aniostr: $stateParams.aniostr,
                        modelo: $stateParams.modelo,
                        nivel: $stateParams.nivel,
                        centro: $stateParams.centro,
                        ep: $stateParams.ep
                    };
                }]
            }
        })
	}

})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteGlobal', ReporteGlobal);

    ReporteGlobal.$inject = ['$resource'];

    function ReporteGlobal ($resource) {

        var resourceUrl =  'apo/reporteglobal:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro,:ep';

        return $resource(resourceUrl, {}, {
            'downl': { 
            	url:'apo/reporteglobal',
            	method: 'POST',
            	headers: {
                    accept: 'application/octet-stream' 
                },
                responseType: 'arraybuffer',
                cache: false,
            	transformResponse: function (data,headers) {
            		var fileName = getFileNameFromHeader(headers('content-disposition'));
	                if (data && fileName != null) {
	                    let blob = new Blob([data], { 
	                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
	                    }),
	                    objectUrl = URL.createObjectURL(blob);
	                    let a = document.createElement('a');
	                    a.href = objectUrl;
	                    a.download = fileName;
	                    a.target = '_blank';
	                    a.click();
	                }
                    return data;
                }
            }
        });
        
        function getFileNameFromHeader(header){
            if (!header) return null;

            var result = header.split(";")[1].trim().split("=")[1];

            return result.replace(/"/g, '');
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteGlobalController', ReporteGlobalController);

    ReporteGlobalController.$inject = ['$scope', '$state', '$window','ReporteGlobal', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','LoginService',
    	'AniosEscolares','Instituciones','NivelesEducativosService','ModelosEducativosService','Periodos'];

    function ReporteGlobalController ($scope, $state,$window, ReporteGlobal, ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,
    		AniosEscolares,Instituciones,NivelesEducativosService,ModelosEducativosService,Periodos) {
        var vm = this;
        
       
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        
        vm.download=download;
        vm.indicePeriodo=pagingParams.indice;
        vm.intercurso=pagingParams.ic;
        vm.indiceIntercurso=pagingParams.iic;
        vm.periodos;
        vm.search=search;
        vm.type=pagingParams.type;
        vm.currentSearch=pagingParams.search;
        vm.anioSeleccionado=pagingParams.anio;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.institucionSelected=pagingParams.centro;
        vm.evaluacionesPendientes=pagingParams.ep;
        cargarDropdrown();
//        loadAll();
        vm.isNew = isNew;
        vm.limpiar = limpiar;
        vm.esLicMEFI = esLicMEFI;
        
        $scope.$watchGroup(["vm.anioSeleccionado","vm.institucionSelected","vm.intercurso"],function(newValue,oldValue){
        	
        	if (newValue === oldValue) {
      	      return;
      	    }
        	
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                });
        	}
        	
        	if(vm.intercurso){
        		vm.indicePeriodo = 0;
        	}else{
        		vm.indiceIntercurso = 0;
        	}
	      	
        });
        
        function loadAll () {
        	
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null && vm.intercurso != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                });
        	}
        	
        	ReporteGlobal.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro:vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.usuarios = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        function download(indicePeriodo,intercurso,indiceIntercurso,anioSeleccionado,modeloSeleccionado,nivelSeleccionado,institucionSelected){
        	
        	if(anioSeleccionado == 0 || modeloSeleccionado == 0 || nivelSeleccionado == 0 || institucionSelected == 0 || 
        		indicePeriodo == null || intercurso == null || indiceIntercurso == null || anioSeleccionado == null || modeloSeleccionado == null || nivelSeleccionado == null || modeloSeleccionado == '' || nivelSeleccionado == '' || institucionSelected == null   )
        		return ;
        	let parametros = [indicePeriodo,intercurso,indiceIntercurso,anioSeleccionado,modeloSeleccionado,nivelSeleccionado,institucionSelected];
        	ReporteGlobal.downl(parametros,ondownloadSuccess, ondownloadError);
        }
        
        function ondownloadSuccess (result) {
        	//console.log(result);
        }

        function ondownloadError (error) {
        	console.log(error);
        }
        function esLicMEFI(tipo,mefi){
        	if(mefi==="MEFI" || mefi==="MEFI_2"){
        		if(tipo=='Licenciatura'){
        			return true;
        		}
        	}
        	
        	return false;
        }


        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            },onSuccess,{reload:false});
       	 function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.usuarios = data;
             vm.page = pagingParams.page;
         }
        }
        
        function isNew(){
        	if( vm.usuarios.evaluacion.id ==null )
        		return true;
        	else
        		return false;
        }
        
        function cargarDropdrown(){
        	vm.aniosEscolares=AniosEscolares.query();
        	vm.dependencias=Instituciones.query();
        	vm.niveles=NivelesEducativosService.getAll();
        	vm.modelos=ModelosEducativosService.getAll();
        }
        
        function limpiar() {
        	vm.modeloSeleccionado=null;
        }
        
        function search(){
        	
        	if(vm.anioSeleccionado==null )
        		return ;
        	$state.transitionTo($state.$current, {
                page: 0,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                aniostr: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes
            },onSuccess);
        	 function onSuccess(data, headers) {
                 vm.links = ParseLinks.parse(headers('link'));
                 vm.totalItems = headers('X-Total-Count');
                 vm.queryCount = vm.totalItems;
                 vm.usuarios = data;
                 vm.page = pagingParams.page;
             }
        	
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoVirtualPIIRegenerarService', ReporteEvaluativoVirtualPIIRegenerarService);

    ReporteEvaluativoVirtualPIIRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoVirtualPIIRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteVirtualPII/:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo,:grupo';

        return $resource(resourceUrl, {}, {
            'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteVirtualPIIregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoVirtualPIIService', ReporteEvaluativoVirtualPIIService);

    ReporteEvaluativoVirtualPIIService.$inject = ['$resource'];

    function ReporteEvaluativoVirtualPIIService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteVirtualPII/:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo,:grupo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
					//console.log(data);
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteVirtualPII:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreporteVirtualPII:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreporteVirtualPII:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreporteVirtualPII:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoVirtualPIIController', ReporteEvaluativoVirtualPIIController);

    ReporteEvaluativoVirtualPIIController.$inject = ['$scope', '$state', '$stateParams','ReporteEvaluativoVirtualPIIService', 'ReporteEvaluativoVirtualPIIRegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoVirtualPIIController ($scope, $state, $stateParams,ReporteEvaluativoVirtualPIIService, ReporteEvaluativoVirtualPIIRegenerarService,ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.round=round;
        vm.save=save;
        vm.autoheight=autoheight;
        vm.print=print;
        
		
		function calculateContentHeight( ta, scanAmount ) {
		    var origHeight = ta.style.height,
		        height = ta.offsetHeight,
		        scrollHeight = ta.scrollHeight,
		        overflow = ta.style.overflow;
		    /// only bother if the ta is bigger than content
		    if ( height >= scrollHeight ) {
		        /// check that our browser supports changing dimension
		        /// calculations mid-way through a function call...
		        ta.style.height = (height + scanAmount) + 'px';
		        /// because the scrollbar can cause calculation problems
		        ta.style.overflow = 'hidden';
		        /// by checking that scrollHeight has updated
		        if ( scrollHeight < ta.scrollHeight ) {
		            /// now try and scan the ta's height downwards
		            /// until scrollHeight becomes larger than height
		            while (ta.offsetHeight >= ta.scrollHeight) {
		                ta.style.height = (height -= scanAmount)+'px';
		            }
		            /// be more specific to get the exact height
		            while (ta.offsetHeight < ta.scrollHeight) {
		                ta.style.height = (height++)+'px';
		            }
		            /// reset the ta back to it's original height
		            ta.style.height = origHeight;
		            /// put the overflow back
		            ta.style.overflow = overflow;
		            return height;
		        }
		    } else {
		        return scrollHeight;
		    }
		}
		
		function autoheight(element) {
			var rows = 1;
			var ta = document.getElementById(element),
			style = (window.getComputedStyle) ?
			window.getComputedStyle(ta) : ta.currentStyle,
			
			// This will get the line-height only if it is set in the css,
			// otherwise it's "normal"
			taLineHeight = parseInt(style.lineHeight, 10),
			// Get the scroll height of the textarea
			taHeight = calculateContentHeight(ta, taLineHeight),
			// calculate the number of lines
			rows = Math.ceil(taHeight / taLineHeight);
			return rows;
		}
		
		
		
        function round(valor){
        	return Math.round(valor);
        }
        
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoVirtualPIIRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoVirtualPIIService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoVirtualPIIService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
        }
		
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;
			if(vm.wrapper.tipoUser==1){
				 $state.go('generarReporteVirtualPII', 
					{
					 	idA: $stateParams.idA,
			 			idP: $stateParams.idP,
			 			idAnio: $stateParams.idAnio,
			 			idIndice: $stateParams.idIndice,
			 			ic: $stateParams.ic,
			            iic: $stateParams.iic,
			 			tipoEvaluacion: $stateParams.tipoEvaluacion,
			 			idDependencia: $stateParams.idDependencia,
			 			nivell: $stateParams.nivell,
			 			modeloo: $stateParams.modeloo,
						grupo: $stateParams.grupo
					},
					{ reload: true });
			}else{
				if(vm.wrapper.tipoUser==2){
			        $state.go('revisionReporteVirtualPII', null, { reload: true });
			    }
			}	
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'iteraccion1',
    			type: 'bar'
            },
            title: {
                text: ''
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: 
            	[
					'Muestra respeto al dirigirse hacia sus estudiantes.',
					'Muestra respeto hacia la institución.',
					'Promueve un ambiente inclusivo, libre de violencia y discriminación.'
            	],
                type: 'integer'
            },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
			series: 
			[
			    {
			         name: 'Estudiantes',
			         data: [
			            Math.round(vm.reporte.muestrarespest_e),
			         	Math.round(vm.reporte.muestrarespintitu_e), 
			         	Math.round(vm.reporte.promueveinclulibreviodisc_e)
			            ],
			        	color: '#002e5f'
			     }
			]
        });

        var chart2 = new Highcharts.Chart({
            chart: {
                renderTo: 'iteraccion2',
    			type: 'bar'
            },
            title: {
                text: ''
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: [
					'Ofrece sesiones síncronas de atención a dudas y conversación en inglés semanalmente.',
					'Provee información de contacto, incluyendo correo electrónico y horario de atención.'
            		],
                type: 'integer'
            },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
            series: 
			[
				{
                	name: 'Estudiantes',
	                data: [
						Math.round(vm.reporte.ofresincr_e),
	                	Math.round(vm.reporte.provinfocont_e)
					],
	               	color: '#002e5f'
				}, 
				{
					name: 'Autoevaluación',
					data: [
						Math.round(vm.reporte.ofresincr_p),
						Math.round(vm.reporte.provinfocont_p)
					],
					color: '#ffb60f'
				}
			]
        });
        
		var chart3 = new Highcharts.Chart({
		    chart: {
		        renderTo: 'estrategias2',
				type: 'bar'
		    },
		    title: {
		        text: ''
		    },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
		    xAxis: {
		    	categories: [
					'Apertura las lecciones y recursos puntualmente cada semana.',
					'Brinda una inducción al inicio del curso mediante videoconferencia.',
					'Informa a sus estudiantes sobre las fechas de corte para las actividades de aprendizaje y pruebas de desempeño.',
					'Resuelve dudas respecto a las actividades y los contenidos abordados durante el curso en tiempo y forma.'
		    		],
		        type: 'integer'
		    },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
		    series: 
			[
				{
		        	name: 'Estudiantes',
		            data: [
						Math.round(vm.reporte.aperturaleccionespuntual_e),
						Math.round(vm.reporte.brindaitrovideopii_e),
						Math.round(vm.reporte.infofechaactspru_e),
						Math.round(vm.reporte.resududasacti_e)
					],
		           	color: '#002e5f'
				}, 
				{
					name: 'Autoevaluación',
					data: [
						Math.round(vm.reporte.aperturaleccionespuntual_e),
						Math.round(vm.reporte.brindaitrovideopii_p),
						Math.round(vm.reporte.infofechaactspru_p),
						Math.round(vm.reporte.resududasacti_p)
					],
					color: '#ffb60f'
				}
			]
		});
		var chart4 = new Highcharts.Chart({
		    chart: {
		        renderTo: 'estrategias3',
		        type: 'bar'
		    },
		    title: {
		        text: ''
		    },
		    yAxis: {
		        title: {
		            text: ''
		        }
		    },
		    xAxis: {
		        categories: [
					'Informa la puntuación obtenida en cada una de las estrategias de evaluación.',
					'Retroalimenta en tiempo y forma el progreso académico de cada estudiante para que identifique sus fortalezas y debilidades.'
		            ],
		        type: 'integer'
		    },
		    tooltip: {
		        valueSuffix: '%'
		    },
		    plotOptions: {
		        bar: {
		            dataLabels: {
		                enabled: true,
		                format: '{y}%'
		            }
		        },
		    },
		    series: 
		    [
		        {
		            name: 'Estudiantes',
		            data: [
		                Math.round(vm.reporte.infopuntuestrev_e),
		                Math.round(vm.reporte.retrotiemfor_e)
		            ],
		            color: '#002e5f'
		        }, 
		        {
		            name: 'Autoevaluación',
		            data: [
		                Math.round(vm.reporte.infopuntuestrev_p),
		                Math.round(vm.reporte.retrotiemfor_p)
		            ],
		            color: '#ffb60f'
		        }
		    ]
		});
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoVirtualRegenerarService', ReporteEvaluativoVirtualRegenerarService);

    ReporteEvaluativoVirtualRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoVirtualRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteVirtual:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
        	'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreportevirtualregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();
(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoVirtualService', ReporteEvaluativoVirtualService);

    ReporteEvaluativoVirtualService.$inject = ['$resource'];

    function ReporteEvaluativoVirtualService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteVirtual:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreportevirtual:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreportevirtual:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreportevirtual:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreportevirtual:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoVirtualController', ReporteEvaluativoVirtualController);

    ReporteEvaluativoVirtualController.$inject = ['$scope', '$state', 'ReporteEvaluativoVirtualService', 'ReporteEvaluativoVirtualRegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoVirtualController ($scope, $state, ReporteEvaluativoVirtualService,ReporteEvaluativoVirtualRegenerarService, ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.save=save;
        vm.print=print;
        
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoVirtualRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoVirtualService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoVirtualService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
             
        }
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;
//            if(vm.wrapper.regenerar){
//            	$state.go('volvergenerarReporteVirtual', null, { reload: true });
//            }else{
            	if(vm.wrapper.tipoUser==1){
                    $state.go('generarReporteVirtual', {
        			 	idA: $stateParams.idA,
             			idP: $stateParams.idP,
             			idAnio: $stateParams.idAnio,
             			idIndice: $stateParams.idIndice,
             			ic: $stateParams.ic,
                        iic: $stateParams.iic,
             			tipoEvaluacion: $stateParams.tipoEvaluacion,
             			idDependencia: $stateParams.idDependencia,
             			nivell: $stateParams.nivell,
             			modeloo: $stateParams.modeloo
        			} , { reload: true });
                }else{
                	if(vm.wrapper.tipoUser==2){
                        $state.go('revisionReporteVirtual', null, { reload: true });
                    }
                }
                    
//            }
            
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'identidadinstitucionalVir',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'Es respetuoso cuando se expresa de la Universidad, de otros docentes o compañeros de trabajo.', 
            		'Muestra respeto al dirigirse hacia los estudiantes.', 
            		'Está comprometido con el proceso de formación del estudiante', 
            		'Muestra con el ejemplo congruencia entre lo que dice y hace.', 
            		'Promueve la ética de la profesión en su desempeño.',
            		'Demuestra tolerancia en el intercambio de conocimientos, experiencias y opiniones.',
            		'Evidencia compromiso social en su desempeño.'],
//                type: 'integer'
            },
            yAxis: {
                title: {
                    text: null,
                },
                opposite:true,
//                labels: {
//                	enabled: false
//                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
            	enabled:false
            },
            series: [{
                name: 'Estudiantes',
                data: [
                	parseFloat(vm.reporte.respetounidocentes),
                	parseFloat(vm.reporte.respetoestudiantes),
                	parseFloat(vm.reporte.comprometidoformacionestudiante),
                	parseFloat(vm.reporte.congruenciadicehace),
                	parseFloat(vm.reporte.promueticadesemp),
                	parseFloat(vm.reporte.toleranciaconoexopin),
                	parseFloat(vm.reporte.evidenciacomprsocial)
                	],
               	color: '#002e5f'
            }]
        });
        
        var chart2 = new Highcharts.Chart({
            chart: {
                renderTo: 'ambientesaprendizajeVir',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'Orienta el dominio de conocimientos, habilidades y actitudes, durante las sesiones.', 
            		'Promueve acciones para fortalecer el desempeño autónomo del estudiante.',
            		'Brinda herramientas complementarias que favorecen el aprendizaje.', 
            		'Utiliza diversas herramientas digitales (plataformas virtuales, base de datos, software, sitios web, bibliotecas virtuales).',
            		'Favorece el uso de herramientas digitales (plataformas virtuales, base de datos, software, sitios web) como recurso didáctico.',
            		'Promueve el uso de materiales y recursos en idioma inglés', 
            		'Utiliza actividades dentro y/o fuera del aula, que contribuyen al desarrollo del aprendizaje,',
            		'Utiliza actividades de aprendizaje que promueven el análisis de los contenidos.', 
            		'Utiliza actividades donde el estudiante integre conocimientos previos y nuevos.',
            		'Utiliza actividades que promueven el interés del estudiante hacia el aprendizaje de la asignatura.'
            		],
//                type: 'integer'
            },
            yAxis: {
                title: {
                    text: null,
                },
                opposite:true,
//                labels: {
//                	enabled: false
//                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
            	enabled:false
            },
            series: [{
                name: 'Estudiantes',
                data: [
                	parseFloat(vm.reporte.orientaconohabact),
                	parseFloat(vm.reporte.promaccionesfortalecerestu),
                	parseFloat(vm.reporte.herrcomplementarias),
                	parseFloat(vm.reporte.herrdigitales),
                	parseFloat(vm.reporte.prominteracestu),
                	parseFloat(vm.reporte.materialesingles),
                	parseFloat(vm.reporte.habilidadaulavirtual),
                	parseFloat(vm.reporte.anacontenidos),
                	parseFloat(vm.reporte.actividadintegrepreviosnuevos),
                	parseFloat(vm.reporte.actividadinteresestu)
                	],
               	color: '#002e5f'
            }]
        });
        var chart3 = new Highcharts.Chart({
            chart: {
                renderTo: 'evaluacionVir',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'Establece el puntaje de cada una de las actividades de evaluación.',
            		'Respeta los criterios establecidos durante la asignatura.', 
            		'Informa la puntuación obtenida en cada una de las actividades.',
            		'Procura que las actividades de evaluación se relacionen con lo visto en la asignatura.', 
            		'Retroalimenta evidenciando fortalezas y debilidades de las actividades propuestas.',
            		'Resuelve dudas respecto a los contenidos abordados.', 
            		'Utiliza diferentes formas para evaluar los aprendizajes.'
            		],
//                type: 'integer'
            },
            yAxis: {
                title: {
                    text: null,
                },
                opposite:true,
//                labels: {
//                	enabled: false
//                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
            	enabled:false
            },
            series: [{
                name: 'Estudiantes',
                data: [
                	parseFloat(vm.reporte.puntuajeeva),
                	parseFloat(vm.reporte.respetacriterios),
                	parseFloat(vm.reporte.informapuntacion),
                	parseFloat(vm.reporte.actrelacionen),
                	parseFloat(vm.reporte.retrofotalezasdevilidades),
                	parseFloat(vm.reporte.resuelvedudas),
                	parseFloat(vm.reporte.difformasevaluar)
                	],
               	color: '#002e5f'
            }]
        });
    }
})();
(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoUAEVRegenerarService', ReporteEvaluativoUAEVRegenerarService);

    ReporteEvaluativoUAEVRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoUAEVRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteUAEV:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteuaevregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoUAEVService', ReporteEvaluativoUAEVService);

    ReporteEvaluativoUAEVService.$inject = ['$resource'];

    function ReporteEvaluativoUAEVService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteUAEV:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteuaev:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreporteuaev:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreporteuaev:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreporteuaev:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoUAEVController', ReporteEvaluativoUAEVController);

    ReporteEvaluativoUAEVController.$inject = ['$scope', '$state', '$stateParams','ReporteEvaluativoUAEVService', 'ReporteEvaluativoUAEVRegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoUAEVController ($scope, $state, $stateParams,ReporteEvaluativoUAEVService, ReporteEvaluativoUAEVRegenerarService,ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.round=round;
        vm.save=save;
        
        vm.print=print;
        
        function round(valor){
        	return Math.round(valor);
        }
        
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoUAEVRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoUAEVService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoUAEVService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
             
        }
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;

//            if(vm.wrapper.regenerar){
//            	$state.go('volvergenerarReporteUAEV', null, { reload: true });
//            }else{
//            console.log($stateParams);
            	if(vm.wrapper.tipoUser==1){
            		 $state.go('generarReporteUAEV', 
            			{
            			 	idA: $stateParams.idA,
	             			idP: $stateParams.idP,
	             			idAnio: $stateParams.idAnio,
	             			idIndice: $stateParams.idIndice,
	             			ic: $stateParams.ic,
	                        iic: $stateParams.iic,
	             			tipoEvaluacion: $stateParams.tipoEvaluacion,
	             			idDependencia: $stateParams.idDependencia,
	             			nivell: $stateParams.nivell,
	             			modeloo: $stateParams.modeloo
            			} 
            				 
            		 ,{ reload: true });
            	}else{
            		if(vm.wrapper.tipoUser==2){
                        $state.go('revisionReporteUAEV', null, { reload: true });
                    }
            	}
//            }
        }
        

        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'iteraccion',
    			type: 'bar'
            },
            title: {
                text: 'Relación Profesor - Estudiante'
            },
            xAxis: {
            	categories: 
            	[
            		'Muestra respeto en sus mensajes y comentarios',
            		'Promueve las reglas de la comunicación virtual (etiquetas)',
            		'Orienta al estudiantado para identificar sus necesidades o recursos para aprender de manera independiente',
            		'Promueve la ética en la asignatura que imparte',
            		'Utiliza diferentes herramientas institucionales de comunicación para mantener contacto'
            	],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: 
            [
	            {
	                name: 'Estudiantes',
	                data: 
	                	[
		                	Math.round(vm.reporte.respetoMensajesComs_e),
		                	Math.round(vm.reporte.promueveReglasComunicacionV_e), 
		                	Math.round(vm.reporte.orientaEstuIdenNec_e),
		                	Math.round(vm.reporte.promEtiAsigImp_e),
		                	Math.round(vm.reporte.utiDiferentesHerramientas_e)
	                	],
	               	color: '#002e5f'
	            }
            ]
        });

        var chart2 = new Highcharts.Chart({
            chart: {
                renderTo: 'estrategias',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'Sugiere actividades complementarias para reforzar el desarrollo de las competencias',
            		'Brinda seguimiento a las dudas o comentarios en el tiempo establecido',
            		'Utiliza actividades de aprendizaje que promueven el análisis de los temas tratados',
            		'Utiliza actividades donde el estudiante integra los conocimientos previos y los nuevos',
            		'Utiliza actividades que promueven el interés hacia el aprendizaje de la asignatura'
            		],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: [Math.round(vm.reporte.sugiereActsComplem_e),
                		Math.round(vm.reporte.brindaSeguiDudas_e), 
                		Math.round(vm.reporte.utiActsAprendizaje_e),
                		Math.round(vm.reporte.utiActsIntegraConocimientos_e),
                		Math.round(vm.reporte.utiActsPromuInt_e)],
               	color: '#002e5f'
            }, {
                name: 'Profesor (a)',
                data: [Math.round(vm.reporte.sugieroActsComples_p), 
                	Math.round(vm.reporte.brindoSeguimientoDudas_p), 
                	Math.round(vm.reporte.utiActsAprenPromuevenAnalisis_p),
                	Math.round(vm.reporte.utiActsEstuInteConoci_p),
                	Math.round(vm.reporte.utiActsPromuInteApre_p)],
                color: '#ffb60f'
            }]
        });
        var chart3 = new Highcharts.Chart({
            chart: {
                renderTo: 'materias',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: 
            	[
            		'Promueve el uso de diferentes herramientas tecnológicas, para el desarrollo de la asignatura',
            		'Utiliza diferentes materiales o recursos para orientar el aprendizaje'
            	],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: 
                [
                	Math.round(vm.reporte.promuUsoDifHerrTecno_e),
                	Math.round(vm.reporte.utiDifMateriales_e)
                ],
               	color: '#002e5f'
            }, {
                name: 'Profesor (a)',
                data: [Math.round(vm.reporte.promuDifsHerrTecno_p), 
                	Math.round(vm.reporte.utiDifMateOriAprendizaje_p)],
                color: '#ffb60f'
            }]
        });
        var chart4 = new Highcharts.Chart({
            chart: {
                renderTo: 'evaluacion',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: 
            		[
            			'Comunica el puntaje de cada una de las actividades de aprendizaje',
            			'Informa la puntuación obtenida en cada una de las actividades',
            			'Procura que las actividades se relacionen con lo visto en la asignatura',
            			'Retroalimenta el progreso académico para identificar fortalezas y debilidades',
            			'Retroalimenta las actividades utilizando los criterios de evaluación establecidos'
            		],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: [
	                	Math.round(vm.reporte.comunicaPuntajeActs_e),
	                	Math.round(vm.reporte.infoPuntuacionObtenida_e), 
	                	Math.round(vm.reporte.procActsRelacionenVisto_e),
	                	Math.round(vm.reporte.retroaliProgrAcademico_e), 
	                	Math.round(vm.reporte.retroaliActsCriterios_e)
                	],
               	color: '#002e5f'
            }, {
                name: 'Profesor (a)',
                data: 
                	[
	                	Math.round(vm.reporte.comuPuntajeActsAprene_p), 
	                	Math.round(vm.reporte.infoPuntObtea_p), 
	                	Math.round(vm.reporte.procuraActsRelacionen_p),
	                	Math.round(vm.reporte.retroaliProgrAcade_p), 
	                	Math.round(vm.reporte.retroaliActsUtiCriterios_p)
                	],
                color: '#ffb60f'
            }]
        });
 
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoRegularRegenerarService', ReporteEvaluativoRegularRegenerarService);

    ReporteEvaluativoRegularRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoRegularRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteRegular:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
        	'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteregularregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();
(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoRegularService', ReporteEvaluativoRegularService);

    ReporteEvaluativoRegularService.$inject = ['$resource'];

    function ReporteEvaluativoRegularService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteRegular:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteregular:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreporteregular:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
            ,
            'getRevision': {
            	url:'apo/revisionreporteregular:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreporteregular:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoRegularController', ReporteEvaluativoRegularController);

    ReporteEvaluativoRegularController.$inject = ['$scope', '$state', 'ReporteEvaluativoRegularService', 'ReporteEvaluativoRegularRegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoRegularController ($scope, $state, ReporteEvaluativoRegularService, ReporteEvaluativoRegularRegenerarService,ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.save=save;
        vm.print=print;
        
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoRegularRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 }); 
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoRegularService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoRegularService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
             
        }
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;
            
//            if(vm.wrapper.regenerar){
//            	$state.go('volvergenerarReporteRegular', null, { reload: true });
//            }else{
            	if(vm.wrapper.tipoUser==1){
                 $state.go('generarReporteRegular', {
     			 	idA: $stateParams.idA,
         			idP: $stateParams.idP,
         			idAnio: $stateParams.idAnio,
         			idIndice: $stateParams.idIndice,
         			ic: $stateParams.ic,
                    iic: $stateParams.iic,
         			tipoEvaluacion: $stateParams.tipoEvaluacion,
         			idDependencia: $stateParams.idDependencia,
         			nivell: $stateParams.nivell,
         			modeloo: $stateParams.modeloo
    			} , { reload: true });
            	}else{
            		if(vm.wrapper.tipoUser==2){
                        $state.go('revisionReporteRegular', null, { reload: true });
                    }
            	}
                
//            }
            
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'identidadinstitucionalReg',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'Es respetuoso cuando se expresa de la Universidad, de otros docentes o compañeros de trabajo.', 
            		'Muestra respeto al dirigirse hacia los estudiantes.', 
            		'Está comprometido con el proceso de formación del estudiante', 
            		'Muestra con el ejemplo congruencia entre lo que dice y hace.', 
            		'Promueve la ética de la profesión en su desempeño.',
            		'Demuestra tolerancia en el intercambio de conocimientos, experiencias y opiniones.',
            		'Evidencia compromiso social en su desempeño.'],
//                type: 'integer'
            },
            yAxis: {
                title: {
                    text: null,
                },
                opposite:true,
//                labels: {
//                	enabled: false
//                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
            	enabled:false
            },
            series: [{
                name: 'Estudiantes',
                data: [
                	parseFloat(vm.reporte.respetounidoc),
                	parseFloat(vm.reporte.respetoestudiantes),
                	parseFloat(vm.reporte.comprometidoformacionestudiante),
                	parseFloat(vm.reporte.congruenciadicehace),
                	parseFloat(vm.reporte.eticaprofdesem),
                	parseFloat(vm.reporte.toleranciaconoexpopin),
                	parseFloat(vm.reporte.evitacompsocialdesemp)
                	],
               	color: '#002e5f'
            }]
        });
        
        var chart2 = new Highcharts.Chart({
            chart: {
                renderTo: 'ambientesaprendizajeReg',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'Orienta el dominio de conocimientos, habilidades y actitudes, durante las sesiones.', 
            		'Promueve acciones para fortalecer el desempeño autónomo del estudiante.',
            		'Brinda herramientas complementarias que favorecen el aprendizaje.', 
            		'Favorece el uso de herramientas digitales (plataformas virtuales, base de datos, software, sitios web) como recurso didáctico.',
            		'Promueve el uso de materiales y recursos en idioma inglés', 
            		'Utiliza actividades dentro y/o fuera del aula, que contribuyen al desarrollo del aprendizaje,',
            		'Utiliza actividades de aprendizaje que promueven el análisis de los contenidos.', 
            		'Utiliza actividades donde el estudiante integre conocimientos previos y nuevos.',
            		'Utiliza actividades que promueven el interés del estudiante hacia el aprendizaje de la asignatura.'
            		],
//                type: 'integer'
            },
            yAxis: {
                title: {
                    text: null,
                },
                opposite:true,
//                labels: {
//                	enabled: false
//                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
            	enabled:false
            },
            series: [{
                name: 'Estudiantes',
                data: [
                	parseFloat(vm.reporte.orientadominioconohabact),
                	parseFloat(vm.reporte.promaccionesfortalecerdesemestu),
                	parseFloat(vm.reporte.brindaherracompl),
                	parseFloat(vm.reporte.usoheramientasdigitales),
                	parseFloat(vm.reporte.prommaterialesingles),
                	parseFloat(vm.reporte.actividaddesarollo),
                	parseFloat(vm.reporte.actividadanalisis),
                	parseFloat(vm.reporte.actividadintegrar),
                	parseFloat(vm.reporte.actividadinteres)
                	],
               	color: '#002e5f'
            }]
        });
        var chart3 = new Highcharts.Chart({
            chart: {
                renderTo: 'evaluacionReg',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'Establece el puntaje de cada una de las actividades de evaluación.',
            		'Respeta los criterios establecidos durante la asignatura.', 
            		'Informa la puntuación obtenida en cada una de las actividades.',
            		'Procura que las actividades de evaluación se relacionen con lo visto en la asignatura.', 
            		'Retroalimenta evidenciando fortalezas y debilidades de las actividades propuestas.',
            		'Resuelve dudas respecto a los contenidos abordados.', 
            		'Utiliza diferentes formas para evaluar los aprendizajes.'
            		],
//                type: 'integer'
            },
            yAxis: {
                title: {
                    text: null,
                },
                opposite:true,
//                labels: {
//                	enabled: false
//                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
            	enabled:false
            },
            series: [{
                name: 'Estudiantes',
                data: [
                	parseFloat(vm.reporte.establecepuntaje),
                	parseFloat(vm.reporte.respetacriterios),
                	parseFloat(vm.reporte.informapuntacion),
                	parseFloat(vm.reporte.actividadesrelacionanasignatura),
                	parseFloat(vm.reporte.retroalimentafotalezadevilidades),
                	parseFloat(vm.reporte.resuelvedudas),
                	parseFloat(vm.reporte.difformasevaluar)
                	],
               	color: '#002e5f'
            }]
        });
        
    }
})();
(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoOyOService', ReporteEvaluativoOyOService);

    ReporteEvaluativoOyOService.$inject = ['$resource'];

    function ReporteEvaluativoOyOService ($resource) {
        var resourceUrl =  'apo/guardarreporteoo';

        return $resource(resourceUrl, {}, {
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoOORegenerarService', ReporteEvaluativoOORegenerarService);

    ReporteEvaluativoOORegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoOORegenerarService ($resource) {
    	var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteOO:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
        	'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteooregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoOOService', ReporteEvaluativoOOService);

    ReporteEvaluativoOOService.$inject = ['$resource'];

    function ReporteEvaluativoOOService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteOO:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoOOController', ReporteEvaluativoOOController);

    ReporteEvaluativoOOController.$inject = ['$scope', '$state', '$stateParams', 'ReporteEvaluativoOOService', 'ReporteEvaluativoOORegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity','ReporteEvaluativoOyOService'
    	];

    function ReporteEvaluativoOOController ($scope, $state, $stateParams, ReporteEvaluativoOOService, ReporteEvaluativoOORegenerarService, ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity,ReporteEvaluativoOyOService
    		) {
        var vm = this;
        
       // vm.loadPage = loadPage;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        //loadAll();
        vm.round=round;
        vm.save=save;
        vm.print=print;
        
        vm.isVersion2=isVersion2;
        
        vm.insatisfechoCompetenciasProfesor=insatisfechoCompetenciasProfesor;
        vm.satisfechoCompetenciasProfesor=satisfechoCompetenciasProfesor;
        vm.muysatisfechoCompetenciasProfesor=muysatisfechoCompetenciasProfesor;
        
        vm.insatisfechoDesempenioProfesor=insatisfechoDesempenioProfesor;
        vm.satisfechoDesempenioProfesor=satisfechoDesempenioProfesor;
        vm.muysatisfechoDesempenioProfesor=muysatisfechoDesempenioProfesor;
        
        vm.insatisfechoActividadesDocenteProfesor=insatisfechoActividadesDocenteProfesor;
        vm.satisfechoActividadesDocenteProfesor=satisfechoActividadesDocenteProfesor;
        vm.muysatisfechoActividadesDocenteProfesor=muysatisfechoActividadesDocenteProfesor;
        
        function round(valor){
        	return Math.round(valor);
        }
        
        
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoOORegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoOyOService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 //alert("save");
                	 ReporteEvaluativoOyOService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } 
        	 }
             
        }
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;
            if(vm.wrapper.tipoUser==1){
                $state.go('generarReporteOO', {
        			 	idA: $stateParams.idA,
             			idP: $stateParams.idP,
             			idAnio: $stateParams.idAnio,
             			idIndice: $stateParams.idIndice,
             			ic: $stateParams.ic,
                        iic: $stateParams.iic,
             			tipoEvaluacion: $stateParams.tipoEvaluacion,
             			idDependencia: $stateParams.idDependencia,
             			nivell: $stateParams.nivell,
             			modeloo: $stateParams.modeloo
        			} , { reload: true });
            } else {
            	if(vm.wrapper.tipoUser==2){
                	$state.go('revisionReporteOO', {
						id: result.id
					}, { reload: true });
                }
            } 
        }
        
        function getCalProfesor(cadena,lugar){
        	var arrayDeCadenas = cadena.split(",");
        	return arrayDeCadenas[lugar];
        }
        
        function getSizeCalProfesor(cadena){
        	var arrayDeCadenas = cadena.split(",");
        	return arrayDeCadenas.length;
        }
        
        function isVersion2(){
//        	console.log("holaa");
        	var aux = getSizeCalProfesor(vm.reporte.valorCompetenciasProfesor);
        	var aux2 = false;
        	if(aux>1){//v2
        		aux2=true;
        	}
//        	console.log("aux: "+aux);
//        	console.log("aux2: "+aux2);
        	return aux2;
        }
        
        function insatisfechoCompetenciasProfesor(){
        	var valor = getCalProfesor(vm.reporte.valorCompetenciasProfesor,0);
        	return valor;
        }
        
        function satisfechoCompetenciasProfesor(){
        	var valor = getCalProfesor(vm.reporte.valorCompetenciasProfesor,1);
        	return valor;
        }

		function muysatisfechoCompetenciasProfesor(){
			var valor = getCalProfesor(vm.reporte.valorCompetenciasProfesor,2);
        	return valor;
		}
		
		function insatisfechoDesempenioProfesor(){
			var valor = getCalProfesor(vm.reporte.valorDesempenioProfesor,0);
        	return valor;
		}
		
		function satisfechoDesempenioProfesor(){
			var valor = getCalProfesor(vm.reporte.valorDesempenioProfesor,1);
        	return valor;
		}

		function muysatisfechoDesempenioProfesor(){
			var valor = getCalProfesor(vm.reporte.valorDesempenioProfesor,2);
        	return valor;
		}

		function insatisfechoActividadesDocenteProfesor(){
			var valor = getCalProfesor(vm.reporte.valorActividadesDocente,0);
        	return valor;
		}
		
		function satisfechoActividadesDocenteProfesor(){
			var valor = getCalProfesor(vm.reporte.valorActividadesDocente,1);
        	return valor;
		}

		function muysatisfechoActividadesDocenteProfesor(){
			var valor = getCalProfesor(vm.reporte.valorActividadesDocente,2);
        	return valor;
		}
        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'iteraccion',
    			type: 'bar'
            },
            title: {
                text: 'Relación Profesor - Estudiante'
            },
            xAxis: {
            	categories: ['Muestra respeto al dirigirse hacia los estudiantes', 
            		'Guía a los estudiantes a identificar sus necesidades o recursos para aprender de manera independiente', 
            		'Muestra con el ejemplo congruencia entre lo que dice y hace', 
            		'Promueve la ética de la profesión en la asignatura que imparte', 
            		'Promueve el intercambio de conocimientos, experiencias y opiniones entre los estudiantes',
            		'Optimiza el tiempo de las sesiones presenciales para el logro de los aprendizajes.'],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: [Math.round(vm.reporte.muestraRespetoEstudiantes),
                	Math.round(vm.reporte.guiaAprenderIndependienteE), 
                	Math.round(vm.reporte.congruenciaEstudiantes),
                	Math.round(vm.reporte.eticaEstudiantes),
                	Math.round(vm.reporte.intercambioConocimientoE),
                	Math.round(vm.reporte.optimizaTiempoEstudiante)],
               	color: '#002e5f'
            }, {
                name: 'Autoevaluación',
                data: [
                	Math.round(vm.reporte.muestraRespetoProfesor), 
                	Math.round(vm.reporte.guiaAprenderIndependienteP), 
                	Math.round(vm.reporte.congruenciaProfesor),
                	Math.round(vm.reporte.eticaProfesor),
                	Math.round(vm.reporte.intercambioConocimientoP),
                	Math.round(vm.reporte.optimizaTiempoProfesor)],
                color: '#ffb60f'
            }]
        });

        var chart2 = new Highcharts.Chart({
            chart: {
                renderTo: 'tic',
    			type: 'bar'
            },
            title: {
                text: 'TIC'
            },
            xAxis: {
            	categories: ['Promuevo el uso de la plataforma UADY Virtual como herramienta de apoyo al proceso de enseñanza y aprendizaje'],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: [Math.round(vm.reporte.usoPlataformasEstudiantes)],
               	color: '#002e5f'
            }, {
                name: 'Autoevaluación',
                data: [Math.round(vm.reporte.usoPlataformasProfesor)],
                color: '#ffb60f'
            }]
        });
        var chart3 = new Highcharts.Chart({
            chart: {
                renderTo: 'estrategias',
    			type: 'bar'
            },
            title: {
                text: 'Estrategias'
            },
            xAxis: {
            	categories: ['Sugiero actividades complementarias de aprendizaje para reforzar el desarrollo de las competencias.', 
            		'Utilizo actividades de aprendizaje dentro y/o fuera del aula, que contribuyan al desarrollo de las competencias de la asignatura.', 
            		'Utilizo actividades de aprendizaje que promuevan el análisis de los temas tratados.', 
            		'Utilizo actividades donde el estudiante integre los conocimientos previos y los nuevos.', 
            		'Utilizo actividades que promuevan el interés del estudiante hacia el aprendizaje de la asignatura.'],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: [Math.round(vm.reporte.actividadesComplementariasE),
                		Math.round(vm.reporte.desarrolloCompetenciasE), 
                		Math.round(vm.reporte.promueveAnalisisEstudiantes),
                		Math.round(vm.reporte.integraConocimientoEstudiante),
                		Math.round(vm.reporte.interesAprendizajeEstudiante)],
               	color: '#002e5f'
            }, {
                name: 'Autoevaluación',
                data: [Math.round(vm.reporte.actividadesComplementariasP), 
                	Math.round(vm.reporte.desarrolloCompetenciasP), 
                	Math.round(vm.reporte.promueveAnalisisProfesor),
                	Math.round(vm.reporte.integraConocimientoProfesor),
                	Math.round(vm.reporte.interesAprendizajeProfesor)],
                color: '#ffb60f'
            }]
        });
        var chart4 = new Highcharts.Chart({
            chart: {
                renderTo: 'tecnicas',
    			type: 'bar'
            },
            title: {
                text: 'Evaluación - técnicas'
            },
            xAxis: {
            	categories: ['Establezco el puntaje de cada una de las actividades de evaluación utilizadas durante la asignatura.', 
            		'Informo la puntuación obtenida en cada una de las estrategias de evaluación.'],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: [Math.round(vm.reporte.establecePuntajeEstudiante),
                	Math.round(vm.reporte.informaPuntuacionEstudiante)],
               	color: '#002e5f'
            }, {
                name: 'Autoevaluación',
                data: [Math.round(vm.reporte.establecePuntajeProfesor), 
                	Math.round(vm.reporte.informaPuntuacionProfesor)],
                color: '#ffb60f'
            }]
        });
        var chart5 = new Highcharts.Chart({
            chart: {
                renderTo: 'evaluacion',
    			type: 'bar'
            },
            title: {
                text: 'Evaluación'
            },
            xAxis: {
            	categories: ['Procuro que las actividades de evaluación se relacione con lo visto en la asignatura.', 
            		'Retroalimento el progreso academico para que el estudiante identifique sus fortalezas y debilidades.', 
            		'Utilizo diferentes formas de evaluación.'],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: [Math.round(vm.reporte.actividadesRelacionadoVistoE),
                	Math.round(vm.reporte.retroalimentoEstudiante), 
                	Math.round(vm.reporte.diferentesFormasEvaluacionE)],
               	color: '#002e5f'
            }, {
                name: 'Autoevaluación',
                data: [Math.round(vm.reporte.actividadesRelacionadoVistoP), 
                	Math.round(vm.reporte.retroalimentoProfesor), 
                	Math.round(vm.reporte.diferentesFormasEvaluacionP)],
                color: '#ffb60f'
            }]
        });
        var chart6 = new Highcharts.Chart({
            chart: {
                renderTo: 'valores',
    			type: 'bar'
            },
            title: {
                text: 'Valores Universitarios'
            },
            xAxis: [{
                categories: ['No ético', 
            		'Deshonesto', 
            		'Irresponsable social', 
            		'Intolerante', 
            		'Ilegal',
            		'Irrespetuoso',
            		'No humilde',
            		'Inequitativo',
            		'Sin rigor académico'],
                reversed: false,
                labels: {
                    step: 1
                }
            }, { // mirror axis on right side
                opposite: true,
                reversed: false,
                categories: ['Ético', 
            		'Honesto', 
            		'Responsable social', 
            		'Tolerante', 
            		'Legal',
            		'Respetuoso',
            		'Humilde',
            		'Equitativo',
            		'Rigor académico'],
                linkedTo: 0,
                labels: {
                    step: 1
                }
            }],
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: [
                	Math.round(vm.reporte.eticoEstudiantes),
                	Math.round(vm.reporte.honestoEstudiantes), 
                	Math.round(vm.reporte.responsableSocialEstudiantes),
                	Math.round(vm.reporte.toleranteEstudiantes),
                	Math.round(vm.reporte.legalEstudiantes),
                	Math.round(vm.reporte.respetuosoEstudiantes),
                	Math.round(vm.reporte.humildeEstudiantes),
                	Math.round(vm.reporte.equitativoEstudiantes),
                	Math.round(vm.reporte.rigoerAcademicoEstudiantes)],
               	color: '#002e5f'
            }, {
                name: 'Autoevaluación',
                data: [Math.round(vm.reporte.eticoProfesor), 
                	Math.round(vm.reporte.honestoProfesor), 
                	Math.round(vm.reporte.responsableSocialProfesor),
                	Math.round(vm.reporte.toleranteProfesor),
                	Math.round(vm.reporte.legalProfesor),
                	Math.round(vm.reporte.respetuosoProfesor),
                	Math.round(vm.reporte.humildeProfesor),
                	Math.round(vm.reporte.equitativoProfesor),
                	Math.round(vm.reporte.rigorAcademicoProfesor)],
                color: '#ffb60f'
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoMixtoPIIRegenerarService', ReporteEvaluativoMixtoPIIRegenerarService);

    ReporteEvaluativoMixtoPIIRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoMixtoPIIRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteMixtoPII/:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo,:grupo';

        return $resource(resourceUrl, {}, {
            'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteMixtoPIIregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoMixtoPIIService', ReporteEvaluativoMixtoPIIService);

    ReporteEvaluativoMixtoPIIService.$inject = ['$resource'];

    function ReporteEvaluativoMixtoPIIService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteMixtoPII/:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo,:grupo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
					//console.log(data);
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteMixtoPII:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreporteMixtoPII:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreporteMixtoPII:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreporteMixtoPII:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoMixtoPIIController', ReporteEvaluativoMixtoPIIController);

    ReporteEvaluativoMixtoPIIController.$inject = ['$scope', '$state', '$stateParams','ReporteEvaluativoMixtoPIIService', 'ReporteEvaluativoMixtoPIIRegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoMixtoPIIController ($scope, $state, $stateParams,ReporteEvaluativoMixtoPIIService, ReporteEvaluativoMixtoPIIRegenerarService,ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.round=round;
        vm.save=save;
        vm.autoheight=autoheight;
        vm.print=print;
        
		
		function calculateContentHeight( ta, scanAmount ) {
		    var origHeight = ta.style.height,
		        height = ta.offsetHeight,
		        scrollHeight = ta.scrollHeight,
		        overflow = ta.style.overflow;
		    /// only bother if the ta is bigger than content
		    if ( height >= scrollHeight ) {
		        /// check that our browser supports changing dimension
		        /// calculations mid-way through a function call...
		        ta.style.height = (height + scanAmount) + 'px';
		        /// because the scrollbar can cause calculation problems
		        ta.style.overflow = 'hidden';
		        /// by checking that scrollHeight has updated
		        if ( scrollHeight < ta.scrollHeight ) {
		            /// now try and scan the ta's height downwards
		            /// until scrollHeight becomes larger than height
		            while (ta.offsetHeight >= ta.scrollHeight) {
		                ta.style.height = (height -= scanAmount)+'px';
		            }
		            /// be more specific to get the exact height
		            while (ta.offsetHeight < ta.scrollHeight) {
		                ta.style.height = (height++)+'px';
		            }
		            /// reset the ta back to it's original height
		            ta.style.height = origHeight;
		            /// put the overflow back
		            ta.style.overflow = overflow;
		            return height;
		        }
		    } else {
		        return scrollHeight;
		    }
		}
		
		function autoheight(element) {
			var rows = 1;
			var ta = document.getElementById(element),
			style = (window.getComputedStyle) ?
			window.getComputedStyle(ta) : ta.currentStyle,
			
			// This will get the line-height only if it is set in the css,
			// otherwise it's "normal"
			taLineHeight = parseInt(style.lineHeight, 10),
			// Get the scroll height of the textarea
			taHeight = calculateContentHeight(ta, taLineHeight),
			// calculate the number of lines
			rows = Math.ceil(taHeight / taLineHeight);
			return rows;
		}
		
		
		
        function round(valor){
        	return Math.round(valor);
        }
        
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoMixtoPIIRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoMixtoPIIService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoMixtoPIIService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
        }
		
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;
			if(vm.wrapper.tipoUser==1){
				 $state.go('generarReporteMixtoPII', 
					{
					 	idA: $stateParams.idA,
			 			idP: $stateParams.idP,
			 			idAnio: $stateParams.idAnio,
			 			idIndice: $stateParams.idIndice,
			 			ic: $stateParams.ic,
			            iic: $stateParams.iic,
			 			tipoEvaluacion: $stateParams.tipoEvaluacion,
			 			idDependencia: $stateParams.idDependencia,
			 			nivell: $stateParams.nivell,
			 			modeloo: $stateParams.modeloo,
						grupo: $stateParams.grupo
					},
					{ reload: true });
			}else{
				if(vm.wrapper.tipoUser==2){
			        $state.go('revisionReporteMixtoPII', null, { reload: true });
			    }
			}	
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'iteraccion1',
    			type: 'bar'
            },
            title: {
                text: ''
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: 
            	[
					'Muestra respeto al dirigirse hacia sus estudiantes.',
					'Muestra respeto hacia la institución.',
					'Promueve un ambiente inclusivo, libre de violencia y discriminación.'
            	],
                type: 'integer'
            },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
			series: 
			[
			    {
			         name: 'Estudiantes',
			         data: [
			            Math.round(vm.reporte.muestrarespest_e),
			         	Math.round(vm.reporte.muestrarespintitu_e), 
			         	Math.round(vm.reporte.promueveinclulibreviodisc_e)
			            ],
			        	color: '#002e5f'
			     }
			]
        });

        var chart2 = new Highcharts.Chart({
            chart: {
                renderTo: 'iteraccion2',
    			type: 'bar'
            },
            title: {
                text: ''
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: [
					'Fomenta la participación de sus estudiantes en clase.',
					'Guía a sus estudiantes a identificar sus necesidades'
            		],
                type: 'integer'
            },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
            series: 
			[
				{
                	name: 'Estudiantes',
	                data: [
						Math.round(vm.reporte.fomentapartiestclase_e),
	                	Math.round(vm.reporte.guiaestidennece_e)
					],
	               	color: '#002e5f'
				}, 
				{
					name: 'Autoevaluación',
					data: [
						Math.round(vm.reporte.fomentapartiestclase_p),
						Math.round(vm.reporte.guiaestidennece_p)
					],
					color: '#ffb60f'
				}
			]
        });
        var chart3 = new Highcharts.Chart({
            chart: {
                renderTo: 'estrategias1',
    			type: 'bar'
            },
            title: {
                text: ''
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: 
            	[
					'Inicia sus clases puntualmente.',
					'Optimiza el tiempo de las sesiones presenciales para el logro de los aprendizajes.'
            	],
                type: 'integer'
            },
			tooltip: {
				valueSuffix: '%'
			},
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
						format: '{y}%'
                    }
                },
            },
            series: 
			[
				{
	                name: 'Estudiantes',
	                data: 
	                [
						vm.reporte.iniclaspuntual_e,
						vm.reporte.optitiempresenaprend_e
	                ],
	               	color: '#002e5f'
            	}
			]
        });
		var chart4 = new Highcharts.Chart({
		    chart: {
		        renderTo: 'estrategias2',
				type: 'bar'
		    },
		    title: {
		        text: ''
		    },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
		    xAxis: {
		    	categories: [
					'Brinda lineamientos y estrategias para evitar el plagio.',
					'Brinda una inducción al curso PII al inicio del período.',
					'Desarrolla sus sesiones presenciales en inglés.',
					'Informa a sus estudiantes sobre las fechas de corte para las actividades de aprendizaje y pruebas de desempeño.',
					'Ofrece recursos para aprender de manera independiente.',
					'Resuelve dudas respecto a las actividades y los contenidos abordados.',
					'Utiliza actividades de aprendizaje que contribuyen al desarrollo de las competencias (comprensión auditiva y lectora, producción oral y escrita).',
					'Utiliza actividades donde se integran los conocimientos previos y los nuevos.',
					'Utiliza actividades que promueven el interés del estudiantado hacia el aprendizaje del idioma.'
		    		],
		        type: 'integer'
		    },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
		    series: 
			[
				{
		        	name: 'Estudiantes',
		            data: [
						Math.round(vm.reporte.brindalineestrevplag_e),
						Math.round(vm.reporte.brindaitropii_e),
						Math.round(vm.reporte.dessesipreseningles_e),
						Math.round(vm.reporte.infofechaactspru_e),
						Math.round(vm.reporte.ofrecrecurindepen_e),
						Math.round(vm.reporte.resududasacti_e),
						Math.round(vm.reporte.utilactiaprendesacompe_e),
						Math.round(vm.reporte.utiactconoprevnuev_e),
						Math.round(vm.reporte.utiactprointeres_e)
					],
		           	color: '#002e5f'
				}, 
				{
					name: 'Autoevaluación',
					data: [
						Math.round(vm.reporte.brindalineestrevplag_p),
						Math.round(vm.reporte.brindaitropii_p),
						Math.round(vm.reporte.dessesipreseningles_p),
						Math.round(vm.reporte.infofechaactspru_p),
						Math.round(vm.reporte.ofrecrecurindepen_p),
						Math.round(vm.reporte.resududasacti_p),
						Math.round(vm.reporte.utilactiaprendesacompe_p),
						Math.round(vm.reporte.utiactconoprevnuev_p),
						Math.round(vm.reporte.utiactprointeres_p)
					],
					color: '#ffb60f'
				}
			]
		});
		var chart5 = new Highcharts.Chart({
		    chart: {
		        renderTo: 'estrategias3',
		        type: 'bar'
		    },
		    title: {
		        text: ''
		    },
		    yAxis: {
		        title: {
		            text: ''
		        }
		    },
		    xAxis: {
		        categories: [
					'Informa la puntuación obtenida en cada una de las estrategias de evaluación.',
					'Retroalimenta en tiempo y forma el progreso académico de cada estudiante para que identifique sus fortalezas y debilidades.'
		            ],
		        type: 'integer'
		    },
		    tooltip: {
		        valueSuffix: '%'
		    },
		    plotOptions: {
		        bar: {
		            dataLabels: {
		                enabled: true,
		                format: '{y}%'
		            }
		        },
		    },
		    series: 
		    [
		        {
		            name: 'Estudiantes',
		            data: [
		                Math.round(vm.reporte.infopuntuestrev_e),
		                Math.round(vm.reporte.retrotiemfor_e)
		            ],
		            color: '#002e5f'
		        }, 
		        {
		            name: 'Autoevaluación',
		            data: [
		                Math.round(vm.reporte.infopuntuestrev_p),
		                Math.round(vm.reporte.retrotiemfor_p)
		            ],
		            color: '#ffb60f'
		        }
		    ]
		});
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoLicRegenerarService', ReporteEvaluativoLicRegenerarService);

    ReporteEvaluativoLicRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoLicRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteLic:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteLicregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoLicService', ReporteEvaluativoLicService);

    ReporteEvaluativoLicService.$inject = ['$resource'];

    function ReporteEvaluativoLicService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteLic:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteLic:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreporteLic:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreporteLic:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreporteLic:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoLicController', ReporteEvaluativoLicController);

    ReporteEvaluativoLicController.$inject = ['$scope', '$state', '$stateParams','ReporteEvaluativoLicService', 'ReporteEvaluativoLicRegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoLicController ($scope, $state, $stateParams,ReporteEvaluativoLicService, ReporteEvaluativoLicRegenerarService,ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.round=round;
        vm.save=save;
        vm.autoheight=autoheight;
        vm.print=print;
        
		
		function calculateContentHeight( ta, scanAmount ) {
		    var origHeight = ta.style.height,
		        height = ta.offsetHeight,
		        scrollHeight = ta.scrollHeight,
		        overflow = ta.style.overflow;
		    /// only bother if the ta is bigger than content
		    if ( height >= scrollHeight ) {
		        /// check that our browser supports changing dimension
		        /// calculations mid-way through a function call...
		        ta.style.height = (height + scanAmount) + 'px';
		        /// because the scrollbar can cause calculation problems
		        ta.style.overflow = 'hidden';
		        /// by checking that scrollHeight has updated
		        if ( scrollHeight < ta.scrollHeight ) {
		            /// now try and scan the ta's height downwards
		            /// until scrollHeight becomes larger than height
		            while (ta.offsetHeight >= ta.scrollHeight) {
		                ta.style.height = (height -= scanAmount)+'px';
		            }
		            /// be more specific to get the exact height
		            while (ta.offsetHeight < ta.scrollHeight) {
		                ta.style.height = (height++)+'px';
		            }
		            /// reset the ta back to it's original height
		            ta.style.height = origHeight;
		            /// put the overflow back
		            ta.style.overflow = overflow;
		            return height;
		        }
		    } else {
		        return scrollHeight;
		    }
		}
		
		function autoheight(element) {
			var rows = 1;
//			console.log("Hola");
//			var el = document.getElementById(element);
//		    el.style.height = "5px";
//		    el.style.height = (el.scrollHeight)+"px";

			var ta = document.getElementById(element),
			style = (window.getComputedStyle) ?
			window.getComputedStyle(ta) : ta.currentStyle,
			
			// This will get the line-height only if it is set in the css,
			// otherwise it's "normal"
			taLineHeight = parseInt(style.lineHeight, 10),
			// Get the scroll height of the textarea
			taHeight = calculateContentHeight(ta, taLineHeight),
			// calculate the number of lines
			rows = Math.ceil(taHeight / taLineHeight);
			
//			document.getElementById("lines").innerHTML = "there are " +
//			rows + " lines in the text area";
//			console.log(rows);
			return rows;
		}
		
		
		
        function round(valor){
        	return Math.round(valor);
        }
        
        function print(){
        	window.print();
        }
		
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoLicRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoLicService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoLicService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
        }
		
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;
			if(vm.wrapper.tipoUser==1){
				 $state.go('generarReporteLic', 
					{
					 	idA: $stateParams.idA,
			 			idP: $stateParams.idP,
			 			idAnio: $stateParams.idAnio,
			 			idIndice: $stateParams.idIndice,
			 			ic: $stateParams.ic,
			            iic: $stateParams.iic,
			 			tipoEvaluacion: $stateParams.tipoEvaluacion,
			 			idDependencia: $stateParams.idDependencia,
			 			nivell: $stateParams.nivell,
			 			modeloo: $stateParams.modeloo
					},
					{ reload: true });
			}else{
				if(vm.wrapper.tipoUser==2){
			        $state.go('revisionReporteLic', null, { reload: true });
			    }
			}	
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'iteraccion',
    			type: 'bar'
            },
            title: {
                text: 'Estrategias de enseñanza y aprendizaje'
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: 
            	[
					'1. Establece actividades de aprendizaje donde se relacionan conocimientos nuevos con previos',
					'2. Utiliza actividades de aprendizaje que promueven el análisis de los contenidos',
					'3. Implementa actividades que aportan experiencia para el campo laboral',
					'4. Considera actividades que permiten ver la utilidad de la asignatura',
					'5. Utiliza actividades que desarrollan las competencias de la asignatura'
            	],
                type: 'integer'
            },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
			series: 
			[
			    {
			         name: 'Estudiantes',
			         data: [
			            Math.round(vm.reporte.estraenzapren1_e),
			         	Math.round(vm.reporte.estraenzapren2_e), 
			         	Math.round(vm.reporte.estraenzapren3_e),
			         	Math.round(vm.reporte.estraenzapren4_e),
			         	Math.round(vm.reporte.estraenzapren5_e)
			            ],
			        	color: '#002e5f'
			     }
			]
        });

        var chart2 = new Highcharts.Chart({
            chart: {
                renderTo: 'estrategias',
    			type: 'bar'
            },
            title: {
                text: 'Estrategias de evaluación'
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: [
					'6. Explica los requisitos y valor de cada actividad, al solicitarla',
					'7. Utiliza instrumentos para evaluar las actividades (rúbrica, listas de cotejo, de verificación, etc.)',
					'8. Informa la puntuación obtenida, encada una de las actividades realizadas',
					'9. Retroalimenta el progreso académico, señalando fortalezas y áreas de mejora'
            		],
                type: 'integer'
            },
			tooltip: {
			    valueSuffix: '%'
			},
			plotOptions: {
			    bar: {
			        dataLabels: {
			            enabled: true,
						format: '{y}%'
			        }
			    },
			},
            series: 
			[
				{
                	name: 'Estudiantes',
	                data: [
						Math.round(vm.reporte.estraevprom6_e),
	                	Math.round(vm.reporte.estraevprom7_e), 
	                	Math.round(vm.reporte.estraevprom8_e),
	                	Math.round(vm.reporte.estraevprom9_e)
					],
	               	color: '#002e5f'
            	}
			]
        });
        var chart3 = new Highcharts.Chart({
            chart: {
                renderTo: 'materias',
    			type: 'bar'
            },
            title: {
                text: ''
            },
			yAxis: {
				title: {
			    	text: ''
			    }
			},
            xAxis: {
            	categories: 
            	[
					'Dominio de contenidos',
					'Forma de evaluar',
					'Forma de trabajo en la asignatura',
					'Materiales de apoyo',
					'Planeación de la asignatura',
					'Relaciones con el grupo',
					'Utilidad para el campo laboral',
					'Conducta ética y profesional',
					'No brindaron recomendaciones'
            	],
                type: 'integer'
            },
			tooltip: {
				valueSuffix: '%'
			},
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true,
						format: '{y}%'
                    }
                },
            },
            series: 
			[
				{
	                name: 'Estudiantes',
	                data: 
	                [
						vm.reporte.domicont_e,
						vm.reporte.formaev_e,
						vm.reporte.formtrbasig_e,
						vm.reporte.matapoy_e,
						vm.reporte.planasig_e,
						vm.reporte.relagrpo_e,
						vm.reporte.uticamplab_e,
						vm.reporte.conduceticyprof_e,
						vm.reporte.norecomen_e
	                ],
	               	color: '#002e5f'
            	}
			]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoLibreRegenerarService', ReporteEvaluativoLibreRegenerarService);

    ReporteEvaluativoLibreRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoLibreRegenerarService ($resource) {
    	 var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteLI:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
        	'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteliregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoLibreService', ReporteEvaluativoLibreService);

    ReporteEvaluativoLibreService.$inject = ['$resource'];

    function ReporteEvaluativoLibreService ($resource) {
        var resourceUrl =  'apo/guardarreporteli:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': { method:'POST' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoLIService', ReporteEvaluativoLIService);

    ReporteEvaluativoLIService.$inject = ['$resource'];

    function ReporteEvaluativoLIService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteLI:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': { method:'POST' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoLIController', ReporteEvaluativoLIController);

    ReporteEvaluativoLIController.$inject = ['$scope', '$state', 'ReporteEvaluativoLibreService', 'ReporteEvaluativoLibreRegenerarService', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoLIController ($scope, $state, ReporteEvaluativoLibreService, ReporteEvaluativoLibreRegenerarService, ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.round=round;
        vm.save=save;
        function round(valor){
        	return Math.round(valor);
        }
        vm.print=print;
        
        function print(){
        	window.print();
        }
        
        function save(){
       	 vm.isSaving = true;
       	 
       	if(vm.wrapper.regenerar){
       		ReporteEvaluativoLibreRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
         	 $promise.then(function(result){
       		 vm.wrapper.reporte=result;
       	 });
       	}else{
       		if (vm.wrapper.reporte.id !== null) {
            	ReporteEvaluativoLibreService.update(vm.wrapper, onSaveSuccess, onSaveError).
              	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
            } else {
            	ReporteEvaluativoLibreService.save(vm.wrapper, onSaveSuccess, onSaveError).
           	 	$promise.then(function(result){
        		 vm.wrapper.reporte=result;
        	 });
            }
       	}
            
       }
       function onSaveSuccess (result) {
           $scope.$emit('sideApp:reporte', result);
           
           vm.isSaving = false;
           
//           if(vm.wrapper.regenerar){
//        	   $state.go('volvergenerarReporteLI', null, { reload: true });
//           }else{
        	   if(vm.wrapper.tipoUser==1){
                $state.go('generarReporteLI', {
    			 	idA: $stateParams.idA,
         			idP: $stateParams.idP,
         			idAnio: $stateParams.idAnio,
         			idIndice: $stateParams.idIndice,
         			ic: $stateParams.ic,
                    iic: $stateParams.iic,
         			tipoEvaluacion: $stateParams.tipoEvaluacion,
         			idDependencia: $stateParams.idDependencia,
         			nivell: $stateParams.nivell,
         			modeloo: $stateParams.modeloo
    			} , { reload: true });
               }else{
            	   if(vm.wrapper.tipoUser==2){
                       $state.go('revisionReporteLI', null, { reload: true }); 
            	   }
               }
               
//           }
           
       }

       function onSaveError () {
           vm.isSaving = false;
       }
        
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'iteraccion',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: ['Muestra respeto al dirigirse hacia los estudiantes', 
            		'Muestra con el ejemplo congruencia entre lo que dice y hace', 
            		'Promueve el intercambio de conocimientos, experiencias y opiniones entre los estudiantes',
            		'Optimiza el tiempo de las sesiones presenciales para el logro de los aprendizajes.'],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: [Math.round(vm.reporte.muestraRespetoEstudiantes),
                	Math.round(vm.reporte.congruenciaEstudiantes),
                	Math.round(vm.reporte.intercambioConocimientoE),
                	Math.round(vm.reporte.optimizaTiempoEstudiante)],
               	color: '#002e5f'
            }, {
                name: 'Autoevaluación',
                data: [
                	Math.round(vm.reporte.muestraRespetoProfesor),
                	Math.round(vm.reporte.congruenciaProfesor),
                	Math.round(vm.reporte.intercambioConocimientoP),
                	Math.round(vm.reporte.optimizaTiempoProfesor)],
                color: '#ffb60f'
            }]
        });

        var chart2 = new Highcharts.Chart({
            chart: {
                renderTo: 'dimensionii',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: ['Utilizo actividades que promuevan el interés del estudiante hacia el aprendizaje de la asignatura.',
            		'Establezco el puntaje de cada una de las actividades de evaluación utilizadas durante la asignatura.', 
            		'Informo la puntuación obtenida en cada una de las estrategias de evaluación.',
            		'Procuro que las actividades de evaluación se relacione con lo visto en la asignatura.', 
            		'Retroalimento el progreso academico para que el estudiante identifique sus fortalezas y debilidades.'],
                type: 'integer'
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            series: [{
                name: 'Estudiantes',
                data: [Math.round(vm.reporte.interesAprendizajeEstudiante),
                	Math.round(vm.reporte.establecePuntajeEstudiante),
                	Math.round(vm.reporte.informaPuntuacionEstudiante),
                	Math.round(vm.reporte.actividadesRelacionadoVistoE),
                	Math.round(vm.reporte.retroalimentoEstudiante)],
               	color: '#002e5f'
            }, {
                name: 'Autoevaluación',
                data: [Math.round(vm.reporte.interesAprendizajeProfesor),
                	Math.round(vm.reporte.establecePuntajeProfesor), 
                	Math.round(vm.reporte.informaPuntuacionProfesor),
                	Math.round(vm.reporte.actividadesRelacionadoVistoP), 
                	Math.round(vm.reporte.retroalimentoProfesor)],
                color: '#ffb60f'
            }]
        });
        
       
      

        


    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoCURegenerarService', ReporteEvaluativoCURegenerarService);

    ReporteEvaluativoCURegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoCURegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteCU:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
        	'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreportecuregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();
(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoCUService', ReporteEvaluativoCUService);

    ReporteEvaluativoCUService.$inject = ['$resource'];

    function ReporteEvaluativoCUService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteCU:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreportecu:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreportecu:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreportecu:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreportecu:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoCUController', ReporteEvaluativoCUController);

    ReporteEvaluativoCUController.$inject = ['$scope', '$state', '$stateParams', 'ReporteEvaluativoCUService','ReporteEvaluativoCURegenerarService', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoCUController ($scope, $state, $stateParams, ReporteEvaluativoCUService, ReporteEvaluativoCURegenerarService, ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.round=round;
        vm.save=save;
        vm.print=print;
        vm.nivelObtenido=nivelObtenido;
        
        function round(valor){
        	return Math.round(valor);
        }
        
        function nivelObtenido(media){
        	var mediaObtenida = parseFloat(media);
        	var limiteInferiorSobresaliente = 3.60;
        	var limiteSuperiorSatisfactorio = 3.59;
        	var limiteInferiorSatisfactorio = 2.81;
        	var limiteSuperiorInsatisfactorio = 2.80;
        	var nivel = 'No aplica';
        	
        	if(mediaObtenida>=limiteInferiorSobresaliente){
        		nivel = 'Sobresaliente';
        	}else{
        		if(mediaObtenida>=limiteInferiorSatisfactorio && mediaObtenida<=limiteSuperiorSatisfactorio ){
        			nivel = 'Satisfactorio';
        		}else{
        			if(mediaObtenida<=limiteSuperiorInsatisfactorio){
        				nivel = 'Insatisfactorio';
        			}
        		}
        	}
        	return nivel;
        }
        
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoCURegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoCUService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoCUService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
        }
        function onSaveSuccess (result) {
			$scope.$emit('sideApp:reporte', result);
			vm.isSaving = false;
			if (vm.wrapper.tipoUser == 1) {
				$state.go('generarReporteCU', 
				{
					idA: $stateParams.idA,
					idP: $stateParams.idP,
					idAnio: $stateParams.idAnio,
					idIndice: $stateParams.idIndice,
					ic: $stateParams.ic,
					iic: $stateParams.iic,
					tipoEvaluacion: $stateParams.tipoEvaluacion,
					idDependencia: $stateParams.idDependencia,
					nivell: $stateParams.nivell,
					modeloo: $stateParams.modeloo
				}, 
				{ reload: true });
			} else {
				if (vm.wrapper.tipoUser == 2) {
					$state.go('revisionReporteCU', null, { reload: true });
				}
			}
		}

        function onSaveError () {
            vm.isSaving = false;
        }
        
        Highcharts.setOptions({
            chart: {
                backgroundColor: {
                    linearGradient: [0, 0, 500, 500],
                    stops: [
                        [0, 'rgb(255, 255, 255)'],
                        [1, 'rgb(255, 255, 255)']
                        ]
                },
                borderWidth: 2,
                plotBackgroundColor: 'rgba(255, 255, 255, .9)',
                plotShadow: true,
                plotBorderWidth: 1
            }
        });
        
        var chart1 = new Highcharts.Chart({
            chart: {
                renderTo: 'desempeniocategoria',
    			type: 'bar'
            },
            title: {
                text: ''
            },
            xAxis: {
            	categories: [
            		'I. Cumplimiento', 
            		'II. Planeación', 
            		'III. Estrategias didácticas', 
            		'IV. Actitud del profesor', 
            		'V. Comunicación',
            		'VI. Evaluación de los aprendizajes',
            		'VII. Específicas del área de conocimiento'],
//                type: 'integer'
            },
            yAxis: {
                title: {
                    text: null,
                },
                opposite:true,
//                labels: {
//                	enabled: false
//                }
            },
            plotOptions: {
                bar: {
                    dataLabels: {
                        enabled: true
                    }
                }
            },
            legend: {
            	enabled:false
            },
            series: [{
                name: 'Estudiantes',
                data: [
                	parseFloat(vm.wrapper.promedioCumplimiento),
                	parseFloat(vm.wrapper.promedioPlaneacion),
                	parseFloat(vm.wrapper.promedioEstrategiasDidacticas),
                	parseFloat(vm.wrapper.promedioActitudDelProfesor),
                	parseFloat(vm.wrapper.promedioComunicacion),
                	parseFloat(vm.wrapper.promedioEvaluacionAprendizajes),
                	parseFloat(vm.wrapper.promedioEspecificasAreaConocimiento)
                	],
               	color: '#002e5f'
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoBachilleratoRegenerarService', ReporteEvaluativoBachilleratoRegenerarService);

    ReporteEvaluativoBachilleratoRegenerarService.$inject = ['$resource'];

    function ReporteEvaluativoBachilleratoRegenerarService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/regenerarreporteBachillerato:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'regenerar': {
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteBachilleratoregenerar:id',
            	method:'PUT' 
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoBachilleratoService', ReporteEvaluativoBachilleratoService);

    ReporteEvaluativoBachilleratoService.$inject = ['$resource'];

    function ReporteEvaluativoBachilleratoService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo/reporteBachillerato:idA,:idP,:idAnio,:idIndice,:ic,:iic,:tipoEvaluacion,:idDependencia,:nivell,:modeloo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	url:'apo/guardarreporteBachillerato:id',
            	method:'PUT' 
            },
            'save': {
            	url:'apo/guardarreporteBachillerato:id',
            	method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getRevision': {
            	url:'apo/revisionreporteBachillerato:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'ver': {
            	url:'apo/verreporteBachillerato:id',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoBachilleratoController', ReporteEvaluativoBachilleratoController);

    ReporteEvaluativoBachilleratoController.$inject = ['$scope', '$state', '$stateParams','ReporteEvaluativoBachilleratoService', 'ReporteEvaluativoBachilleratoRegenerarService','ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'LoginService','entity'
    	];

    function ReporteEvaluativoBachilleratoController ($scope, $state, $stateParams,ReporteEvaluativoBachilleratoService, ReporteEvaluativoBachilleratoRegenerarService,ParseLinks, AlertService, pagingParams, paginationConstants,LoginService,entity
    		) {
        var vm = this;
        vm.reporte=entity.reporte;
        vm.wrapper=entity;
        vm.tipo=entity.tipo;
        vm.dosDecimales=dosDecimales;
		vm.nivelObtenido=nivelObtenido;
        vm.save=save;
        
        vm.print=print;
        
		function nivelObtenido(media){
			var mediaObtenida = parseFloat(media);
			var limiteInferiorSobresaliente = 3.72;
			var limiteSuperiorSatisfactorio = 3.71;
			var limiteInferiorSatisfactorio = 3.27;
			var limiteSuperiorSuficiente = 3.26;
			var limiteInferiorSuficiente = 2.94;
			var limiteSuperiorNecesitaMejorar = 2.93;
			var nivel = 'No aplica';
			
			if(mediaObtenida>=limiteInferiorSobresaliente){
				nivel = 'Sobresaliente';
			}else{
				if(mediaObtenida>=limiteInferiorSatisfactorio && mediaObtenida<=limiteSuperiorSatisfactorio ){
					nivel = 'Satisfactorio';
				}else{
					if(mediaObtenida>=limiteInferiorSuficiente && mediaObtenida<=limiteSuperiorSuficiente ){
						nivel = 'Suficiente';
					}else{
						if(mediaObtenida<=limiteSuperiorNecesitaMejorar){
							nivel = 'Necesita mejorar';
						}
					}
				}
			}
			return nivel;
		}
		
        function dosDecimales(valor){
			var numero = valor;
			return Number(numero).toFixed(2);
        }
        
		function round(valor){
			return Math.round(valor);
		}
				
        function print(){
        	window.print();
        }
        
        function save(){
        	 vm.isSaving = true;
        	 if(vm.wrapper.regenerar){
        		 ReporteEvaluativoBachilleratoRegenerarService.update(vm.wrapper, onSaveSuccess, onSaveError).
               	 $promise.then(function(result){
            		 vm.wrapper.reporte=result;
            	 });
        	 }else{
        		 if (vm.wrapper.reporte.id !== null) {
                	 ReporteEvaluativoBachilleratoService.update(vm.wrapper, onSaveSuccess, onSaveError).
                   	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 } else {
                	 ReporteEvaluativoBachilleratoService.save(vm.wrapper, onSaveSuccess, onSaveError).
                	 $promise.then(function(result){
                		 vm.wrapper.reporte=result;
                	 });
                 }
        	 }
             
        }
        function onSaveSuccess (result) {
            $scope.$emit('sideApp:reporte', result);
            vm.isSaving = false;

            	if(vm.wrapper.tipoUser==1){
            		 $state.go('generarReporteBachillerato', 
            			{
            			 	idA: $stateParams.idA,
	             			idP: $stateParams.idP,
	             			idAnio: $stateParams.idAnio,
	             			idIndice: $stateParams.idIndice,
	             			ic: $stateParams.ic,
	                        iic: $stateParams.iic,
	             			tipoEvaluacion: $stateParams.tipoEvaluacion,
	             			idDependencia: $stateParams.idDependencia,
	             			nivell: $stateParams.nivell,
	             			modeloo: $stateParams.modeloo
            			} 
            				 
            		 ,{ reload: true });
            	}else{
            		if(vm.wrapper.tipoUser==2){
                        $state.go('revisionReporteBachillerato', null, { reload: true });
                    }
            	}
//            }
        }
        

        function onSaveError () {
            vm.isSaving = false;
        }
 
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reporteevaluativo', {
                parent: 'app',
                url: '/reporteEvaluativo?page&sort&search',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE', 'ADMINISTRATIVO_BACHILLERATO_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativo/reporteevaluativo.html',
                        controller: 'ReporteEvaluativoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    type: '1',
                    indice: '1',
                    ic: false,
                    iic: '0',
                    anio: '0',
                    aniostr: '',
                    modelo: '0',
                    nivel: '0',
                    centro: '0',
                    ep: false
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            type: $stateParams.type,
                            indice: $stateParams.indice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            anio: $stateParams.anio,
                            aniostr: $stateParams.aniostr,
                            modelo: $stateParams.modelo,
                            nivel: $stateParams.nivel,
                            centro: $stateParams.centro,
                            ep: $stateParams.ep
                        };
                    }]
                }
            })
            .state('generarReporteOO', {
                parent: 'reporteevaluativo',
                url: '/reporte/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoOO/reporteevaluativoOO.html',
                        controller: 'ReporteEvaluativoOOController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoOOService', '$state',
                        function($stateParams, ReporteEvaluativoOOService, $state) {
                            return ReporteEvaluativoOOService.get({
                                idA: $stateParams.idA,
                                idP: $stateParams.idP,
                                idAnio: $stateParams.idAnio,
                                idIndice: $stateParams.idIndice,
                                ic: $stateParams.ic,
                                iic: $stateParams.iic,
                                tipoEvaluacion: $stateParams.tipoEvaluacion,
                                idDependencia: $stateParams.idDependencia,
                                nivell: $stateParams.nivell,
                                modeloo: $stateParams.modeloo
                            }).$promise;
                        }]
                },
            })
            .state('generarReporteLic', {
                parent: 'reporteevaluativo',
                url: '/reporteLic/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoLic/reporteevaluativoLic.html',
                        controller: 'ReporteEvaluativoLicController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoLicService', '$state',
                        function($stateParams, ReporteEvaluativoLicService, $state) {
                            return ReporteEvaluativoLicService.get({
                                idA: $stateParams.idA,
                                idP: $stateParams.idP,
                                idAnio: $stateParams.idAnio,
                                idIndice: $stateParams.idIndice,
                                ic: $stateParams.ic,
                                iic: $stateParams.iic,
                                tipoEvaluacion: $stateParams.tipoEvaluacion,
                                idDependencia: $stateParams.idDependencia,
                                nivell: $stateParams.nivell,
                                modeloo: $stateParams.modeloo
                            }).$promise;
                        }]
                },
            })
            .state('generarReporteLI', {
                parent: 'reporteevaluativo',
                url: '/reporteli/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoLI/reporteevaluativoLI.html',
                        controller: 'ReporteEvaluativoLIController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoLIService', '$state', function($stateParams, ReporteEvaluativoLIService, $state) {
                        return ReporteEvaluativoLIService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('generarReporteCU', {
                parent: 'reporteevaluativo',
                url: '/reporteCU/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoCU/reporteevaluativoCU.html',
                        controller: 'ReporteEvaluativoCUController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoCUService', '$state',
                        function($stateParams, ReporteEvaluativoCUService, $state) {
                            return ReporteEvaluativoCUService.get({
                                idA: $stateParams.idA,
                                idP: $stateParams.idP,
                                idAnio: $stateParams.idAnio,
                                idIndice: $stateParams.idIndice,
                                ic: $stateParams.ic,
                                iic: $stateParams.iic,
                                tipoEvaluacion: $stateParams.tipoEvaluacion,
                                idDependencia: $stateParams.idDependencia,
                                nivell: $stateParams.nivell,
                                modeloo: $stateParams.modeloo
                            }).$promise;
                        }]
                },
            })
            .state('generarReporteRegular', {
                parent: 'reporteevaluativo',
                url: '/reporteRegular/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoRegular/reporteevaluativoRegular.html',
                        controller: 'ReporteEvaluativoRegularController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoRegularService', '$state', function($stateParams, ReporteEvaluativoRegularService, $state) {
                        return ReporteEvaluativoRegularService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('generarReporteVirtual', {
                parent: 'reporteevaluativo',
                url: '/reporteVirtual/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoVirtual/reporteevaluativoVirtual.html',
                        controller: 'ReporteEvaluativoVirtualController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoVirtualService', '$state', function($stateParams, ReporteEvaluativoVirtualService, $state) {
                        return ReporteEvaluativoVirtualService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('generarReporteUAEV', {
                parent: 'reporteevaluativo',
                url: '/reporteUAEV/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoUAEV/reporteevaluativoUAEV.html',
                        controller: 'ReporteEvaluativoUAEVController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoUAEVService', '$state', function($stateParams, ReporteEvaluativoUAEVService, $state) {
                        return ReporteEvaluativoUAEVService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('generarReporteBachillerato', {
                parent: 'reporteevaluativo',
                url: '/reporteBachillerato/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE', 'ADMINISTRATIVO_BACHILLERATO_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoBachillerato/reporteevaluativoBachillerato.html',
                        controller: 'ReporteEvaluativoBachilleratoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoBachilleratoService', '$state', function($stateParams, ReporteEvaluativoBachilleratoService, $state) {
                        return ReporteEvaluativoBachilleratoService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('generarReporteMixtoPII', {
                parent: 'reporteevaluativo',
                url: '/reporteMixtoPII/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo},{grupo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoMixtoPII/reporteevaluativoMixtoPII.html',
                        controller: 'ReporteEvaluativoMixtoPIIController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoMixtoPIIService', '$state', function($stateParams, ReporteEvaluativoMixtoPIIService, $state) {
                        return ReporteEvaluativoMixtoPIIService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo,
                            grupo: $stateParams.grupo
                        }).$promise;
                    }]
                },
            })
            .state('generarReporteVirtualPII', {
                parent: 'reporteevaluativo',
                url: '/reporteVirtualPII/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo},{grupo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoVirtualPII/reporteevaluativoVirtualPII.html',
                        controller: 'ReporteEvaluativoVirtualPIIController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoVirtualPIIService', '$state', function($stateParams, ReporteEvaluativoVirtualPIIService, $state) {
                        return ReporteEvaluativoVirtualPIIService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo,
                            grupo: $stateParams.grupo
                        }).$promise;
                    }]
                },
            })


            .state('volvergenerarReporteOO', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporte/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoOO/reporteevaluativoOO.html',
                        controller: 'ReporteEvaluativoOOController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoOORegenerarService', '$state',
                        function($stateParams, ReporteEvaluativoOORegenerarService, $state) {
                            return ReporteEvaluativoOORegenerarService.get({
                                idA: $stateParams.idA,
                                idP: $stateParams.idP,
                                idAnio: $stateParams.idAnio,
                                idIndice: $stateParams.idIndice,
                                ic: $stateParams.ic,
                                iic: $stateParams.iic,
                                tipoEvaluacion: $stateParams.tipoEvaluacion,
                                idDependencia: $stateParams.idDependencia,
                                nivell: $stateParams.nivell,
                                modeloo: $stateParams.modeloo
                            }).$promise;
                        }]
                },
            })
            .state('volvergenerarReporteLic', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteLic/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoLic/reporteevaluativoLic.html',
                        controller: 'ReporteEvaluativoLicController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoLicRegenerarService', '$state', function($stateParams, ReporteEvaluativoLicRegenerarService, $state) {
                        return ReporteEvaluativoLicRegenerarService.regenerar({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteLI', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteli/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoLI/reporteevaluativoLI.html',
                        controller: 'ReporteEvaluativoLIController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoLIRegenerarService', '$state', function($stateParams, ReporteEvaluativoLIRegenerarService, $state) {
                        return ReporteEvaluativoLIRegenerarService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteCU', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteCU/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoCU/reporteevaluativoCU.html',
                        controller: 'ReporteEvaluativoCUController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoCURegenerarService', '$state', function($stateParams, ReporteEvaluativoCURegenerarService, $state) {
                        return ReporteEvaluativoCURegenerarService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteRegular', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteRegular/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoRegular/reporteevaluativoRegular.html',
                        controller: 'ReporteEvaluativoRegularController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoRegularRegenerarService', '$state', function($stateParams, ReporteEvaluativoRegularRegenerarService, $state) {
                        return ReporteEvaluativoRegularRegenerarService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteVirtual', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteVirtual/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoVirtual/reporteevaluativoVirtual.html',
                        controller: 'ReporteEvaluativoVirtualController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoVirtualRegenerarService', '$state', function($stateParams, ReporteEvaluativoVirtualRegenerarService, $state) {
                        return ReporteEvaluativoVirtualRegenerarService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteUAEV', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteUAEV/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoUAEV/reporteevaluativoUAEV.html',
                        controller: 'ReporteEvaluativoUAEVController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoUAEVRegenerarService', '$state', function($stateParams, ReporteEvaluativoUAEVRegenerarService, $state) {
                        return ReporteEvaluativoUAEVRegenerarService.regenerar({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteBachillerato', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteBachillerato/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE', 'ADMINISTRATIVO_BACHILLERATO_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoBachillerato/reporteevaluativoBachillerato.html',
                        controller: 'ReporteEvaluativoBachilleratoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoBachilleratoRegenerarService', '$state', function($stateParams, ReporteEvaluativoBachilleratoRegenerarService, $state) {
                        return ReporteEvaluativoBachilleratoRegenerarService.regenerar({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteMixtoPII', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteMixtoPII/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo},{grupo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoMixtoPII/reporteevaluativoMixtoPII.html',
                        controller: 'ReporteEvaluativoMixtoPIIController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoMixtoPIIRegenerarService', '$state', function($stateParams, ReporteEvaluativoMixtoPIIRegenerarService, $state) {
                        return ReporteEvaluativoMixtoPIIRegenerarService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo,
                            grupo: $stateParams.grupo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteVirtualPII', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteVirtualPII/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo},{grupo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoVirtualPII/reporteevaluativoVirtualPII.html',
                        controller: 'ReporteEvaluativoVirtualPIIController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoVirtualPIIRegenerarService', '$state', function($stateParams, ReporteEvaluativoVirtualPIIRegenerarService, $state) {
                        return ReporteEvaluativoVirtualPIIRegenerarService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo,
                            grupo: $stateParams.grupo
                        }).$promise;
                    }]
                },
            });

    }

})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ReporteEvaluativoService', ReporteEvaluativoService);

    ReporteEvaluativoService.$inject = ['$resource'];

    function ReporteEvaluativoService ($resource) {
        var resourceUrl =  'apo/reporteEvaluativo:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro,:ep';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'reportesMasivos': { 
            	url:'apo/reportesEvaluativosMasivos:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro',
            	method:'GET',
            	isArray: true
            		
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ReporteEvaluativoController', ReporteEvaluativoController);

    ReporteEvaluativoController.$inject = ['$scope', '$state', 'ReporteEvaluativoService', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ClasesAmbitoService','LoginService','downloadService','Periodos',
    	'AniosEscolares','ReporteProfesorService','ReporteAlumnoService','Instituciones','NivelesEducativosService','ModelosEducativosService'];

    function ReporteEvaluativoController ($scope, $state, ReporteEvaluativoService, ParseLinks, AlertService, pagingParams, paginationConstants,ClasesAmbitoService,LoginService,downloadService,Periodos,
    		AniosEscolares,ReporteProfesorService,ReporteAlumnoService,Instituciones,NivelesEducativosService,ModelosEducativosService) {
        var vm = this;
        
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
     
        vm.indicePeriodo=pagingParams.indice;
        vm.intercurso=intercursoValue();
        vm.indiceIntercurso=pagingParams.iic;
        vm.periodos;
        vm.search=search;
        vm.type=pagingParams.type;
        vm.currentSearch=pagingParams.search;
        vm.anioSeleccionado=pagingParams.anio;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.institucionSelected=pagingParams.centro;
        vm.evaluacionesPendientes=pagingParams.ep;
		
        cargarDropdrown();
        loadAll();

        vm.limpiar = limpiar;
        vm.generarReportesMasivos = generarReportesMasivos;
        
        $scope.$watchGroup(["vm.anioSeleccionado","vm.institucionSelected","vm.intercurso"],function(newValue,oldValue){
        	if (newValue !== oldValue) {        	
	        	vm.periodos = null;
				
	        	if(vm.anioSeleccionado != null && vm.institucionSelected != null){
	        		vm.periodos = Periodos.query({
	            		anio: vm.anioSeleccionado,
	            		dep: vm.institucionSelected,
	            		ic: vm.intercurso
	                }, onPeriodosSuccess);
	        	}
			}
        });
		
		function cargarDropdrown(){
			vm.aniosEscolares = AniosEscolares.query();
			vm.dependencias = Instituciones.query();
			vm.niveles = NivelesEducativosService.getAll();
			vm.modelos = ModelosEducativosService.getAll();
		}
        
        function loadAll () {
        	vm.periodos = null;
			
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null && vm.intercurso != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                }, onPeriodosSuccess);
        	}
        	
        	ReporteEvaluativoService.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro:vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            }, onSuccess, onError);
        	
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            },onTransitionSuccess);
        }

        function search(){
        	if(vm.anioSeleccionado != null){
	        	$state.transitionTo($state.$current, {
	                page: 0,
	                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
	                search: vm.currentSearch,
	                type: vm.type,
	                indice: vm.indicePeriodo,
	                ic: vm.intercurso,
	                iic: vm.indiceIntercurso,
	                anio: vm.anioSeleccionado,
	                aniostr: vm.anioSeleccionado,
	                modelo: vm.modeloSeleccionado,
	                nivel: vm.nivelSeleccionado,
	                centro: vm.institucionSelected,
	                ep: vm.evaluacionesPendientes
	            },onSearchTransitionSuccess)
			}
        }
        
        function generarReportesMasivos(){
        	if(vm.anioSeleccionado==null || vm.anioSeleccionado==0  || vm.indicePeriodo == null || vm.intercurso == null || vm.indiceIntercurso == null || vm.modeloSeleccionado == null || vm.nivelSeleccionado == null|| vm.modeloSeleccionado == 0 || vm.nivelSeleccionado == 0 || vm.institucionSelected == null|| vm.institucionSelected == 0)
        		return ;
        	
        	ReporteEvaluativoService.reportesMasivos({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro:vm.institucionSelected
            }, onSuccess, onError);
        }
		
		function onSuccess(data, headers) {
		    vm.links = ParseLinks.parse(headers('link'));
		    vm.totalItems = headers('X-Total-Count');
		    vm.queryCount = vm.totalItems;
		    vm.wrappers = data;
		    vm.page = pagingParams.page;
		}
		
		function intercursoValue() {
			if (typeof pagingParams.ic === 'boolean') {
				return pagingParams.ic;
			}
			
			if(pagingParams.ic === 'true')
				return true;
			return false;
		}

		function onPeriodosSuccess(){
			if(vm.intercurso === true){
				vm.indicePeriodo = 0;
				vm.indiceIntercurso = pagingParams.iic;
			}else{
				vm.indicePeriodo = pagingParams.indice;
				vm.indiceIntercurso = 0;
			}
		}

		function onSearchTransitionSuccess(){
		}

		function onTransitionSuccess(){
		}

		function onError(error) {
		    AlertService.error(error.data.message);
		}
		

		function limpiar() {
			vm.modeloSeleccionado = null;
		}

		function sort() {
			var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
		    if (vm.predicate !== 'id') {
		    	result.push('id');
		    }
		    return result;
		}  
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('Periodos', Periodos);

    Periodos.$inject = ['$resource'];

    function Periodos ($resource) {
        var resourceUrl =  'apo/periodo/:anio,:dep,:ic';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('NivelesEducativosService', NivelesEducativosService);

    NivelesEducativosService.$inject = ['$resource'];

    function NivelesEducativosService ($resource) {
        var resourceUrl =  'apo/nivelesEducativos';

        return $resource(resourceUrl, {}, {
        	'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('NivelEducativoService', NivelEducativoService);

    NivelEducativoService.$inject = ['$resource'];

    function NivelEducativoService ($resource) {
        var resourceUrl =  'apo/nivelEducativo';//nohay

        return $resource(resourceUrl, {}, {
//            'query': { method: 'GET', isArray: true},
//            'get': {
//                method: 'GET',
//                transformResponse: function (data) {
//                    if (data) {
//                        data = angular.fromJson(data);
//                    }
//                    return data;
//                }
//            },
//            'update': { method:'PUT' },
            'getNivelByPlanAlumno': {
         	   url:'apo/getNivelByPlanAlumno/{nivPlan}',
         	   method: 'POST'
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ModelosEducativosService', ModelosEducativosService);

    ModelosEducativosService.$inject = ['$resource'];

    function ModelosEducativosService ($resource) {
        var resourceUrl =  'apo/modelosEducativos';

        return $resource(resourceUrl, {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'Error page!'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('Instituciones', Instituciones);

    Instituciones.$inject = ['$resource'];

    function Instituciones ($resource) {
        var resourceUrl =  'apo/instituciones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'instAdmvoGeneralSIDE': { url:'apo/instAdmvoGeneralSIDE', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
            	pageTitle: 'SIDE',
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.hasRol=hasRol;
        vm.rolesUsuario=rolesUsuario;
        
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
        function hasRol () {
        	var has=false;
        	if(vm.account!=null && vm.account.authorities!=null){
        		 for(var i=0;i<vm.account.authorities.length;i++){
        			 if(vm.account.authorities[i]=='PROFESOR'){
        				 has=true; 
        			 }
        			 if(vm.account.authorities[i]=='RESPONSABLE_SIDE'){
        				 has=true;}
        			 if(vm.account.authorities[i]=='ALUMNO'){
        				 has=true;}
        			 if(vm.account.authorities[i]=='ADMINISTRATIVO_GENERAL_SIDE'){
        				 has=true;}
				     if(vm.account.authorities[i]=='ADMINISTRATIVO_BACHILLERATO_SIDE'){
						 has=true;}
        		 }
        	}
            return has;
        }
        
        function rolesUsuario () {
        	
        	var roles = [];
//        	console.log(vm.account.authorities);
        	if(vm.account!=null && vm.account.authorities!=null){
        		 for(var i=0;i<vm.account.authorities.length;i++){
        			 if(vm.account.authorities[i]=='PROFESOR'){
        				 roles.push("PROFESOR");}
        			 if(vm.account.authorities[i]=='RESPONSABLE_SIDE'){
        				 roles.push("RESPONSABLE_SIDE");}
        			 if(vm.account.authorities[i]=='ALUMNO'){
        				 roles.push("ALUMNO");}
        			 if(vm.account.authorities[i]=='ADMINISTRATIVO_GENERAL_SIDE'){
        				 roles.push("ADMINISTRATIVO_GENERAL_SIDE");}
					if(vm.account.authorities[i]=='ADMINISTRATIVO_BACHILLERATO_SIDE'){
						 roles.push("ADMINISTRATIVO_BACHILLERATO_SIDE");}
        		 }
        	}
            return roles;
        }
    }
})();

/*
 Highcharts JS v5.0.7 (2017-01-17)

 (c) 2009-2016 Torstein Honsi

 License: www.highcharts.com/license
*/
(function(L,a){"object"===typeof module&&module.exports?module.exports=L.document?a(L):a:L.Highcharts=a(L)})("undefined"!==typeof window?window:this,function(L){L=function(){var a=window,B=a.document,A=a.navigator&&a.navigator.userAgent||"",H=B&&B.createElementNS&&!!B.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,G=/(edge|msie|trident)/i.test(A)&&!window.opera,r=!H,g=/Firefox/.test(A),f=g&&4>parseInt(A.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,!0):{product:"Highcharts",
version:"5.0.7",deg2rad:2*Math.PI/360,doc:B,hasBidiBug:f,hasTouch:B&&void 0!==B.documentElement.ontouchstart,isMS:G,isWebKit:/AppleWebKit/.test(A),isFirefox:g,isTouchDevice:/(Mobile|Android|Windows Phone)/.test(A),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:H,vml:r,win:a,charts:[],marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){}}}();(function(a){var B=[],A=a.charts,H=a.doc,G=a.win;a.error=function(r,g){r=a.isNumber(r)?"Highcharts error #"+
r+": www.highcharts.com/errors/"+r:r;if(g)throw Error(r);G.console&&console.log(r)};a.Fx=function(a,g,f){this.options=g;this.elem=a;this.prop=f};a.Fx.prototype={dSetter:function(){var a=this.paths[0],g=this.paths[1],f=[],u=this.now,l=a.length,q;if(1===u)f=this.toD;else if(l===g.length&&1>u)for(;l--;)q=parseFloat(a[l]),f[l]=isNaN(q)?a[l]:u*parseFloat(g[l]-q)+q;else f=g;this.elem.attr("d",f,null,!0)},update:function(){var a=this.elem,g=this.prop,f=this.now,u=this.options.step;if(this[g+"Setter"])this[g+
"Setter"]();else a.attr?a.element&&a.attr(g,f,null,!0):a.style[g]=f+this.unit;u&&u.call(a,f,this)},run:function(a,g,f){var r=this,l=function(a){return l.stopped?!1:r.step(a)},q;this.startTime=+new Date;this.start=a;this.end=g;this.unit=f;this.now=this.start;this.pos=0;l.elem=this.elem;l.prop=this.prop;l()&&1===B.push(l)&&(l.timerId=setInterval(function(){for(q=0;q<B.length;q++)B[q]()||B.splice(q--,1);B.length||clearInterval(l.timerId)},13))},step:function(a){var r=+new Date,f,u=this.options;f=this.elem;
var l=u.complete,q=u.duration,d=u.curAnim,b;if(f.attr&&!f.element)f=!1;else if(a||r>=q+this.startTime){this.now=this.end;this.pos=1;this.update();a=d[this.prop]=!0;for(b in d)!0!==d[b]&&(a=!1);a&&l&&l.call(f);f=!1}else this.pos=u.easing((r-this.startTime)/q),this.now=this.start+(this.end-this.start)*this.pos,this.update(),f=!0;return f},initPath:function(r,g,f){function u(a){var e,b;for(n=a.length;n--;)e="M"===a[n]||"L"===a[n],b=/[a-zA-Z]/.test(a[n+3]),e&&b&&a.splice(n+1,0,a[n+1],a[n+2],a[n+1],a[n+
2])}function l(a,e){for(;a.length<m;){a[0]=e[m-a.length];var b=a.slice(0,t);[].splice.apply(a,[0,0].concat(b));E&&(b=a.slice(a.length-t),[].splice.apply(a,[a.length,0].concat(b)),n--)}a[0]="M"}function q(a,e){for(var b=(m-a.length)/t;0<b&&b--;)c=a.slice().splice(a.length/z-t,t*z),c[0]=e[m-t-b*t],C&&(c[t-6]=c[t-2],c[t-5]=c[t-1]),[].splice.apply(a,[a.length/z,0].concat(c)),E&&b--}g=g||"";var d,b=r.startX,p=r.endX,C=-1<g.indexOf("C"),t=C?7:3,m,c,n;g=g.split(" ");f=f.slice();var E=r.isArea,z=E?2:1,e;
C&&(u(g),u(f));if(b&&p){for(n=0;n<b.length;n++)if(b[n]===p[0]){d=n;break}else if(b[0]===p[p.length-b.length+n]){d=n;e=!0;break}void 0===d&&(g=[])}g.length&&a.isNumber(d)&&(m=f.length+d*z*t,e?(l(g,f),q(f,g)):(l(f,g),q(g,f)));return[g,f]}};a.extend=function(a,g){var f;a||(a={});for(f in g)a[f]=g[f];return a};a.merge=function(){var r,g=arguments,f,u={},l=function(q,d){var b,p;"object"!==typeof q&&(q={});for(p in d)d.hasOwnProperty(p)&&(b=d[p],a.isObject(b,!0)&&"renderTo"!==p&&"number"!==typeof b.nodeType?
q[p]=l(q[p]||{},b):q[p]=d[p]);return q};!0===g[0]&&(u=g[1],g=Array.prototype.slice.call(g,2));f=g.length;for(r=0;r<f;r++)u=l(u,g[r]);return u};a.pInt=function(a,g){return parseInt(a,g||10)};a.isString=function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(r,g){return r&&"object"===typeof r&&(!g||!a.isArray(r))};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)};a.erase=
function(a,g){for(var f=a.length;f--;)if(a[f]===g){a.splice(f,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(r,g,f){var u,l;if(a.isString(g))a.defined(f)?r.setAttribute(g,f):r&&r.getAttribute&&(l=r.getAttribute(g));else if(a.defined(g)&&a.isObject(g))for(u in g)r.setAttribute(u,g[u]);return l};a.splat=function(r){return a.isArray(r)?r:[r]};a.syncTimeout=function(a,g,f){if(g)return setTimeout(a,g,f);a.call(0,f)};a.pick=function(){var a=arguments,g,f,u=a.length;for(g=
0;g<u;g++)if(f=a[g],void 0!==f&&null!==f)return f};a.css=function(r,g){a.isMS&&!a.svg&&g&&void 0!==g.opacity&&(g.filter="alpha(opacity\x3d"+100*g.opacity+")");a.extend(r.style,g)};a.createElement=function(r,g,f,u,l){r=H.createElement(r);var q=a.css;g&&a.extend(r,g);l&&q(r,{padding:0,border:"none",margin:0});f&&q(r,f);u&&u.appendChild(r);return r};a.extendClass=function(r,g){var f=function(){};f.prototype=new r;a.extend(f.prototype,g);return f};a.pad=function(a,g,f){return Array((g||2)+1-String(a).length).join(f||
0)+a};a.relativeLength=function(a,g){return/%$/.test(a)?g*parseFloat(a)/100:parseFloat(a)};a.wrap=function(a,g,f){var r=a[g];a[g]=function(){var a=Array.prototype.slice.call(arguments),q=arguments,d=this;d.proceed=function(){r.apply(d,arguments.length?arguments:q)};a.unshift(r);a=f.apply(this,a);d.proceed=null;return a}};a.getTZOffset=function(r){var g=a.Date;return 6E4*(g.hcGetTimezoneOffset&&g.hcGetTimezoneOffset(r)||g.hcTimezoneOffset||0)};a.dateFormat=function(r,g,f){if(!a.defined(g)||isNaN(g))return a.defaultOptions.lang.invalidDate||
"";r=a.pick(r,"%Y-%m-%d %H:%M:%S");var u=a.Date,l=new u(g-a.getTZOffset(g)),q,d=l[u.hcGetHours](),b=l[u.hcGetDay](),p=l[u.hcGetDate](),C=l[u.hcGetMonth](),t=l[u.hcGetFullYear](),m=a.defaultOptions.lang,c=m.weekdays,n=m.shortWeekdays,E=a.pad,u=a.extend({a:n?n[b]:c[b].substr(0,3),A:c[b],d:E(p),e:E(p,2," "),w:b,b:m.shortMonths[C],B:m.months[C],m:E(C+1),y:t.toString().substr(2,2),Y:t,H:E(d),k:d,I:E(d%12||12),l:d%12||12,M:E(l[u.hcGetMinutes]()),p:12>d?"AM":"PM",P:12>d?"am":"pm",S:E(l.getSeconds()),L:E(Math.round(g%
1E3),3)},a.dateFormats);for(q in u)for(;-1!==r.indexOf("%"+q);)r=r.replace("%"+q,"function"===typeof u[q]?u[q](g):u[q]);return f?r.substr(0,1).toUpperCase()+r.substr(1):r};a.formatSingle=function(r,g){var f=/\.([0-9])/,u=a.defaultOptions.lang;/f$/.test(r)?(f=(f=r.match(f))?f[1]:-1,null!==g&&(g=a.numberFormat(g,f,u.decimalPoint,-1<r.indexOf(",")?u.thousandsSep:""))):g=a.dateFormat(r,g);return g};a.format=function(r,g){for(var f="{",u=!1,l,q,d,b,p=[],C;r;){f=r.indexOf(f);if(-1===f)break;l=r.slice(0,
f);if(u){l=l.split(":");q=l.shift().split(".");b=q.length;C=g;for(d=0;d<b;d++)C=C[q[d]];l.length&&(C=a.formatSingle(l.join(":"),C));p.push(C)}else p.push(l);r=r.slice(f+1);f=(u=!u)?"}":"{"}p.push(r);return p.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(r,g,f,u,l){var q,d=r;f=a.pick(f,1);q=r/f;g||(g=l?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],!1===u&&(1===f?g=a.grep(g,function(a){return 0===a%1}):.1>=f&&(g=[1/f])));
for(u=0;u<g.length&&!(d=g[u],l&&d*f>=r||!l&&q<=(g[u]+(g[u+1]||g[u]))/2);u++);return d=a.correctFloat(d*f,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,g){var f=a.length,r,l;for(l=0;l<f;l++)a[l].safeI=l;a.sort(function(a,d){r=g(a,d);return 0===r?a.safeI-d.safeI:r});for(l=0;l<f;l++)delete a[l].safeI};a.arrayMin=function(a){for(var g=a.length,f=a[0];g--;)a[g]<f&&(f=a[g]);return f};a.arrayMax=function(a){for(var g=a.length,f=a[0];g--;)a[g]>f&&(f=a[g]);return f};a.destroyObjectProperties=
function(a,g){for(var f in a)a[f]&&a[f]!==g&&a[f].destroy&&a[f].destroy(),delete a[f]};a.discardElement=function(r){var g=a.garbageBin;g||(g=a.createElement("div"));r&&g.appendChild(r);g.innerHTML=""};a.correctFloat=function(a,g){return parseFloat(a.toPrecision(g||14))};a.setAnimation=function(r,g){g.renderer.globalAnimation=a.pick(r,g.options.chart.animation,!0)};a.animObject=function(r){return a.isObject(r)?a.merge(r):{duration:r?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,
day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(r,g,f,u){r=+r||0;g=+g;var l=a.defaultOptions.lang,q=(r.toString().split(".")[1]||"").length,d,b;-1===g?g=Math.min(q,20):a.isNumber(g)||(g=2);b=(Math.abs(r)+Math.pow(10,-Math.max(g,q)-1)).toFixed(g);q=String(a.pInt(b));d=3<q.length?q.length%3:0;f=a.pick(f,l.decimalPoint);u=a.pick(u,l.thousandsSep);r=(0>r?"-":"")+(d?q.substr(0,d)+u:"");r+=q.substr(d).replace(/(\d{3})(?=\d)/g,"$1"+u);g&&(r+=f+b.slice(-g));return r};Math.easeInOutSine=
function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(r,g){return"width"===g?Math.min(r.offsetWidth,r.scrollWidth)-a.getStyle(r,"padding-left")-a.getStyle(r,"padding-right"):"height"===g?Math.min(r.offsetHeight,r.scrollHeight)-a.getStyle(r,"padding-top")-a.getStyle(r,"padding-bottom"):(r=G.getComputedStyle(r,void 0))&&a.pInt(r.getPropertyValue(g))};a.inArray=function(a,g){return g.indexOf?g.indexOf(a):[].indexOf.call(g,a)};a.grep=function(a,g){return[].filter.call(a,g)};a.find=function(a,
g){return[].find.call(a,g)};a.map=function(a,g){for(var f=[],u=0,l=a.length;u<l;u++)f[u]=g.call(a[u],a[u],u,a);return f};a.offset=function(a){var g=H.documentElement;a=a.getBoundingClientRect();return{top:a.top+(G.pageYOffset||g.scrollTop)-(g.clientTop||0),left:a.left+(G.pageXOffset||g.scrollLeft)-(g.clientLeft||0)}};a.stop=function(a,g){for(var f=B.length;f--;)B[f].elem!==a||g&&g!==B[f].prop||(B[f].stopped=!0)};a.each=function(a,g,f){return Array.prototype.forEach.call(a,g,f)};a.addEvent=function(r,
g,f){function u(a){a.target=a.srcElement||G;f.call(r,a)}var l=r.hcEvents=r.hcEvents||{};r.addEventListener?r.addEventListener(g,f,!1):r.attachEvent&&(r.hcEventsIE||(r.hcEventsIE={}),r.hcEventsIE[f.toString()]=u,r.attachEvent("on"+g,u));l[g]||(l[g]=[]);l[g].push(f);return function(){a.removeEvent(r,g,f)}};a.removeEvent=function(r,g,f){function u(a,b){r.removeEventListener?r.removeEventListener(a,b,!1):r.attachEvent&&(b=r.hcEventsIE[b.toString()],r.detachEvent("on"+a,b))}function l(){var a,b;if(r.nodeName)for(b in g?
(a={},a[g]=!0):a=d,a)if(d[b])for(a=d[b].length;a--;)u(b,d[b][a])}var q,d=r.hcEvents,b;d&&(g?(q=d[g]||[],f?(b=a.inArray(f,q),-1<b&&(q.splice(b,1),d[g]=q),u(g,f)):(l(),d[g]=[])):(l(),r.hcEvents={}))};a.fireEvent=function(r,g,f,u){var l;l=r.hcEvents;var q,d;f=f||{};if(H.createEvent&&(r.dispatchEvent||r.fireEvent))l=H.createEvent("Events"),l.initEvent(g,!0,!0),a.extend(l,f),r.dispatchEvent?r.dispatchEvent(l):r.fireEvent(g,l);else if(l)for(l=l[g]||[],q=l.length,f.target||a.extend(f,{preventDefault:function(){f.defaultPrevented=
!0},target:r,type:g}),g=0;g<q;g++)(d=l[g])&&!1===d.call(r,f)&&f.preventDefault();u&&!f.defaultPrevented&&u(f)};a.animate=function(r,g,f){var u,l="",q,d,b;a.isObject(f)||(u=arguments,f={duration:u[2],easing:u[3],complete:u[4]});a.isNumber(f.duration)||(f.duration=400);f.easing="function"===typeof f.easing?f.easing:Math[f.easing]||Math.easeInOutSine;f.curAnim=a.merge(g);for(b in g)a.stop(r,b),d=new a.Fx(r,f,b),q=null,"d"===b?(d.paths=d.initPath(r,r.d,g.d),d.toD=g.d,u=0,q=1):r.attr?u=r.attr(b):(u=parseFloat(a.getStyle(r,
b))||0,"opacity"!==b&&(l="px")),q||(q=g[b]),q.match&&q.match("px")&&(q=q.replace(/px/g,"")),d.run(u,q,l)};a.seriesType=function(r,g,f,u,l){var q=a.getOptions(),d=a.seriesTypes;q.plotOptions[r]=a.merge(q.plotOptions[g],f);d[r]=a.extendClass(d[g]||function(){},u);d[r].prototype.type=r;l&&(d[r].prototype.pointClass=a.extendClass(a.Point,l));return d[r]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),g=0;return function(){return"highcharts-"+a+"-"+g++}}();G.jQuery&&(G.jQuery.fn.highcharts=
function(){var r=[].slice.call(arguments);if(this[0])return r[0]?(new (a[a.isString(r[0])?r.shift():"Chart"])(this[0],r[0],r[1]),this):A[a.attr(this[0],"data-highcharts-chart")]});H&&!H.defaultView&&(a.getStyle=function(r,g){var f={width:"clientWidth",height:"clientHeight"}[g];if(r.style[g])return a.pInt(r.style[g]);"opacity"===g&&(g="filter");if(f)return r.style.zoom=1,Math.max(r[f]-2*a.getStyle(r,"padding"),0);r=r.currentStyle[g.replace(/\-(\w)/g,function(a,l){return l.toUpperCase()})];"filter"===
g&&(r=r.replace(/alpha\(opacity=([0-9]+)\)/,function(a,l){return l/100}));return""===r?1:a.pInt(r)});Array.prototype.forEach||(a.each=function(a,g,f){for(var u=0,l=a.length;u<l;u++)if(!1===g.call(f,a[u],u,a))return u});Array.prototype.indexOf||(a.inArray=function(a,g){var f,u=0;if(g)for(f=g.length;u<f;u++)if(g[u]===a)return u;return-1});Array.prototype.filter||(a.grep=function(a,g){for(var f=[],u=0,l=a.length;u<l;u++)g(a[u],u)&&f.push(a[u]);return f});Array.prototype.find||(a.find=function(a,g){var f,
u=a.length;for(f=0;f<u;f++)if(g(a[f],f))return a[f]})})(L);(function(a){var B=a.each,A=a.isNumber,H=a.map,G=a.merge,r=a.pInt;a.Color=function(g){if(!(this instanceof a.Color))return new a.Color(g);this.init(g)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[r(a[1]),r(a[2]),r(a[3]),parseFloat(a[4],10)]}},{regex:/#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})/,parse:function(a){return[r(a[1],
16),r(a[2],16),r(a[3],16),1]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[r(a[1]),r(a[2]),r(a[3]),1]}}],names:{white:"#ffffff",black:"#000000"},init:function(g){var f,u,l,q;if((this.input=g=this.names[g]||g)&&g.stops)this.stops=H(g.stops,function(d){return new a.Color(d[1])});else for(l=this.parsers.length;l--&&!u;)q=this.parsers[l],(f=q.regex.exec(g))&&(u=q.parse(f));this.rgba=u||[]},get:function(a){var f=this.input,g=this.rgba,l;this.stops?
(l=G(f),l.stops=[].concat(l.stops),B(this.stops,function(f,d){l.stops[d]=[l.stops[d][0],f.get(a)]})):l=g&&A(g[0])?"rgb"===a||!a&&1===g[3]?"rgb("+g[0]+","+g[1]+","+g[2]+")":"a"===a?g[3]:"rgba("+g.join(",")+")":f;return l},brighten:function(a){var f,g=this.rgba;if(this.stops)B(this.stops,function(l){l.brighten(a)});else if(A(a)&&0!==a)for(f=0;3>f;f++)g[f]+=r(255*a),0>g[f]&&(g[f]=0),255<g[f]&&(g[f]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this}};a.color=function(g){return new a.Color(g)}})(L);
(function(a){var B,A,H=a.addEvent,G=a.animate,r=a.attr,g=a.charts,f=a.color,u=a.css,l=a.createElement,q=a.defined,d=a.deg2rad,b=a.destroyObjectProperties,p=a.doc,C=a.each,t=a.extend,m=a.erase,c=a.grep,n=a.hasTouch,E=a.inArray,z=a.isArray,e=a.isFirefox,x=a.isMS,F=a.isObject,w=a.isString,h=a.isWebKit,y=a.merge,J=a.noop,K=a.pick,I=a.pInt,k=a.removeEvent,D=a.stop,P=a.svg,N=a.SVG_NS,S=a.symbolSizes,O=a.win;B=a.SVGElement=function(){return this};B.prototype={opacity:1,SVG_NS:N,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textDecoration textOverflow textOutline".split(" "),
init:function(a,k){this.element="span"===k?l(k):p.createElementNS(this.SVG_NS,k);this.renderer=a},animate:function(v,k,e){k=a.animObject(K(k,this.renderer.globalAnimation,!0));0!==k.duration?(e&&(k.complete=e),G(this,v,k)):this.attr(v,null,e);return this},colorGradient:function(v,k,e){var b=this.renderer,h,D,c,x,M,m,n,d,F,t,p,w=[],l;v.linearGradient?D="linearGradient":v.radialGradient&&(D="radialGradient");if(D){c=v[D];M=b.gradients;n=v.stops;t=e.radialReference;z(c)&&(v[D]=c={x1:c[0],y1:c[1],x2:c[2],
y2:c[3],gradientUnits:"userSpaceOnUse"});"radialGradient"===D&&t&&!q(c.gradientUnits)&&(x=c,c=y(c,b.getRadialAttr(t,x),{gradientUnits:"userSpaceOnUse"}));for(p in c)"id"!==p&&w.push(p,c[p]);for(p in n)w.push(n[p]);w=w.join(",");M[w]?t=M[w].attr("id"):(c.id=t=a.uniqueKey(),M[w]=m=b.createElement(D).attr(c).add(b.defs),m.radAttr=x,m.stops=[],C(n,function(v){0===v[1].indexOf("rgba")?(h=a.color(v[1]),d=h.get("rgb"),F=h.get("a")):(d=v[1],F=1);v=b.createElement("stop").attr({offset:v[0],"stop-color":d,
"stop-opacity":F}).add(m);m.stops.push(v)}));l="url("+b.url+"#"+t+")";e.setAttribute(k,l);e.gradient=w;v.toString=function(){return l}}},applyTextOutline:function(a){var v=this.element,k,e,b,c;-1!==a.indexOf("contrast")&&(a=a.replace(/contrast/g,this.renderer.getContrast(v.style.fill)));this.fakeTS=!0;this.ySetter=this.xSetter;k=[].slice.call(v.getElementsByTagName("tspan"));a=a.split(" ");e=a[a.length-1];(b=a[0])&&"none"!==b&&(b=b.replace(/(^[\d\.]+)(.*?)$/g,function(a,v,k){return 2*v+k}),C(k,function(a){"highcharts-text-outline"===
a.getAttribute("class")&&m(k,v.removeChild(a))}),c=v.firstChild,C(k,function(a,k){0===k&&(a.setAttribute("x",v.getAttribute("x")),k=v.getAttribute("y"),a.setAttribute("y",k||0),null===k&&v.setAttribute("y",0));a=a.cloneNode(1);r(a,{"class":"highcharts-text-outline",fill:e,stroke:e,"stroke-width":b,"stroke-linejoin":"round"});v.insertBefore(a,c)}))},attr:function(a,k,e,b){var v,c=this.element,h,x=this,M;"string"===typeof a&&void 0!==k&&(v=a,a={},a[v]=k);if("string"===typeof a)x=(this[a+"Getter"]||
this._defaultGetter).call(this,a,c);else{for(v in a)k=a[v],M=!1,b||D(this,v),this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)/.test(v)&&(h||(this.symbolAttr(a),h=!0),M=!0),!this.rotation||"x"!==v&&"y"!==v||(this.doTransform=!0),M||(M=this[v+"Setter"]||this._defaultSetter,M.call(this,k,v,c),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(v)&&this.updateShadows(v,k,M));this.doTransform&&(this.updateTransform(),this.doTransform=!1)}e&&e();return x},updateShadows:function(a,
k,e){for(var v=this.shadows,b=v.length;b--;)e.call(v[b],"height"===a?Math.max(k-(v[b].cutHeight||0),0):"d"===a?this.d:k,a,v[b])},addClass:function(a,k){var v=this.attr("class")||"";-1===v.indexOf(a)&&(k||(a=(v+(v?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==r(this.element,"class").indexOf(a)},removeClass:function(a){r(this.element,"class",(r(this.element,"class")||"").replace(a,""));return this},symbolAttr:function(a){var v=this;C("x y r start end width height innerR anchorX anchorY".split(" "),
function(k){v[k]=K(a[k],v[k])});v.attr({d:v.renderer.symbols[v.symbolName](v.x,v.y,v.width,v.height,v)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,k){var v,e={},b;k=k||a.strokeWidth||0;b=Math.round(k)%2/2;a.x=Math.floor(a.x||this.x||0)+b;a.y=Math.floor(a.y||this.y||0)+b;a.width=Math.floor((a.width||this.width||0)-2*b);a.height=Math.floor((a.height||this.height||0)-2*b);q(a.strokeWidth)&&(a.strokeWidth=k);for(v in a)this[v]!==a[v]&&
(this[v]=e[v]=a[v]);return e},css:function(a){var v=this.styles,k={},e=this.element,b,c,h="";b=!v;var D=["textOverflow","width"];a&&a.color&&(a.fill=a.color);if(v)for(c in a)a[c]!==v[c]&&(k[c]=a[c],b=!0);if(b){b=this.textWidth=a&&a.width&&"text"===e.nodeName.toLowerCase()&&I(a.width)||this.textWidth;v&&(a=t(v,k));this.styles=a;b&&!P&&this.renderer.forExport&&delete a.width;if(x&&!P)u(this.element,a);else{v=function(a,v){return"-"+v.toLowerCase()};for(c in a)-1===E(c,D)&&(h+=c.replace(/([A-Z])/g,v)+
":"+a[c]+";");h&&r(e,"style",h)}this.added&&(b&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline))}return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,k){var v=this,e=v.element;n&&"click"===a?(e.ontouchstart=function(a){v.touchEventFired=Date.now();a.preventDefault();k.call(e,a)},e.onclick=function(a){(-1===O.navigator.userAgent.indexOf("Android")||1100<Date.now()-(v.touchEventFired||0))&&k.call(e,a)}):e["on"+a]=k;return this},setRadialReference:function(a){var v=
this.renderer.gradients[this.element.gradient];this.element.radialReference=a;v&&v.radAttr&&v.animate(this.renderer.getRadialAttr(a,v.radAttr));return this},translate:function(a,k){return this.attr({translateX:a,translateY:k})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,k=this.translateY||0,e=this.scaleX,b=this.scaleY,c=this.inverted,h=this.rotation,D=this.element;c&&(a+=this.width,k+=this.height);a=["translate("+a+","+
k+")"];c?a.push("rotate(90) scale(-1,1)"):h&&a.push("rotate("+h+" "+(D.getAttribute("x")||0)+" "+(D.getAttribute("y")||0)+")");(q(e)||q(b))&&a.push("scale("+K(e,1)+" "+K(b,1)+")");a.length&&D.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);return this},align:function(a,k,e){var v,b,c,h,D={};b=this.renderer;c=b.alignedObjects;var x,y;if(a){if(this.alignOptions=a,this.alignByTranslate=k,!e||w(e))this.alignTo=v=e||"renderer",m(c,this),c.push(this),
e=null}else a=this.alignOptions,k=this.alignByTranslate,v=this.alignTo;e=K(e,b[v],b);v=a.align;b=a.verticalAlign;c=(e.x||0)+(a.x||0);h=(e.y||0)+(a.y||0);"right"===v?x=1:"center"===v&&(x=2);x&&(c+=(e.width-(a.width||0))/x);D[k?"translateX":"x"]=Math.round(c);"bottom"===b?y=1:"middle"===b&&(y=2);y&&(h+=(e.height-(a.height||0))/y);D[k?"translateY":"y"]=Math.round(h);this[this.placed?"animate":"attr"](D);this.placed=!0;this.alignAttr=D;return this},getBBox:function(a,k){var v,e=this.renderer,b,c=this.element,
h=this.styles,D,x=this.textStr,m,y=e.cache,n=e.cacheKeys,F;k=K(k,this.rotation);b=k*d;D=h&&h.fontSize;void 0!==x&&(F=x.toString(),-1===F.indexOf("\x3c")&&(F=F.replace(/[0-9]/g,"0")),F+=["",k||0,D,h&&h.width,h&&h.textOverflow].join());F&&!a&&(v=y[F]);if(!v){if(c.namespaceURI===this.SVG_NS||e.forExport){try{(m=this.fakeTS&&function(a){C(c.querySelectorAll(".highcharts-text-outline"),function(v){v.style.display=a})})&&m("none"),v=c.getBBox?t({},c.getBBox()):{width:c.offsetWidth,height:c.offsetHeight},
m&&m("")}catch(W){}if(!v||0>v.width)v={width:0,height:0}}else v=this.htmlGetBBox();e.isSVG&&(a=v.width,e=v.height,h&&"11px"===h.fontSize&&17===Math.round(e)&&(v.height=e=14),k&&(v.width=Math.abs(e*Math.sin(b))+Math.abs(a*Math.cos(b)),v.height=Math.abs(e*Math.cos(b))+Math.abs(a*Math.sin(b))));if(F&&0<v.height){for(;250<n.length;)delete y[n.shift()];y[F]||n.push(F);y[F]=v}}return v},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},
fadeOut:function(a){var v=this;v.animate({opacity:0},{duration:a||150,complete:function(){v.attr({y:-9999})}})},add:function(a){var v=this.renderer,k=this.element,e;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&v.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)e=this.zIndexSetter();e||(a?a.element:v.box).appendChild(k);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var v=a.parentNode;v&&v.removeChild(a)},destroy:function(){var a=
this.element||{},k=this.renderer.isSVG&&"SPAN"===a.nodeName&&this.parentGroup,e,b;a.onclick=a.onmouseout=a.onmouseover=a.onmousemove=a.point=null;D(this);this.clipPath&&(this.clipPath=this.clipPath.destroy());if(this.stops){for(b=0;b<this.stops.length;b++)this.stops[b]=this.stops[b].destroy();this.stops=null}this.safeRemoveChild(a);for(this.destroyShadows();k&&k.div&&0===k.div.childNodes.length;)a=k.parentGroup,this.safeRemoveChild(k.div),delete k.div,k=a;this.alignTo&&m(this.renderer.alignedObjects,
this);for(e in this)delete this[e];return null},shadow:function(a,k,e){var v=[],b,c,h=this.element,D,x,m,y;if(!a)this.destroyShadows();else if(!this.shadows){x=K(a.width,3);m=(a.opacity||.15)/x;y=this.parentInverted?"(-1,-1)":"("+K(a.offsetX,1)+", "+K(a.offsetY,1)+")";for(b=1;b<=x;b++)c=h.cloneNode(0),D=2*x+1-2*b,r(c,{isShadow:"true",stroke:a.color||"#000000","stroke-opacity":m*b,"stroke-width":D,transform:"translate"+y,fill:"none"}),e&&(r(c,"height",Math.max(r(c,"height")-D,0)),c.cutHeight=D),k?
k.element.appendChild(c):h.parentNode.insertBefore(c,h),v.push(c);this.shadows=v}return this},destroyShadows:function(){C(this.shadows||[],function(a){this.safeRemoveChild(a)},this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=K(this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,k,e){a&&a.join&&(a=
a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");e.setAttribute(k,a);this[k]=a},dashstyleSetter:function(a){var v,k=this["stroke-width"];"inherit"===k&&(k=1);if(a=a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(v=a.length;v--;)a[v]=I(a[v])*k;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",
a)}},alignSetter:function(a){this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,k,e){this[k]=a;e.setAttribute(k,a)},titleSetter:function(a){var v=this.element.getElementsByTagName("title")[0];v||(v=p.createElementNS(this.SVG_NS,"title"),this.element.appendChild(v));v.firstChild&&v.removeChild(v.firstChild);v.appendChild(p.createTextNode(String(K(a),"").replace(/<[^>]*>/g,"")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,
this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,k,e){"string"===typeof a?e.setAttribute(k,a):a&&this.colorGradient(a,k,e)},visibilitySetter:function(a,k,e){"inherit"===a?e.removeAttribute(k):e.setAttribute(k,a)},zIndexSetter:function(a,k){var v=this.renderer,e=this.parentGroup,b=(e||v).element||v.box,c,h=this.element,D;c=this.added;var x;q(a)&&(h.zIndex=a,a=+a,this[k]===a&&(c=!1),this[k]=a);if(c){(a=this.zIndex)&&e&&(e.handleZ=!0);k=b.childNodes;for(x=0;x<k.length&&
!D;x++)e=k[x],c=e.zIndex,e!==h&&(I(c)>a||!q(a)&&q(c)||0>a&&!q(c)&&b!==v.box)&&(b.insertBefore(h,e),D=!0);D||b.appendChild(h)}return D},_defaultSetter:function(a,k,e){e.setAttribute(k,a)}};B.prototype.yGetter=B.prototype.xGetter;B.prototype.translateXSetter=B.prototype.translateYSetter=B.prototype.rotationSetter=B.prototype.verticalAlignSetter=B.prototype.scaleXSetter=B.prototype.scaleYSetter=function(a,k){this[k]=a;this.doTransform=!0};B.prototype["stroke-widthSetter"]=B.prototype.strokeSetter=function(a,
k,e){this[k]=a;this.stroke&&this["stroke-width"]?(B.prototype.fillSetter.call(this,this.stroke,"stroke",e),e.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===k&&0===a&&this.hasStroke&&(e.removeAttribute("stroke"),this.hasStroke=!1)};A=a.SVGRenderer=function(){this.init.apply(this,arguments)};A.prototype={Element:B,SVG_NS:N,init:function(a,k,b,c,D,x){var v;c=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"}).css(this.getStyle(c));v=c.element;
a.appendChild(v);-1===a.innerHTML.indexOf("xmlns")&&r(v,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=v;this.boxWrapper=c;this.alignedObjects=[];this.url=(e||h)&&p.getElementsByTagName("base").length?O.location.href.replace(/#.*?$/,"").replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(p.createTextNode("Created with Highcharts 5.0.7"));this.defs=this.createElement("defs").add();this.allowHTML=x;this.forExport=D;this.gradients=
{};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(k,b,!1);var m;e&&a.getBoundingClientRect&&(k=function(){u(a,{left:0,top:0});m=a.getBoundingClientRect();u(a,{left:Math.ceil(m.left)-m.left+"px",top:Math.ceil(m.top)-m.top+"px"})},k(),this.unSubPixelFix=H(O,"resize",k))},getStyle:function(a){return this.style=t({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},
destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();b(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var k=new this.Element;k.init(this,a);return k},draw:J,getRadialAttr:function(a,k){return{cx:a[0]-a[2]/2+k.cx*a[2],cy:a[1]-a[2]/2+k.cy*a[2],r:k.r*a[2]}},buildText:function(a){var k=a.element,v=this,e=v.forExport,b=K(a.textStr,"").toString(),
h=-1!==b.indexOf("\x3c"),D=k.childNodes,x,m,y,n,F=r(k,"x"),d=a.styles,t=a.textWidth,w=d&&d.lineHeight,l=d&&d.textOutline,z=d&&"ellipsis"===d.textOverflow,f=d&&"nowrap"===d.whiteSpace,E=d&&d.fontSize,q,g=D.length,d=t&&!a.added&&this.box,J=function(a){var e;e=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:E||v.style.fontSize||12;return w?I(w):v.fontMetrics(e,a.getAttribute("style")?a:k).h};q=[b,z,f,w,l,E,t].join();if(q!==a.textCache){for(a.textCache=q;g--;)k.removeChild(D[g]);h||l||z||t||-1!==
b.indexOf(" ")?(x=/<.*class="([^"]+)".*>/,m=/<.*style="([^"]+)".*>/,y=/<.*href="(http[^"]+)".*>/,d&&d.appendChild(k),b=h?b.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[b],b=c(b,function(a){return""!==a}),C(b,function(b,c){var h,D=0;b=b.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");
h=b.split("|||");C(h,function(b){if(""!==b||1===h.length){var d={},w=p.createElementNS(v.SVG_NS,"tspan"),l,E;x.test(b)&&(l=b.match(x)[1],r(w,"class",l));m.test(b)&&(E=b.match(m)[1].replace(/(;| |^)color([ :])/,"$1fill$2"),r(w,"style",E));y.test(b)&&!e&&(r(w,"onclick",'location.href\x3d"'+b.match(y)[1]+'"'),u(w,{cursor:"pointer"}));b=(b.replace(/<(.|\n)*?>/g,"")||" ").replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e");if(" "!==b){w.appendChild(p.createTextNode(b));D?d.dx=0:c&&null!==F&&(d.x=F);r(w,d);
k.appendChild(w);!D&&c&&(!P&&e&&u(w,{display:"block"}),r(w,"dy",J(w)));if(t){d=b.replace(/([^\^])-/g,"$1- ").split(" ");l=1<h.length||c||1<d.length&&!f;for(var q,g,M=[],C=J(w),K=a.rotation,I=b,Q=I.length;(l||z)&&(d.length||M.length);)a.rotation=0,q=a.getBBox(!0),g=q.width,!P&&v.forExport&&(g=v.measureSpanWidth(w.firstChild.data,a.styles)),q=g>t,void 0===n&&(n=q),z&&n?(Q/=2,""===I||!q&&.5>Q?d=[]:(I=b.substring(0,I.length+(q?-1:1)*Math.ceil(Q)),d=[I+(3<t?"\u2026":"")],w.removeChild(w.firstChild))):
q&&1!==d.length?(w.removeChild(w.firstChild),M.unshift(d.pop())):(d=M,M=[],d.length&&!f&&(w=p.createElementNS(N,"tspan"),r(w,{dy:C,x:F}),E&&r(w,"style",E),k.appendChild(w)),g>t&&(t=g)),d.length&&w.appendChild(p.createTextNode(d.join(" ").replace(/- /g,"-")));a.rotation=K}D++}}})}),n&&a.attr("title",a.textStr),d&&d.removeChild(k),l&&a.applyTextOutline&&a.applyTextOutline(l)):k.appendChild(p.createTextNode(b.replace(/&lt;/g,"\x3c").replace(/&gt;/g,"\x3e")))}},getContrast:function(a){a=f(a).rgba;return 510<
a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,k,e,b,c,h,D,m,d){var v=this.label(a,k,e,d,null,null,null,null,"button"),n=0;v.attr(y({padding:8,r:2},c));var F,w,p,l;c=y({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},c);F=c.style;delete c.style;h=y(c,{fill:"#e6e6e6"},h);w=h.style;delete h.style;D=y(c,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},D);p=D.style;delete D.style;m=y(c,{style:{color:"#cccccc"}},m);l=m.style;
delete m.style;H(v.element,x?"mouseover":"mouseenter",function(){3!==n&&v.setState(1)});H(v.element,x?"mouseout":"mouseleave",function(){3!==n&&v.setState(n)});v.setState=function(a){1!==a&&(v.state=n=a);v.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);v.attr([c,h,D,m][a||0]).css([F,w,p,l][a||0])};v.attr(c).css(t({cursor:"default"},F));return v.on("click",function(a){3!==n&&b.call(v,a)})},crispLine:function(a,
k){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-k%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+k%2/2);return a},path:function(a){var k={fill:"none"};z(a)?k.d=a:F(a)&&t(k,a);return this.createElement("path").attr(k)},circle:function(a,k,e){a=F(a)?a:{x:a,y:k,r:e};k=this.createElement("circle");k.xSetter=k.ySetter=function(a,k,e){e.setAttribute("c"+k,a)};return k.attr(a)},arc:function(a,k,e,b,c,h){F(a)&&(k=a.y,e=a.r,b=a.innerR,c=a.start,h=a.end,a=a.x);a=this.symbol("arc",a||0,k||0,e||0,e||0,{innerR:b||
0,start:c||0,end:h||0});a.r=e;return a},rect:function(a,k,e,b,c,h){c=F(a)?a.r:c;var v=this.createElement("rect");a=F(a)?a:void 0===a?{}:{x:a,y:k,width:Math.max(e,0),height:Math.max(b,0)};void 0!==h&&(a.strokeWidth=h,a=v.crisp(a));a.fill="none";c&&(a.r=c);v.rSetter=function(a,k,e){r(e,{rx:a,ry:a})};return v.attr(a)},setSize:function(a,k,e){var b=this.alignedObjects,v=b.length;this.width=a;this.height=k;for(this.boxWrapper.animate({width:a,height:k},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+
" "+this.attr("height")})},duration:K(e,!0)?void 0:0});v--;)b[v].align()},g:function(a){var k=this.createElement("g");return a?k.attr({"class":"highcharts-"+a}):k},image:function(a,k,e,b,c){var v={preserveAspectRatio:"none"};1<arguments.length&&t(v,{x:k,y:e,width:b,height:c});v=this.createElement("image").attr(v);v.element.setAttributeNS?v.element.setAttributeNS("http://www.w3.org/1999/xlink","href",a):v.element.setAttribute("hc-svg-href",a);return v},symbol:function(a,k,e,b,c,h){var v=this,D,x=this.symbols[a],
m=q(k)&&x&&this.symbols[a](Math.round(k),Math.round(e),b,c,h),y=/^url\((.*?)\)$/,d,n;x?(D=this.path(m),D.attr("fill","none"),t(D,{symbolName:a,x:k,y:e,width:b,height:c}),h&&t(D,h)):y.test(a)&&(d=a.match(y)[1],D=this.image(d),D.imgwidth=K(S[d]&&S[d].width,h&&h.width),D.imgheight=K(S[d]&&S[d].height,h&&h.height),n=function(){D.attr({width:D.width,height:D.height})},C(["width","height"],function(a){D[a+"Setter"]=function(a,k){var e={},b=this["img"+k],v="width"===k?"translateX":"translateY";this[k]=a;
q(b)&&(this.element&&this.element.setAttribute(k,b),this.alignByTranslate||(e[v]=((this[k]||0)-b)/2,this.attr(e)))}}),q(k)&&D.attr({x:k,y:e}),D.isImg=!0,q(D.imgwidth)&&q(D.imgheight)?n():(D.attr({width:0,height:0}),l("img",{onload:function(){var a=g[v.chartIndex];0===this.width&&(u(this,{position:"absolute",top:"-999em"}),p.body.appendChild(this));S[d]={width:this.width,height:this.height};D.imgwidth=this.width;D.imgheight=this.height;D.element&&n();this.parentNode&&this.parentNode.removeChild(this);
v.imgCount--;if(!v.imgCount&&a&&a.onload)a.onload()},src:d}),this.imgCount++));return D},symbols:{circle:function(a,k,e,b){return this.arc(a+e/2,k+b/2,e/2,b/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,k,e,b){return["M",a,k,"L",a+e,k,a+e,k+b,a,k+b,"Z"]},triangle:function(a,k,e,b){return["M",a+e/2,k,"L",a+e,k+b,a,k+b,"Z"]},"triangle-down":function(a,k,e,b){return["M",a,k,"L",a+e,k,a+e/2,k+b,"Z"]},diamond:function(a,k,e,b){return["M",a+e/2,k,"L",a+e,k+b/2,a+e/2,k+b,a,k+b/2,"Z"]},arc:function(a,
k,e,b,c){var v=c.start,h=c.r||e,D=c.r||b||e,x=c.end-.001;e=c.innerR;b=c.open;var m=Math.cos(v),d=Math.sin(v),y=Math.cos(x),x=Math.sin(x);c=c.end-v<Math.PI?0:1;h=["M",a+h*m,k+D*d,"A",h,D,0,c,1,a+h*y,k+D*x];q(e)&&h.push(b?"M":"L",a+e*y,k+e*x,"A",e,e,0,c,0,a+e*m,k+e*d);h.push(b?"":"Z");return h},callout:function(a,k,e,b,c){var h=Math.min(c&&c.r||0,e,b),D=h+6,v=c&&c.anchorX;c=c&&c.anchorY;var x;x=["M",a+h,k,"L",a+e-h,k,"C",a+e,k,a+e,k,a+e,k+h,"L",a+e,k+b-h,"C",a+e,k+b,a+e,k+b,a+e-h,k+b,"L",a+h,k+b,"C",
a,k+b,a,k+b,a,k+b-h,"L",a,k+h,"C",a,k,a,k,a+h,k];v&&v>e?c>k+D&&c<k+b-D?x.splice(13,3,"L",a+e,c-6,a+e+6,c,a+e,c+6,a+e,k+b-h):x.splice(13,3,"L",a+e,b/2,v,c,a+e,b/2,a+e,k+b-h):v&&0>v?c>k+D&&c<k+b-D?x.splice(33,3,"L",a,c+6,a-6,c,a,c-6,a,k+h):x.splice(33,3,"L",a,b/2,v,c,a,b/2,a,k+h):c&&c>b&&v>a+D&&v<a+e-D?x.splice(23,3,"L",v+6,k+b,v,k+b+6,v-6,k+b,a+h,k+b):c&&0>c&&v>a+D&&v<a+e-D&&x.splice(3,3,"L",v-6,k,v,k-6,v+6,k,e-h,k);return x}},clipRect:function(k,e,b,c){var h=a.uniqueKey(),D=this.createElement("clipPath").attr({id:h}).add(this.defs);
k=this.rect(k,e,b,c,0).add(D);k.id=h;k.clipPath=D;k.count=0;return k},text:function(a,k,e,b){var c=!P&&this.forExport,h={};if(b&&(this.allowHTML||!this.forExport))return this.html(a,k,e);h.x=Math.round(k||0);e&&(h.y=Math.round(e));if(a||0===a)h.text=a;a=this.createElement("text").attr(h);c&&a.css({position:"absolute"});b||(a.xSetter=function(a,k,e){var b=e.getElementsByTagName("tspan"),c,h=e.getAttribute(k),D;for(D=0;D<b.length;D++)c=b[D],c.getAttribute(k)===h&&c.setAttribute(k,a);e.setAttribute(k,
a)});return a},fontMetrics:function(a,k){a=a||k&&k.style&&k.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?I(a):/em/.test(a)?parseFloat(a)*(k?this.fontMetrics(null,k.parentNode).f:16):12;k=24>a?a+3:Math.round(1.2*a);return{h:k,b:Math.round(.8*k),f:a}},rotCorr:function(a,k,e){var b=a;k&&e&&(b=Math.max(b*Math.cos(k*d),4));return{x:-a/3*Math.sin(k*d),y:b}},label:function(a,e,b,c,h,D,x,m,d){var v=this,n=v.g("button"!==d&&"label"),F=n.text=v.text("",0,0,x).attr({zIndex:1}),w,p,l=0,z=3,
E=0,f,g,J,K,P,N={},I,u,r=/^url\((.*?)\)$/.test(c),M=r,S,Q,R,O;d&&n.addClass("highcharts-"+d);M=r;S=function(){return(I||0)%2/2};Q=function(){var a=F.element.style,k={};p=(void 0===f||void 0===g||P)&&q(F.textStr)&&F.getBBox();n.width=(f||p.width||0)+2*z+E;n.height=(g||p.height||0)+2*z;u=z+v.fontMetrics(a&&a.fontSize,F).b;M&&(w||(n.box=w=v.symbols[c]||r?v.symbol(c):v.rect(),w.addClass(("button"===d?"":"highcharts-label-box")+(d?" highcharts-"+d+"-box":"")),w.add(n),a=S(),k.x=a,k.y=(m?-u:0)+a),k.width=
Math.round(n.width),k.height=Math.round(n.height),w.attr(t(k,N)),N={})};R=function(){var a=E+z,k;k=m?0:u;q(f)&&p&&("center"===P||"right"===P)&&(a+={center:.5,right:1}[P]*(f-p.width));if(a!==F.x||k!==F.y)F.attr("x",a),void 0!==k&&F.attr("y",k);F.x=a;F.y=k};O=function(a,k){w?w.attr(a,k):N[a]=k};n.onAdd=function(){F.add(n);n.attr({text:a||0===a?a:"",x:e,y:b});w&&q(h)&&n.attr({anchorX:h,anchorY:D})};n.widthSetter=function(a){f=a};n.heightSetter=function(a){g=a};n["text-alignSetter"]=function(a){P=a};
n.paddingSetter=function(a){q(a)&&a!==z&&(z=n.padding=a,R())};n.paddingLeftSetter=function(a){q(a)&&a!==E&&(E=a,R())};n.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==l&&(l=a,p&&n.attr({x:J}))};n.textSetter=function(a){void 0!==a&&F.textSetter(a);Q();R()};n["stroke-widthSetter"]=function(a,k){a&&(M=!0);I=this["stroke-width"]=a;O(k,a)};n.strokeSetter=n.fillSetter=n.rSetter=function(a,k){"fill"===k&&a&&(M=!0);O(k,a)};n.anchorXSetter=function(a,k){h=a;O(k,Math.round(a)-S()-J)};n.anchorYSetter=
function(a,k){D=a;O(k,a-K)};n.xSetter=function(a){n.x=a;l&&(a-=l*((f||p.width)+2*z));J=Math.round(a);n.attr("translateX",J)};n.ySetter=function(a){K=n.y=Math.round(a);n.attr("translateY",K)};var V=n.css;return t(n,{css:function(a){if(a){var k={};a=y(a);C(n.textProps,function(e){void 0!==a[e]&&(k[e]=a[e],delete a[e])});F.css(k)}return V.call(n,a)},getBBox:function(){return{width:p.width+2*z,height:p.height+2*z,x:p.x-z,y:p.y-z}},shadow:function(a){a&&(Q(),w&&w.shadow(a));return n},destroy:function(){k(n.element,
"mouseenter");k(n.element,"mouseleave");F&&(F=F.destroy());w&&(w=w.destroy());B.prototype.destroy.call(n);n=v=Q=R=O=null}})}};a.Renderer=A})(L);(function(a){var B=a.attr,A=a.createElement,H=a.css,G=a.defined,r=a.each,g=a.extend,f=a.isFirefox,u=a.isMS,l=a.isWebKit,q=a.pInt,d=a.SVGRenderer,b=a.win,p=a.wrap;g(a.SVGElement.prototype,{htmlCss:function(a){var b=this.element;if(b=a&&"SPAN"===b.tagName&&a.width)delete a.width,this.textWidth=b,this.updateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace=
"nowrap",a.overflow="hidden");this.styles=g(this.styles,a);H(this.element,a);return this},htmlGetBBox:function(){var a=this.element;"text"===a.nodeName&&(a.style.position="absolute");return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,b=this.element,m=this.translateX||0,c=this.translateY||0,n=this.x||0,d=this.y||0,p=this.textAlign||"left",e={left:0,center:.5,right:1}[p],x=this.styles;H(b,{marginLeft:m,marginTop:c});
this.shadows&&r(this.shadows,function(a){H(a,{marginLeft:m+1,marginTop:c+1})});this.inverted&&r(b.childNodes,function(e){a.invertChild(e,b)});if("SPAN"===b.tagName){var F=this.rotation,w=q(this.textWidth),h=x&&x.whiteSpace,y=[F,p,b.innerHTML,this.textWidth,this.textAlign].join();y!==this.cTT&&(x=a.fontMetrics(b.style.fontSize).b,G(F)&&this.setSpanRotation(F,e,x),H(b,{width:"",whiteSpace:h||"nowrap"}),b.offsetWidth>w&&/[ \-]/.test(b.textContent||b.innerText)&&H(b,{width:w+"px",display:"block",whiteSpace:h||
"normal"}),this.getSpanCorrection(b.offsetWidth,x,e,F,p));H(b,{left:n+(this.xCorr||0)+"px",top:d+(this.yCorr||0)+"px"});l&&(x=b.offsetHeight);this.cTT=y}}else this.alignOnAdd=!0},setSpanRotation:function(a,d,m){var c={},n=u?"-ms-transform":l?"-webkit-transform":f?"MozTransform":b.opera?"-o-transform":"";c[n]=c.transform="rotate("+a+"deg)";c[n+(f?"Origin":"-origin")]=c.transformOrigin=100*d+"% "+m+"px";H(this.element,c)},getSpanCorrection:function(a,b,m){this.xCorr=-a*m;this.yCorr=-b}});g(d.prototype,
{html:function(a,b,m){var c=this.createElement("span"),n=c.element,d=c.renderer,l=d.isSVG,e=function(a,e){r(["opacity","visibility"],function(b){p(a,b+"Setter",function(a,b,c,x){a.call(this,b,c,x);e[c]=b})})};c.textSetter=function(a){a!==n.innerHTML&&delete this.bBox;n.innerHTML=this.textStr=a;c.htmlUpdateTransform()};l&&e(c,c.element.style);c.xSetter=c.ySetter=c.alignSetter=c.rotationSetter=function(a,e){"align"===e&&(e="textAlign");c[e]=a;c.htmlUpdateTransform()};c.attr({text:a,x:Math.round(b),
y:Math.round(m)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});n.style.whiteSpace="nowrap";c.css=c.htmlCss;l&&(c.add=function(a){var b,x=d.box.parentNode,h=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)h.push(a),a=a.parentGroup;r(h.reverse(),function(a){var n,m=B(a.element,"class");m&&(m={className:m});b=a.div=a.div||A("div",m,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&
a.styles.pointerEvents},b||x);n=b.style;g(a,{on:function(){c.on.apply({element:h[0].div},arguments);return a},translateXSetter:function(e,k){n.left=e+"px";a[k]=e;a.doTransform=!0},translateYSetter:function(e,k){n.top=e+"px";a[k]=e;a.doTransform=!0}});e(a,n)})}}else b=x;b.appendChild(n);c.added=!0;c.alignOnAdd&&c.htmlUpdateTransform();return c});return c}})})(L);(function(a){var B,A,H=a.createElement,G=a.css,r=a.defined,g=a.deg2rad,f=a.discardElement,u=a.doc,l=a.each,q=a.erase,d=a.extend;B=a.extendClass;
var b=a.isArray,p=a.isNumber,C=a.isObject,t=a.merge;A=a.noop;var m=a.pick,c=a.pInt,n=a.SVGElement,E=a.SVGRenderer,z=a.win;a.svg||(A={docMode8:u&&8===u.documentMode,init:function(a,b){var e=["\x3c",b,' filled\x3d"f" stroked\x3d"f"'],c=["position: ","absolute",";"],h="div"===b;("shape"===b||h)&&c.push("left:0;top:0;width:1px;height:1px;");c.push("visibility: ",h?"hidden":"visible");e.push(' style\x3d"',c.join(""),'"/\x3e');b&&(e=h||"span"===b||"img"===b?e.join(""):a.prepVML(e),this.element=H(e));this.renderer=
a},add:function(a){var e=this.renderer,b=this.element,c=e.box,h=a&&a.inverted,c=a?a.element||a:c;a&&(this.parentGroup=a);h&&e.invertChild(b,c);c.appendChild(b);this.added=!0;this.alignOnAdd&&!this.deferUpdateTransform&&this.updateTransform();if(this.onAdd)this.onAdd();this.className&&this.attr("class",this.className);return this},updateTransform:n.prototype.htmlUpdateTransform,setSpanRotation:function(){var a=this.rotation,b=Math.cos(a*g),c=Math.sin(a*g);G(this.element,{filter:a?["progid:DXImageTransform.Microsoft.Matrix(M11\x3d",
b,", M12\x3d",-c,", M21\x3d",c,", M22\x3d",b,", sizingMethod\x3d'auto expand')"].join(""):"none"})},getSpanCorrection:function(a,b,c,n,h){var e=n?Math.cos(n*g):1,x=n?Math.sin(n*g):0,d=m(this.elemHeight,this.element.offsetHeight),F;this.xCorr=0>e&&-a;this.yCorr=0>x&&-d;F=0>e*x;this.xCorr+=x*b*(F?1-c:c);this.yCorr-=e*b*(n?F?c:1-c:1);h&&"left"!==h&&(this.xCorr-=a*c*(0>e?-1:1),n&&(this.yCorr-=d*c*(0>x?-1:1)),G(this.element,{textAlign:h}))},pathToVML:function(a){for(var b=a.length,e=[];b--;)p(a[b])?e[b]=
Math.round(10*a[b])-5:"Z"===a[b]?e[b]="x":(e[b]=a[b],!a.isArc||"wa"!==a[b]&&"at"!==a[b]||(e[b+5]===e[b+7]&&(e[b+7]+=a[b+7]>a[b+5]?1:-1),e[b+6]===e[b+8]&&(e[b+8]+=a[b+8]>a[b+6]?1:-1)));return e.join(" ")||"x"},clip:function(a){var b=this,e;a?(e=a.members,q(e,b),e.push(b),b.destroyClip=function(){q(e,b)},a=a.getCSS(b)):(b.destroyClip&&b.destroyClip(),a={clip:b.docMode8?"inherit":"rect(auto)"});return b.css(a)},css:n.prototype.htmlCss,safeRemoveChild:function(a){a.parentNode&&f(a)},destroy:function(){this.destroyClip&&
this.destroyClip();return n.prototype.destroy.apply(this)},on:function(a,b){this.element["on"+a]=function(){var a=z.event;a.target=a.srcElement;b(a)};return this},cutOffPath:function(a,b){var e;a=a.split(/[ ,]/);e=a.length;if(9===e||11===e)a[e-4]=a[e-2]=c(a[e-2])-10*b;return a.join(" ")},shadow:function(a,b,n){var e=[],h,d=this.element,x=this.renderer,p,F=d.style,k,D=d.path,l,t,z,f;D&&"string"!==typeof D.value&&(D="x");t=D;if(a){z=m(a.width,3);f=(a.opacity||.15)/z;for(h=1;3>=h;h++)l=2*z+1-2*h,n&&
(t=this.cutOffPath(D.value,l+.5)),k=['\x3cshape isShadow\x3d"true" strokeweight\x3d"',l,'" filled\x3d"false" path\x3d"',t,'" coordsize\x3d"10 10" style\x3d"',d.style.cssText,'" /\x3e'],p=H(x.prepVML(k),null,{left:c(F.left)+m(a.offsetX,1),top:c(F.top)+m(a.offsetY,1)}),n&&(p.cutOff=l+1),k=['\x3cstroke color\x3d"',a.color||"#000000",'" opacity\x3d"',f*h,'"/\x3e'],H(x.prepVML(k),null,null,p),b?b.element.appendChild(p):d.parentNode.insertBefore(p,d),e.push(p);this.shadows=e}return this},updateShadows:A,
setAttr:function(a,b){this.docMode8?this.element[a]=b:this.element.setAttribute(a,b)},classSetter:function(a){(this.added?this.element:this).className=a},dashstyleSetter:function(a,b,c){(c.getElementsByTagName("stroke")[0]||H(this.renderer.prepVML(["\x3cstroke/\x3e"]),null,null,c))[b]=a||"solid";this[b]=a},dSetter:function(a,b,c){var e=this.shadows;a=a||[];this.d=a.join&&a.join(" ");c.path=a=this.pathToVML(a);if(e)for(c=e.length;c--;)e[c].path=e[c].cutOff?this.cutOffPath(a,e[c].cutOff):a;this.setAttr(b,
a)},fillSetter:function(a,b,c){var e=c.nodeName;"SPAN"===e?c.style.color=a:"IMG"!==e&&(c.filled="none"!==a,this.setAttr("fillcolor",this.renderer.color(a,c,b,this)))},"fill-opacitySetter":function(a,b,c){H(this.renderer.prepVML(["\x3c",b.split("-")[0],' opacity\x3d"',a,'"/\x3e']),null,null,c)},opacitySetter:A,rotationSetter:function(a,b,c){c=c.style;this[b]=c[b]=a;c.left=-Math.round(Math.sin(a*g)+1)+"px";c.top=Math.round(Math.cos(a*g))+"px"},strokeSetter:function(a,b,c){this.setAttr("strokecolor",
this.renderer.color(a,c,b,this))},"stroke-widthSetter":function(a,b,c){c.stroked=!!a;this[b]=a;p(a)&&(a+="px");this.setAttr("strokeweight",a)},titleSetter:function(a,b){this.setAttr(b,a)},visibilitySetter:function(a,b,c){"inherit"===a&&(a="visible");this.shadows&&l(this.shadows,function(c){c.style[b]=a});"DIV"===c.nodeName&&(a="hidden"===a?"-999em":0,this.docMode8||(c.style[b]=a?"visible":"hidden"),b="top");c.style[b]=a},xSetter:function(a,b,c){this[b]=a;"x"===b?b="left":"y"===b&&(b="top");this.updateClipping?
(this[b]=a,this.updateClipping()):c.style[b]=a},zIndexSetter:function(a,b,c){c.style[b]=a}},A["stroke-opacitySetter"]=A["fill-opacitySetter"],a.VMLElement=A=B(n,A),A.prototype.ySetter=A.prototype.widthSetter=A.prototype.heightSetter=A.prototype.xSetter,A={Element:A,isIE8:-1<z.navigator.userAgent.indexOf("MSIE 8.0"),init:function(a,b,c){var e,h;this.alignedObjects=[];e=this.createElement("div").css({position:"relative"});h=e.element;a.appendChild(e.element);this.isVML=!0;this.box=h;this.boxWrapper=
e;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(b,c,!1);if(!u.namespaces.hcv){u.namespaces.add("hcv","urn:schemas-microsoft-com:vml");try{u.createStyleSheet().cssText="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}catch(y){u.styleSheets[0].cssText+="hcv\\:fill, hcv\\:path, hcv\\:shape, hcv\\:stroke{ behavior:url(#default#VML); display: inline-block; } "}}},isHidden:function(){return!this.box.offsetWidth},
clipRect:function(a,b,c,n){var e=this.createElement(),m=C(a);return d(e,{members:[],count:0,left:(m?a.x:a)+1,top:(m?a.y:b)+1,width:(m?a.width:c)-1,height:(m?a.height:n)-1,getCSS:function(a){var b=a.element,c=b.nodeName,k=a.inverted,e=this.top-("shape"===c?b.offsetTop:0),h=this.left,b=h+this.width,n=e+this.height,e={clip:"rect("+Math.round(k?h:e)+"px,"+Math.round(k?n:b)+"px,"+Math.round(k?b:n)+"px,"+Math.round(k?e:h)+"px)"};!k&&a.docMode8&&"DIV"===c&&d(e,{width:b+"px",height:n+"px"});return e},updateClipping:function(){l(e.members,
function(a){a.element&&a.css(e.getCSS(a))})}})},color:function(b,c,n,m){var e=this,d,x=/^rgba/,p,t,k="none";b&&b.linearGradient?t="gradient":b&&b.radialGradient&&(t="pattern");if(t){var D,w,z=b.linearGradient||b.radialGradient,f,E,v,q,g,F="";b=b.stops;var C,u=[],r=function(){p=['\x3cfill colors\x3d"'+u.join(",")+'" opacity\x3d"',v,'" o:opacity2\x3d"',E,'" type\x3d"',t,'" ',F,'focus\x3d"100%" method\x3d"any" /\x3e'];H(e.prepVML(p),null,null,c)};f=b[0];C=b[b.length-1];0<f[0]&&b.unshift([0,f[1]]);1>
C[0]&&b.push([1,C[1]]);l(b,function(k,b){x.test(k[1])?(d=a.color(k[1]),D=d.get("rgb"),w=d.get("a")):(D=k[1],w=1);u.push(100*k[0]+"% "+D);b?(v=w,q=D):(E=w,g=D)});if("fill"===n)if("gradient"===t)n=z.x1||z[0]||0,b=z.y1||z[1]||0,f=z.x2||z[2]||0,z=z.y2||z[3]||0,F='angle\x3d"'+(90-180*Math.atan((z-b)/(f-n))/Math.PI)+'"',r();else{var k=z.r,A=2*k,B=2*k,G=z.cx,U=z.cy,L=c.radialReference,T,k=function(){L&&(T=m.getBBox(),G+=(L[0]-T.x)/T.width-.5,U+=(L[1]-T.y)/T.height-.5,A*=L[2]/T.width,B*=L[2]/T.height);F=
'src\x3d"'+a.getOptions().global.VMLRadialGradientURL+'" size\x3d"'+A+","+B+'" origin\x3d"0.5,0.5" position\x3d"'+G+","+U+'" color2\x3d"'+g+'" ';r()};m.added?k():m.onAdd=k;k=q}else k=D}else x.test(b)&&"IMG"!==c.tagName?(d=a.color(b),m[n+"-opacitySetter"](d.get("a"),n,c),k=d.get("rgb")):(k=c.getElementsByTagName(n),k.length&&(k[0].opacity=1,k[0].type="solid"),k=b);return k},prepVML:function(a){var b=this.isIE8;a=a.join("");b?(a=a.replace("/\x3e",' xmlns\x3d"urn:schemas-microsoft-com:vml" /\x3e'),a=
-1===a.indexOf('style\x3d"')?a.replace("/\x3e",' style\x3d"display:inline-block;behavior:url(#default#VML);" /\x3e'):a.replace('style\x3d"','style\x3d"display:inline-block;behavior:url(#default#VML);')):a=a.replace("\x3c","\x3chcv:");return a},text:E.prototype.html,path:function(a){var c={coordsize:"10 10"};b(a)?c.d=a:C(a)&&d(c,a);return this.createElement("shape").attr(c)},circle:function(a,b,c){var e=this.symbol("circle");C(a)&&(c=a.r,b=a.y,a=a.x);e.isCircle=!0;e.r=c;return e.attr({x:a,y:b})},g:function(a){var b;
a&&(b={className:"highcharts-"+a,"class":"highcharts-"+a});return this.createElement("div").attr(b)},image:function(a,b,c,n,h){var e=this.createElement("img").attr({src:a});1<arguments.length&&e.attr({x:b,y:c,width:n,height:h});return e},createElement:function(a){return"rect"===a?this.symbol(a):E.prototype.createElement.call(this,a)},invertChild:function(a,b){var e=this;b=b.style;var n="IMG"===a.tagName&&a.style;G(a,{flip:"x",left:c(b.width)-(n?c(n.top):1),top:c(b.height)-(n?c(n.left):1),rotation:-90});
l(a.childNodes,function(b){e.invertChild(b,a)})},symbols:{arc:function(a,b,c,n,h){var e=h.start,m=h.end,d=h.r||c||n;c=h.innerR;n=Math.cos(e);var p=Math.sin(e),k=Math.cos(m),D=Math.sin(m);if(0===m-e)return["x"];e=["wa",a-d,b-d,a+d,b+d,a+d*n,b+d*p,a+d*k,b+d*D];h.open&&!c&&e.push("e","M",a,b);e.push("at",a-c,b-c,a+c,b+c,a+c*k,b+c*D,a+c*n,b+c*p,"x","e");e.isArc=!0;return e},circle:function(a,b,c,n,h){h&&r(h.r)&&(c=n=2*h.r);h&&h.isCircle&&(a-=c/2,b-=n/2);return["wa",a,b,a+c,b+n,a+c,b+n/2,a+c,b+n/2,"e"]},
rect:function(a,b,c,n,h){return E.prototype.symbols[r(h)&&h.r?"callout":"square"].call(0,a,b,c,n,h)}}},a.VMLRenderer=B=function(){this.init.apply(this,arguments)},B.prototype=t(E.prototype,A),a.Renderer=B);E.prototype.measureSpanWidth=function(a,b){var c=u.createElement("span");a=u.createTextNode(a);c.appendChild(a);G(c,b);this.box.appendChild(c);b=c.offsetWidth;f(c);return b}})(L);(function(a){function B(){var l=a.defaultOptions.global,f=u.moment;if(l.timezone){if(f)return function(a){return-f.tz(a,
l.timezone).utcOffset()};a.error(25)}return l.useUTC&&l.getTimezoneOffset}function A(){var l=a.defaultOptions.global,q,d=l.useUTC,b=d?"getUTC":"get",p=d?"setUTC":"set";a.Date=q=l.Date||u.Date;q.hcTimezoneOffset=d&&l.timezoneOffset;q.hcGetTimezoneOffset=B();q.hcMakeTime=function(a,b,m,c,n,p){var l;d?(l=q.UTC.apply(0,arguments),l+=r(l)):l=(new q(a,b,f(m,1),f(c,0),f(n,0),f(p,0))).getTime();return l};G("Minutes Hours Day Date Month FullYear".split(" "),function(a){q["hcGet"+a]=b+a});G("Milliseconds Seconds Minutes Hours Date Month FullYear".split(" "),
function(a){q["hcSet"+a]=p+a})}var H=a.color,G=a.each,r=a.getTZOffset,g=a.merge,f=a.pick,u=a.win;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{useUTC:!0,VMLRadialGradientURL:"http://code.highcharts.com/5.0.7/gfx/vml-radial-gradient.png"},chart:{borderRadius:0,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:20},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",
align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",
width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",
month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:H("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"http://www.highcharts.com",
position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(l){a.defaultOptions=g(!0,a.defaultOptions,l);A();return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;A()})(L);(function(a){var B=a.arrayMax,A=a.arrayMin,H=a.defined,G=a.destroyObjectProperties,r=a.each,g=a.erase,f=a.merge,u=a.pick;a.PlotLineOrBand=function(a,f){this.axis=
a;f&&(this.options=f,this.id=f.id)};a.PlotLineOrBand.prototype={render:function(){var a=this,q=a.axis,d=q.horiz,b=a.options,p=b.label,g=a.label,t=b.to,m=b.from,c=b.value,n=H(m)&&H(t),E=H(c),z=a.svgElem,e=!z,x=[],F,w=b.color,h=u(b.zIndex,0),y=b.events,x={"class":"highcharts-plot-"+(n?"band ":"line ")+(b.className||"")},J={},K=q.chart.renderer,I=n?"bands":"lines",k=q.log2lin;q.isLog&&(m=k(m),t=k(t),c=k(c));E?(x={stroke:w,"stroke-width":b.width},b.dashStyle&&(x.dashstyle=b.dashStyle)):n&&(w&&(x.fill=
w),b.borderWidth&&(x.stroke=b.borderColor,x["stroke-width"]=b.borderWidth));J.zIndex=h;I+="-"+h;(w=q[I])||(q[I]=w=K.g("plot-"+I).attr(J).add());e&&(a.svgElem=z=K.path().attr(x).add(w));if(E)x=q.getPlotLinePath(c,z.strokeWidth());else if(n)x=q.getPlotBandPath(m,t,b);else return;if(e&&x&&x.length){if(z.attr({d:x}),y)for(F in b=function(b){z.on(b,function(k){y[b].apply(a,[k])})},y)b(F)}else z&&(x?(z.show(),z.animate({d:x})):(z.hide(),g&&(a.label=g=g.destroy())));p&&H(p.text)&&x&&x.length&&0<q.width&&
0<q.height&&!x.flat?(p=f({align:d&&n&&"center",x:d?!n&&4:10,verticalAlign:!d&&n&&"middle",y:d?n?16:10:n?6:-4,rotation:d&&!n&&90},p),this.renderLabel(p,x,n,h)):g&&g.hide();return a},renderLabel:function(a,f,d,b){var p=this.label,l=this.axis.chart.renderer;p||(p={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(d?"band":"line")+"-label "+(a.className||"")},p.zIndex=b,this.label=p=l.text(a.text,0,0,a.useHTML).attr(p).add(),p.css(a.style));b=[f[1],f[4],d?f[6]:f[1]];f=[f[2],f[5],
d?f[7]:f[2]];d=A(b);l=A(f);p.align(a,!1,{x:d,y:l,width:B(b)-d,height:B(f)-l});p.show()},destroy:function(){g(this.axis.plotLinesAndBands,this);delete this.axis;G(this)}};a.AxisPlotLineOrBandExtension={getPlotBandPath:function(a,f){f=this.getPlotLinePath(f,null,null,!0);(a=this.getPlotLinePath(a,null,null,!0))&&f?(a.flat=a.toString()===f.toString(),a.push(f[4],f[5],f[1],f[2],"z")):a=null;return a},addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,
"plotLines")},addPlotBandOrLine:function(f,g){var d=(new a.PlotLineOrBand(this,f)).render(),b=this.userOptions;d&&(g&&(b[g]=b[g]||[],b[g].push(f)),this.plotLinesAndBands.push(d));return d},removePlotBandOrLine:function(a){for(var f=this.plotLinesAndBands,d=this.options,b=this.userOptions,p=f.length;p--;)f[p].id===a&&f[p].destroy();r([d.plotLines||[],b.plotLines||[],d.plotBands||[],b.plotBands||[]],function(b){for(p=b.length;p--;)b[p].id===a&&g(b,b[p])})}}})(L);(function(a){var B=a.correctFloat,A=
a.defined,H=a.destroyObjectProperties,G=a.isNumber,r=a.merge,g=a.pick,f=a.deg2rad;a.Tick=function(a,f,g,d){this.axis=a;this.pos=f;this.type=g||"";this.isNew=!0;g||d||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,f=a.options,q=a.chart,d=a.categories,b=a.names,p=this.pos,C=f.labels,t=a.tickPositions,m=p===t[0],c=p===t[t.length-1],b=d?g(d[p],b[p],p):p,d=this.label,t=t.info,n;a.isDatetimeAxis&&t&&(n=f.dateTimeLabelFormats[t.higherRanks[p]||t.unitName]);this.isFirst=m;this.isLast=
c;f=a.labelFormatter.call({axis:a,chart:q,isFirst:m,isLast:c,dateTimeLabelFormat:n,value:a.isLog?B(a.lin2log(b)):b});A(d)?d&&d.attr({text:f}):(this.labelLength=(this.label=d=A(f)&&C.enabled?q.renderer.text(f,0,0,C.useHTML).css(r(C.style)).add(a.labelGroup):null)&&d.getBBox().width,this.rotation=0)},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var l=this.axis,q=a.x,d=l.chart.chartWidth,b=l.chart.spacing,p=g(l.labelLeft,
Math.min(l.pos,b[3])),b=g(l.labelRight,Math.max(l.pos+l.len,d-b[1])),C=this.label,t=this.rotation,m={left:0,center:.5,right:1}[l.labelAlign],c=C.getBBox().width,n=l.getSlotWidth(),E=n,z=1,e,x={};if(t)0>t&&q-m*c<p?e=Math.round(q/Math.cos(t*f)-p):0<t&&q+m*c>b&&(e=Math.round((d-q)/Math.cos(t*f)));else if(d=q+(1-m)*c,q-m*c<p?E=a.x+E*(1-m)-p:d>b&&(E=b-a.x+E*m,z=-1),E=Math.min(n,E),E<n&&"center"===l.labelAlign&&(a.x+=z*(n-E-m*(n-Math.min(c,E)))),c>E||l.autoRotation&&(C.styles||{}).width)e=E;e&&(x.width=
e,(l.options.labels.style||{}).textOverflow||(x.textOverflow="ellipsis"),C.css(x))},getPosition:function(a,f,g,d){var b=this.axis,p=b.chart,l=d&&p.oldChartHeight||p.chartHeight;return{x:a?b.translate(f+g,null,null,d)+b.transB:b.left+b.offset+(b.opposite?(d&&p.oldChartWidth||p.chartWidth)-b.right-b.left:0),y:a?l-b.bottom+b.offset-(b.opposite?b.height:0):l-b.translate(f+g,null,null,d)-b.transB}},getLabelPosition:function(a,g,q,d,b,p,C,t){var m=this.axis,c=m.transA,n=m.reversed,E=m.staggerLines,z=m.tickRotCorr||
{x:0,y:0},e=b.y;A(e)||(e=0===m.side?q.rotation?-8:-q.getBBox().height:2===m.side?z.y+8:Math.cos(q.rotation*f)*(z.y-q.getBBox(!1,0).height/2));a=a+b.x+z.x-(p&&d?p*c*(n?-1:1):0);g=g+e-(p&&!d?p*c*(n?1:-1):0);E&&(q=C/(t||1)%E,m.opposite&&(q=E-q-1),g+=m.labelOffset/E*q);return{x:a,y:Math.round(g)}},getMarkPath:function(a,f,g,d,b,p){return p.crispLine(["M",a,f,"L",a+(b?0:-g),f+(b?g:0)],d)},render:function(a,f,q){var d=this.axis,b=d.options,p=d.chart.renderer,l=d.horiz,t=this.type,m=this.label,c=this.pos,
n=b.labels,E=this.gridLine,z=t?t+"Tick":"tick",e=d.tickSize(z),x=this.mark,F=!x,w=n.step,h={},y=!0,J=d.tickmarkOffset,K=this.getPosition(l,c,J,f),I=K.x,K=K.y,k=l&&I===d.pos+d.len||!l&&K===d.pos?-1:1,D=t?t+"Grid":"grid",P=b[D+"LineWidth"],N=b[D+"LineColor"],r=b[D+"LineDashStyle"],D=g(b[z+"Width"],!t&&d.isXAxis?1:0),z=b[z+"Color"];q=g(q,1);this.isActive=!0;E||(h.stroke=N,h["stroke-width"]=P,r&&(h.dashstyle=r),t||(h.zIndex=1),f&&(h.opacity=0),this.gridLine=E=p.path().attr(h).addClass("highcharts-"+(t?
t+"-":"")+"grid-line").add(d.gridGroup));if(!f&&E&&(c=d.getPlotLinePath(c+J,E.strokeWidth()*k,f,!0)))E[this.isNew?"attr":"animate"]({d:c,opacity:q});e&&(d.opposite&&(e[0]=-e[0]),F&&(this.mark=x=p.path().addClass("highcharts-"+(t?t+"-":"")+"tick").add(d.axisGroup),x.attr({stroke:z,"stroke-width":D})),x[F?"attr":"animate"]({d:this.getMarkPath(I,K,e[0],x.strokeWidth()*k,l,p),opacity:q}));m&&G(I)&&(m.xy=K=this.getLabelPosition(I,K,m,l,n,J,a,w),this.isFirst&&!this.isLast&&!g(b.showFirstLabel,1)||this.isLast&&
!this.isFirst&&!g(b.showLastLabel,1)?y=!1:!l||d.isRadial||n.step||n.rotation||f||0===q||this.handleOverflow(K),w&&a%w&&(y=!1),y&&G(K.y)?(K.opacity=q,m[this.isNew?"attr":"animate"](K)):m.attr("y",-9999),this.isNew=!1)},destroy:function(){H(this,this.axis)}}})(L);(function(a){var B=a.addEvent,A=a.animObject,H=a.arrayMax,G=a.arrayMin,r=a.AxisPlotLineOrBandExtension,g=a.color,f=a.correctFloat,u=a.defaultOptions,l=a.defined,q=a.deg2rad,d=a.destroyObjectProperties,b=a.each,p=a.extend,C=a.fireEvent,t=a.format,
m=a.getMagnitude,c=a.grep,n=a.inArray,E=a.isArray,z=a.isNumber,e=a.isString,x=a.merge,F=a.normalizeTickInterval,w=a.pick,h=a.PlotLineOrBand,y=a.removeEvent,J=a.splat,K=a.syncTimeout,I=a.Tick;a.Axis=function(){this.init.apply(this,arguments)};a.Axis.prototype={defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,style:{color:"#666666",cursor:"default",fontSize:"11px"},
x:0},minPadding:.01,maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",startOfWeek:1,startOnTick:!1,tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},maxPadding:.05,
minPadding:.05,startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],
x:0},title:{rotation:0}},init:function(a,b){var k=b.isX;this.chart=a;this.horiz=a.inverted?!k:k;this.isXAxis=k;this.coll=this.coll||(k?"xAxis":"yAxis");this.opposite=b.opposite;this.side=b.side||(this.horiz?this.opposite?0:2:this.opposite?1:3);this.setOptions(b);var c=this.options,e=c.type;this.labelFormatter=c.labels.formatter||this.defaultLabelFormatter;this.userOptions=b;this.minPixelPadding=0;this.reversed=c.reversed;this.visible=!1!==c.visible;this.zoomEnabled=!1!==c.zoomEnabled;this.hasNames=
"category"===e||!0===c.categories;this.categories=c.categories||this.hasNames;this.names=this.names||[];this.isLog="logarithmic"===e;this.isDatetimeAxis="datetime"===e;this.isLinked=l(c.linkedTo);this.ticks={};this.labelEdge=[];this.minorTicks={};this.plotLinesAndBands=[];this.alternateBands={};this.len=0;this.minRange=this.userMinRange=c.minRange||c.maxZoom;this.range=c.range;this.offset=c.offset||0;this.stacks={};this.oldStacks={};this.stacksTouched=0;this.min=this.max=null;this.crosshair=w(c.crosshair,
J(a.options.tooltip.crosshairs)[k?0:1],!1);var h;b=this.options.events;-1===n(this,a.axes)&&(k?a.axes.splice(a.xAxis.length,0,this):a.axes.push(this),a[this.coll].push(this));this.series=this.series||[];a.inverted&&k&&void 0===this.reversed&&(this.reversed=!0);this.removePlotLine=this.removePlotBand=this.removePlotBandOrLine;for(h in b)B(this,h,b[h]);this.isLog&&(this.val2lin=this.log2lin,this.lin2val=this.lin2log)},setOptions:function(a){this.options=x(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,
[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],x(u[this.coll],a))},defaultLabelFormatter:function(){var b=this.axis,c=this.value,e=b.categories,h=this.dateTimeLabelFormat,n=u.lang,d=n.numericSymbols,n=n.numericSymbolMagnitude||1E3,v=d&&d.length,m,f=b.options.labels.format,b=b.isLog?c:b.tickInterval;if(f)m=t(f,this);else if(e)m=c;else if(h)m=a.dateFormat(h,c);else if(v&&1E3<=b)for(;v--&&void 0===m;)e=Math.pow(n,v+1),b>=
e&&0===10*c%e&&null!==d[v]&&0!==c&&(m=a.numberFormat(c/e,-1)+d[v]);void 0===m&&(m=1E4<=Math.abs(c)?a.numberFormat(c,-1):a.numberFormat(c,-1,void 0,""));return m},getSeriesExtremes:function(){var a=this,e=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();b(a.series,function(b){if(b.visible||!e.options.chart.ignoreHiddenSeries){var k=b.options,h=k.threshold,D;a.hasVisibleSeries=!0;a.isLog&&0>=h&&(h=null);if(a.isXAxis)k=b.xData,
k.length&&(b=G(k),z(b)||b instanceof Date||(k=c(k,function(a){return z(a)}),b=G(k)),a.dataMin=Math.min(w(a.dataMin,k[0]),b),a.dataMax=Math.max(w(a.dataMax,k[0]),H(k)));else if(b.getExtremes(),D=b.dataMax,b=b.dataMin,l(b)&&l(D)&&(a.dataMin=Math.min(w(a.dataMin,b),b),a.dataMax=Math.max(w(a.dataMax,D),D)),l(h)&&(a.threshold=h),!k.softThreshold||a.isLog)a.softThreshold=!1}})},translate:function(a,b,c,e,h,n){var k=this.linkedParent||this,D=1,m=0,d=e?k.oldTransA:k.transA;e=e?k.oldMin:k.min;var f=k.minPixelPadding;
h=(k.isOrdinal||k.isBroken||k.isLog&&h)&&k.lin2val;d||(d=k.transA);c&&(D*=-1,m=k.len);k.reversed&&(D*=-1,m-=D*(k.sector||k.len));b?(a=(a*D+m-f)/d+e,h&&(a=k.lin2val(a))):(h&&(a=k.val2lin(a)),a=D*(a-e)*d+m+D*f+(z(n)?d*n:0));return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,c,e,h){var k=this.chart,D=this.left,n=this.top,m,d,f=c&&k.oldChartHeight||
k.chartHeight,p=c&&k.oldChartWidth||k.chartWidth,y;m=this.transB;var t=function(a,b,k){if(a<b||a>k)e?a=Math.min(Math.max(b,a),k):y=!0;return a};h=w(h,this.translate(a,null,null,c));a=c=Math.round(h+m);m=d=Math.round(f-h-m);z(h)?this.horiz?(m=n,d=f-this.bottom,a=c=t(a,D,D+this.width)):(a=D,c=p-this.right,m=d=t(m,n,n+this.height)):y=!0;return y&&!e?null:k.renderer.crispLine(["M",a,m,"L",c,d],b||1)},getLinearTickPositions:function(a,b,c){var k,e=f(Math.floor(b/a)*a),h=f(Math.ceil(c/a)*a),D=[];if(b===
c&&z(b))return[b];for(b=e;b<=h;){D.push(b);b=f(b+a);if(b===k)break;k=b}return D},getMinorTickPositions:function(){var a=this.options,b=this.tickPositions,c=this.minorTickInterval,e=[],h,n=this.pointRangePadding||0;h=this.min-n;var n=this.max+n,m=n-h;if(m&&m/c<this.len/3)if(this.isLog)for(n=b.length,h=1;h<n;h++)e=e.concat(this.getLogTickPositions(c,b[h-1],b[h],!0));else if(this.isDatetimeAxis&&"auto"===a.minorTickInterval)e=e.concat(this.getTimeTicks(this.normalizeTimeTickInterval(c),h,n,a.startOfWeek));
else for(b=h+(b[0]-h)%c;b<=n&&b!==e[0];b+=c)e.push(b);0!==e.length&&this.trimTicks(e,a.startOnTick,a.endOnTick);return e},adjustForMinRange:function(){var a=this.options,c=this.min,e=this.max,h,n=this.dataMax-this.dataMin>=this.minRange,m,v,d,f,p,y;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(l(a.min)||l(a.max)?this.minRange=null:(b(this.series,function(a){f=a.xData;for(v=p=a.xIncrement?1:f.length-1;0<v;v--)if(d=f[v]-f[v-1],void 0===m||d<m)m=d}),this.minRange=Math.min(5*m,this.dataMax-this.dataMin)));
e-c<this.minRange&&(y=this.minRange,h=(y-e+c)/2,h=[c-h,w(a.min,c-h)],n&&(h[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),c=H(h),e=[c+y,w(a.max,c+y)],n&&(e[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),e=G(e),e-c<y&&(h[0]=e-y,h[1]=w(a.min,e-y),c=H(h)));this.min=c;this.max=e},getClosest:function(){var a;this.categories?a=1:b(this.series,function(b){var k=b.closestPointRange,c=b.visible||!b.chart.options.chart.ignoreHiddenSeries;!b.noSharedTooltip&&l(k)&&c&&(a=l(a)?Math.min(a,k):k)});
return a},nameToX:function(a){var b=E(this.categories),k=b?this.categories:this.names,c=a.options.x,e;a.series.requireSorting=!1;l(c)||(c=!1===this.options.uniqueNames?a.series.autoIncrement():n(a.name,k));-1===c?b||(e=k.length):e=c;this.names[e]=a.name;return e},updateNames:function(){var a=this;0<this.names.length&&(this.names.length=0,this.minRange=void 0,b(this.series||[],function(k){k.xIncrement=null;if(!k.points||k.isDirtyData)k.processData(),k.generatePoints();b(k.points,function(b,c){var e;
b.options&&(e=a.nameToX(b),e!==b.x&&(b.x=e,k.xData[c]=e))})}))},setAxisTranslation:function(a){var k=this,c=k.max-k.min,h=k.axisPointRange||0,n,m=0,d=0,f=k.linkedParent,y=!!k.categories,p=k.transA,t=k.isXAxis;if(t||y||h)n=k.getClosest(),f?(m=f.minPointOffset,d=f.pointRangePadding):b(k.series,function(a){var b=y?1:t?w(a.options.pointRange,n,0):k.axisPointRange||0;a=a.options.pointPlacement;h=Math.max(h,b);k.single||(m=Math.max(m,e(a)?0:b/2),d=Math.max(d,"on"===a?0:b))}),f=k.ordinalSlope&&n?k.ordinalSlope/
n:1,k.minPointOffset=m*=f,k.pointRangePadding=d*=f,k.pointRange=Math.min(h,c),t&&(k.closestPointRange=n);a&&(k.oldTransA=p);k.translationSlope=k.transA=p=k.len/(c+d||1);k.transB=k.horiz?k.left:k.bottom;k.minPixelPadding=p*m},minFromRange:function(){return this.max-this.range},setTickInterval:function(k){var c=this,e=c.chart,h=c.options,n=c.isLog,d=c.log2lin,v=c.isDatetimeAxis,y=c.isXAxis,p=c.isLinked,t=h.maxPadding,x=h.minPadding,g=h.tickInterval,E=h.tickPixelInterval,q=c.categories,J=c.threshold,
K=c.softThreshold,I,r,u,A;v||q||p||this.getTickAmount();u=w(c.userMin,h.min);A=w(c.userMax,h.max);p?(c.linkedParent=e[c.coll][h.linkedTo],e=c.linkedParent.getExtremes(),c.min=w(e.min,e.dataMin),c.max=w(e.max,e.dataMax),h.type!==c.linkedParent.options.type&&a.error(11,1)):(!K&&l(J)&&(c.dataMin>=J?(I=J,x=0):c.dataMax<=J&&(r=J,t=0)),c.min=w(u,I,c.dataMin),c.max=w(A,r,c.dataMax));n&&(!k&&0>=Math.min(c.min,w(c.dataMin,c.min))&&a.error(10,1),c.min=f(d(c.min),15),c.max=f(d(c.max),15));c.range&&l(c.max)&&
(c.userMin=c.min=u=Math.max(c.min,c.minFromRange()),c.userMax=A=c.max,c.range=null);C(c,"foundExtremes");c.beforePadding&&c.beforePadding();c.adjustForMinRange();!(q||c.axisPointRange||c.usePercentage||p)&&l(c.min)&&l(c.max)&&(d=c.max-c.min)&&(!l(u)&&x&&(c.min-=d*x),!l(A)&&t&&(c.max+=d*t));z(h.floor)?c.min=Math.max(c.min,h.floor):z(h.softMin)&&(c.min=Math.min(c.min,h.softMin));z(h.ceiling)?c.max=Math.min(c.max,h.ceiling):z(h.softMax)&&(c.max=Math.max(c.max,h.softMax));K&&l(c.dataMin)&&(J=J||0,!l(u)&&
c.min<J&&c.dataMin>=J?c.min=J:!l(A)&&c.max>J&&c.dataMax<=J&&(c.max=J));c.tickInterval=c.min===c.max||void 0===c.min||void 0===c.max?1:p&&!g&&E===c.linkedParent.options.tickPixelInterval?g=c.linkedParent.tickInterval:w(g,this.tickAmount?(c.max-c.min)/Math.max(this.tickAmount-1,1):void 0,q?1:(c.max-c.min)*E/Math.max(c.len,E));y&&!k&&b(c.series,function(a){a.processData(c.min!==c.oldMin||c.max!==c.oldMax)});c.setAxisTranslation(!0);c.beforeSetTickPositions&&c.beforeSetTickPositions();c.postProcessTickInterval&&
(c.tickInterval=c.postProcessTickInterval(c.tickInterval));c.pointRange&&!g&&(c.tickInterval=Math.max(c.pointRange,c.tickInterval));k=w(h.minTickInterval,c.isDatetimeAxis&&c.closestPointRange);!g&&c.tickInterval<k&&(c.tickInterval=k);v||n||g||(c.tickInterval=F(c.tickInterval,null,m(c.tickInterval),w(h.allowDecimals,!(.5<c.tickInterval&&5>c.tickInterval&&1E3<c.max&&9999>c.max)),!!this.tickAmount));this.tickAmount||(c.tickInterval=c.unsquish());this.setTickPositions()},setTickPositions:function(){var a=
this.options,b,c=a.tickPositions,e=a.tickPositioner,h=a.startOnTick,n=a.endOnTick,m;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===a.minorTickInterval&&this.tickInterval?this.tickInterval/5:a.minorTickInterval;this.tickPositions=b=c&&c.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,
!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()]),this.tickPositions=b,e&&(e=e.apply(this,[this.min,this.max])))&&(this.tickPositions=b=e);this.trimTicks(b,h,n);this.isLinked||(this.min===this.max&&l(this.min)&&!this.tickAmount&&(m=!0,this.min-=.5,this.max+=.5),this.single=m,c||e||this.adjustTickAmount())},trimTicks:function(a,b,c){var k=a[0],e=a[a.length-1],h=this.minPointOffset||
0;if(!this.isLinked){if(b)this.min=k;else for(;this.min-h>a[0];)a.shift();if(c)this.max=e;else for(;this.max+h<a[a.length-1];)a.pop();0===a.length&&l(k)&&a.push((e+k)/2)}},alignToOthers:function(){var a={},c,e=this.options;!1===this.chart.options.chart.alignTicks||!1===e.alignTicks||this.isLog||b(this.chart[this.coll],function(b){var k=b.options,k=[b.horiz?k.left:k.top,k.width,k.height,k.pane].join();b.series.length&&(a[k]?c=!0:a[k]=1)});return c},getTickAmount:function(){var a=this.options,b=a.tickAmount,
c=a.tickPixelInterval;!l(a.tickInterval)&&this.len<c&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&(b=Math.ceil(this.len/c)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,c=this.tickAmount,e=this.finalTickAmt,h=b&&b.length;if(h<c){for(;b.length<c;)b.push(f(b[b.length-1]+a));this.transA*=(h-1)/(c-1);this.max=b[b.length-1]}else h>c&&(this.tickInterval*=2,this.setTickPositions());
if(l(e)){for(a=c=b.length;a--;)(3===e&&1===a%2||2>=e&&0<a&&a<c-1)&&b.splice(a,1);this.finalTickAmt=void 0}},setScale:function(){var a,c;this.oldMin=this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();c=this.len!==this.oldAxisLength;b(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});c||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=
!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=c||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks()},setExtremes:function(a,c,e,h,n){var k=this,m=k.chart;e=w(e,!0);b(k.series,function(a){delete a.kdTree});n=p(n,{min:a,max:c});C(k,"setExtremes",n,function(){k.userMin=a;k.userMax=c;k.eventArgs=n;e&&m.redraw(h)})},zoom:function(a,b){var c=this.dataMin,k=this.dataMax,e=this.options,
h=Math.min(c,w(e.min,c)),e=Math.max(k,w(e.max,k));if(a!==this.min||b!==this.max)this.allowZoomOutside||(l(c)&&(a<h&&(a=h),a>e&&(a=e)),l(k)&&(b<h&&(b=h),b>e&&(b=e))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var a=this.chart,b=this.options,c=b.offsets||[0,0,0,0],e=this.horiz,h=w(b.width,a.plotWidth-c[3]+c[1]),n=w(b.height,a.plotHeight-c[0]+c[2]),m=w(b.top,a.plotTop+c[0]),b=w(b.left,a.plotLeft+c[3]),c=/%$/;c.test(n)&&(n=
Math.round(parseFloat(n)/100*a.plotHeight));c.test(m)&&(m=Math.round(parseFloat(m)/100*a.plotHeight+a.plotTop));this.left=b;this.top=m;this.width=h;this.height=n;this.bottom=a.chartHeight-n-m;this.right=a.chartWidth-h-b;this.len=Math.max(e?h:n,0);this.pos=e?b:m},getExtremes:function(){var a=this.isLog,b=this.lin2log;return{min:a?f(b(this.min)):this.min,max:a?f(b(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=
this.isLog,c=this.lin2log,k=b?c(this.min):this.min,b=b?c(this.max):this.max;null===a?a=k:k>a?a=k:b<a&&(a=b);return this.translate(a,0,1,0,1)},autoLabelAlign:function(a){a=(w(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,c=b[a+"Length"],k=w(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(k&&c)return"inside"===b[a+"Position"]&&(c=-c),[c,k]},labelMetrics:function(){return this.chart.renderer.fontMetrics(this.options.labels.style&&
this.options.labels.style.fontSize,this.ticks[0]&&this.ticks[0].label)},unsquish:function(){var a=this.options.labels,c=this.horiz,e=this.tickInterval,h=e,n=this.len/(((this.categories?1:0)+this.max-this.min)/e),m,d=a.rotation,f=this.labelMetrics(),p,y=Number.MAX_VALUE,t,x=function(a){a/=n||1;a=1<a?Math.ceil(a):1;return a*e};c?(t=!a.staggerLines&&!a.step&&(l(d)?[d]:n<w(a.autoRotationLimit,80)&&a.autoRotation))&&b(t,function(a){var b;if(a===d||a&&-90<=a&&90>=a)p=x(Math.abs(f.h/Math.sin(q*a))),b=p+
Math.abs(a/360),b<y&&(y=b,m=a,h=p)}):a.step||(h=x(f.h));this.autoRotation=t;this.labelRotation=w(m,d);return h},getSlotWidth:function(){var a=this.chart,b=this.horiz,c=this.options.labels,e=Math.max(this.tickPositions.length-(this.categories?0:1),1),h=a.margin[3];return b&&2>(c.step||0)&&!c.rotation&&(this.staggerLines||1)*this.len/e||!b&&(h&&h-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,c=a.renderer,h=this.tickPositions,n=this.ticks,m=this.options.labels,d=this.horiz,
v=this.getSlotWidth(),f=Math.max(1,Math.round(v-2*(m.padding||5))),p={},y=this.labelMetrics(),t=m.style&&m.style.textOverflow,g,z=0,E,w;e(m.rotation)||(p.rotation=m.rotation||0);b(h,function(a){(a=n[a])&&a.labelLength>z&&(z=a.labelLength)});this.maxLabelLength=z;if(this.autoRotation)z>f&&z>y.h?p.rotation=this.labelRotation:this.labelRotation=0;else if(v&&(g={width:f+"px"},!t))for(g.textOverflow="clip",E=h.length;!d&&E--;)if(w=h[E],f=n[w].label)f.styles&&"ellipsis"===f.styles.textOverflow?f.css({textOverflow:"clip"}):
n[w].labelLength>v&&f.css({width:v+"px"}),f.getBBox().height>this.len/h.length-(y.h-y.f)&&(f.specCss={textOverflow:"ellipsis"});p.rotation&&(g={width:(z>.5*a.chartHeight?.33*a.chartHeight:a.chartHeight)+"px"},t||(g.textOverflow="ellipsis"));if(this.labelAlign=m.align||this.autoLabelAlign(this.labelRotation))p.align=this.labelAlign;b(h,function(a){var b=(a=n[a])&&a.label;b&&(b.attr(p),g&&b.css(x(g,b.specCss)),delete b.specCss,a.rotation=p.rotation)});this.tickRotCorr=c.rotCorr(y.b,this.labelRotation||
0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||l(this.min)&&l(this.max)&&!!this.tickPositions},addTitle:function(a){var b=this.chart.renderer,c=this.horiz,k=this.opposite,e=this.options.title,h;this.axisTitle||((h=e.textAlign)||(h=(c?{low:"left",middle:"center",high:"right"}:{low:k?"right":"left",middle:"center",high:k?"left":"right"})[e.align]),this.axisTitle=b.text(e.text,0,0,e.useHTML).attr({zIndex:7,rotation:e.rotation||0,align:h}).addClass("highcharts-axis-title").css(e.style).add(this.axisGroup),
this.axisTitle.isNew=!0);this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new I(this,a)},getOffset:function(){var a=this,c=a.chart,e=c.renderer,h=a.options,n=a.tickPositions,m=a.ticks,d=a.horiz,f=a.side,p=c.inverted?[1,0,3,2][f]:f,y,t,x=0,g,z=0,E=h.title,q=h.labels,F=0,J=c.axisOffset,c=c.clipOffset,K=[-1,1,1,-1][f],C,I=h.className,r=a.axisParent,u=this.tickSize("tick");y=a.hasData();a.showAxis=t=y||w(h.showEmpty,!0);a.staggerLines=a.horiz&&q.staggerLines;
a.axisGroup||(a.gridGroup=e.g("grid").attr({zIndex:h.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(I||"")).add(r),a.axisGroup=e.g("axis").attr({zIndex:h.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(I||"")).add(r),a.labelGroup=e.g("axis-labels").attr({zIndex:q.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(I||"")).add(r));if(y||a.isLinked)b(n,function(b,c){a.generateTick(b,c)}),a.renderUnsquish(),!1===q.reserveSpace||0!==f&&2!==f&&
{1:"left",3:"right"}[f]!==a.labelAlign&&"center"!==a.labelAlign||b(n,function(a){F=Math.max(m[a].getLabelSize(),F)}),a.staggerLines&&(F*=a.staggerLines,a.labelOffset=F*(a.opposite?-1:1));else for(C in m)m[C].destroy(),delete m[C];E&&E.text&&!1!==E.enabled&&(a.addTitle(t),t&&(x=a.axisTitle.getBBox()[d?"height":"width"],g=E.offset,z=l(g)?0:w(E.margin,d?5:10)));a.renderLine();a.offset=K*w(h.offset,J[f]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};e=0===f?-a.labelMetrics().h:2===f?a.tickRotCorr.y:0;z=Math.abs(F)+
z;F&&(z=z-e+K*(d?w(q.y,a.tickRotCorr.y+8*K):q.x));a.axisTitleMargin=w(g,z);J[f]=Math.max(J[f],a.axisTitleMargin+x+K*a.offset,z,y&&n.length&&u?u[0]:0);h=h.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);c[p]=Math.max(c[p],h)},getLinePath:function(a){var b=this.chart,c=this.opposite,k=this.offset,e=this.horiz,h=this.left+(c?this.width:0)+k,k=b.chartHeight-this.bottom-(c?this.height:0)+k;c&&(a*=-1);return b.renderer.crispLine(["M",e?this.left:h,e?k:this.top,"L",e?b.chartWidth-this.right:h,e?k:b.chartHeight-
this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,c=this.top,e=this.len,h=this.options.title,n=a?b:c,m=this.opposite,d=this.offset,f=h.x||0,p=h.y||0,y=this.chart.renderer.fontMetrics(h.style&&h.style.fontSize,this.axisTitle).f,e={low:n+(a?0:e),
middle:n+e/2,high:n+(a?e:0)}[h.align],b=(a?c+this.height:b)+(a?1:-1)*(m?-1:1)*this.axisTitleMargin+(2===this.side?y:0);return{x:a?e+f:b+(m?this.width:0)+d+f,y:a?b+p-(m?this.height:0)+d:e+p}},renderMinorTick:function(a){var b=this.chart.hasRendered&&z(this.oldMin),c=this.minorTicks;c[a]||(c[a]=new I(this,a,"minor"));b&&c[a].isNew&&c[a].render(null,!0);c[a].render(null,!1,1)},renderTick:function(a,b){var c=this.isLinked,e=this.ticks,k=this.chart.hasRendered&&z(this.oldMin);if(!c||a>=this.min&&a<=this.max)e[a]||
(e[a]=new I(this,a)),k&&e[a].isNew&&e[a].render(b,!0,.1),e[a].render(b)},render:function(){var a=this,c=a.chart,e=a.options,n=a.isLog,m=a.lin2log,d=a.isLinked,v=a.tickPositions,f=a.axisTitle,p=a.ticks,y=a.minorTicks,t=a.alternateBands,x=e.stackLabels,z=e.alternateGridColor,g=a.tickmarkOffset,E=a.axisLine,w=a.showAxis,l=A(c.renderer.globalAnimation),q,F;a.labelEdge.length=0;a.overlap=!1;b([p,y,t],function(a){for(var b in a)a[b].isActive=!1});if(a.hasData()||d)a.minorTickInterval&&!a.categories&&b(a.getMinorTickPositions(),
function(b){a.renderMinorTick(b)}),v.length&&(b(v,function(b,c){a.renderTick(b,c)}),g&&(0===a.min||a.single)&&(p[-1]||(p[-1]=new I(a,-1,null,!0)),p[-1].render(-1))),z&&b(v,function(b,e){F=void 0!==v[e+1]?v[e+1]+g:a.max-g;0===e%2&&b<a.max&&F<=a.max+(c.polar?-g:g)&&(t[b]||(t[b]=new h(a)),q=b+g,t[b].options={from:n?m(q):q,to:n?m(F):F,color:z},t[b].render(),t[b].isActive=!0)}),a._addedPlotLB||(b((e.plotLines||[]).concat(e.plotBands||[]),function(b){a.addPlotBandOrLine(b)}),a._addedPlotLB=!0);b([p,y,t],
function(a){var b,e,h=[],k=l.duration;for(b in a)a[b].isActive||(a[b].render(b,!1,0),a[b].isActive=!1,h.push(b));K(function(){for(e=h.length;e--;)a[h[e]]&&!a[h[e]].isActive&&(a[h[e]].destroy(),delete a[h[e]])},a!==t&&c.hasRendered&&k?k:0)});E&&(E[E.isPlaced?"animate":"attr"]({d:this.getLinePath(E.strokeWidth())}),E.isPlaced=!0,E[w?"show":"hide"](!0));f&&w&&(f[f.isNew?"attr":"animate"](a.getTitlePosition()),f.isNew=!1);x&&x.enabled&&a.renderStackTotals();a.isDirty=!1},redraw:function(){this.visible&&
(this.render(),b(this.plotLinesAndBands,function(a){a.render()}));b(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var c=this,e=c.stacks,h,k=c.plotLinesAndBands,m;a||y(c);for(h in e)d(e[h]),e[h]=null;b([c.ticks,c.minorTicks,c.alternateBands],function(a){d(a)});if(k)for(a=k.length;a--;)k[a].destroy();b("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross".split(" "),function(a){c[a]&&(c[a]=c[a].destroy())});
for(m in c)c.hasOwnProperty(m)&&-1===n(m,c.keepProps)&&delete c[m]},drawCrosshair:function(a,b){var c,e=this.crosshair,h=w(e.snap,!0),k,n=this.cross;a||(a=this.cross&&this.cross.e);this.crosshair&&!1!==(l(b)||!h)?(h?l(b)&&(k=this.isXAxis?b.plotX:this.len-b.plotY):k=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos),l(k)&&(c=this.getPlotLinePath(b&&(this.isXAxis?b.x:w(b.stackY,b.y)),null,null,null,k)||null),l(c)?(b=this.categories&&!this.isRadial,n||(this.cross=n=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+
(b?"category ":"thin ")+e.className).attr({zIndex:w(e.zIndex,2)}).add(),n.attr({stroke:e.color||(b?g("#ccd6eb").setOpacity(.25).get():"#cccccc"),"stroke-width":w(e.width,1)}),e.dashStyle&&n.attr({dashstyle:e.dashStyle})),n.show().attr({d:c}),b&&!e.width&&n.attr({"stroke-width":this.transA}),this.cross.e=a):this.hideCrosshair()):this.hideCrosshair()},hideCrosshair:function(){this.cross&&this.cross.hide()}};p(a.Axis.prototype,r)})(L);(function(a){var B=a.Axis,A=a.Date,H=a.dateFormat,G=a.defaultOptions,
r=a.defined,g=a.each,f=a.extend,u=a.getMagnitude,l=a.getTZOffset,q=a.normalizeTickInterval,d=a.pick,b=a.timeUnits;B.prototype.getTimeTicks=function(a,q,t,m){var c=[],n={},p=G.global.useUTC,z,e=new A(q-l(q)),x=A.hcMakeTime,F=a.unitRange,w=a.count,h;if(r(q)){e[A.hcSetMilliseconds](F>=b.second?0:w*Math.floor(e.getMilliseconds()/w));if(F>=b.second)e[A.hcSetSeconds](F>=b.minute?0:w*Math.floor(e.getSeconds()/w));if(F>=b.minute)e[A.hcSetMinutes](F>=b.hour?0:w*Math.floor(e[A.hcGetMinutes]()/w));if(F>=b.hour)e[A.hcSetHours](F>=
b.day?0:w*Math.floor(e[A.hcGetHours]()/w));if(F>=b.day)e[A.hcSetDate](F>=b.month?1:w*Math.floor(e[A.hcGetDate]()/w));F>=b.month&&(e[A.hcSetMonth](F>=b.year?0:w*Math.floor(e[A.hcGetMonth]()/w)),z=e[A.hcGetFullYear]());if(F>=b.year)e[A.hcSetFullYear](z-z%w);if(F===b.week)e[A.hcSetDate](e[A.hcGetDate]()-e[A.hcGetDay]()+d(m,1));z=e[A.hcGetFullYear]();m=e[A.hcGetMonth]();var y=e[A.hcGetDate](),J=e[A.hcGetHours]();if(A.hcTimezoneOffset||A.hcGetTimezoneOffset)h=(!p||!!A.hcGetTimezoneOffset)&&(t-q>4*b.month||
l(q)!==l(t)),e=e.getTime(),e=new A(e+l(e));p=e.getTime();for(q=1;p<t;)c.push(p),p=F===b.year?x(z+q*w,0):F===b.month?x(z,m+q*w):!h||F!==b.day&&F!==b.week?h&&F===b.hour?x(z,m,y,J+q*w):p+F*w:x(z,m,y+q*w*(F===b.day?1:7)),q++;c.push(p);F<=b.hour&&1E4>c.length&&g(c,function(a){0===a%18E5&&"000000000"===H("%H%M%S%L",a)&&(n[a]="day")})}c.info=f(a,{higherRanks:n,totalRange:F*w});return c};B.prototype.normalizeTimeTickInterval=function(a,d){var f=d||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",
[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];d=f[f.length-1];var m=b[d[0]],c=d[1],n;for(n=0;n<f.length&&!(d=f[n],m=b[d[0]],c=d[1],f[n+1]&&a<=(m*c[c.length-1]+b[f[n+1][0]])/2);n++);m===b.year&&a<5*m&&(c=[1,2,5]);a=q(a/m,c,"year"===d[0]?Math.max(u(a/m),1):1);return{unitRange:m,count:a,unitName:d[0]}}})(L);(function(a){var B=a.Axis,A=a.getMagnitude,H=a.map,G=a.normalizeTickInterval,r=a.pick;B.prototype.getLogTickPositions=
function(a,f,u,l){var g=this.options,d=this.len,b=this.lin2log,p=this.log2lin,C=[];l||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),C=this.getLinearTickPositions(a,f,u);else if(.08<=a)for(var d=Math.floor(f),t,m,c,n,E,g=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];d<u+1&&!E;d++)for(m=g.length,t=0;t<m&&!E;t++)c=p(b(d)*g[t]),c>f&&(!l||n<=u)&&void 0!==n&&C.push(n),n>u&&(E=!0),n=c;else f=b(f),u=b(u),a=g[l?"minorTickInterval":"tickInterval"],a=r("auto"===a?null:a,this._minorAutoInterval,
g.tickPixelInterval/(l?5:1)*(u-f)/((l?d/this.tickPositions.length:d)||1)),a=G(a,null,A(a)),C=H(this.getLinearTickPositions(a,f,u),p),l||(this._minorAutoInterval=a/5);l||(this.tickInterval=a);return C};B.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};B.prototype.lin2log=function(a){return Math.pow(10,a)}})(L);(function(a){var B=a.dateFormat,A=a.each,H=a.extend,G=a.format,r=a.isNumber,g=a.map,f=a.merge,u=a.pick,l=a.splat,q=a.syncTimeout,d=a.timeUnits;a.Tooltip=function(){this.init.apply(this,
arguments)};a.Tooltip.prototype={init:function(a,d){this.chart=a;this.options=d;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=d.split&&!a.inverted;this.shared=d.shared||this.split},cleanSplit:function(a){A(this.chart.series,function(b){var d=b&&b.tt;d&&(!d.isActive||a?b.tt=d.destroy():d.isActive=!1)})},getLabel:function(){var a=this.chart.renderer,d=this.options;this.label||(this.split?this.label=a.g("tooltip"):(this.label=a.label("",0,0,d.shape||"callout",null,null,d.useHTML,
null,"tooltip").attr({padding:d.padding,r:d.borderRadius}),this.label.attr({fill:d.backgroundColor,"stroke-width":d.borderWidth}).css(d.style).shadow(d.shadow)),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();this.init(this.chart,f(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},
move:function(a,d,f,t){var b=this,c=b.now,n=!1!==b.options.animation&&!b.isHidden&&(1<Math.abs(a-c.x)||1<Math.abs(d-c.y)),p=b.followPointer||1<b.len;H(c,{x:n?(2*c.x+a)/3:a,y:n?(c.y+d)/2:d,anchorX:p?void 0:n?(2*c.anchorX+f)/3:f,anchorY:p?void 0:n?(c.anchorY+t)/2:t});b.getLabel().attr(c);n&&(clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){b&&b.move(a,d,f,t)},32))},hide:function(a){var b=this;clearTimeout(this.hideTimer);a=u(a,this.options.hideDelay,500);this.isHidden||(this.hideTimer=
q(function(){b.getLabel()[a?"fadeOut":"hide"]();b.isHidden=!0},a))},getAnchor:function(a,d){var b,f=this.chart,m=f.inverted,c=f.plotTop,n=f.plotLeft,p=0,z=0,e,x;a=l(a);b=a[0].tooltipPos;this.followPointer&&d&&(void 0===d.chartX&&(d=f.pointer.normalize(d)),b=[d.chartX-f.plotLeft,d.chartY-c]);b||(A(a,function(a){e=a.series.yAxis;x=a.series.xAxis;p+=a.plotX+(!m&&x?x.left-n:0);z+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!m&&e?e.top-c:0)}),p/=a.length,z/=a.length,b=[m?f.plotWidth-z:p,this.shared&&
!m&&1<a.length&&d?d.chartY-c:m?f.plotHeight-p:z]);return g(b,Math.round)},getPosition:function(a,d,f){var b=this.chart,m=this.distance,c={},n=f.h||0,p,z=["y",b.chartHeight,d,f.plotY+b.plotTop,b.plotTop,b.plotTop+b.plotHeight],e=["x",b.chartWidth,a,f.plotX+b.plotLeft,b.plotLeft,b.plotLeft+b.plotWidth],x=!this.followPointer&&u(f.ttBelow,!b.inverted===!!f.negative),g=function(a,b,e,h,d,f){var k=e<h-m,y=h+m+e<b,p=h-m-e;h+=m;if(x&&y)c[a]=h;else if(!x&&k)c[a]=p;else if(k)c[a]=Math.min(f-e,0>p-n?p:p-n);
else if(y)c[a]=Math.max(d,h+n+e>b?h:h+n);else return!1},w=function(a,b,e,h){var k;h<m||h>b-m?k=!1:c[a]=h<e/2?1:h>b-e/2?b-e-2:h-e/2;return k},h=function(a){var b=z;z=e;e=b;p=a},y=function(){!1!==g.apply(0,z)?!1!==w.apply(0,e)||p||(h(!0),y()):p?c.x=c.y=0:(h(!0),y())};(b.inverted||1<this.len)&&h();y();return c},defaultFormatter:function(a){var b=this.points||l(this),d;d=[a.tooltipFooterHeaderFormatter(b[0])];d=d.concat(a.bodyFormatter(b));d.push(a.tooltipFooterHeaderFormatter(b[0],!0));return d},refresh:function(a,
d){var b=this.chart,f,m=this.options,c,n,p={},z=[];f=m.formatter||this.defaultFormatter;var p=b.hoverPoints,e=this.shared;clearTimeout(this.hideTimer);this.followPointer=l(a)[0].series.tooltipOptions.followPointer;n=this.getAnchor(a,d);d=n[0];c=n[1];!e||a.series&&a.series.noSharedTooltip?p=a.getLabelConfig():(b.hoverPoints=a,p&&A(p,function(a){a.setState()}),A(a,function(a){a.setState("hover");z.push(a.getLabelConfig())}),p={x:a[0].category,y:a[0].y},p.points=z,a=a[0]);this.len=z.length;p=f.call(p,
this);e=a.series;this.distance=u(e.tooltipOptions.distance,16);!1===p?this.hide():(f=this.getLabel(),this.isHidden&&f.attr({opacity:1}).show(),this.split?this.renderSplit(p,b.hoverPoints):(f.attr({text:p&&p.join?p.join(""):p}),f.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+u(a.colorIndex,e.colorIndex)),f.attr({stroke:m.borderColor||a.color||e.color||"#666666"}),this.updatePosition({plotX:d,plotY:c,negative:a.negative,ttBelow:a.ttBelow,h:n[2]||0})),this.isHidden=!1)},renderSplit:function(b,
d){var f=this,p=[],m=this.chart,c=m.renderer,n=!0,g=this.options,z,e=this.getLabel();A(b.slice(0,d.length+1),function(a,b){b=d[b-1]||{isHeader:!0,plotX:d[0].plotX};var x=b.series||f,h=x.tt,y=b.series||{},t="highcharts-color-"+u(b.colorIndex,y.colorIndex,"none");h||(x.tt=h=c.label(null,null,null,"callout").addClass("highcharts-tooltip-box "+t).attr({padding:g.padding,r:g.borderRadius,fill:g.backgroundColor,stroke:b.color||y.color||"#333333","stroke-width":g.borderWidth}).add(e));h.isActive=!0;h.attr({text:a});
h.css(g.style);a=h.getBBox();y=a.width+h.strokeWidth();b.isHeader?(z=a.height,y=Math.max(0,Math.min(b.plotX+m.plotLeft-y/2,m.chartWidth-y))):y=b.plotX+m.plotLeft-u(g.distance,16)-y;0>y&&(n=!1);a=(b.series&&b.series.yAxis&&b.series.yAxis.pos)+(b.plotY||0);a-=m.plotTop;p.push({target:b.isHeader?m.plotHeight+z:a,rank:b.isHeader?1:0,size:x.tt.getBBox().height+1,point:b,x:y,tt:h})});this.cleanSplit();a.distribute(p,m.plotHeight+z);A(p,function(a){var b=a.point,c=b.series;a.tt.attr({visibility:void 0===
a.pos?"hidden":"inherit",x:n||b.isHeader?a.x:b.plotX+m.plotLeft+u(g.distance,16),y:a.pos+m.plotTop,anchorX:b.isHeader?b.plotX+m.plotLeft:b.plotX+c.xAxis.pos,anchorY:b.isHeader?a.pos+m.plotTop-15:b.plotY+c.yAxis.pos})})},updatePosition:function(a){var b=this.chart,d=this.getLabel(),d=(this.options.positioner||this.getPosition).call(this,d.width,d.height,a);this.move(Math.round(d.x),Math.round(d.y||0),a.plotX+b.plotLeft,a.plotY+b.plotTop)},getDateFormat:function(a,f,g,t){var b=B("%m-%d %H:%M:%S.%L",
f),c,n,p={millisecond:15,second:12,minute:9,hour:6,day:3},z="millisecond";for(n in d){if(a===d.week&&+B("%w",f)===g&&"00:00:00.000"===b.substr(6)){n="week";break}if(d[n]>a){n=z;break}if(p[n]&&b.substr(p[n])!=="01-01 00:00:00.000".substr(p[n]))break;"week"!==n&&(z=n)}n&&(c=t[n]);return c},getXDateFormat:function(a,d,f){d=d.dateTimeLabelFormats;var b=f&&f.closestPointRange;return(b?this.getDateFormat(b,a.x,f.options.startOfWeek,d):d.day)||d.year},tooltipFooterHeaderFormatter:function(a,d){var b=d?"footer":
"header";d=a.series;var f=d.tooltipOptions,m=f.xDateFormat,c=d.xAxis,n=c&&"datetime"===c.options.type&&r(a.key),b=f[b+"Format"];n&&!m&&(m=this.getXDateFormat(a,f,c));n&&m&&(b=b.replace("{point.key}","{point.key:"+m+"}"));return G(b,{point:a,series:d})},bodyFormatter:function(a){return g(a,function(a){var b=a.series.tooltipOptions;return(b.pointFormatter||a.point.tooltipFormatter).call(a.point,b.pointFormat)})}}})(L);(function(a){var B=a.addEvent,A=a.attr,H=a.charts,G=a.color,r=a.css,g=a.defined,f=
a.doc,u=a.each,l=a.extend,q=a.fireEvent,d=a.offset,b=a.pick,p=a.removeEvent,C=a.splat,t=a.Tooltip,m=a.win;a.Pointer=function(a,b){this.init(a,b)};a.Pointer.prototype={init:function(a,d){this.options=d;this.chart=a;this.runChartClick=d.chart.events&&!!d.chart.events.click;this.pinchDown=[];this.lastValidTouch={};t&&d.tooltip.enabled&&(a.tooltip=new t(a,d.tooltip),this.followTouchMove=b(d.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var c=this.chart,d=c.options.chart,m=d.zoomType||
"",c=c.inverted;/touch/.test(a.type)&&(m=b(d.pinchType,m));this.zoomX=a=/x/.test(m);this.zoomY=m=/y/.test(m);this.zoomHor=a&&!c||m&&c;this.zoomVert=m&&!c||a&&c;this.hasZoom=a||m},normalize:function(a,b){var c,n;a=a||m.event;a.target||(a.target=a.srcElement);n=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;b||(this.chartPosition=b=d(this.chart.container));void 0===n.pageX?(c=Math.max(a.x,a.clientX-b.left),b=a.y):(c=n.pageX-b.left,b=n.pageY-b.top);return l(a,{chartX:Math.round(c),
chartY:Math.round(b)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};u(this.chart.axes,function(c){b[c.isXAxis?"xAxis":"yAxis"].push({axis:c,value:c.toValue(a[c.horiz?"chartX":"chartY"])})});return b},runPointActions:function(c){var d=this.chart,m=d.series,p=d.tooltip,e=p?p.shared:!1,g=!0,t=d.hoverPoint,w=d.hoverSeries,h,y,l,q=[],r;if(!e&&!w)for(h=0;h<m.length;h++)if(m[h].directTouch||!m[h].options.stickyTracking)m=[];w&&(e?w.noSharedTooltip:w.directTouch)&&t?q=[t]:(e||!w||w.options.stickyTracking||
(m=[w]),u(m,function(a){y=a.noSharedTooltip&&e;l=!e&&a.directTouch;a.visible&&!y&&!l&&b(a.options.enableMouseTracking,!0)&&(r=a.searchPoint(c,!y&&1===a.kdDimensions))&&r.series&&q.push(r)}),q.sort(function(a,b){var c=a.distX-b.distX,h=a.dist-b.dist,k=(b.series.group&&b.series.group.zIndex)-(a.series.group&&a.series.group.zIndex);return 0!==c&&e?c:0!==h?h:0!==k?k:a.series.index>b.series.index?-1:1}));if(e)for(h=q.length;h--;)(q[h].x!==q[0].x||q[h].series.noSharedTooltip)&&q.splice(h,1);if(q[0]&&(q[0]!==
this.prevKDPoint||p&&p.isHidden)){if(e&&!q[0].series.noSharedTooltip){for(h=0;h<q.length;h++)q[h].onMouseOver(c,q[h]!==(w&&w.directTouch&&t||q[0]));q.length&&p&&p.refresh(q.sort(function(a,b){return a.series.index-b.series.index}),c)}else if(p&&p.refresh(q[0],c),!w||!w.directTouch)q[0].onMouseOver(c);this.prevKDPoint=q[0];g=!1}g&&(m=w&&w.tooltipOptions.followPointer,p&&m&&!p.isHidden&&(m=p.getAnchor([{}],c),p.updatePosition({plotX:m[0],plotY:m[1]})));this.unDocMouseMove||(this.unDocMouseMove=B(f,
"mousemove",function(b){if(H[a.hoverChartIndex])H[a.hoverChartIndex].pointer.onDocumentMouseMove(b)}));u(e?q:[b(t,q[0])],function(a){u(d.axes,function(b){(!a||a.series&&a.series[b.coll]===b)&&b.drawCrosshair(c,a)})})},reset:function(a,b){var c=this.chart,d=c.hoverSeries,e=c.hoverPoint,n=c.hoverPoints,m=c.tooltip,f=m&&m.shared?n:e;a&&f&&u(C(f),function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)m&&f&&(m.refresh(f),e&&(e.setState(e.state,!0),u(c.axes,function(a){a.crosshair&&a.drawCrosshair(null,
e)})));else{if(e)e.onMouseOut();n&&u(n,function(a){a.setState()});if(d)d.onMouseOut();m&&m.hide(b);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());u(c.axes,function(a){a.hideCrosshair()});this.hoverX=this.prevKDPoint=c.hoverPoints=c.hoverPoint=null}},scaleGroups:function(a,b){var c=this.chart,d;u(c.series,function(e){d=a||e.getPlotBox();e.xAxis&&e.xAxis.zoomEnabled&&e.group&&(e.group.attr(d),e.markerGroup&&(e.markerGroup.attr(d),e.markerGroup.clip(b?c.clipRect:null)),e.dataLabelsGroup&&
e.dataLabelsGroup.attr(d))});c.clipRect.attr(b||c.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,c=b.options.chart,d=a.chartX,e=a.chartY,m=this.zoomHor,f=this.zoomVert,p=b.plotLeft,h=b.plotTop,y=b.plotWidth,g=b.plotHeight,t,q=this.selectionMarker,k=this.mouseDownX,l=this.mouseDownY,r=c.panKey&&a[c.panKey+"Key"];q&&q.touch||(d<p?d=p:d>p+y&&(d=p+y),e<
h?e=h:e>h+g&&(e=h+g),this.hasDragged=Math.sqrt(Math.pow(k-d,2)+Math.pow(l-e,2)),10<this.hasDragged&&(t=b.isInsidePlot(k-p,l-h),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&t&&!r&&!q&&(this.selectionMarker=q=b.renderer.rect(p,h,m?1:y,f?1:g,0).attr({fill:c.selectionMarkerFill||G("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",zIndex:7}).add()),q&&m&&(d-=k,q.attr({width:Math.abs(d),x:(0<d?0:d)+k})),q&&f&&(d=e-l,q.attr({height:Math.abs(d),y:(0<d?0:d)+l})),t&&!q&&c.panning&&b.pan(a,
c.panning)))},drop:function(a){var b=this,c=this.chart,d=this.hasPinched;if(this.selectionMarker){var e={originalEvent:a,xAxis:[],yAxis:[]},m=this.selectionMarker,f=m.attr?m.attr("x"):m.x,p=m.attr?m.attr("y"):m.y,h=m.attr?m.attr("width"):m.width,y=m.attr?m.attr("height"):m.height,t;if(this.hasDragged||d)u(c.axes,function(c){if(c.zoomEnabled&&g(c.min)&&(d||b[{xAxis:"zoomX",yAxis:"zoomY"}[c.coll]])){var m=c.horiz,k="touchend"===a.type?c.minPixelPadding:0,n=c.toValue((m?f:p)+k),m=c.toValue((m?f+h:p+
y)-k);e[c.coll].push({axis:c,min:Math.min(n,m),max:Math.max(n,m)});t=!0}}),t&&q(c,"selection",e,function(a){c.zoom(l(a,d?{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();d&&this.scaleGroups()}c&&(r(c.container,{cursor:c._cursor}),c.cancelClick=10<this.hasDragged,c.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);this.zoomOption(a);a.preventDefault&&a.preventDefault();this.dragStart(a)},onDocumentMouseUp:function(b){H[a.hoverChartIndex]&&
H[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,c=this.chartPosition;a=this.normalize(a,c);!c||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var c=H[a.hoverChartIndex];c&&(b.relatedTarget||b.toElement)&&(c.pointer.reset(),c.pointer.chartPosition=null)},onContainerMouseMove:function(b){var c=this.chart;g(a.hoverChartIndex)&&H[a.hoverChartIndex]&&H[a.hoverChartIndex].mouseIsDown||
(a.hoverChartIndex=c.index);b=this.normalize(b);b.returnValue=!1;"mousedown"===c.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!c.isInsidePlot(b.chartX-c.plotLeft,b.chartY-c.plotTop)||c.openMenu||this.runPointActions(b)},inClass:function(a,b){for(var c;a;){if(c=A(a,"class")){if(-1!==c.indexOf(b))return!0;if(-1!==c.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;if(!(!b||!a||
b.options.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,c=b.hoverPoint,d=b.plotLeft,e=b.plotTop;a=this.normalize(a);b.cancelClick||(c&&this.inClass(a.target,"highcharts-tracker")?(q(c.series,"click",l(a,{point:c})),b.hoverPoint&&c.firePointEvent("click",a)):(l(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-d,a.chartY-e)&&q(b,"click",a)))},setDOMEvents:function(){var b=
this,d=b.chart.container;d.onmousedown=function(a){b.onContainerMouseDown(a)};d.onmousemove=function(a){b.onContainerMouseMove(a)};d.onclick=function(a){b.onContainerClick(a)};B(d,"mouseleave",b.onContainerMouseLeave);1===a.chartCount&&B(f,"mouseup",b.onDocumentMouseUp);a.hasTouch&&(d.ontouchstart=function(a){b.onContainerTouchStart(a)},d.ontouchmove=function(a){b.onContainerTouchMove(a)},1===a.chartCount&&B(f,"touchend",b.onDocumentTouchEnd))},destroy:function(){var b;p(this.chart.container,"mouseleave",
this.onContainerMouseLeave);a.chartCount||(p(f,"mouseup",this.onDocumentMouseUp),p(f,"touchend",this.onDocumentTouchEnd));clearInterval(this.tooltipTimeout);for(b in this)this[b]=null}}})(L);(function(a){var B=a.charts,A=a.each,H=a.extend,G=a.map,r=a.noop,g=a.pick;H(a.Pointer.prototype,{pinchTranslate:function(a,g,l,q,d,b){this.zoomHor&&this.pinchTranslateDirection(!0,a,g,l,q,d,b);this.zoomVert&&this.pinchTranslateDirection(!1,a,g,l,q,d,b)},pinchTranslateDirection:function(a,g,l,q,d,b,p,r){var f=
this.chart,m=a?"x":"y",c=a?"X":"Y",n="chart"+c,E=a?"width":"height",z=f["plot"+(a?"Left":"Top")],e,x,F=r||1,w=f.inverted,h=f.bounds[a?"h":"v"],y=1===g.length,J=g[0][n],u=l[0][n],I=!y&&g[1][n],k=!y&&l[1][n],D;l=function(){!y&&20<Math.abs(J-I)&&(F=r||Math.abs(u-k)/Math.abs(J-I));x=(z-u)/F+J;e=f["plot"+(a?"Width":"Height")]/F};l();g=x;g<h.min?(g=h.min,D=!0):g+e>h.max&&(g=h.max-e,D=!0);D?(u-=.8*(u-p[m][0]),y||(k-=.8*(k-p[m][1])),l()):p[m]=[u,k];w||(b[m]=x-z,b[E]=e);b=w?1/F:F;d[E]=e;d[m]=g;q[w?a?"scaleY":
"scaleX":"scale"+c]=F;q["translate"+c]=b*z+(u-b*J)},pinch:function(a){var f=this,l=f.chart,q=f.pinchDown,d=a.touches,b=d.length,p=f.lastValidTouch,C=f.hasZoom,t=f.selectionMarker,m={},c=1===b&&(f.inClass(a.target,"highcharts-tracker")&&l.runTrackerClick||f.runChartClick),n={};1<b&&(f.initiated=!0);C&&f.initiated&&!c&&a.preventDefault();G(d,function(a){return f.normalize(a)});"touchstart"===a.type?(A(d,function(a,b){q[b]={chartX:a.chartX,chartY:a.chartY}}),p.x=[q[0].chartX,q[1]&&q[1].chartX],p.y=[q[0].chartY,
q[1]&&q[1].chartY],A(l.axes,function(a){if(a.zoomEnabled){var b=l.bounds[a.horiz?"h":"v"],c=a.minPixelPadding,d=a.toPixels(g(a.options.min,a.dataMin)),m=a.toPixels(g(a.options.max,a.dataMax)),f=Math.max(d,m);b.min=Math.min(a.pos,Math.min(d,m)-c);b.max=Math.max(a.pos+a.len,f+c)}}),f.res=!0):f.followTouchMove&&1===b?this.runPointActions(f.normalize(a)):q.length&&(t||(f.selectionMarker=t=H({destroy:r,touch:!0},l.plotBox)),f.pinchTranslate(q,d,m,t,n,p),f.hasPinched=C,f.scaleGroups(m,n),f.res&&(f.res=
!1,this.reset(!1,0)))},touch:function(f,r){var l=this.chart,q,d;if(l.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=l.index;1===f.touches.length?(f=this.normalize(f),(d=l.isInsidePlot(f.chartX-l.plotLeft,f.chartY-l.plotTop))&&!l.openMenu?(r&&this.runPointActions(f),"touchmove"===f.type&&(r=this.pinchDown,q=r[0]?4<=Math.sqrt(Math.pow(r[0].chartX-f.chartX,2)+Math.pow(r[0].chartY-f.chartY,2)):!1),g(q,!0)&&this.pinch(f)):r&&this.reset()):2===f.touches.length&&
this.pinch(f)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(f){B[a.hoverChartIndex]&&B[a.hoverChartIndex].pointer.drop(f)}})})(L);(function(a){var B=a.addEvent,A=a.charts,H=a.css,G=a.doc,r=a.extend,g=a.noop,f=a.Pointer,u=a.removeEvent,l=a.win,q=a.wrap;if(l.PointerEvent||l.MSPointerEvent){var d={},b=!!l.PointerEvent,p=function(){var a,b=[];b.item=function(a){return this[a]};for(a in d)d.hasOwnProperty(a)&&
b.push({pageX:d[a].pageX,pageY:d[a].pageY,target:d[a].target});return b},C=function(b,d,c,f){"touch"!==b.pointerType&&b.pointerType!==b.MSPOINTER_TYPE_TOUCH||!A[a.hoverChartIndex]||(f(b),f=A[a.hoverChartIndex].pointer,f[d]({type:c,target:b.currentTarget,preventDefault:g,touches:p()}))};r(f.prototype,{onContainerPointerDown:function(a){C(a,"onContainerTouchStart","touchstart",function(a){d[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){C(a,"onContainerTouchMove",
"touchmove",function(a){d[a.pointerId]={pageX:a.pageX,pageY:a.pageY};d[a.pointerId].target||(d[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){C(a,"onDocumentTouchEnd","touchend",function(a){delete d[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,b?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,b?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(G,b?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});q(f.prototype,
"init",function(a,b,c){a.call(this,b,c);this.hasZoom&&H(b.container,{"-ms-touch-action":"none","touch-action":"none"})});q(f.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(B)});q(f.prototype,"destroy",function(a){this.batchMSEvents(u);a.call(this)})}})(L);(function(a){var B,A=a.addEvent,H=a.css,G=a.discardElement,r=a.defined,g=a.each,f=a.extend,u=a.isFirefox,l=a.marginNames,q=a.merge,d=a.pick,b=a.setAnimation,p=a.stableSort,C=a.win,t=a.wrap;
B=a.Legend=function(a,b){this.init(a,b)};B.prototype={init:function(a,b){this.chart=a;this.setOptions(b);b.enabled&&(this.render(),A(this.chart,"endResize",function(){this.legend.positionCheckboxes()}))},setOptions:function(a){var b=d(a.padding,8);this.options=a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=q(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=a.itemMarginTop||0;this.initialItemX=this.padding=b;this.initialItemY=b-5;this.itemHeight=this.maxItemWidth=0;this.symbolWidth=d(a.symbolWidth,
16);this.pages=[]},update:function(a,b){var c=this.chart;this.setOptions(q(!0,this.options,a));this.destroy();c.isDirtyLegend=c.isDirtyBox=!0;d(b,!0)&&c.redraw()},colorizeItem:function(a,b){a.legendGroup[b?"removeClass":"addClass"]("highcharts-legend-item-hidden");var c=this.options,d=a.legendItem,m=a.legendLine,e=a.legendSymbol,f=this.itemHiddenStyle.color,c=b?c.itemStyle.color:f,p=b?a.color||f:f,g=a.options&&a.options.marker,h={fill:p},y;d&&d.css({fill:c,color:c});m&&m.attr({stroke:p});if(e){if(g&&
e.isMarker&&(h=a.pointAttribs(),!b))for(y in h)h[y]=f;e.attr(h)}},positionItem:function(a){var b=this.options,d=b.symbolPadding,b=!b.rtl,m=a._legendItemPos,f=m[0],m=m[1],e=a.checkbox;(a=a.legendGroup)&&a.element&&a.translate(b?f:this.legendWidth-f-2*d-4,m);e&&(e.x=f,e.y=m)},destroyItem:function(a){var b=a.checkbox;g(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});b&&G(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}
g(this.getAllItems(),function(b){g(["legendItem","legendGroup"],a,b)});g(["box","title","group"],a,this);this.display=null},positionCheckboxes:function(a){var b=this.group&&this.group.alignAttr,d,m=this.clipHeight||this.legendHeight,f=this.titleHeight;b&&(d=b.translateY,g(this.allItems,function(c){var e=c.checkbox,n;e&&(n=d+f+e.y+(a||0)+3,H(e,{left:b.translateX+c.checkboxOffset+e.x-20+"px",top:n+"px",display:n>d-6&&n<d+m-6?"":"none"}))}))},renderTitle:function(){var a=this.padding,b=this.options.title,
d=0;b.text&&(this.title||(this.title=this.chart.renderer.label(b.text,a-3,a-4,null,null,null,null,null,"legend-title").attr({zIndex:1}).css(b.style).add(this.group)),a=this.title.getBBox(),d=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:d}));this.titleHeight=d},setText:function(b){var c=this.options;b.legendItem.attr({text:c.labelFormat?a.format(c.labelFormat,b):c.labelFormatter.call(b)})},renderItem:function(a){var b=this.chart,f=b.renderer,m=this.options,p="horizontal"===
m.layout,e=this.symbolWidth,g=m.symbolPadding,l=this.itemStyle,t=this.itemHiddenStyle,h=this.padding,y=p?d(m.itemDistance,20):0,J=!m.rtl,r=m.width,I=m.itemMarginBottom||0,k=this.itemMarginTop,u=this.initialItemX,C=a.legendItem,N=!a.series,A=!N&&a.series.drawLegendSymbol?a.series:a,B=A.options,B=this.createCheckboxForItem&&B&&B.showCheckbox,v=m.useHTML;C||(a.legendGroup=f.g("legend-item").addClass("highcharts-"+A.type+"-series highcharts-color-"+a.colorIndex+(a.options.className?" "+a.options.className:
"")+(N?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=C=f.text("",J?e+g:-g,this.baseline||0,v).css(q(a.visible?l:t)).attr({align:J?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(l=l.fontSize,this.fontMetrics=f.fontMetrics(l,C),this.baseline=this.fontMetrics.f+3+k,C.attr("y",this.baseline)),this.symbolHeight=m.symbolHeight||this.fontMetrics.f,A.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,C,v),B&&this.createCheckboxForItem(a));
this.colorizeItem(a,a.visible);this.setText(a);f=C.getBBox();e=a.checkboxOffset=m.itemWidth||a.legendItemWidth||e+g+f.width+y+(B?20:0);this.itemHeight=g=Math.round(a.legendItemHeight||f.height);p&&this.itemX-u+e>(r||b.chartWidth-2*h-u-m.x)&&(this.itemX=u,this.itemY+=k+this.lastLineHeight+I,this.lastLineHeight=0);this.maxItemWidth=Math.max(this.maxItemWidth,e);this.lastItemY=k+this.itemY+I;this.lastLineHeight=Math.max(g,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];p?this.itemX+=e:
(this.itemY+=k+g+I,this.lastLineHeight=g);this.offsetWidth=r||Math.max((p?this.itemX-u-y:e)+h,this.offsetWidth)},getAllItems:function(){var a=[];g(this.chart.series,function(b){var c=b&&b.options;b&&d(c.showInLegend,r(c.linkedTo)?!1:void 0,!0)&&(a=a.concat(b.legendItems||("point"===c.legendType?b.data:b)))});return a},adjustMargins:function(a,b){var c=this.chart,f=this.options,m=f.align.charAt(0)+f.verticalAlign.charAt(0)+f.layout.charAt(0);f.floating||g([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,
/(lbv|lm|ltv)/],function(e,n){e.test(m)&&!r(a[n])&&(c[l[n]]=Math.max(c[l[n]],c.legend[(n+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][n]*f[n%2?"x":"y"]+d(f.margin,12)+b[n]))})},render:function(){var a=this,b=a.chart,d=b.renderer,q=a.group,l,e,t,r,w=a.box,h=a.options,y=a.padding;a.itemX=a.initialItemX;a.itemY=a.initialItemY;a.offsetWidth=0;a.lastItemY=0;q||(a.group=q=d.g("legend").attr({zIndex:7}).add(),a.contentGroup=d.g().attr({zIndex:1}).add(q),a.scrollGroup=d.g().add(a.contentGroup));a.renderTitle();
l=a.getAllItems();p(l,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});h.reversed&&l.reverse();a.allItems=l;a.display=e=!!l.length;a.lastLineHeight=0;g(l,function(b){a.renderItem(b)});t=(h.width||a.offsetWidth)+y;r=a.lastItemY+a.lastLineHeight+a.titleHeight;r=a.handleOverflow(r);r+=y;w||(a.box=w=d.rect().addClass("highcharts-legend-box").attr({r:h.borderRadius}).add(q),w.isNew=!0);w.attr({stroke:h.borderColor,"stroke-width":h.borderWidth||0,fill:h.backgroundColor||
"none"}).shadow(h.shadow);0<t&&0<r&&(w[w.isNew?"attr":"animate"](w.crisp({x:0,y:0,width:t,height:r},w.strokeWidth())),w.isNew=!1);w[e?"show":"hide"]();a.legendWidth=t;a.legendHeight=r;g(l,function(b){a.positionItem(b)});e&&q.align(f({width:t,height:r},h),!0,"spacingBox");b.isResizing||this.positionCheckboxes()},handleOverflow:function(a){var b=this,f=this.chart,m=f.renderer,p=this.options,e=p.y,f=f.spacingBox.height+("top"===p.verticalAlign?-e:e)-this.padding,e=p.maxHeight,q,l=this.clipRect,t=p.navigation,
h=d(t.animation,!0),y=t.arrowSize||12,r=this.nav,u=this.pages,I=this.padding,k,D=this.allItems,C=function(a){a?l.attr({height:a}):l&&(b.clipRect=l.destroy(),b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=a?"rect("+I+"px,9999px,"+(I+a)+"px,0)":"auto")};"horizontal"!==p.layout||"middle"===p.verticalAlign||p.floating||(f/=2);e&&(f=Math.min(f,e));u.length=0;a>f&&!1!==t.enabled?(this.clipHeight=q=Math.max(f-20-this.titleHeight-I,0),this.currentPage=d(this.currentPage,1),this.fullHeight=
a,g(D,function(a,b){var c=a._legendItemPos[1];a=Math.round(a.legendItem.getBBox().height);var e=u.length;if(!e||c-u[e-1]>q&&(k||c)!==u[e-1])u.push(k||c),e++;b===D.length-1&&c+a-u[e-1]>q&&u.push(c);c!==k&&(k=c)}),l||(l=b.clipRect=m.clipRect(0,I,9999,0),b.contentGroup.clip(l)),C(q),r||(this.nav=r=m.g().attr({zIndex:1}).add(this.group),this.up=m.symbol("triangle",0,0,y,y).on("click",function(){b.scroll(-1,h)}).add(r),this.pager=m.text("",15,10).addClass("highcharts-legend-navigation").css(t.style).add(r),
this.down=m.symbol("triangle-down",0,0,y,y).on("click",function(){b.scroll(1,h)}).add(r)),b.scroll(0),a=f):r&&(C(),r.hide(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,c){var d=this.pages,f=d.length;a=this.currentPage+a;var m=this.clipHeight,e=this.options.navigation,p=this.pager,g=this.padding;a>f&&(a=f);0<a&&(void 0!==c&&b(c,this.chart),this.nav.attr({translateX:g,translateY:m+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===
a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),p.attr({text:a+"/"+f}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===f?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),this.up.attr({fill:1===a?e.inactiveColor:e.activeColor}).css({cursor:1===a?"default":"pointer"}),this.down.attr({fill:a===f?e.inactiveColor:e.activeColor}).css({cursor:a===f?"default":"pointer"}),c=-d[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:c}),this.currentPage=
a,this.positionCheckboxes(c))}};a.LegendSymbolMixin={drawRectangle:function(a,b){var c=a.symbolHeight,f=a.options.squareSymbol;b.legendSymbol=this.chart.renderer.rect(f?(a.symbolWidth-c)/2:0,a.baseline-c+1,f?c:a.symbolWidth,c,d(a.options.symbolRadius,c/2)).addClass("highcharts-point").attr({zIndex:3}).add(b.legendGroup)},drawLineMarker:function(a){var b=this.options,f=b.marker,m=a.symbolWidth,p=a.symbolHeight,e=p/2,g=this.chart.renderer,l=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);
var t;t={"stroke-width":b.lineWidth||0};b.dashStyle&&(t.dashstyle=b.dashStyle);this.legendLine=g.path(["M",0,a,"L",m,a]).addClass("highcharts-graph").attr(t).add(l);f&&!1!==f.enabled&&(b=Math.min(d(f.radius,e),e),0===this.symbol.indexOf("url")&&(f=q(f,{width:p,height:p}),b=0),this.legendSymbol=f=g.symbol(this.symbol,m/2-b,a-b,2*b,2*b,f).addClass("highcharts-point").add(l),f.isMarker=!0)}};(/Trident\/7\.0/.test(C.navigator.userAgent)||u)&&t(B.prototype,"positionItem",function(a,b){var c=this,d=function(){b._legendItemPos&&
a.call(c,b)};d();setTimeout(d)})})(L);(function(a){var B=a.addEvent,A=a.animate,H=a.animObject,G=a.attr,r=a.doc,g=a.Axis,f=a.createElement,u=a.defaultOptions,l=a.discardElement,q=a.charts,d=a.css,b=a.defined,p=a.each,C=a.extend,t=a.find,m=a.fireEvent,c=a.getStyle,n=a.grep,E=a.isNumber,z=a.isObject,e=a.isString,x=a.Legend,F=a.marginNames,w=a.merge,h=a.Pointer,y=a.pick,J=a.pInt,K=a.removeEvent,I=a.seriesTypes,k=a.splat,D=a.svg,P=a.syncTimeout,N=a.win,S=a.Renderer,O=a.Chart=function(){this.getArgs.apply(this,
arguments)};a.chart=function(a,b,c){return new O(a,b,c)};O.prototype={callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(e(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(b,c){var e,h=b.series;b.series=null;e=w(u,b);e.series=b.series=h;this.userOptions=b;this.respRules=[];b=e.chart;h=b.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.callback=c;this.isResizing=0;this.options=e;this.axes=[];this.series=[];this.hasCartesianSeries=b.showAxes;
var d;this.index=q.length;q.push(this);a.chartCount++;if(h)for(d in h)B(this,d,h[d]);this.xAxis=[];this.yAxis=[];this.pointCount=this.colorCounter=this.symbolCounter=0;this.firstRender()},initSeries:function(b){var c=this.options.chart;(c=I[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].name||"Series "+(b[a].index+1))},isInsidePlot:function(a,b,c){var e=c?
b:a;a=c?a:b;return 0<=e&&e<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(b){var c=this.axes,e=this.series,h=this.pointer,d=this.legend,k=this.isDirtyLegend,f,n,y=this.hasCartesianSeries,g=this.isDirtyBox,v=e.length,l=v,q=this.renderer,t=q.isHidden(),w=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(b,this);t&&this.cloneRenderTo();for(this.layOutTitles();l--;)if(b=e[l],b.options.stacking&&(f=!0,b.isDirty)){n=!0;break}if(n)for(l=v;l--;)b=e[l],b.options.stacking&&(b.isDirty=
!0);p(e,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),k=!0);a.isDirtyData&&m(a,"updatedData")});k&&d.options.enabled&&(d.render(),this.isDirtyLegend=!1);f&&this.getStacks();y&&p(c,function(a){a.updateNames();a.setScale()});this.getMargins();y&&(p(c,function(a){a.isDirty&&(g=!0)}),p(c,function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,w.push(function(){m(a,"afterSetExtremes",C(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(g||f)&&a.redraw()}));
g&&this.drawChartBox();m(this,"predraw");p(e,function(a){(g||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});h&&h.reset(!0);q.draw();m(this,"redraw");m(this,"render");t&&this.cloneRenderTo(!0);p(w,function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var c,e=this.series,h;c=t(this.axes,b)||t(this.series,b);for(h=0;!c&&h<e.length;h++)c=t(e[h].points||[],b);return c},getAxes:function(){var a=this,b=this.options,c=b.xAxis=k(b.xAxis||{}),b=b.yAxis=k(b.yAxis||
{});p(c,function(a,b){a.index=b;a.isX=!0});p(b,function(a,b){a.index=b});c=c.concat(b);p(c,function(b){new g(a,b)})},getSelectedPoints:function(){var a=[];p(this.series,function(b){a=a.concat(n(b.points||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return n(this.series,function(a){return a.selected})},setTitle:function(a,b,c){var e=this,h=e.options,d;d=h.title=w({style:{color:"#333333",fontSize:h.isStock?"16px":"18px"}},h.title,a);h=h.subtitle=w({style:{color:"#666666"}},
h.subtitle,b);p([["title",a,d],["subtitle",b,h]],function(a,b){var c=a[0],h=e[c],d=a[1];a=a[2];h&&d&&(e[c]=h=h.destroy());a&&a.text&&!h&&(e[c]=e.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),e[c].update=function(a){e.setTitle(!b&&a,b&&a)},e[c].css(a.style))});e.layOutTitles(c)},layOutTitles:function(a){var b=0,c,e=this.renderer,h=this.spacingBox;p(["title","subtitle"],function(a){var c=this[a],d=this.options[a],k;c&&(k=d.style.fontSize,
k=e.fontMetrics(k,c).b,c.css({width:(d.width||h.width+d.widthAdjust)+"px"}).align(C({y:b+k+("title"===a?-3:2)},d),!1,"spacingBox"),d.floating||d.verticalAlign||(b=Math.ceil(b+c.getBBox().height)))},this);c=this.titleOffset!==b;this.titleOffset=b;!this.isDirtyBox&&c&&(this.isDirtyBox=c,this.hasRendered&&y(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var a=this.options.chart,e=a.width,a=a.height,h=this.renderToClone||this.renderTo;b(e)||(this.containerWidth=c(h,"width"));b(a)||(this.containerHeight=
c(h,"height"));this.chartWidth=Math.max(0,e||this.containerWidth||600);this.chartHeight=Math.max(0,a||this.containerHeight||400)},cloneRenderTo:function(a){var b=this.renderToClone,c=this.container;if(a){if(b){for(;b.childNodes.length;)this.renderTo.appendChild(b.firstChild);l(b);delete this.renderToClone}}else c&&c.parentNode===this.renderTo&&this.renderTo.removeChild(c),this.renderToClone=b=this.renderTo.cloneNode(0),d(b,{position:"absolute",top:"-9999px",display:"block"}),b.style.setProperty&&
b.style.setProperty("display","block","important"),r.body.appendChild(b),c&&b.appendChild(c)},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var b,c=this.options,h=c.chart,d,k;b=this.renderTo;var m=a.uniqueKey(),n;b||(this.renderTo=b=h.renderTo);e(b)&&(this.renderTo=b=r.getElementById(b));b||a.error(13,!0);d=J(G(b,"data-highcharts-chart"));E(d)&&q[d]&&q[d].hasRendered&&q[d].destroy();G(b,"data-highcharts-chart",this.index);b.innerHTML="";
h.skipClone||b.offsetWidth||this.cloneRenderTo();this.getChartSize();d=this.chartWidth;k=this.chartHeight;n=C({position:"relative",overflow:"hidden",width:d+"px",height:k+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},h.style);this.container=b=f("div",{id:m},n,this.renderToClone||b);this._cursor=b.style.cursor;this.renderer=new (a[h.renderer]||S)(b,d,k,null,h.forExport,c.exporting&&c.exporting.allowHTML);this.setClassName(h.className);this.renderer.setStyle(h.style);
this.renderer.chartIndex=this.index},getMargins:function(a){var c=this.spacing,e=this.margin,h=this.titleOffset;this.resetMargins();h&&!b(e[0])&&(this.plotTop=Math.max(this.plotTop,h+this.options.title.margin+c[0]));this.legend.display&&this.legend.adjustMargins(e,c);this.extraMargin&&(this[this.extraMargin.type]=(this[this.extraMargin.type]||0)+this.extraMargin.value);this.extraTopMargin&&(this.plotTop+=this.extraTopMargin);a||this.getAxisMargins()},getAxisMargins:function(){var a=this,c=a.axisOffset=
[0,0,0,0],e=a.margin;a.hasCartesianSeries&&p(a.axes,function(a){a.visible&&a.getOffset()});p(F,function(h,d){b(e[d])||(a[h]+=c[d])});a.setChartSize()},reflow:function(a){var e=this,h=e.options.chart,d=e.renderTo,k=b(h.width),f=h.width||c(d,"width"),h=h.height||c(d,"height"),d=a?a.target:N;if(!k&&!e.isPrinting&&f&&h&&(d===N||d===r)){if(f!==e.containerWidth||h!==e.containerHeight)clearTimeout(e.reflowTimeout),e.reflowTimeout=P(function(){e.container&&e.setSize(void 0,void 0,!1)},a?100:0);e.containerWidth=
f;e.containerHeight=h}},initReflow:function(){var a=this,b;b=B(N,"resize",function(b){a.reflow(b)});B(a,"destroy",b)},setSize:function(b,c,e){var h=this,k=h.renderer;h.isResizing+=1;a.setAnimation(e,h);h.oldChartHeight=h.chartHeight;h.oldChartWidth=h.chartWidth;void 0!==b&&(h.options.chart.width=b);void 0!==c&&(h.options.chart.height=c);h.getChartSize();b=k.globalAnimation;(b?A:d)(h.container,{width:h.chartWidth+"px",height:h.chartHeight+"px"},b);h.setChartSize(!0);k.setSize(h.chartWidth,h.chartHeight,
e);p(h.axes,function(a){a.isDirty=!0;a.setScale()});h.isDirtyLegend=!0;h.isDirtyBox=!0;h.layOutTitles();h.getMargins();h.redraw(e);h.oldChartHeight=null;m(h,"resize");P(function(){h&&m(h,"endResize",null,function(){--h.isResizing})},H(b).duration)},setChartSize:function(a){var b=this.inverted,c=this.renderer,e=this.chartWidth,h=this.chartHeight,d=this.options.chart,k=this.spacing,f=this.clipOffset,m,n,y,g;this.plotLeft=m=Math.round(this.plotLeft);this.plotTop=n=Math.round(this.plotTop);this.plotWidth=
y=Math.max(0,Math.round(e-m-this.marginRight));this.plotHeight=g=Math.max(0,Math.round(h-n-this.marginBottom));this.plotSizeX=b?g:y;this.plotSizeY=b?y:g;this.plotBorderWidth=d.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:k[3],y:k[0],width:e-k[3]-k[1],height:h-k[0]-k[2]};this.plotBox=c.plotBox={x:m,y:n,width:y,height:g};e=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(e,f[3])/2);c=Math.ceil(Math.max(e,f[0])/2);this.clipBox={x:b,y:c,width:Math.floor(this.plotSizeX-Math.max(e,f[1])/
2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(e,f[2])/2-c))};a||p(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()})},resetMargins:function(){var a=this,b=a.options.chart;p(["margin","spacing"],function(c){var e=b[c],h=z(e)?e:[e,e,e,e];p(["Top","Right","Bottom","Left"],function(e,d){a[c][d]=y(b[c+e],h[d])})});p(F,function(b,c){a[b]=y(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=
this.chartWidth,e=this.chartHeight,h=this.chartBackground,d=this.plotBackground,k=this.plotBorder,f,m=this.plotBGImage,n=a.backgroundColor,p=a.plotBackgroundColor,y=a.plotBackgroundImage,g,l=this.plotLeft,q=this.plotTop,t=this.plotWidth,w=this.plotHeight,x=this.plotBox,r=this.clipRect,z=this.clipBox,J="animate";h||(this.chartBackground=h=b.rect().addClass("highcharts-background").add(),J="attr");f=a.borderWidth||0;g=f+(a.shadow?8:0);n={fill:n||"none"};if(f||h["stroke-width"])n.stroke=a.borderColor,
n["stroke-width"]=f;h.attr(n).shadow(a.shadow);h[J]({x:g/2,y:g/2,width:c-g-f%2,height:e-g-f%2,r:a.borderRadius});J="animate";d||(J="attr",this.plotBackground=d=b.rect().addClass("highcharts-plot-background").add());d[J](x);d.attr({fill:p||"none"}).shadow(a.plotShadow);y&&(m?m.animate(x):this.plotBGImage=b.image(y,l,q,t,w).add());r?r.animate({width:z.width,height:z.height}):this.clipRect=b.clipRect(z);J="animate";k||(J="attr",this.plotBorder=k=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());
k.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});k[J](k.crisp({x:l,y:q,width:t,height:w},-k.strokeWidth()));this.isDirtyBox=!1},propFromSeries:function(){var a=this,b=a.options.chart,c,e=a.options.series,h,d;p(["inverted","angular","polar"],function(k){c=I[b.type||b.defaultSeriesType];d=b[k]||c&&c.prototype[k];for(h=e&&e.length;!d&&h--;)(c=I[e[h].type])&&c.prototype[k]&&(d=!0);a[k]=d})},linkSeries:function(){var a=this,b=a.series;p(b,function(a){a.linkedSeries.length=
0});p(b,function(b){var c=b.options.linkedTo;e(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=y(b.options.visible,c.options.visible,b.visible))})},renderSeries:function(){p(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&p(b.items,function(c){var e=C(b.style,c.style),h=J(e.left)+a.plotLeft,d=J(e.top)+a.plotTop+12;delete e.left;delete e.top;a.renderer.text(c.html,
h,d).attr({zIndex:2}).css(e).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,e,h,d;this.setTitle();this.legend=new x(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;e=this.plotHeight-=21;p(a,function(a){a.setScale()});this.getAxisMargins();h=1.1<c/this.plotWidth;d=1.05<e/this.plotHeight;if(h||d)p(a,function(a){(a.horiz&&h||!a.horiz&&d)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&
p(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=w(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(N.location.href=a.href)}).attr({align:a.position.align,
zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,c=b.axes,e=b.series,h=b.container,d,k=h&&h.parentNode;m(b,"destroy");q[b.index]=void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");K(b);for(d=c.length;d--;)c[d]=c[d].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(d=e.length;d--;)e[d]=e[d].destroy();p("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),
function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});h&&(h.innerHTML="",K(h),k&&l(h));for(d in b)delete b[d]},isReadyToRender:function(){var a=this;return D||N!=N.top||"complete"===r.readyState?!0:(r.attachEvent("onreadystatechange",function(){r.detachEvent("onreadystatechange",a.firstRender);"complete"===r.readyState&&a.firstRender()}),!1)},firstRender:function(){var a=this,b=a.options;if(a.isReadyToRender()){a.getContainer();m(a,"init");a.resetMargins();a.setChartSize();a.propFromSeries();
a.getAxes();p(b.series||[],function(b){a.initSeries(b)});a.linkSeries();m(a,"beforeRender");h&&(a.pointer=new h(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.cloneRenderTo(!0)}},onload:function(){p([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);m(this,"load");m(this,"render");b(this.index)&&!1!==this.options.chart.reflow&&this.initReflow();this.onload=null}}})(L);(function(a){var B,A=a.each,H=a.extend,G=a.erase,r=a.fireEvent,
g=a.format,f=a.isArray,u=a.isNumber,l=a.pick,q=a.removeEvent;B=a.Point=function(){};B.prototype={init:function(a,b,f){this.series=a;this.color=a.color;this.applyOptions(b,f);a.options.colorByPoint?(b=a.options.colors||a.chart.options.colors,this.color=this.color||b[a.colorCounter],b=b.length,f=a.colorCounter,a.colorCounter++,a.colorCounter===b&&(a.colorCounter=0)):f=a.colorIndex;this.colorIndex=l(this.colorIndex,f);a.chart.pointCount++;return this},applyOptions:function(a,b){var d=this.series,f=d.options.pointValKey||
d.pointValKey;a=B.prototype.optionsToObject.call(this,a);H(this,a);this.options=this.options?H(this.options,a):a;a.group&&delete this.group;f&&(this.y=this[f]);this.isNull=l(this.isValid&&!this.isValid(),null===this.x||!u(this.y,!0));this.selected&&(this.state="select");"name"in this&&void 0===b&&d.xAxis&&d.xAxis.hasNames&&(this.x=d.xAxis.nameToX(this));void 0===this.x&&d&&(this.x=void 0===b?d.autoIncrement(this):b);return this},optionsToObject:function(a){var b={},d=this.series,g=d.options.keys,
l=g||d.pointArrayMap||["y"],m=l.length,c=0,n=0;if(u(a)||null===a)b[l[0]]=a;else if(f(a))for(!g&&a.length>m&&(d=typeof a[0],"string"===d?b.name=a[0]:"number"===d&&(b.x=a[0]),c++);n<m;)g&&void 0===a[c]||(b[l[n]]=a[c]),c++,n++;else"object"===typeof a&&(b=a,a.dataLabels&&(d._hasPointLabels=!0),a.marker&&(d._hasPointMarkers=!0));return b},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":
"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,b=a.zones,a=a.zoneAxis||"y",f=0,g;for(g=b[f];this[a]>=g.value;)g=b[++f];g&&g.color&&!this.options.color&&(this.color=g.color);return g},destroy:function(){var a=this.series.chart,b=a.hoverPoints,f;a.pointCount--;b&&(this.setState(),G(b,this),b.length||
(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)q(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(f in this)this[f]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],b,f=6;f--;)b=a[f],this[b]&&(this[b]=this[b].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,
point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var b=this.series,d=b.tooltipOptions,f=l(d.valueDecimals,""),q=d.valuePrefix||"",m=d.valueSuffix||"";A(b.pointArrayMap||["y"],function(b){b="{point."+b;if(q||m)a=a.replace(b+"}",q+b+"}"+m);a=a.replace(b+"}",b+":,."+f+"f}")});return g(a,{point:this,series:this.series})},firePointEvent:function(a,b,f){var d=this,g=this.series.options;(g.point.events[a]||d.options&&d.options.events&&d.options.events[a])&&
this.importEvents();"click"===a&&g.allowPointSelect&&(f=function(a){d.select&&d.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});r(this,a,b,f)},visible:!0}})(L);(function(a){var B=a.addEvent,A=a.animObject,H=a.arrayMax,G=a.arrayMin,r=a.correctFloat,g=a.Date,f=a.defaultOptions,u=a.defaultPlotOptions,l=a.defined,q=a.each,d=a.erase,b=a.extend,p=a.fireEvent,C=a.grep,t=a.isArray,m=a.isNumber,c=a.isString,n=a.merge,E=a.pick,z=a.removeEvent,e=a.splat,x=a.SVGElement,F=a.syncTimeout,w=a.win;a.Series=a.seriesType("line",
null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",radius:4,states:{hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",
x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{hover:{lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,c){var e=this,h,d,k=a.series,f;e.chart=a;e.options=c=e.setOptions(c);e.linkedSeries=[];e.bindAxes();b(e,{name:c.name,state:"",visible:!1!==
c.visible,selected:!0===c.selected});d=c.events;for(h in d)B(e,h,d[h]);if(d&&d.click||c.point&&c.point.events&&c.point.events.click||c.allowPointSelect)a.runTrackerClick=!0;e.getColor();e.getSymbol();q(e.parallelArrays,function(a){e[a+"Data"]=[]});e.setData(c.data,!1);e.isCartesian&&(a.hasCartesianSeries=!0);k.length&&(f=k[k.length-1]);e._i=E(f&&f._i,-1)+1;a.orderSeries(this.insert(k))},insert:function(a){var b=this.options.index,c;if(m(b)){for(c=a.length;c--;)if(b>=E(a[c].options.index,a[c]._i)){a.splice(c+
1,0,this);break}-1===c&&a.unshift(this);c+=1}else a.push(this);return E(c,a.length-1)},bindAxes:function(){var b=this,c=b.options,e=b.chart,d;q(b.axisTypes||[],function(h){q(e[h],function(a){d=a.options;if(c[h]===d.index||void 0!==c[h]&&c[h]===d.id||void 0===c[h]&&0===d.index)b.insert(a.series),b[h]=a,a.isDirty=!0});b[h]||b.optionalAxis===h||a.error(18,!0)})},updateParallelArrays:function(a,b){var c=a.series,e=arguments,h=m(b)?function(e){var h="y"===e&&c.toYData?c.toYData(a):a[e];c[e+"Data"][b]=
h}:function(a){Array.prototype[b].apply(c[a+"Data"],Array.prototype.slice.call(e,2))};q(c.parallelArrays,h)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,e=a.pointIntervalUnit,b=E(b,a.pointStart,0);this.pointInterval=c=E(this.pointInterval,a.pointInterval,1);e&&(a=new g(b),"day"===e?a=+a[g.hcSetDate](a[g.hcGetDate]()+c):"month"===e?a=+a[g.hcSetMonth](a[g.hcGetMonth]()+c):"year"===e&&(a=+a[g.hcSetFullYear](a[g.hcGetFullYear]()+c)),c=a-b);this.xIncrement=b+c;return b},setOptions:function(a){var b=
this.chart,c=b.options.plotOptions,b=b.userOptions||{},e=b.plotOptions||{},h=c[this.type];this.userOptions=a;c=n(h,c.series,a);this.tooltipOptions=n(f.tooltip,f.plotOptions[this.type].tooltip,b.tooltip,e.series&&e.series.tooltip,e[this.type]&&e[this.type].tooltip,a.tooltip);null===h.marker&&delete c.marker;this.zoneAxis=c.zoneAxis;a=this.zones=(c.zones||[]).slice();!c.negativeColor&&!c.negativeFillColor||c.zones||a.push({value:c[this.zoneAxis+"Threshold"]||c.threshold||0,className:"highcharts-negative",
color:c.negativeColor,fillColor:c.negativeFillColor});a.length&&l(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});return c},getCyclic:function(a,b,c){var e,h=this.chart,d=this.userOptions,f=a+"Index",n=a+"Counter",m=c?c.length:E(h.options.chart[a+"Count"],h[a+"Count"]);b||(e=E(d[f],d["_"+f]),l(e)||(h.series.length||(h[n]=0),d["_"+f]=e=h[n]%m,h[n]+=1),c&&(b=c[e]));void 0!==e&&(this[f]=e);this[a]=b},getColor:function(){this.options.colorByPoint?this.options.color=null:this.getCyclic("color",
this.options.color||u[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,setData:function(b,e,d,f){var h=this,k=h.points,n=k&&k.length||0,g,p=h.options,y=h.chart,l=null,w=h.xAxis,x=p.turboThreshold,r=this.xData,z=this.yData,F=(g=h.pointArrayMap)&&g.length;b=b||[];g=b.length;e=E(e,!0);if(!1!==f&&g&&n===g&&!h.cropped&&!h.hasGroupedData&&h.visible)q(b,function(a,
b){k[b].update&&a!==p.data[b]&&k[b].update(a,!1,null,!1)});else{h.xIncrement=null;h.colorCounter=0;q(this.parallelArrays,function(a){h[a+"Data"].length=0});if(x&&g>x){for(d=0;null===l&&d<g;)l=b[d],d++;if(m(l))for(d=0;d<g;d++)r[d]=this.autoIncrement(),z[d]=b[d];else if(t(l))if(F)for(d=0;d<g;d++)l=b[d],r[d]=l[0],z[d]=l.slice(1,F+1);else for(d=0;d<g;d++)l=b[d],r[d]=l[0],z[d]=l[1];else a.error(12)}else for(d=0;d<g;d++)void 0!==b[d]&&(l={series:h},h.pointClass.prototype.applyOptions.apply(l,[b[d]]),h.updateParallelArrays(l,
d));c(z[0])&&a.error(14,!0);h.data=[];h.options.data=h.userOptions.data=b;for(d=n;d--;)k[d]&&k[d].destroy&&k[d].destroy();w&&(w.minRange=w.userMinRange);h.isDirty=y.isDirtyBox=!0;h.isDirtyData=!!k;d=!1}"point"===p.legendType&&(this.processData(),this.generatePoints());e&&y.redraw(d)},processData:function(b){var c=this.xData,e=this.yData,h=c.length,d;d=0;var k,f,n=this.xAxis,m,g=this.options;m=g.cropThreshold;var p=this.getExtremesFromAll||g.getExtremesFromAll,l=this.isCartesian,g=n&&n.val2lin,q=n&&
n.isLog,t,w;if(l&&!this.isDirty&&!n.isDirty&&!this.yAxis.isDirty&&!b)return!1;n&&(b=n.getExtremes(),t=b.min,w=b.max);if(l&&this.sorted&&!p&&(!m||h>m||this.forceCrop))if(c[h-1]<t||c[0]>w)c=[],e=[];else if(c[0]<t||c[h-1]>w)d=this.cropData(this.xData,this.yData,t,w),c=d.xData,e=d.yData,d=d.start,k=!0;for(m=c.length||1;--m;)h=q?g(c[m])-g(c[m-1]):c[m]-c[m-1],0<h&&(void 0===f||h<f)?f=h:0>h&&this.requireSorting&&a.error(15);this.cropped=k;this.cropStart=d;this.processedXData=c;this.processedYData=e;this.closestPointRange=
f},cropData:function(a,b,c,e){var h=a.length,d=0,f=h,n=E(this.cropShoulder,1),m;for(m=0;m<h;m++)if(a[m]>=c){d=Math.max(0,m-n);break}for(c=m;c<h;c++)if(a[c]>e){f=c+n;break}return{xData:a.slice(d,f),yData:b.slice(d,f),start:d,end:f}},generatePoints:function(){var a=this.options.data,b=this.data,c,d=this.processedXData,f=this.processedYData,k=this.pointClass,n=d.length,m=this.cropStart||0,g,p=this.hasGroupedData,l,q=[],t;b||p||(b=[],b.length=a.length,b=this.data=b);for(t=0;t<n;t++)g=m+t,p?(l=(new k).init(this,
[d[t]].concat(e(f[t]))),l.dataGroup=this.groupMap[t]):(l=b[g])||void 0===a[g]||(b[g]=l=(new k).init(this,a[g],d[t])),l.index=g,q[t]=l;if(b&&(n!==(c=b.length)||p))for(t=0;t<c;t++)t!==m||p||(t+=n),b[t]&&(b[t].destroyElements(),b[t].plotX=void 0);this.data=b;this.points=q},getExtremes:function(a){var b=this.yAxis,c=this.processedXData,e,h=[],d=0;e=this.xAxis.getExtremes();var f=e.min,n=e.max,g,p,l,q;a=a||this.stackedYData||this.processedYData||[];e=a.length;for(q=0;q<e;q++)if(p=c[q],l=a[q],g=(m(l,!0)||
t(l))&&(!b.isLog||l.length||0<l),p=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(c[q+1]||p)>=f&&(c[q-1]||p)<=n,g&&p)if(g=l.length)for(;g--;)null!==l[g]&&(h[d++]=l[g]);else h[d++]=l;this.dataMin=G(h);this.dataMax=H(h)},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,b=a.stacking,c=this.xAxis,e=c.categories,d=this.yAxis,k=this.points,f=k.length,n=!!this.modifyValue,g=a.pointPlacement,p="between"===g||m(g),q=a.threshold,
t=a.startFromThreshold?q:0,w,x,z,F,u=Number.MAX_VALUE;"between"===g&&(g=.5);m(g)&&(g*=E(a.pointRange||c.pointRange));for(a=0;a<f;a++){var C=k[a],A=C.x,B=C.y;x=C.low;var H=b&&d.stacks[(this.negStacks&&B<(t?0:q)?"-":"")+this.stackKey],G;d.isLog&&null!==B&&0>=B&&(C.isNull=!0);C.plotX=w=r(Math.min(Math.max(-1E5,c.translate(A,0,0,0,1,g,"flags"===this.type)),1E5));b&&this.visible&&!C.isNull&&H&&H[A]&&(F=this.getStackIndicator(F,A,this.index),G=H[A],B=G.points[F.key],x=B[0],B=B[1],x===t&&F.key===H[A].base&&
(x=E(q,d.min)),d.isLog&&0>=x&&(x=null),C.total=C.stackTotal=G.total,C.percentage=G.total&&C.y/G.total*100,C.stackY=B,G.setOffset(this.pointXOffset||0,this.barW||0));C.yBottom=l(x)?d.translate(x,0,1,0,1):null;n&&(B=this.modifyValue(B,C));C.plotY=x="number"===typeof B&&Infinity!==B?Math.min(Math.max(-1E5,d.translate(B,0,1,0,1)),1E5):void 0;C.isInside=void 0!==x&&0<=x&&x<=d.len&&0<=w&&w<=c.len;C.clientX=p?r(c.translate(A,0,0,0,1,g)):w;C.negative=C.y<(q||0);C.category=e&&void 0!==e[C.x]?e[C.x]:C.x;C.isNull||
(void 0!==z&&(u=Math.min(u,Math.abs(w-z))),z=w);C.zone=this.zones.length&&C.getZone()}this.closestPointRangePx=u},getValidPoints:function(a,b){var c=this.chart;return C(a||this.points||[],function(a){return b&&!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,e=b.renderer,d=b.inverted,h=this.clipBox,f=h||b.clipBox,n=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,f.height,c.xAxis,c.yAxis].join(),m=b[n],g=b[n+"m"];m||(a&&(f.width=
0,b[n+"m"]=g=e.clipRect(-99,d?-b.plotLeft:-b.plotTop,99,d?b.chartWidth:b.chartHeight)),b[n]=m=e.clipRect(f),m.count={length:0});a&&!m.count[this.index]&&(m.count[this.index]=!0,m.count.length+=1);!1!==c.clip&&(this.group.clip(a||h?m:b.clipRect),this.markerGroup.clip(g),this.sharedClipKey=n);a||(m.count[this.index]&&(delete m.count[this.index],--m.count.length),0===m.count.length&&n&&b[n]&&(h||(b[n]=b[n].destroy()),b[n+"m"]&&(this.markerGroup.clip(),b[n+"m"]=b[n+"m"].destroy())))},animate:function(a){var b=
this.chart,c=A(this.options.animation),e;a?this.setClip(c):(e=this.sharedClipKey,(a=b[e])&&a.animate({width:b.plotSizeX},c),b[e+"m"]&&b[e+"m"].animate({width:b.plotSizeX+99},c),this.animate=null)},afterAnimate:function(){this.setClip();p(this,"afterAnimate")},drawPoints:function(){var a=this.points,b=this.chart,c,e,d,k,f=this.options.marker,n,g,p,l,q=this.markerGroup,t=E(f.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>2*f.radius);if(!1!==f.enabled||this._hasPointMarkers)for(e=0;e<a.length;e++)d=
a[e],c=d.plotY,k=d.graphic,n=d.marker||{},g=!!d.marker,p=t&&void 0===n.enabled||n.enabled,l=d.isInside,p&&m(c)&&null!==d.y?(c=E(n.symbol,this.symbol),d.hasImage=0===c.indexOf("url"),p=this.markerAttribs(d,d.selected&&"select"),k?k[l?"show":"hide"](!0).animate(p):l&&(0<p.width||d.hasImage)&&(d.graphic=k=b.renderer.symbol(c,p.x,p.y,p.width,p.height,g?n:f).add(q)),k&&k.attr(this.pointAttribs(d,d.selected&&"select")),k&&k.addClass(d.getClassName(),!0)):k&&(d.graphic=k.destroy())},markerAttribs:function(a,
b){var c=this.options.marker,e=a.marker||{},d=E(e.radius,c.radius);b&&(c=c.states[b],b=e.states&&e.states[b],d=E(b&&b.radius,c&&c.radius,d+(c&&c.radiusPlus||0)));a.hasImage&&(d=0);a={x:Math.floor(a.plotX)-d,y:a.plotY-d};d&&(a.width=a.height=2*d);return a},pointAttribs:function(a,b){var c=this.options.marker,e=a&&a.options,d=e&&e.marker||{},h=this.color,f=e&&e.color,n=a&&a.color,e=E(d.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;h=f||a||n||h;a=d.fillColor||c.fillColor||h;h=d.lineColor||c.lineColor||
h;b&&(c=c.states[b],b=d.states&&d.states[b]||{},e=E(b.lineWidth,c.lineWidth,e+E(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,h=b.lineColor||c.lineColor||h);return{stroke:h,"stroke-width":e,fill:a}},destroy:function(){var a=this,b=a.chart,c=/AppleWebKit\/533/.test(w.navigator.userAgent),e,f=a.data||[],k,n,m;p(a,"destroy");z(a);q(a.axisTypes||[],function(b){(m=a[b])&&m.series&&(d(m.series,a),m.isDirty=m.forceRedraw=!0)});a.legendItem&&a.chart.legend.destroyItem(a);for(e=f.length;e--;)(k=
f[e])&&k.destroy&&k.destroy();a.points=null;clearTimeout(a.animationTimeout);for(n in a)a[n]instanceof x&&!a[n].survive&&(e=c&&"group"===n?"hide":"destroy",a[n][e]());b.hoverSeries===a&&(b.hoverSeries=null);d(b.series,a);b.orderSeries();for(n in a)delete a[n]},getGraphPath:function(a,b,c){var e=this,d=e.options,h=d.step,f,n=[],m=[],g;a=a||e.points;(f=a.reversed)&&a.reverse();(h={right:1,center:2}[h]||h&&3)&&f&&(h=4-h);!d.connectNulls||b||c||(a=this.getValidPoints(a));q(a,function(f,k){var p=f.plotX,
q=f.plotY,t=a[k-1];(f.leftCliff||t&&t.rightCliff)&&!c&&(g=!0);f.isNull&&!l(b)&&0<k?g=!d.connectNulls:f.isNull&&!b?g=!0:(0===k||g?k=["M",f.plotX,f.plotY]:e.getPointSpline?k=e.getPointSpline(a,f,k):h?(k=1===h?["L",t.plotX,q]:2===h?["L",(t.plotX+p)/2,t.plotY,"L",(t.plotX+p)/2,q]:["L",p,t.plotY],k.push("L",p,q)):k=["L",p,q],m.push(f.x),h&&m.push(f.x),n.push.apply(n,k),g=!1)});n.xMap=m;return e.graphPath=n},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),
e=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]];q(this.zones,function(c,d){e.push(["zone-graph-"+d,"highcharts-graph highcharts-zone-graph-"+d+" "+(c.className||""),c.color||a.color,c.dashStyle||b.dashStyle])});q(e,function(e,d){var h=e[0],f=a[h];f?(f.endX=c.xMap,f.animate({d:c})):c.length&&(a[h]=a.chart.renderer.path(c).addClass(e[1]).attr({zIndex:1}).add(a.group),f={stroke:e[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},e[3]?f.dashstyle=e[3]:"square"!==b.linecap&&
(f["stroke-linecap"]=f["stroke-linejoin"]="round"),f=a[h].attr(f).shadow(2>d&&b.shadow));f&&(f.startX=c.xMap,f.isArea=c.isArea)})},applyZones:function(){var a=this,b=this.chart,c=b.renderer,e=this.zones,d,f,n=this.clips||[],m,g=this.graph,p=this.area,l=Math.max(b.chartWidth,b.chartHeight),t=this[(this.zoneAxis||"y")+"Axis"],w,x,r=b.inverted,z,F,u,C,A=!1;e.length&&(g||p)&&t&&void 0!==t.min&&(x=t.reversed,z=t.horiz,g&&g.hide(),p&&p.hide(),w=t.getExtremes(),q(e,function(e,h){d=x?z?b.plotWidth:0:z?0:
t.toPixels(w.min);d=Math.min(Math.max(E(f,d),0),l);f=Math.min(Math.max(Math.round(t.toPixels(E(e.value,w.max),!0)),0),l);A&&(d=f=t.toPixels(w.max));F=Math.abs(d-f);u=Math.min(d,f);C=Math.max(d,f);t.isXAxis?(m={x:r?C:u,y:0,width:F,height:l},z||(m.x=b.plotHeight-m.x)):(m={x:0,y:r?C:u,width:l,height:F},z&&(m.y=b.plotWidth-m.y));r&&c.isVML&&(m=t.isXAxis?{x:0,y:x?u:C,height:m.width,width:b.chartWidth}:{x:m.y-b.plotLeft-b.spacingBox.x,y:0,width:m.height,height:b.chartHeight});n[h]?n[h].animate(m):(n[h]=
c.clipRect(m),g&&a["zone-graph-"+h].clip(n[h]),p&&a["zone-area-"+h].clip(n[h]));A=e.value>w.max}),this.clips=n)},invertGroups:function(a){function b(){q(["group","markerGroup"],function(b){c[b]&&(c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,e;c.xAxis&&(e=B(c.chart,"resize",b),B(c,"destroy",e),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,e,d){var h=this[a],f=!h;f&&(this[a]=h=this.chart.renderer.g(b).attr({zIndex:e||.1}).add(d),h.addClass("highcharts-series-"+this.index+
" highcharts-"+this.type+"-series highcharts-color-"+this.colorIndex+" "+(this.options.className||"")));h.attr({visibility:c})[f?"attr":"animate"](this.getPlotBox());return h},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,e=a.options,d=!!a.animate&&b.renderer.isSVG&&A(e.animation).duration,f=a.visible?"inherit":"hidden",n=
e.zIndex,m=a.hasRendered,g=b.seriesGroup,p=b.inverted;c=a.plotGroup("group","series",f,n,g);a.markerGroup=a.plotGroup("markerGroup","markers",f,n,g);d&&a.animate(!0);c.inverted=a.isCartesian?p:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(p);!1===e.clip||a.sharedClipKey||m||c.clip(b.clipRect);d&&a.animate();m||(a.animationTimeout=F(function(){a.afterAnimate()},
d));a.isDirty=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,c=this.group,e=this.xAxis,d=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:E(e&&e.left,a.plotLeft),translateY:E(d&&d.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdDimensions:1,kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,e=this.yAxis,d=this.chart.inverted;return this.searchKDTree({clientX:d?
c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:d?e.len-a.chartX+e.pos:a.chartY-e.pos},b)},buildKDTree:function(){function a(c,e,d){var h,f;if(f=c&&c.length)return h=b.kdAxisArray[e%d],c.sort(function(a,b){return a[h]-b[h]}),f=Math.floor(f/2),{point:c[f],left:a(c.slice(0,f),e+1,d),right:a(c.slice(f+1),e+1,d)}}this.buildingKdTree=!0;var b=this,c=b.kdDimensions;delete b.kdTree;F(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,
b){function c(a,b,k,n){var m=b.point,g=e.kdAxisArray[k%n],p,t,q=m;t=l(a[d])&&l(m[d])?Math.pow(a[d]-m[d],2):null;p=l(a[h])&&l(m[h])?Math.pow(a[h]-m[h],2):null;p=(t||0)+(p||0);m.dist=l(p)?Math.sqrt(p):Number.MAX_VALUE;m.distX=l(t)?Math.sqrt(t):Number.MAX_VALUE;g=a[g]-m[g];p=0>g?"left":"right";t=0>g?"right":"left";b[p]&&(p=c(a,b[p],k+1,n),q=p[f]<q[f]?p:m);b[t]&&Math.sqrt(g*g)<q[f]&&(a=c(a,b[t],k+1,n),q=a[f]<q[f]?a:q);return q}var e=this,d=this.kdAxisArray[0],h=this.kdAxisArray[1],f=b?"distX":"dist";
this.kdTree||this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,this.kdDimensions,this.kdDimensions)}})})(L);(function(a){function B(a,d,b,f,g){var p=a.chart.inverted;this.axis=a;this.isNegative=b;this.options=d;this.x=f;this.total=null;this.points={};this.stack=g;this.rightCliff=this.leftCliff=0;this.alignOptions={align:d.align||(p?b?"left":"right":"center"),verticalAlign:d.verticalAlign||(p?"middle":b?"bottom":"top"),y:l(d.y,p?4:b?14:-6),x:l(d.x,p?b?-6:6:0)};this.textAlign=
d.textAlign||(p?b?"right":"left":"center")}var A=a.Axis,H=a.Chart,G=a.correctFloat,r=a.defined,g=a.destroyObjectProperties,f=a.each,u=a.format,l=a.pick;a=a.Series;B.prototype={destroy:function(){g(this,this.axis)},render:function(a){var d=this.options,b=d.format,b=b?u(b,this):d.formatter.call(this);this.label?this.label.attr({text:b,visibility:"hidden"}):this.label=this.axis.chart.renderer.text(b,null,null,d.useHTML).css(d.style).attr({align:this.textAlign,rotation:d.rotation,visibility:"hidden"}).add(a)},
setOffset:function(a,d){var b=this.axis,f=b.chart,g=f.inverted,l=b.reversed,l=this.isNegative&&!l||!this.isNegative&&l,m=b.translate(b.usePercentage?100:this.total,0,0,0,1),b=b.translate(0),b=Math.abs(m-b);a=f.xAxis[0].translate(this.x)+a;var c=f.plotHeight,g={x:g?l?m:m-b:a,y:g?c-a-d:l?c-m-b:c-m,width:g?b:d,height:g?d:b};if(d=this.label)d.align(this.alignOptions,null,g),g=d.alignAttr,d[!1===this.options.crop||f.isInsidePlot(g.x,g.y)?"show":"hide"](!0)}};H.prototype.getStacks=function(){var a=this;
f(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});f(a.series,function(d){!d.options.stacking||!0!==d.visible&&!1!==a.options.chart.ignoreHiddenSeries||(d.stackKey=d.type+l(d.options.stack,""))})};A.prototype.buildStacks=function(){var a=this.series,d,b=l(this.options.reversedStacks,!0),f=a.length,g;if(!this.isXAxis){this.usePercentage=!1;for(g=f;g--;)a[b?g:f-g-1].setStackedPoints();for(g=f;g--;)d=a[b?g:f-g-1],d.setStackCliffs&&d.setStackCliffs();if(this.usePercentage)for(g=
0;g<f;g++)a[g].setPercentStacks()}};A.prototype.renderStackTotals=function(){var a=this.chart,d=a.renderer,b=this.stacks,f,g,l=this.stackTotalGroup;l||(this.stackTotalGroup=l=d.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());l.translate(a.plotLeft,a.plotTop);for(f in b)for(g in a=b[f],a)a[g].render(l)};A.prototype.resetStacks=function(){var a=this.stacks,d,b;if(!this.isXAxis)for(d in a)for(b in a[d])a[d][b].touched<this.stacksTouched?(a[d][b].destroy(),delete a[d][b]):(a[d][b].total=
null,a[d][b].cum=null)};A.prototype.cleanStacks=function(){var a,d,b;if(!this.isXAxis)for(d in this.oldStacks&&(a=this.stacks=this.oldStacks),a)for(b in a[d])a[d][b].cum=a[d][b].total};a.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var a=this.processedXData,d=this.processedYData,b=[],f=d.length,g=this.options,t=g.threshold,m=g.startFromThreshold?t:0,c=g.stack,g=g.stacking,n=this.stackKey,u="-"+n,z=this.negStacks,
e=this.yAxis,x=e.stacks,F=e.oldStacks,w,h,y,A,K,I,k;e.stacksTouched+=1;for(K=0;K<f;K++)I=a[K],k=d[K],w=this.getStackIndicator(w,I,this.index),A=w.key,y=(h=z&&k<(m?0:t))?u:n,x[y]||(x[y]={}),x[y][I]||(F[y]&&F[y][I]?(x[y][I]=F[y][I],x[y][I].total=null):x[y][I]=new B(e,e.options.stackLabels,h,I,c)),y=x[y][I],null!==k&&(y.points[A]=y.points[this.index]=[l(y.cum,m)],r(y.cum)||(y.base=A),y.touched=e.stacksTouched,0<w.index&&!1===this.singleStacks&&(y.points[A][0]=y.points[this.index+","+I+",0"][0])),"percent"===
g?(h=h?n:u,z&&x[h]&&x[h][I]?(h=x[h][I],y.total=h.total=Math.max(h.total,y.total)+Math.abs(k)||0):y.total=G(y.total+(Math.abs(k)||0))):y.total=G(y.total+(k||0)),y.cum=l(y.cum,m)+(k||0),null!==k&&(y.points[A].push(y.cum),b[K]=y.cum);"percent"===g&&(e.usePercentage=!0);this.stackedYData=b;e.oldStacks={}}};a.prototype.setPercentStacks=function(){var a=this,d=a.stackKey,b=a.yAxis.stacks,g=a.processedXData,l;f([d,"-"+d],function(d){for(var f=g.length,c,n;f--;)if(c=g[f],l=a.getStackIndicator(l,c,a.index,
d),c=(n=b[d]&&b[d][c])&&n.points[l.key])n=n.total?100/n.total:0,c[0]=G(c[0]*n),c[1]=G(c[1]*n),a.stackedYData[f]=c[1]})};a.prototype.getStackIndicator=function(a,d,b,f){!r(a)||a.x!==d||f&&a.key!==f?a={x:d,index:0,key:f}:a.index++;a.key=[b,d,a.index].join();return a}})(L);(function(a){var B=a.addEvent,A=a.animate,H=a.Axis,G=a.createElement,r=a.css,g=a.defined,f=a.each,u=a.erase,l=a.extend,q=a.fireEvent,d=a.inArray,b=a.isNumber,p=a.isObject,C=a.merge,t=a.pick,m=a.Point,c=a.Series,n=a.seriesTypes,E=a.setAnimation,
z=a.splat;l(a.Chart.prototype,{addSeries:function(a,b,c){var e,d=this;a&&(b=t(b,!0),q(d,"addSeries",{options:a},function(){e=d.initSeries(a);d.isDirtyLegend=!0;d.linkSeries();b&&d.redraw(c)}));return e},addAxis:function(a,b,c,d){var e=b?"xAxis":"yAxis",f=this.options;a=C(a,{index:this[e].length,isX:b});new H(this,a);f[e]=z(f[e]||{});f[e].push(a);t(c,!0)&&this.redraw(d)},showLoading:function(a){var b=this,c=b.options,e=b.loadingDiv,d=c.loading,f=function(){e&&r(e,{left:b.plotLeft+"px",top:b.plotTop+
"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};e||(b.loadingDiv=e=G("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=G("span",{className:"highcharts-loading-inner"},null,e),B(b,"redraw",f));e.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;r(e,l(d.style,{zIndex:10}));r(b.loadingSpan,d.labelStyle);b.loadingShown||(r(e,{opacity:0,display:""}),A(e,{opacity:d.style.opacity||.5},{duration:d.showDuration||0}));b.loadingShown=
!0;f()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",A(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){r(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions".split(" "),update:function(a,c){var e,n={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},h=a.chart,m,p;if(h){C(!0,this.options.chart,h);"className"in h&&this.setClassName(h.className);if("inverted"in h||"polar"in h)this.propFromSeries(),m=!0;for(e in h)h.hasOwnProperty(e)&&(-1!==d("chart."+e,this.propsRequireUpdateSeries)&&(p=!0),-1!==d(e,this.propsRequireDirtyBox)&&(this.isDirtyBox=
!0));"style"in h&&this.renderer.setStyle(h.style)}for(e in a){if(this[e]&&"function"===typeof this[e].update)this[e].update(a[e],!1);else if("function"===typeof this[n[e]])this[n[e]](a[e]);"chart"!==e&&-1!==d(e,this.propsRequireUpdateSeries)&&(p=!0)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&C(!0,this.options.plotOptions,a.plotOptions);f(["xAxis","yAxis","series"],function(b){a[b]&&f(z(a[b]),function(a,c){(c=g(a.id)&&this.get(a.id)||this[b][c])&&c.coll===b&&c.update(a,!1)},this)},this);
m&&f(this.axes,function(a){a.update({},!1)});p&&f(this.series,function(a){a.update({},!1)});a.loading&&C(!0,this.options.loading,a.loading);e=h&&h.width;h=h&&h.height;b(e)&&e!==this.chartWidth||b(h)&&h!==this.chartHeight?this.setSize(e,h):t(c,!0)&&this.redraw()},setSubtitle:function(a){this.setTitle(void 0,a)}});l(m.prototype,{update:function(a,b,c,d){function e(){f.applyOptions(a);null===f.y&&n&&(f.graphic=n.destroy());p(a,!0)&&(n&&n.element&&a&&a.marker&&a.marker.symbol&&(f.graphic=n.destroy()),
a&&a.dataLabels&&f.dataLabel&&(f.dataLabel=f.dataLabel.destroy()));m=f.index;g.updateParallelArrays(f,m);l.data[m]=p(l.data[m],!0)?f.options:a;g.isDirty=g.isDirtyData=!0;!g.fixedBox&&g.hasCartesianSeries&&(k.isDirtyBox=!0);"point"===l.legendType&&(k.isDirtyLegend=!0);b&&k.redraw(c)}var f=this,g=f.series,n=f.graphic,m,k=g.chart,l=g.options;b=t(b,!0);!1===d?e():f.firePointEvent("update",{options:a},e)},remove:function(a,b){this.series.removePoint(d(this,this.series.data),a,b)}});l(c.prototype,{addPoint:function(a,
b,c,d){var e=this.options,f=this.data,g=this.chart,n=this.xAxis,n=n&&n.hasNames&&n.names,m=e.data,k,p,l=this.xData,q,w;b=t(b,!0);k={series:this};this.pointClass.prototype.applyOptions.apply(k,[a]);w=k.x;q=l.length;if(this.requireSorting&&w<l[q-1])for(p=!0;q&&l[q-1]>w;)q--;this.updateParallelArrays(k,"splice",q,0,0);this.updateParallelArrays(k,q);n&&k.name&&(n[w]=k.name);m.splice(q,0,a);p&&(this.data.splice(q,0,null),this.processData());"point"===e.legendType&&this.generatePoints();c&&(f[0]&&f[0].remove?
f[0].remove(!1):(f.shift(),this.updateParallelArrays(k,"shift"),m.shift()));this.isDirtyData=this.isDirty=!0;b&&g.redraw(d)},removePoint:function(a,b,c){var e=this,d=e.data,f=d[a],g=e.points,n=e.chart,m=function(){g&&g.length===d.length&&g.splice(a,1);d.splice(a,1);e.options.data.splice(a,1);e.updateParallelArrays(f||{series:e},"splice",a,1);f&&f.destroy();e.isDirty=!0;e.isDirtyData=!0;b&&n.redraw()};E(c,n);b=t(b,!0);f?f.firePointEvent("remove",null,m):m()},remove:function(a,b,c){function e(){d.destroy();
f.isDirtyLegend=f.isDirtyBox=!0;f.linkSeries();t(a,!0)&&f.redraw(b)}var d=this,f=d.chart;!1!==c?q(d,"remove",null,e):e()},update:function(a,b){var c=this,e=this.chart,d=this.userOptions,g=this.type,m=a.type||d.type||e.options.chart.type,p=n[g].prototype,q=["group","markerGroup","dataLabelsGroup"],k;if(m&&m!==g||void 0!==a.zIndex)q.length=0;f(q,function(a){q[a]=c[a];delete c[a]});a=C(d,{animation:!1,index:this.index,pointStart:this.xData[0]},{data:this.options.data},a);this.remove(!1,null,!1);for(k in p)this[k]=
void 0;l(this,n[m||g].prototype);f(q,function(a){c[a]=q[a]});this.init(e,a);e.linkSeries();t(b,!0)&&e.redraw(!1)}});l(H.prototype,{update:function(a,b){var c=this.chart;a=c.options[this.coll][this.options.index]=C(this.userOptions,a);this.destroy(!0);this.init(c,l(a,{events:void 0}));c.isDirtyBox=!0;t(b,!0)&&c.redraw()},remove:function(a){for(var b=this.chart,c=this.coll,e=this.series,d=e.length;d--;)e[d]&&e[d].remove(!1);u(b.axes,this);u(b[c],this);b.options[c].splice(this.options.index,1);f(b[c],
function(a,b){a.options.index=b});this.destroy();b.isDirtyBox=!0;t(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(L);(function(a){var B=a.color,A=a.each,H=a.map,G=a.pick,r=a.Series,g=a.seriesType;g("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(){var a=[],g=[],l=this.xAxis,q=this.yAxis,d=q.stacks[this.stackKey],b={},p=this.points,r=this.index,t=q.series,m=t.length,c,n=G(q.options.reversedStacks,
!0)?1:-1,E,z;if(this.options.stacking){for(E=0;E<p.length;E++)b[p[E].x]=p[E];for(z in d)null!==d[z].total&&g.push(z);g.sort(function(a,b){return a-b});c=H(t,function(){return this.visible});A(g,function(e,f){var p=0,t,h;if(b[e]&&!b[e].isNull)a.push(b[e]),A([-1,1],function(a){var p=1===a?"rightNull":"leftNull",l=0,q=d[g[f+a]];if(q)for(E=r;0<=E&&E<m;)t=q.points[E],t||(E===r?b[e][p]=!0:c[E]&&(h=d[e].points[E])&&(l-=h[1]-h[0])),E+=n;b[e][1===a?"rightCliff":"leftCliff"]=l});else{for(E=r;0<=E&&E<m;){if(t=
d[e].points[E]){p=t[1];break}E+=n}p=q.toPixels(p,!0);a.push({isNull:!0,plotX:l.toPixels(e,!0),plotY:p,yBottom:p})}})}return a},getGraphPath:function(a){var f=r.prototype.getGraphPath,g=this.options,q=g.stacking,d=this.yAxis,b,p,C=[],t=[],m=this.index,c,n=d.stacks[this.stackKey],E=g.threshold,z=d.getThreshold(g.threshold),e,g=g.connectNulls||"percent"===q,x=function(b,e,f){var h=a[b];b=q&&n[h.x].points[m];var g=h[f+"Null"]||0;f=h[f+"Cliff"]||0;var p,l,h=!0;f||g?(p=(g?b[0]:b[1])+f,l=b[0]+f,h=!!g):!q&&
a[e]&&a[e].isNull&&(p=l=E);void 0!==p&&(t.push({plotX:c,plotY:null===p?z:d.getThreshold(p),isNull:h}),C.push({plotX:c,plotY:null===l?z:d.getThreshold(l),doCurve:!1}))};a=a||this.points;q&&(a=this.getStackPoints());for(b=0;b<a.length;b++)if(p=a[b].isNull,c=G(a[b].rectPlotX,a[b].plotX),e=G(a[b].yBottom,z),!p||g)g||x(b,b-1,"left"),p&&!q&&g||(t.push(a[b]),C.push({x:b,plotX:c,plotY:e})),g||x(b,b+1,"right");b=f.call(this,t,!0,!0);C.reversed=!0;p=f.call(this,C,!0,!0);p.length&&(p[0]="L");p=b.concat(p);f=
f.call(this,t,!1,g);p.xMap=b.xMap;this.areaPath=p;return f},drawGraph:function(){this.areaPath=[];r.prototype.drawGraph.apply(this);var a=this,g=this.areaPath,l=this.options,q=[["area","highcharts-area",this.color,l.fillColor]];A(this.zones,function(d,b){q.push(["zone-area-"+b,"highcharts-area highcharts-zone-area-"+b+" "+d.className,d.color||a.color,d.fillColor||l.fillColor])});A(q,function(d){var b=d[0],f=a[b];f?(f.endX=g.xMap,f.animate({d:g})):(f=a[b]=a.chart.renderer.path(g).addClass(d[1]).attr({fill:G(d[3],
B(d[2]).setOpacity(G(l.fillOpacity,.75)).get()),zIndex:0}).add(a.group),f.isArea=!0);f.startX=g.xMap;f.shiftUnit=l.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(L);(function(a){var B=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,H,G){var r=H.plotX,g=H.plotY,f=a[G-1];G=a[G+1];var u,l,q,d;if(f&&!f.isNull&&!1!==f.doCurve&&G&&!G.isNull&&!1!==G.doCurve){a=f.plotY;q=G.plotX;G=G.plotY;var b=0;u=(1.5*r+f.plotX)/2.5;l=(1.5*g+a)/2.5;q=(1.5*r+q)/2.5;d=(1.5*g+G)/2.5;
q!==u&&(b=(d-l)*(q-r)/(q-u)+g-d);l+=b;d+=b;l>a&&l>g?(l=Math.max(a,g),d=2*g-l):l<a&&l<g&&(l=Math.min(a,g),d=2*g-l);d>G&&d>g?(d=Math.max(G,g),l=2*g-d):d<G&&d<g&&(d=Math.min(G,g),l=2*g-d);H.rightContX=q;H.rightContY=d}H=["C",B(f.rightContX,f.plotX),B(f.rightContY,f.plotY),B(u,r),B(l,g),r,g];f.rightContX=f.rightContY=null;return H}})})(L);(function(a){var B=a.seriesTypes.area.prototype,A=a.seriesType;A("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:B.getStackPoints,getGraphPath:B.getGraphPath,
setStackCliffs:B.setStackCliffs,drawGraph:B.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(L);(function(a){var B=a.animObject,A=a.color,H=a.each,G=a.extend,r=a.isNumber,g=a.merge,f=a.pick,u=a.Series,l=a.seriesType,q=a.svg;l("column","line",{borderRadius:0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1,shadow:!1},select:{color:"#cccccc",borderColor:"#000000",shadow:!1}},dataLabels:{align:null,verticalAlign:null,
y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){u.prototype.init.apply(this,arguments);var a=this,b=a.chart;b.hasRendered&&H(b.series,function(b){b.type===a.type&&(b.isDirty=!0)})},getColumnMetrics:function(){var a=this,b=a.options,g=a.xAxis,l=a.yAxis,t=g.reversed,m,c={},n=0;!1===b.grouping?n=1:H(a.chart.series,function(b){var e=
b.options,d=b.yAxis,f;b.type===a.type&&b.visible&&l.len===d.len&&l.pos===d.pos&&(e.stacking?(m=b.stackKey,void 0===c[m]&&(c[m]=n++),f=c[m]):!1!==e.grouping&&(f=n++),b.columnIndex=f)});var q=Math.min(Math.abs(g.transA)*(g.ordinalSlope||b.pointRange||g.closestPointRange||g.tickInterval||1),g.len),r=q*b.groupPadding,e=(q-2*r)/(n||1),b=Math.min(b.maxPointWidth||g.len,f(b.pointWidth,e*(1-2*b.pointPadding)));a.columnMetrics={width:b,offset:(e-b)/2+(r+((a.columnIndex||0)+(t?1:0))*e-q/2)*(t?-1:1)};return a.columnMetrics},
crispCol:function(a,b,f,g){var d=this.chart,m=this.borderWidth,c=-(m%2?.5:0),m=m%2?.5:1;d.inverted&&d.renderer.isVML&&(m+=1);f=Math.round(a+f)+c;a=Math.round(a)+c;g=Math.round(b+g)+m;c=.5>=Math.abs(b)&&.5<g;b=Math.round(b)+m;g-=b;c&&g&&(--b,g+=1);return{x:a,y:b,width:f-a,height:g}},translate:function(){var a=this,b=a.chart,g=a.options,l=a.dense=2>a.closestPointRange*a.xAxis.transA,l=a.borderWidth=f(g.borderWidth,l?0:1),t=a.yAxis,m=a.translatedThreshold=t.getThreshold(g.threshold),c=f(g.minPointLength,
5),n=a.getColumnMetrics(),q=n.width,r=a.barW=Math.max(q,1+2*l),e=a.pointXOffset=n.offset;b.inverted&&(m-=.5);g.pointPadding&&(r=Math.ceil(r));u.prototype.translate.apply(a);H(a.points,function(d){var g=f(d.yBottom,m),n=999+Math.abs(g),n=Math.min(Math.max(-n,d.plotY),t.len+n),h=d.plotX+e,l=r,p=Math.min(n,g),z,x=Math.max(n,g)-p;Math.abs(x)<c&&c&&(x=c,z=!t.reversed&&!d.negative||t.reversed&&d.negative,p=Math.abs(p-m)>c?g-c:m-(z?c:0));d.barX=h;d.pointWidth=q;d.tooltipPos=b.inverted?[t.len+t.pos-b.plotLeft-
n,a.xAxis.len-h-l/2,x]:[h+l/2,n+t.pos-b.plotTop,x];d.shapeType="rect";d.shapeArgs=a.crispCol.apply(a,d.isNull?[d.plotX,t.len/2,0,0]:[h,p,l,x])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,b){var d=this.options,f,g=this.pointAttrToOptions||{};f=g.stroke||"borderColor";var m=g["stroke-width"]||"borderWidth",c=a&&a.color||this.color,n=a[f]||d[f]||this.color||
c,l=a[m]||d[m]||this[m]||0,g=d.dashStyle;a&&this.zones.length&&(c=(c=a.getZone())&&c.color||a.options.color||this.color);b&&(a=d.states[b],b=a.brightness,c=a.color||void 0!==b&&A(c).brighten(a.brightness).get()||c,n=a[f]||n,l=a[m]||l,g=a.dashStyle||g);f={fill:c,stroke:n,"stroke-width":l};d.borderRadius&&(f.r=d.borderRadius);g&&(f.dashstyle=g);return f},drawPoints:function(){var a=this,b=this.chart,f=a.options,l=b.renderer,t=f.animationLimit||250,m;H(a.points,function(c){var d=c.graphic;if(r(c.plotY)&&
null!==c.y){m=c.shapeArgs;if(d)d[b.pointCount<t?"animate":"attr"](g(m));else c.graphic=d=l[c.shapeType](m).attr({"class":c.getClassName()}).add(c.group||a.group);d.attr(a.pointAttribs(c,c.selected&&"select")).shadow(f.shadow,null,f.stacking&&!f.borderRadius)}else d&&(c.graphic=d.destroy())})},animate:function(a){var b=this,d=this.yAxis,f=b.options,g=this.chart.inverted,m={};q&&(a?(m.scaleY=.001,a=Math.min(d.pos+d.len,Math.max(d.pos,d.toPixels(f.threshold))),g?m.translateX=a-d.len:m.translateY=a,b.group.attr(m)):
(m[g?"translateX":"translateY"]=d.pos,b.group.animate(m,G(B(b.options.animation),{step:function(a,d){b.group.attr({scaleY:Math.max(.001,d.pos)})}})),b.animate=null))},remove:function(){var a=this,b=a.chart;b.hasRendered&&H(b.series,function(b){b.type===a.type&&(b.isDirty=!0)});u.prototype.remove.apply(a,arguments)}})})(L);(function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})})(L);(function(a){var B=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',
pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,kdDimensions:2,drawGraph:function(){this.options.lineWidth&&B.prototype.drawGraph.call(this)}})})(L);(function(a){var B=a.pick,A=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,G=this.chart,r=2*(a.slicedOffset||0),g=G.plotWidth-2*r,G=G.plotHeight-
2*r,f=a.center,f=[B(f[0],"50%"),B(f[1],"50%"),a.size||"100%",a.innerSize||0],u=Math.min(g,G),l,q;for(l=0;4>l;++l)q=f[l],a=2>l||2===l&&/%$/.test(q),f[l]=A(q,[g,G,u,f[2]][l])+(a?r:0);f[3]>f[2]&&(f[3]=f[2]);return f}}})(L);(function(a){var B=a.addEvent,A=a.defined,H=a.each,G=a.extend,r=a.inArray,g=a.noop,f=a.pick,u=a.Point,l=a.Series,q=a.seriesType,d=a.setAnimation;q("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,enabled:!0,formatter:function(){return null===this.y?
void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1,shadow:!1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var b=this,d=b.points,f=b.startAngleRad;a||(H(d,function(a){var c=
a.graphic,d=a.shapeArgs;c&&(c.attr({r:a.startR||b.center[3]/2,start:f,end:f}),c.animate({r:d.r,start:d.start,end:d.end},b.options.animation))}),b.animate=null)},updateTotals:function(){var a,d=0,f=this.points,g=f.length,m,c=this.options.ignoreHiddenPoint;for(a=0;a<g;a++)m=f[a],0>m.y&&(m.y=null),d+=c&&!m.visible?0:m.y;this.total=d;for(a=0;a<g;a++)m=f[a],m.percentage=0<d&&(m.visible||!c)?m.y/d*100:0,m.total=d},generatePoints:function(){l.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();
var b=0,d=this.options,g=d.slicedOffset,m=g+(d.borderWidth||0),c,n,l,q=d.startAngle||0,e=this.startAngleRad=Math.PI/180*(q-90),q=(this.endAngleRad=Math.PI/180*(f(d.endAngle,q+360)-90))-e,r=this.points,u=d.dataLabels.distance,d=d.ignoreHiddenPoint,w,h=r.length,y;a||(this.center=a=this.getCenter());this.getX=function(b,c){l=Math.asin(Math.min((b-a[1])/(a[2]/2+u),1));return a[0]+(c?-1:1)*Math.cos(l)*(a[2]/2+u)};for(w=0;w<h;w++){y=r[w];c=e+b*q;if(!d||y.visible)b+=y.percentage/100;n=e+b*q;y.shapeType=
"arc";y.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*c)/1E3,end:Math.round(1E3*n)/1E3};l=(n+c)/2;l>1.5*Math.PI?l-=2*Math.PI:l<-Math.PI/2&&(l+=2*Math.PI);y.slicedTranslation={translateX:Math.round(Math.cos(l)*g),translateY:Math.round(Math.sin(l)*g)};c=Math.cos(l)*a[2]/2;n=Math.sin(l)*a[2]/2;y.tooltipPos=[a[0]+.7*c,a[1]+.7*n];y.half=l<-Math.PI/2||l>Math.PI/2?1:0;y.angle=l;m=Math.min(m,u/5);y.labelPos=[a[0]+c+Math.cos(l)*u,a[1]+n+Math.sin(l)*u,a[0]+c+Math.cos(l)*m,a[1]+n+Math.sin(l)*
m,a[0]+c,a[1]+n,0>u?"center":y.half?"right":"left",l]}},drawGraph:null,drawPoints:function(){var a=this,d=a.chart.renderer,f,g,m,c,n=a.options.shadow;n&&!a.shadowGroup&&(a.shadowGroup=d.g("shadow").add(a.group));H(a.points,function(b){if(null!==b.y){g=b.graphic;c=b.shapeArgs;f=b.sliced?b.slicedTranslation:{};var l=b.shadowGroup;n&&!l&&(l=b.shadowGroup=d.g("shadow").add(a.shadowGroup));l&&l.attr(f);m=a.pointAttribs(b,b.selected&&"select");g?g.setRadialReference(a.center).attr(m).animate(G(c,f)):(b.graphic=
g=d[b.shapeType](c).addClass(b.getClassName()).setRadialReference(a.center).attr(f).add(a.group),b.visible||g.attr({visibility:"hidden"}),g.attr(m).attr({"stroke-linejoin":"round"}).shadow(n,l))}})},searchPoint:g,sortByAngle:function(a,d){a.sort(function(a,b){return void 0!==a.angle&&(b.angle-a.angle)*d})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:a.CenteredSeriesMixin.getCenter,getSymbol:g},{init:function(){u.prototype.init.apply(this,arguments);var a=this,d;a.name=f(a.name,"Slice");
d=function(b){a.slice("select"===b.type)};B(a,"select",d);B(a,"unselect",d);return a},setVisible:function(a,d){var b=this,g=b.series,m=g.chart,c=g.options.ignoreHiddenPoint;d=f(d,c);a!==b.visible&&(b.visible=b.options.visible=a=void 0===a?!b.visible:a,g.options.data[r(b,g.data)]=b.options,H(["graphic","dataLabel","connector","shadowGroup"],function(c){if(b[c])b[c][a?"show":"hide"](!0)}),b.legendItem&&m.legend.colorizeItem(b,a),a||"hover"!==b.state||b.setState(""),c&&(g.isDirty=!0),d&&m.redraw())},
slice:function(a,g,l){var b=this.series;d(l,b.chart);f(g,!0);this.sliced=this.options.sliced=a=A(a)?a:!this.sliced;b.options.data[r(this,b.data)]=this.options;a=a?this.slicedTranslation:{translateX:0,translateY:0};this.graphic.animate(a);this.shadowGroup&&this.shadowGroup.animate(a)},haloPath:function(a){var b=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(b.x,b.y,b.r+a,b.r+a,{innerR:this.shapeArgs.r,start:b.start,end:b.end})}})})(L);(function(a){var B=
a.addEvent,A=a.arrayMax,H=a.defined,G=a.each,r=a.extend,g=a.format,f=a.map,u=a.merge,l=a.noop,q=a.pick,d=a.relativeLength,b=a.Series,p=a.seriesTypes,C=a.stableSort;a.distribute=function(a,b){function c(a,b){return a.target-b.target}var d,g=!0,m=a,e=[],l;l=0;for(d=a.length;d--;)l+=a[d].size;if(l>b){C(a,function(a,b){return(b.rank||0)-(a.rank||0)});for(l=d=0;l<=b;)l+=a[d].size,d++;e=a.splice(d-1,a.length)}C(a,c);for(a=f(a,function(a){return{size:a.size,targets:[a.target]}});g;){for(d=a.length;d--;)g=
a[d],l=(Math.min.apply(0,g.targets)+Math.max.apply(0,g.targets))/2,g.pos=Math.min(Math.max(0,l-g.size/2),b-g.size);d=a.length;for(g=!1;d--;)0<d&&a[d-1].pos+a[d-1].size>a[d].pos&&(a[d-1].size+=a[d].size,a[d-1].targets=a[d-1].targets.concat(a[d].targets),a[d-1].pos+a[d-1].size>b&&(a[d-1].pos=b-a[d-1].size),a.splice(d,1),g=!0)}d=0;G(a,function(a){var b=0;G(a.targets,function(){m[d].pos=a.pos+b;b+=m[d].size;d++})});m.push.apply(m,e);C(m,c)};b.prototype.drawDataLabels=function(){var a=this,b=a.options,
c=b.dataLabels,d=a.points,f,l,e=a.hasRendered||0,p,r,w=q(c.defer,!0),h=a.chart.renderer;if(c.enabled||a._hasPointLabels)a.dlProcessOptions&&a.dlProcessOptions(c),r=a.plotGroup("dataLabelsGroup","data-labels",w&&!e?"hidden":"visible",c.zIndex||6),w&&(r.attr({opacity:+e}),e||B(a,"afterAnimate",function(){a.visible&&r.show(!0);r[b.animation?"animate":"attr"]({opacity:1},{duration:200})})),l=c,G(d,function(e){var d,m=e.dataLabel,n,k,t,z=e.connector,w=!m,x;f=e.dlOptions||e.options&&e.options.dataLabels;
if(d=q(f&&f.enabled,l.enabled)&&null!==e.y)for(k in c=u(l,f),n=e.getLabelConfig(),p=c.format?g(c.format,n):c.formatter.call(n,c),x=c.style,t=c.rotation,x.color=q(c.color,x.color,a.color,"#000000"),"contrast"===x.color&&(x.color=c.inside||0>c.distance||b.stacking?h.getContrast(e.color||a.color):"#000000"),b.cursor&&(x.cursor=b.cursor),n={fill:c.backgroundColor,stroke:c.borderColor,"stroke-width":c.borderWidth,r:c.borderRadius||0,rotation:t,padding:c.padding,zIndex:1},n)void 0===n[k]&&delete n[k];!m||
d&&H(p)?d&&H(p)&&(m?n.text=p:(m=e.dataLabel=h[t?"text":"label"](p,0,-9999,c.shape,null,null,c.useHTML,null,"data-label"),m.addClass("highcharts-data-label-color-"+e.colorIndex+" "+(c.className||"")+(c.useHTML?"highcharts-tracker":""))),m.attr(n),m.css(x).shadow(c.shadow),m.added||m.add(r),a.alignDataLabel(e,m,c,null,w)):(e.dataLabel=m.destroy(),z&&(e.connector=z.destroy()))})};b.prototype.alignDataLabel=function(a,b,c,d,f){var g=this.chart,e=g.inverted,m=q(a.plotX,-9999),n=q(a.plotY,-9999),l=b.getBBox(),
h,p=c.rotation,t=c.align,u=this.visible&&(a.series.forceDL||g.isInsidePlot(m,Math.round(n),e)||d&&g.isInsidePlot(m,e?d.x+1:d.y+d.height-1,e)),E="justify"===q(c.overflow,"justify");u&&(h=c.style.fontSize,h=g.renderer.fontMetrics(h,b).b,d=r({x:e?g.plotWidth-n:m,y:Math.round(e?g.plotHeight-m:n),width:0,height:0},d),r(c,{width:l.width,height:l.height}),p?(E=!1,e=g.renderer.rotCorr(h,p),e={x:d.x+c.x+d.width/2+e.x,y:d.y+c.y+{top:0,middle:.5,bottom:1}[c.verticalAlign]*d.height},b[f?"attr":"animate"](e).attr({align:t}),
m=(p+720)%360,m=180<m&&360>m,"left"===t?e.y-=m?l.height:0:"center"===t?(e.x-=l.width/2,e.y-=l.height/2):"right"===t&&(e.x-=l.width,e.y-=m?0:l.height)):(b.align(c,null,d),e=b.alignAttr),E?this.justifyDataLabel(b,c,e,l,d,f):q(c.crop,!0)&&(u=g.isInsidePlot(e.x,e.y)&&g.isInsidePlot(e.x+l.width,e.y+l.height)),c.shape&&!p&&b.attr({anchorX:a.plotX,anchorY:a.plotY}));u||(b.attr({y:-9999}),b.placed=!1)};b.prototype.justifyDataLabel=function(a,b,c,d,f,g){var e=this.chart,m=b.align,n=b.verticalAlign,l,h,p=a.box?
0:a.padding||0;l=c.x+p;0>l&&("right"===m?b.align="left":b.x=-l,h=!0);l=c.x+d.width-p;l>e.plotWidth&&("left"===m?b.align="right":b.x=e.plotWidth-l,h=!0);l=c.y+p;0>l&&("bottom"===n?b.verticalAlign="top":b.y=-l,h=!0);l=c.y+d.height-p;l>e.plotHeight&&("top"===n?b.verticalAlign="bottom":b.y=e.plotHeight-l,h=!0);h&&(a.placed=!g,a.align(b,null,f))};p.pie&&(p.pie.prototype.drawDataLabels=function(){var d=this,g=d.data,c,l=d.chart,p=d.options.dataLabels,r=q(p.connectorPadding,10),e=q(p.connectorWidth,1),u=
l.plotWidth,F=l.plotHeight,w,h=p.distance,y=d.center,C=y[2]/2,B=y[1],H=0<h,k,D,L,N,S=[[],[]],O,v,M,Q,R=[0,0,0,0];d.visible&&(p.enabled||d._hasPointLabels)&&(b.prototype.drawDataLabels.apply(d),G(g,function(a){a.dataLabel&&a.visible&&(S[a.half].push(a),a.dataLabel._pos=null)}),G(S,function(b,e){var g,m,n=b.length,q,t,z;if(n)for(d.sortByAngle(b,e-.5),0<h&&(g=Math.max(0,B-C-h),m=Math.min(B+C+h,l.plotHeight),q=f(b,function(a){if(a.dataLabel)return z=a.dataLabel.getBBox().height||21,{target:a.labelPos[1]-
g+z/2,size:z,rank:a.y}}),a.distribute(q,m+z-g)),Q=0;Q<n;Q++)c=b[Q],L=c.labelPos,k=c.dataLabel,M=!1===c.visible?"hidden":"inherit",t=L[1],q?void 0===q[Q].pos?M="hidden":(N=q[Q].size,v=g+q[Q].pos):v=t,O=p.justify?y[0]+(e?-1:1)*(C+h):d.getX(v<g+2||v>m-2?t:v,e),k._attr={visibility:M,align:L[6]},k._pos={x:O+p.x+({left:r,right:-r}[L[6]]||0),y:v+p.y-10},L.x=O,L.y=v,null===d.options.size&&(D=k.width,O-D<r?R[3]=Math.max(Math.round(D-O+r),R[3]):O+D>u-r&&(R[1]=Math.max(Math.round(O+D-u+r),R[1])),0>v-N/2?R[0]=
Math.max(Math.round(-v+N/2),R[0]):v+N/2>F&&(R[2]=Math.max(Math.round(v+N/2-F),R[2])))}),0===A(R)||this.verifyDataLabelOverflow(R))&&(this.placeDataLabels(),H&&e&&G(this.points,function(a){var b;w=a.connector;if((k=a.dataLabel)&&k._pos&&a.visible){M=k._attr.visibility;if(b=!w)a.connector=w=l.renderer.path().addClass("highcharts-data-label-connector highcharts-color-"+a.colorIndex).add(d.dataLabelsGroup),w.attr({"stroke-width":e,stroke:p.connectorColor||a.color||"#666666"});w[b?"attr":"animate"]({d:d.connectorPath(a.labelPos)});
w.attr("visibility",M)}else w&&(a.connector=w.destroy())}))},p.pie.prototype.connectorPath=function(a){var b=a.x,c=a.y;return q(this.options.dataLabels.softConnector,!0)?["M",b+("left"===a[6]?5:-5),c,"C",b,c,2*a[2]-a[4],2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),c,"L",a[2],a[3],"L",a[4],a[5]]},p.pie.prototype.placeDataLabels=function(){G(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=!0):b&&b.attr({y:-9999}))})},
p.pie.prototype.alignDataLabel=l,p.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,c=this.options,f=c.center,g=c.minSize||80,l,e;null!==f[0]?l=Math.max(b[2]-Math.max(a[1],a[3]),g):(l=Math.max(b[2]-a[1]-a[3],g),b[0]+=(a[3]-a[1])/2);null!==f[1]?l=Math.max(Math.min(l,b[2]-Math.max(a[0],a[2])),g):(l=Math.max(Math.min(l,b[2]-a[0]-a[2]),g),b[1]+=(a[0]-a[2])/2);l<b[2]?(b[2]=l,b[3]=Math.min(d(c.innerSize||0,l),l),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):e=!0;return e});
p.column&&(p.column.prototype.alignDataLabel=function(a,d,c,f,g){var l=this.chart.inverted,e=a.series,m=a.dlBox||a.shapeArgs,n=q(a.below,a.plotY>q(this.translatedThreshold,e.yAxis.len)),p=q(c.inside,!!this.options.stacking);m&&(f=u(m),0>f.y&&(f.height+=f.y,f.y=0),m=f.y+f.height-e.yAxis.len,0<m&&(f.height-=m),l&&(f={x:e.yAxis.len-f.y-f.height,y:e.xAxis.len-f.x-f.width,width:f.height,height:f.width}),p||(l?(f.x+=n?0:f.width,f.width=0):(f.y+=n?f.height:0,f.height=0)));c.align=q(c.align,!l||p?"center":
n?"right":"left");c.verticalAlign=q(c.verticalAlign,l||p?"middle":n?"top":"bottom");b.prototype.alignDataLabel.call(this,a,d,c,f,g)})})(L);(function(a){var B=a.Chart,A=a.each,H=a.pick,G=a.addEvent;B.prototype.callbacks.push(function(a){function g(){var f=[];A(a.series,function(a){var g=a.options.dataLabels,q=a.dataLabelCollections||["dataLabel"];(g.enabled||a._hasPointLabels)&&!g.allowOverlap&&a.visible&&A(q,function(d){A(a.points,function(a){a[d]&&(a[d].labelrank=H(a.labelrank,a.shapeArgs&&a.shapeArgs.height),
f.push(a[d]))})})});a.hideOverlappingLabels(f)}g();G(a,"redraw",g)});B.prototype.hideOverlappingLabels=function(a){var g=a.length,f,r,l,q,d,b,p,C,t,m=function(a,b,d,f,e,g,l,m){return!(e>a+d||e+l<a||g>b+f||g+m<b)};for(r=0;r<g;r++)if(f=a[r])f.oldOpacity=f.opacity,f.newOpacity=1;a.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(r=0;r<g;r++)for(l=a[r],f=r+1;f<g;++f)if(q=a[f],l&&q&&l.placed&&q.placed&&0!==l.newOpacity&&0!==q.newOpacity&&(d=l.alignAttr,b=q.alignAttr,p=l.parentGroup,C=q.parentGroup,
t=2*(l.box?0:l.padding),d=m(d.x+p.translateX,d.y+p.translateY,l.width-t,l.height-t,b.x+C.translateX,b.y+C.translateY,q.width-t,q.height-t)))(l.labelrank<q.labelrank?l:q).newOpacity=0;A(a,function(a){var b,c;a&&(c=a.newOpacity,a.oldOpacity!==c&&a.placed&&(c?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=c,a[a.isOld?"animate":"attr"](a.alignAttr,null,b)),a.isOld=!0)})}})(L);(function(a){var B=a.addEvent,A=a.Chart,H=a.createElement,G=a.css,r=a.defaultOptions,g=a.defaultPlotOptions,f=a.each,u=
a.extend,l=a.fireEvent,q=a.hasTouch,d=a.inArray,b=a.isObject,p=a.Legend,C=a.merge,t=a.pick,m=a.Point,c=a.Series,n=a.seriesTypes,E=a.svg;a=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart,c=b.pointer,d=function(a){for(var c=a.target,e;c&&!e;)e=c.point,c=c.parentNode;if(void 0!==e&&e!==b.hoverPoint)e.onMouseOver(a)};f(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(f(a.trackerGroups,
function(b){if(a[b]){a[b].addClass("highcharts-tracker").on("mouseover",d).on("mouseout",function(a){c.onTrackerMouseOut(a)});if(q)a[b].on("touchstart",d);a.options.cursor&&a[b].css(G).css({cursor:a.options.cursor})}}),a._hasTracking=!0)},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),g=d.length,h=a.chart,l=h.pointer,m=h.renderer,n=h.options.tooltip.snap,p=a.tracker,k,r=function(){if(h.hoverSeries!==a)a.onMouseOver()},t="rgba(192,192,192,"+
(E?.0001:.002)+")";if(g&&!c)for(k=g+1;k--;)"M"===d[k]&&d.splice(k+1,0,d[k+1]-n,d[k+2],"L"),(k&&"M"===d[k]||k===g)&&d.splice(k,0,"L",d[k-2]+n,d[k-1]);p?p.attr({d:d}):a.graph&&(a.tracker=m.path(d).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:t,fill:c?t:"none","stroke-width":a.graph.strokeWidth()+(c?0:2*n),zIndex:2}).add(a.group),f([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",r).on("mouseout",function(a){l.onTrackerMouseOut(a)});
b.cursor&&a.css({cursor:b.cursor});if(q)a.on("touchstart",r)}))}};n.column&&(n.column.prototype.drawTracker=a.drawTrackerPoint);n.pie&&(n.pie.prototype.drawTracker=a.drawTrackerPoint);n.scatter&&(n.scatter.prototype.drawTracker=a.drawTrackerPoint);u(p.prototype,{setItemEvents:function(a,b,c){var e=this,d=e.chart,f="highcharts-legend-"+(a.series?"point":"series")+"-active";(c?b:a.legendGroup).on("mouseover",function(){a.setState("hover");d.seriesGroup.addClass(f);b.css(e.options.itemHoverStyle)}).on("mouseout",
function(){b.css(a.visible?e.itemStyle:e.itemHiddenStyle);d.seriesGroup.removeClass(f);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):l(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=H("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);B(a.checkbox,"click",function(b){l(a.series||a,"checkboxClick",
{checked:b.target.checked,item:a},function(){a.select()})})}});r.legend.itemStyle.cursor="pointer";u(A.prototype,{showResetZoom:function(){var a=this,b=r.lang,c=a.options.chart.resetZoomButton,d=c.theme,f=d.states,g="chart"===c.relativeTo?null:"plotBox";this.resetZoomButton=a.renderer.button(b.resetZoom,null,null,function(){a.zoomOut()},d,f&&f.hover).attr({align:c.position.align,title:b.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(c.position,!1,g)},zoomOut:function(){var a=this;
l(a,"selection",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var c,d=this.pointer,g=!1,l;!a||a.resetSelection?f(this.axes,function(a){c=a.zoom()}):f(a.xAxis.concat(a.yAxis),function(a){var b=a.axis;d[b.isXAxis?"zoomX":"zoomY"]&&(c=b.zoom(a.min,a.max),b.displayBtn&&(g=!0))});l=this.resetZoomButton;g&&!l?this.showResetZoom():!g&&b(l)&&(this.resetZoomButton=l.destroy());c&&this.redraw(t(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,
e;d&&f(d,function(a){a.setState()});f("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,f=a[d?"chartX":"chartY"],d=d?"mouseDownX":"mouseDownY",g=c[d],h=(b.pointRange||0)/2,k=b.getExtremes(),l=b.toValue(g-f,!0)+h,h=b.toValue(g+b.len-f,!0)-h,m=h<l,g=m?h:l,l=m?l:h,h=Math.min(k.dataMin,k.min)-g,k=l-Math.max(k.dataMax,k.max);b.series.length&&0>h&&0>k&&(b.setExtremes(g,l,!1,!1,{trigger:"pan"}),e=!0);c[d]=f});e&&c.redraw(!1);G(c.container,{cursor:"move"})}});u(m.prototype,{select:function(a,
b){var c=this,e=c.series,g=e.chart;a=t(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=c.options.selected=a;e.options.data[d(c,e.data)]=c.options;c.setState(a&&"select");b||f(g.getSelectedPoints(),function(a){a.selected&&a!==c&&(a.selected=a.options.selected=!1,e.options.data[d(a,e.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a,b){var c=this.series,d=c.chart,e=d.tooltip,f=d.hoverPoint;if(this.series){if(!b){if(f&&
f!==this)f.onMouseOut();if(d.hoverSeries!==c)c.onMouseOver();d.hoverPoint=this}!e||e.shared&&!c.noSharedTooltip?e||this.setState("hover"):(this.setState("hover"),e.refresh(this,a));this.firePointEvent("mouseOver")}},onMouseOut:function(){var a=this.series.chart,b=a.hoverPoints;this.firePointEvent("mouseOut");b&&-1!==d(this,b)||(this.setState(),a.hoverPoint=null)},importEvents:function(){if(!this.hasImportedEvents){var a=C(this.series.options.point,this.options).events,b;this.events=a;for(b in a)B(this,
b,a[b]);this.hasImportedEvents=!0}},setState:function(a,b){var c=Math.floor(this.plotX),d=this.plotY,e=this.series,f=e.options.states[a]||{},l=g[e.type].marker&&e.options.marker,m=l&&!1===l.enabled,n=l&&l.states&&l.states[a]||{},p=!1===n.enabled,k=e.stateMarkerGraphic,q=this.marker||{},r=e.chart,z=e.halo,C,A=l&&e.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===f.enabled||a&&(p||m&&!1===n.enabled)||a&&q.states&&q.states[a]&&!1===q.states[a].enabled)){A&&(C=e.markerAttribs(this,
a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+a),this.graphic.attr(e.pointAttribs(this,a)),C&&this.graphic.animate(C,t(r.options.chart.animation,n.animation,l.animation)),k&&k.hide();else{if(a&&n){l=q.symbol||e.symbol;k&&k.currentSymbol!==l&&(k=k.destroy());if(k)k[b?"animate":"attr"]({x:C.x,y:C.y});else l&&(e.stateMarkerGraphic=k=r.renderer.symbol(l,C.x,C.y,C.width,C.height).add(e.markerGroup),k.currentSymbol=
l);k&&k.attr(e.pointAttribs(this,a))}k&&(k[a&&r.isInsidePlot(c,d,r.inverted)?"show":"hide"](),k.element.point=this)}(c=f.halo)&&c.size?(z||(e.halo=z=r.renderer.path().add(A?e.markerGroup:e.group)),z[b?"animate":"attr"]({d:this.haloPath(c.size)}),z.attr({"class":"highcharts-halo highcharts-color-"+t(this.colorIndex,e.colorIndex)}),z.point=this,z.attr(u({fill:this.color||e.color,"fill-opacity":c.opacity,zIndex:-1},c.attributes))):z&&z.point&&z.point.haloPath&&z.animate({d:z.point.haloPath(0)});this.state=
a}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});u(c.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&l(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&l(this,"mouseOut");!c||a.stickyTracking||
c.shared&&!this.noSharedTooltip||c.hide();this.setState()},setState:function(a){var b=this,c=b.options,d=b.graph,g=c.states,h=c.lineWidth,c=0;a=a||"";if(b.state!==a&&(f([b.group,b.markerGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a,!g[a]||!1!==g[a].enabled)&&(a&&(h=g[a].lineWidth||h+(g[a].lineWidthPlus||0)),d&&!d.dashstyle))for(g={"stroke-width":h},d.attr(g);b["zone-graph-"+c];)b["zone-graph-"+c].attr(g),c+=1},setVisible:function(a,
b){var c=this,d=c.chart,e=c.legendItem,g,m=d.options.chart.ignoreHiddenSeries,n=c.visible;g=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!n:a)?"show":"hide";f(["group","dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(c[a])c[a][g]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&f(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});f(c.linkedSeries,function(b){b.setVisible(a,
!1)});m&&(d.isDirtyBox=!0);!1!==b&&d.redraw();l(c,g)},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);l(this,a?"select":"unselect")},drawTracker:a.drawTrackerGraph})})(L);(function(a){var B=a.Chart,A=a.each,H=a.inArray,G=a.isObject,r=a.pick,g=a.splat;B.prototype.setResponsive=function(a){var f=this.options.responsive;f&&f.rules&&A(f.rules,function(f){this.matchResponsiveRule(f,
a)},this)};B.prototype.matchResponsiveRule=function(f,g){var l=this.respRules,q=f.condition,d;d=q.callback||function(){return this.chartWidth<=r(q.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=r(q.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=r(q.minWidth,0)&&this.chartHeight>=r(q.minHeight,0)};void 0===f._id&&(f._id=a.uniqueKey());d=d.call(this);!l[f._id]&&d?f.chartOptions&&(l[f._id]=this.currentOptions(f.chartOptions),this.update(f.chartOptions,g)):l[f._id]&&!d&&(this.update(l[f._id],g),delete l[f._id])};
B.prototype.currentOptions=function(a){function f(a,d,b,l){var p,q;for(p in a)if(!l&&-1<H(p,["series","xAxis","yAxis"]))for(a[p]=g(a[p]),b[p]=[],q=0;q<a[p].length;q++)b[p][q]={},f(a[p][q],d[p][q],b[p][q],l+1);else G(a[p])?(b[p]={},f(a[p],d[p]||{},b[p],l+1)):b[p]=d[p]||null}var l={};f(a,this.options,l,0);return l}})(L);return L});


(function() {
    'use strict';
    
    angular
    	.module('sideApp')
    	.factory('ReporteProfesorService',ReporteProfesorService);
    

    ReporteProfesorService.$inject = ['$q', '$timeout', '$window','$http','$state','$resource','AlertService'];
    //var downloadModule = angular.module('components.donwload', []);


        function ReporteProfesorService($q, $timeout, $window,$http,$state,$resource,AlertService) {
            var down ={
                	donwl:download,
                //	showDownloadPage:showDownloadPage
                };
        	
        	
            return  down;
            
            
            function download(name) {//descargar archivo

                    var defer = $q.defer();

                    $timeout(function() {
                            $window.location = 'apo/reporteclaseprofesor/'+name;
                        }, 1000)
                        .then(function() {                        	
                            defer.resolve('success');
                            AlertService.info("Es posible que el profesor no haya contestado aún su autoevaluación.\n");
//                            $state.go('clases', null,{reload:false});
                        }, function() {
                            defer.reject('error');
                            AlertService.error("No se pudo generar el archivo.");
                        });
                    return defer.promise;
                }
        }
        
//        function showDownloadPage () {//cargar alumnos
//            var resourceUrl =  'api/alumosdownload/';
//
//            return $resource(resourceUrl, {}, {
//                'query': { method: 'GET', isArray: true},
//                'get': {
//                    method: 'GET',
//                    transformResponse: function (data) {
//                        if (data) {
//                            data = angular.fromJson(data);
//                        }
//                        return data;
//                    }
//                },
//                'update': { method:'PUT' }
//            });
//        }
        
        
        
})();

(function() {
    'use strict';
    
    angular
    	.module('sideApp')
    	.factory('ReporteAlumnoService',ReporteAlumnoService);
    

    ReporteAlumnoService.$inject = ['$q', '$timeout', '$window','$http','$state','$resource','AlertService'];
    //var downloadModule = angular.module('components.donwload', []);


        function ReporteAlumnoService($q, $timeout, $window,$http,$state,$resource,AlertService) {
            var down ={
                	donwl:download,
                //	showDownloadPage:showDownloadPage
                };
        	
        	
            return  down;
            
            
            function download(name) {//descargar archivo

                    var defer = $q.defer();

                    $timeout(function() {
                            $window.location = 'apo/reporteclasealumno/'+name;
                        }, 1000)
                        .then(function() {                        	
                            defer.resolve('success');
                            AlertService.info("Es posible que haya alumnos que no hayan contestado aún su evaluación.\n");
//                            $state.go('clases', null,{reload:false});
                        }, function() {
                            defer.reject('error');
                            AlertService.error("No se pudo generar el archivo.");
                        });
                    return defer.promise;
                }
        }
        
//        function showDownloadPage () {//cargar alumnos
//            var resourceUrl =  'api/alumosdownload/';
//
//            return $resource(resourceUrl, {}, {
//                'query': { method: 'GET', isArray: true},
//                'get': {
//                    method: 'GET',
//                    transformResponse: function (data) {
//                        if (data) {
//                            data = angular.fromJson(data);
//                        }
//                        return data;
//                    }
//                },
//                'update': { method:'PUT' }
//            });
//        }
        
        
        
})();
(function() {
	'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('extracciondatos', {
        	parent: 'app',
            url: '/extracciondatos?page&sort&search',
            data: {
            	authorities: ['ADMINISTRATIVO_GENERAL_SIDE','ADMINISTRATIVO_BACHILLERATO_SIDE','RESPONSABLE_SIDE'],
                pageTitle: 'Portal Docente'
            },
            views: {
                'content@': {
                    templateUrl: 'app/extracciondatos/extracciondatosportal.html',
                    controller: 'EXTRACCIONDATOSController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                type: '1',
                indice : '1',
                ic: false,
                iic: '0',
                anio: '0',
                aniostr: '',
                modelo: '0',
                nivel: '0',
                centro: '0',
                ep: false
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        type: $stateParams.type,
                        indice: $stateParams.indice,
                        ic: $stateParams.ic,
                        iic: $stateParams.iic,
                        anio: $stateParams.anio,
                        aniostr: $stateParams.aniostr,
                        modelo: $stateParams.modelo,
                        nivel: $stateParams.nivel,
                        centro: $stateParams.centro,
                        ep: $stateParams.ep
                    };
                }]
            }
        })
	}

})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('Administrativogeneral', Administrativogeneral);

    Administrativogeneral.$inject = ['$resource'];

    function Administrativogeneral ($resource) {
        var resourceUrl =  'apo/extracciondatos:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro,:ep';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('EXTRACCIONDATOSController', EXTRACCIONDATOSController);

    EXTRACCIONDATOSController.$inject = ['$scope', '$state', 'Administrativogeneral', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ClasesAmbitoService','LoginService','downloadService',
    	'AniosEscolares','ReporteProfesorService','ReporteAlumnoService','Instituciones','NivelesEducativosService','ModelosEducativosService','Periodos'];

    function EXTRACCIONDATOSController ($scope, $state, Administrativogeneral, ParseLinks, AlertService, pagingParams, paginationConstants,ClasesAmbitoService,LoginService,downloadService,
    		AniosEscolares,ReporteProfesorService,ReporteAlumnoService,Instituciones,NivelesEducativosService,ModelosEducativosService,Periodos) {
        var vm = this;
        
       // vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        //vm.openDialog=openDialog;
        vm.download=download;
        vm.descargarReporteAlumnos=descargarReporteAlumnos;
        vm.descargarReporteProfesor=descargarReporteProfesor;
        vm.indicePeriodo=pagingParams.indice;
        vm.intercurso=pagingParams.ic;
        vm.indiceIntercurso=pagingParams.iic;
        vm.periodos;
        vm.search=search;
        vm.type=pagingParams.type;
        vm.currentSearch=pagingParams.search;
        vm.anioSeleccionado=pagingParams.anio;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.institucionSelected=pagingParams.centro;
        vm.evaluacionesPendientes=pagingParams.ep;
        cargarDropdrown();
        loadAll();
        vm.isNew = isNew;
        vm.limpiar = limpiar;
        vm.esLicMEFI = esLicMEFI;
        
        $scope.$watchGroup(["vm.anioSeleccionado","vm.institucionSelected","vm.intercurso"],function(newValue,oldValue){
        	
        	if (newValue === oldValue) {
      	      return;
      	    }
        	
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                });
        	}
        	
        	if(vm.intercurso){
        		vm.indicePeriodo = 0;
        	}else{
        		vm.indiceIntercurso = 0;
        	}
	      	
        });
        
        function loadAll () {
        	
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null && vm.intercurso != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                });
        	}
        	
        	Administrativogeneral.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro:vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.usuarios = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        function download(idAmbito){
            downloadService.donwl(idAmbito)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }
        
        function descargarReporteAlumnos(idAmbito){
        	ReporteAlumnoService.donwl(idAmbito)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }
        
        function descargarReporteProfesor(idAmbito){
        	ReporteProfesorService.donwl(idAmbito)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }
        
        function esLicMEFI(tipo,mefi){
        	if(mefi==="MEFI" || mefi==="MEFI_2"){
        		if(tipo=='Licenciatura'){
        			return true;
        		}
        	}
        	
        	if(tipo=='Bachiller' && vm.institucionSelected==52){
        		return true;
        	}
        	
        	return false;
        }

//        function loadPage (page) {
//            vm.page = page;
//            vm.transition();
//        }
        
//        function openDialog () {
//        	var entity={tipo:null
//        	}
//        	ClasesAmbitoService.open(entity);
//        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            },onSuccess,{reload:false});
       	 function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.usuarios = data;
             vm.page = pagingParams.page;
         }
        }
        
        function isNew(){
        	if( vm.usuarios.evaluacion.id ==null )
        		return true;
        	else
        		return false;
        }
        
        function cargarDropdrown(){
        	vm.aniosEscolares=AniosEscolares.query();
        	vm.dependencias=Instituciones.query();
        	vm.niveles=NivelesEducativosService.getAll();
        	vm.modelos=ModelosEducativosService.getAll();
        }
        
        function limpiar() {
        	vm.modeloSeleccionado=null;
        }
        
        function search(){
        	
        	if(vm.anioSeleccionado==null )
        		return ;
        	$state.transitionTo($state.$current, {
                page: 0,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                aniostr: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes
            },onSuccess);
        	 function onSuccess(data, headers) {
                 vm.links = ParseLinks.parse(headers('link'));
                 vm.totalItems = headers('X-Total-Count');
                 vm.queryCount = vm.totalItems;
                 vm.usuarios = data;
                 vm.page = pagingParams.page;
             }
        	
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('MisReportesEvaluativos', MisReportesEvaluativos);

    MisReportesEvaluativos.$inject = ['$resource'];

    function MisReportesEvaluativos ($resource) {
        var resourceUrl =  'apo/misreportes:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro,:ep';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('MisReportesEvaluativosController', MisReportesEvaluativosController);

    MisReportesEvaluativosController.$inject = ['$scope', '$state', 'MisReportesEvaluativos', 'ParseLinks', 'Periodos',
    	'AlertService', 'pagingParams', 'paginationConstants', 'ClasesAmbitoService','LoginService','downloadService',
    	'AniosEscolares','MisInstituciones','NivelesEducativosService','ModelosEducativosService'];

    function MisReportesEvaluativosController ($scope, $state, MisReportesEvaluativos, ParseLinks, Periodos,
    		AlertService, pagingParams, paginationConstants,ClasesAmbitoService,LoginService,downloadService,
    		AniosEscolares,MisInstituciones,NivelesEducativosService,ModelosEducativosService) {
        var vm = this;
        
       // vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        //vm.openDialog=openDialog;
     
        vm.indicePeriodo=pagingParams.indice;
        vm.intercurso=pagingParams.ic;
        vm.indiceIntercurso=pagingParams.iic;
        vm.search=search;
        vm.type=pagingParams.type;
        vm.currentSearch=pagingParams.search;
        vm.anioSeleccionado=pagingParams.anio;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.institucionSelected=pagingParams.centro;
        vm.evaluacionesPendientes=pagingParams.ep;
        cargarDropdrown();
        loadAll();
        vm.isNew = isNew;
        vm.limpiar = limpiar;
        
        $scope.$watchGroup(["vm.anioSeleccionado","vm.institucionSelected","vm.intercurso"],function(newValue,oldValue){
        	
        	if (newValue === oldValue) {
      	      return;
      	    }
        	
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                });
        	}
        	
        	if(vm.intercurso){
        		vm.indicePeriodo = 0;
        	}else{
        		vm.indiceIntercurso = 0;
        	}
	      	
        });
        
        function loadAll () {
        	
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null && vm.intercurso != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                });
        	}
        	
        	MisReportesEvaluativos.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro:vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.wrappers = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
       

//        function loadPage (page) {
//            vm.page = page;
//            vm.transition();
//        }
        
//        function openDialog () {
//        	var entity={tipo:null
//        	}
//        	ClasesAmbitoService.open(entity);
//        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            },onSuccess,{reload:false});
       	 function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.wrappers = data;
             vm.page = pagingParams.page;
         }
        }
        
        function isNew(){
        	if( vm.usuarios.evaluacion.id ==null )
        		return true;
        	else
        		return false;
        }
        
        function cargarDropdrown(){
        	vm.aniosEscolares=AniosEscolares.query();
        	vm.dependencias=MisInstituciones.query();
        	vm.niveles=NivelesEducativosService.getAll();
        	vm.modelos=ModelosEducativosService.getAll();
        }
        
        function limpiar() {
        	vm.modeloSeleccionado=null;
        }
        
        function search(){
        	
        	if(vm.anioSeleccionado==null )
        		return ;
        	$state.transitionTo($state.$current, {
                page: 0,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                aniostr: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes
            },onSuccess);
        	 function onSuccess(data, headers) {
                 vm.links = ParseLinks.parse(headers('link'));
                 vm.totalItems = headers('X-Total-Count');
                 vm.queryCount = vm.totalItems;
                 vm.wrappers = data;
                 vm.page = pagingParams.page;
             }
        	
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('MisInstituciones', MisInstituciones);

    MisInstituciones.$inject = ['$resource'];

    function MisInstituciones ($resource) {
        var resourceUrl =  'apo/misinstituciones';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('MiReporteEvaluativoOO', MiReporteEvaluativoOO);

    MiReporteEvaluativoOO.$inject = ['$resource'];

    function MiReporteEvaluativoOO ($resource) {
        var resourceUrl =  'apo/verreporteoo:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('MiReporteEvaluativoLibre', MiReporteEvaluativoLibre);

    MiReporteEvaluativoLibre.$inject = ['$resource'];

    function MiReporteEvaluativoLibre ($resource) {
        var resourceUrl =  'apo/verreporteli:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': { method:'POST' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('CuestionarioService', CuestionarioService);

    CuestionarioService.$inject = ['$resource'];
    
    function CuestionarioService ($resource) {
    	var resourceUrl = 'apo/autoevaluacion/:ambito/:profesor';
    	
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'obtener': {
            	url:'apo/autoevaluacion/:ambito/:profesor/:modelo/:nivel/:tipoauto',
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('docente', {
            parent: 'app',
            url: '/docente?page&sort&search',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Mis Asignaturas - Evaluación Docente'
            },
            views: {
                'content@': {
                    templateUrl: 'app/docente/clasesdocente.html',
                    controller: 'DocenteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                anio: '0',
                modelo: '0',
                nivel: '0',
                centro: '0',
                indice: '0',
                ic: false,
                iic: '0'
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        anio: $stateParams.anio,
                        modelo: $stateParams.modelo,
                        nivel: $stateParams.nivel,
                        centro: $stateParams.centro,
                        indice: $stateParams.indice,
                        ic: $stateParams.ic,
                        iic: $stateParams.iic
                    };
                }]
            }
        })
        .state('autoevaluacion', {
            parent: 'docente',
            url: '/autoevaluacion/{ambito}/{profesor}/{modelo}/{nivel}/{idins}/{tipoauto}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Autoevaluación - Evaluación Docente'
            },
            views: {
                'content@': {
                    templateUrl: 'app/docente/autoevaluacion.html',
                    controller: 'AutoevaluacionController',
                    controllerAs: 'vm'
                }
            },
            params: {
            	ambito: '$stateParams.ambito',
            	profesor: '$stateParams.profesor',
            	modelo: '$stateParams.modelo',
            	nivel: '$stateParams.nivel',
            	idins: '$stateParams.idins',
				tipoauto: '$stateParams.tipoauto'
            }
        })
        .state('reporteprofesor', {
            parent: 'app',
            url: '/misevaluaciones?page&sort&search&type',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Mis Reportes Evaluativos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/docente/misreportesevaluativos.html',
                    controller: 'MisReportesEvaluativosController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                type: '1',
                indice : '1',
                ic: false,
                iic: '0',
                anio: '0',
                aniostr: '',
                modelo: '0',
                nivel: '0',
                centro: '0',
                ep: false
                
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        type: $stateParams.type,
                        indice: $stateParams.indice,
                        ic: $stateParams.ic,
                        iic: $stateParams.iic,
                        anio: $stateParams.anio,
                        aniostr: $stateParams.aniostr,
                        modelo: $stateParams.modelo,
                        nivel: $stateParams.nivel,
                        centro: $stateParams.centro,
                        ep: $stateParams.ep
                    };
                }]
            }
        })
         .state('verReporteOO', {
            parent: 'reporteprofesor',
            url: '/reporteoo/{id}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoOO/reporteevaluativoOO.html',
                    controller: 'ReporteEvaluativoOOController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MiReporteEvaluativoOO','$state', function($stateParams, MiReporteEvaluativoOO,$state) {
              	  return MiReporteEvaluativoOO.get({id: $stateParams.id}).$promise;
                }]
            },
        })
		.state('verReporteLic', {
		    parent: 'reporteprofesor',
		    url: '/reportelic/{id}',
		    data: {
		    	authorities: ['PROFESOR'],
		        pageTitle: 'Reporte Evaluativo'
		    },
		    views: {
		        'content@': {
		            templateUrl: 'app/reportes/reporteevaluativoLic/reporteevaluativoLic.html',
		            controller: 'ReporteEvaluativoLicController',
		            controllerAs: 'vm'
		        }
		    },
		    resolve: {
		        entity: ['$stateParams', 'ReporteEvaluativoLicService','$state', function($stateParams, ReporteEvaluativoLicService,$state) {
		      	  return ReporteEvaluativoLicService.ver({id: $stateParams.id}).$promise;
		        }]
		    },
		})
        .state('verReporteCU', {
            parent: 'reporteprofesor',
            url: '/reportecu/{id}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoCU/reporteevaluativoCU.html',
                    controller: 'ReporteEvaluativoCUController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoCUService','$state', function($stateParams, ReporteEvaluativoCUService,$state) {
              	  return ReporteEvaluativoCUService.ver({id: $stateParams.id}).$promise;
                }]
            },
        })
        .state('verReporteLI', {
            parent: 'reporteprofesor',
            url: '/reporteli/{id}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoLI/reporteevaluativoLI.html',
                    controller: 'ReporteEvaluativoLIController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MiReporteEvaluativoLibre','$state', function($stateParams, MiReporteEvaluativoLibre,$state) {
              	  return MiReporteEvaluativoLibre.get({id: $stateParams.id}).$promise;
                }]
            },

        })
        .state('verReporteRegular', {
            parent: 'reporteprofesor',
            url: '/reporteregular/{id}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoRegular/reporteevaluativoRegular.html',
                    controller: 'ReporteEvaluativoRegularController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoRegularService','$state', function($stateParams, ReporteEvaluativoRegularService,$state) {
              	  return ReporteEvaluativoRegularService.ver({id: $stateParams.id}).$promise;
                }]
            },
        })
        .state('verReporteVirtual', {
            parent: 'reporteprofesor',
            url: '/reportevirtual/{id}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoVirtual/reporteevaluativoVirtual.html',
                    controller: 'ReporteEvaluativoVirtualController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoVirtualService','$state', function($stateParams, ReporteEvaluativoVirtualService,$state) {
              	  return ReporteEvaluativoVirtualService.ver({id: $stateParams.id}).$promise;
                }]
            },
        })
        .state('verReporteUAEV', {
            parent: 'reporteprofesor',
            url: '/reporteuaev/{id}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoUAEV/reporteevaluativoUAEV.html',
                    controller: 'ReporteEvaluativoUAEVController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoUAEVService','$state', function($stateParams, ReporteEvaluativoUAEVService,$state) {
              	  return ReporteEvaluativoUAEVService.ver({id: $stateParams.id}).$promise;
                }]
            },
        })
		.state('verReporteBachillerato', {
			parent: 'reporteprofesor',
			url: '/reporteBachillerato/{id}',
			data: {
				authorities: ['PROFESOR'],
				pageTitle: 'Reporte Evaluativo'
			},
			views: {
				'content@': {
					templateUrl: 'app/reportes/reporteevaluativoBachillerato/reporteevaluativoBachillerato.html',
					controller: 'ReporteEvaluativoBachilleratoController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				entity: ['$stateParams', 'ReporteEvaluativoBachilleratoService', '$state', function($stateParams, ReporteEvaluativoBachilleratoService, $state) {
					return ReporteEvaluativoBachilleratoService.ver({ id: $stateParams.id }).$promise;
				}]
			},
		})
		.state('verreporteMixtoPII', {
			parent: 'reporteprofesor',
			url: '/reporteMixtoPII/{id}',
			data: {
				authorities: ['PROFESOR'],
				pageTitle: 'Reporte Evaluativo'
			},
			views: {
				'content@': {
					templateUrl: 'app/reportes/reporteevaluativoMixtoPII/reporteevaluativoMixtoPII.html',
					controller: 'ReporteEvaluativoMixtoPIIController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				entity: ['$stateParams', 'ReporteEvaluativoMixtoPIIService', '$state', function($stateParams, ReporteEvaluativoMixtoPIIService, $state) {
					return ReporteEvaluativoMixtoPIIService.ver({ id: $stateParams.id }).$promise;
				}]
			},
		})
        .state('verreporteVirtualPII', {
            parent: 'reporteprofesor',
            url: '/reporteVirtualPII/{id}',
            data: {
                authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoVirtualPII/reporteevaluativoVirtualPII.html',
                    controller: 'ReporteEvaluativoVirtualPIIController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoVirtualPIIService', '$state', function($stateParams, ReporteEvaluativoVirtualPIIService, $state) {
                    return ReporteEvaluativoVirtualPIIService.ver({ id: $stateParams.id }).$promise;
                }]
            },
        })
    }

})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('Docente', Docente);

    Docente.$inject = ['$resource'];

    function Docente ($resource) {
        var resourceUrl =  'apo/clasesdocente:anio,:modelo,:nivel,:centro,:indice,:ic,:iic/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('DocenteController', DocenteController);

    DocenteController.$inject = ['$scope', '$state', 'Docente', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','AniosEscolares','NivelesEducativosService','ModelosEducativosService','MisInstituciones','Periodos'];

    function DocenteController ($scope, $state, Docente, ParseLinks, AlertService, pagingParams, paginationConstants,AniosEscolares,NivelesEducativosService,ModelosEducativosService,MisInstituciones,Periodos) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.anioSeleccionado=pagingParams.anio;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.institucionSeleccionada = pagingParams.centro;
        vm.indicePeriodo=pagingParams.indice;
        vm.intercurso=pagingParams.ic;
        vm.indiceIntercurso=pagingParams.iic;
        vm.periodos;
        vm.search=search;
        cargarDropdrown();
        loadAll();
        vm.limpiar = limpiar;
        vm.msjCerrado=false;
		
        $scope.$watchGroup(["vm.anioSeleccionado","vm.institucionSeleccionada","vm.intercurso"],function(newValue,oldValue){
        	
        	if (newValue === oldValue) {
      	      return;
      	    }
        	
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSeleccionada != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSeleccionada,
            		ic: vm.intercurso
                });
        	}
        	
        	if(vm.intercurso){
        		vm.indicePeriodo = 0;
        	}else{
        		vm.indiceIntercurso = 0;
        	}
	      	
        });

        function loadAll () {
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSeleccionada != null && vm.intercurso != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSeleccionada,
            		ic: vm.intercurso
                });
        	}
        	
        	Docente.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSeleccionada,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso
            }, onSuccess, onError);
		}
		
        function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
        }
        
		function onSuccess(data, headers) {
			console.log(data);
        	vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            //alert(data);
            vm.clases = data;
             vm.page = pagingParams.page;
        }
		
		/*
		function onSuccess(data, headers) {
		    vm.links = ParseLinks.parse(headers('link'));
		    vm.totalItems = headers('X-Total-Count');
		    vm.queryCount = vm.totalItems;
		    vm.usuarios = data;
		    vm.page = pagingParams.page;
			vm.msjCerrado=true;
		}
		*/
		
        function onError(error) {
        	AlertService.error(error.data.message);
            vm.msjCerrado=false;
        }
		
        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSeleccionada,
                anio: vm.anioSeleccionado,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso
            });
        }
        
        function cargarDropdrown(){
        	vm.aniosEscolares=AniosEscolares.query();
        	vm.dependencias=MisInstituciones.query();
        	vm.niveles=NivelesEducativosService.getAll();
        	vm.modelos=ModelosEducativosService.getAll();
        }
        
        function limpiar() {
        	vm.modeloSeleccionado=null;
        }

        function search(){
        	
        	if(vm.anioSeleccionado==null )
        		return ;

        	$state.transitionTo($state.$current, {
                page: 0,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
//                type: vm.type,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSeleccionada,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso
            },onSuccess, onError);
		}
        
    }
})();

(function() {
    'use strict';
    
    angular
        .module('sideApp')
        .controller('AutoevaluacionController', AutoevaluacionController);

    AutoevaluacionController.$inject = ['$scope', '$state', 'CuestionarioService', 'ParseLinks', 'AlertService'];

    function AutoevaluacionController ($scope, $state, CuestionarioService, ParseLinks, AlertService) {
    	var vm = this;
    	vm.show = 0;
    	vm.save = save;
    	vm.resuelto = null;
    	vm.anterior = anterior;
    	vm.siguiente = siguiente;
    	vm.validarseccion = validarseccion;
    	vm.valido = false;
    	vm.mensaje = null;
    	vm.preguntainvalida = [];
    	vm.idins = $state.params.idins;
		vm.nivel = $state.params.nivel;
    	vm.contain = contain;
        vm.menu=menu;
        vm.msjCargando=true;
		vm.tipoauto= $state.params.tipoauto;
		vm.resetearResDePregDepediente = resetearResDePregDepediente;
		vm.respuestaCheckABoolean = respuestaCheckABoolean;
		vm.deshabilitar = deshabilitar;
		vm.validarPreguntayRespuestaDependiente = validarPreguntayRespuestaDependiente;
		vm.validarCheck = validarCheck;
		vm.valido = false;
		vm.validoCheck = false;
		vm.mensajeCheck = null;
		vm.preguntainvalidaCheck = [];
		vm.tipo = tipo;
		
        loadCuestionario();
    	
        function loadCuestionario(){
        	CuestionarioService.obtener({
        		ambito : $state.params.ambito, 
        		profesor : $state.params.profesor,
        		modelo: $state.params.modelo,
        		nivel: $state.params.nivel,
				tipoauto: $state.params.tipoauto
            }, onSuccess, onError); 
			
        }       

        function onSuccess(data, headers) { 
        	vm.msjCargando=true;
            vm.resuelto = data;
			init();
        }
        
        function onError(error) {
        	vm.msjCargando=false;
            AlertService.error(error.data.message);
        }
        
		function init(){
			var grupo = vm.resuelto.grupoPreguntasForUI;
			var cuestionario = vm.resuelto.cuestionarioResuelto;
			for (var i = 0; i < grupo.length; i++) {
				for (var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++) {
					for (var h = 0; h < cuestionario.respuestasPregunta.length; h++) {
						if (cuestionario.respuestasPregunta[h].pregunta.id == grupo[i].preguntasWrapperForUI[j].pregunta.id &&
							grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'CheckBox'
						) {
							grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada = vm.respuestaCheckABoolean(grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada);

						}
					}
				}
			}
		}
		
        function save() {
        	var grupo = vm.resuelto.grupoPreguntasForUI;
        	var cuestionario = vm.resuelto.cuestionarioResuelto;

			vm.validarseccion(grupo.length-1);
			vm.validarCheck(grupo.length-1);

			if(vm.valido && vm.validoCheck){
	        	for(var i = 0;i < grupo.length; i++){
	        		for(var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++){
	        			for(var h = 0; h < cuestionario.respuestasPregunta.length; h++){
	        				if(cuestionario.respuestasPregunta[h].pregunta.id == grupo[i].preguntasWrapperForUI[j].pregunta.id){
	        					if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'RadioButton'){
	        						cuestionario.respuestasPregunta[h].respuestaSeleccionada =grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
	            				}
	        					if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'TextArea'){
	        						cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
	            				}
	        					if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'Escala'){
	        						cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
	            				}
								if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'CheckBox'){
									cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
								}
	        				}
	        			}	
	        		}
	        	}
				CuestionarioService.save(cuestionario, onSaveSuccess, onSaveError);
			}
            
        }
        
        function onSaveSuccess(result) {
            $scope.$emit('sideApp:usuarioUpdate', result);
            $state.go('docente');
        }
        
        function onSaveError(error) {
            AlertService.error(error.data.message);
            $state.go('docente',{}, {reload: true});
        }
        
        function anterior(indice){
       		vm.show = indice;
       		vm.mensaje = null;
			vm.mensajeCheck = null;
       		vm.valido = null;
			vm.validoCheck = null;
        	
        }
        function siguiente(indice){
        	vm.validarseccion(indice);
			vm.validarCheck(indice);
        	if(vm.valido&& vm.validoCheck)
        		vm.show = indice+2;
        }
		
        function validarseccion(seccion){
			var grupo = vm.resuelto.grupoPreguntasForUI;
			var cuestionario = vm.resuelto.cuestionarioResuelto;
			var valido = true;
			var mensaje = null;
			var k = 0;
			vm.preguntainvalida = [];
			var index =0;
				for(var j = 0; j < grupo[seccion].preguntasWrapperForUI.length; j++){
					for(var h=0; h < cuestionario.respuestasPregunta.length; h++){
						if(
							grupo[seccion].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta != 'CheckBox' &&
							
							(
								grupo[seccion].preguntasWrapperForUI[j].pregunta.obligatoria || 
								!deshabilitar(grupo[seccion].preguntasWrapperForUI[j].pregunta.id,grupo[seccion].preguntasWrapperForUI[j].pregunta.preguntaActivador,grupo[seccion].preguntasWrapperForUI[j].pregunta.opcionpreguntaactivador)
							) && 
							cuestionario.respuestasPregunta[h].pregunta.id==grupo[seccion].preguntasWrapperForUI[j].pregunta.id){
							if(grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == null ||
								(
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'boolean' &&
									    grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == false
								) ||
								(
									grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada != null &&
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'string' &&
									grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada.trim() == ''
								)
							){
								valido = false;
								vm.preguntainvalida[index] = grupo[seccion].preguntasWrapperForUI[j].pregunta.id;
								index++;
							}
						}
					}
				}
				if(!valido){
					mensaje="No has contestado todas las preguntas de esta sección.";
				}
				vm.valido = valido;
				vm.mensaje = mensaje;
        }
        
		function validarCheck(seccion){
			var grupo = vm.resuelto.grupoPreguntasForUI;
			var min = grupo[seccion].grupoPreguntas.min;
			var max = grupo[seccion].grupoPreguntas.max;
			vm.preguntainvalidaCheck = [];
			if(min != null){
				var aux = 0;
				var cuestionario = vm.resuelto.cuestionarioResuelto;
				var valido = false;
				var mensaje = null;
				var index =0;
				for(var j = 0; j < grupo[seccion].preguntasWrapperForUI.length; j++){
					for(var h=0; h < cuestionario.respuestasPregunta.length; h++){
						if(cuestionario.respuestasPregunta[h].pregunta.id==grupo[seccion].preguntasWrapperForUI[j].pregunta.id &&
							grupo[seccion].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'CheckBox'
						){
							vm.preguntainvalidaCheck[index] = grupo[seccion].preguntasWrapperForUI[j].pregunta.id;
							
//							console.log("respuestaSeleccionada: "+grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada);
							if(grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == null ||
								(
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'boolean' &&
								    grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == false
							 	) ||
								(
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'string' &&
									grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == "false"
								) 
								//No considerar a las preguntas string en un check
							){
								index++;
							}else{
								aux++;
							}
						}
					}
				}
				
				var tp = grupo[seccion].preguntasWrapperForUI[0].pregunta.preguntaActivador !=null? grupo[seccion].preguntasWrapperForUI[0].pregunta.preguntaActivador.tipoPregunta.tipoPregunta:null;

				var idpa = grupo[seccion].preguntasWrapperForUI[0].pregunta.preguntaActivador !=null? grupo[seccion].preguntasWrapperForUI[0].pregunta.preguntaActivador.id : null;

				var opa = grupo[seccion].preguntasWrapperForUI[0].pregunta.opcionpreguntaactivador != null? grupo[seccion].preguntasWrapperForUI[0].pregunta.opcionpreguntaactivador.respuestaString:null;
//				console.log("Validar Check");
				var auxVal = tp!=null ? idpa != null? opa != null ? validarPreguntayRespuestaDependiente(idpa,opa,tp):true:true:true;
				
//				console.log(aux);
//				console.log(min);
//				console.log(max);
//				console.log(auxVal);
				if(aux>=min && aux<=max || !auxVal){
					vm.preguntainvalidaCheck = [];
					valido = true;
				}else{
//					console.log("paseeee");
					mensaje = "Selecciona mínimo "+min+" y máximo "+max+" elementos";
				}
				
				vm.validoCheck = valido;
				vm.mensajeCheck = mensaje;
			}else{
				vm.validoCheck = true;
			}
		}
		
        function contain(idpregunta){
        	var invalido = false;
			var index = 0;
        	for(index = 0;index < vm.preguntainvalida.length; index++){
        		if(vm.preguntainvalida[index] == idpregunta){
        			invalido = true;
        			break;
        		}
        	}
			if(!invalido){
				for(index = 0;index < vm.preguntainvalidaCheck.length; index++){
					if(vm.preguntainvalidaCheck[index] == idpregunta){
				    	invalido = true;
				        break;
				    }
				}
			}
        	return invalido;
        }
		
        function menu(){
        	$state.go("docente");
        }
		
		function resetearResDePregDepediente(preguntaId){
//			console.log("Entrando a resetearResDePregDepediente");
			var grupo = vm.resuelto.grupoPreguntasForUI;
			
			for(var i = 0; i < grupo.length; i++){
				for(var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++){
					if(grupo[i].preguntasWrapperForUI[j].pregunta.preguntaActivador !=null && 
						grupo[i].preguntasWrapperForUI[j].pregunta.preguntaActivador.id==preguntaId){
//						console.log("Pregunta: "+preguntaId);
						// Inicio metodo recursivo	
						resetearResDePregDepediente(grupo[i].preguntasWrapperForUI[j].pregunta.id);
						// Fin metodo recursivo		
						grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada=null;
					}
				}
			}

		}
		
		function respuestaCheckABoolean(respuestaCheck){
			let respuesta = (respuestaCheck == true || respuestaCheck == "true" ? true : false);
			return respuesta;
		}

		function deshabilitar(preguntaid,preguntaActivador,opcionpreguntaactivador){
//			console.log("-----------------------");
//			console.log("Entrando a deshabilitar");
			var boolVar = true;
			if( (preguntaActivador == null && opcionpreguntaactivador == null) ||
				(   
					preguntaActivador != null && opcionpreguntaactivador != null &&
					vm.validarPreguntayRespuestaDependiente(preguntaActivador.id,opcionpreguntaactivador.respuestaString,preguntaActivador.tipoPregunta.tipoPregunta)
				) ){
					boolVar = false;
				}
//				console.log("preguntaid "+preguntaid);
//				console.log("deshabilitar? "+boolVar);
			return boolVar;
		}

		function validarPreguntayRespuestaDependiente(idPregActivador,respuestaStringActivador,tipoPregunta){
//			console.log("Entrando a validarPreguntayRespuestaDependiente");
			var grupo = vm.resuelto.grupoPreguntasForUI;
			
			var aux = false;
			
			for(var i = 0; i < grupo.length; i++){
				for(var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++){
					if(grupo[i].preguntasWrapperForUI[j].pregunta.id == idPregActivador ){ 		
						if(grupo[i].preguntasWrapperForUI[j].pregunta.id == idPregActivador){
							if(tipoPregunta == 'CheckBox'){
//								console.log("TipoPreguntaActivador es check");
//								console.log("Tipo de respuestaStringActivador "+respuestaStringActivador);
//								console.log(typeof respuestaStringActivador);
//								console.log("Tipo de respuestaSelect "+ grupo[i].preguntasWrapperForUI[j].respuesta);
//								console.log(grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada);
//								console.log(typeof grupo[i].preguntasWrapperForUI[j].respuesta);
								var boolVar = Boolean(respuestaStringActivador);
								
								if(grupo[i].preguntasWrapperForUI[j].respuesta != null && Boolean(grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada) == boolVar){
									aux=true;
									break;	
								}
							}else{
								if(grupo[i].preguntasWrapperForUI[j].respuesta != null && grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == respuestaStringActivador){
									aux=true;
									break;	
								}
							}
						}
					}		
				}
			}
//			console.log("valor:"+aux);
			return aux;      	
		}
		
		function tipo(tipo){
			return typeof tipo;
		}
    }
})();

(function() {
	'use strict';
	angular.module('sideApp')
	.factory('showdownloadpage', showdownloadpage);

	showdownloadpage.$inject = [ '$resource' ];

	function showdownloadpage ($resource) {
		var resourceUrl = 'apo/alumosquecontestaron/:ambito';

		return $resource(resourceUrl, {}, {
			'get' : {
				method : 'GET',
//				isArray : true
				transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
			},
//			'getNumAlumnosQueContestaronSI': {
//                url:'apo/alumnosquecontestaronsi/:ambito',
//                method: 'GET',
//                transformResponse: function (data) {
//                    return {'total' : data};
//                }
//            },
		});
	}
})();
(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('downloadfilecontroller', downloadfilecontroller);

    downloadfilecontroller.$inject = ['$scope', '$state','$stateParams', 'Clases', 'ParseLinks', 'AlertService', 'downloadService','showdownloadpage'];

    function downloadfilecontroller ($scope, $state, $stateParams,Clases, ParseLinks, AlertService,downloadService,showdownloadpage) {
        var vm = this;
        var idambito;
        vm.download=download;
        vm.showDownloadPage=showDownloadPage;
        showDownloadPage();
        
        function download(idAmbito){
            downloadService.donwl(idAmbito)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }
        
        function showDownloadPage(){
        	idambito=$stateParams.ambito;
        	 vm.alumosObtenidos=showdownloadpage.get ({ambito : $stateParams.ambito});
        }

        function download(){
//        console.log("Entrando");
//        console.log("IdAmbito: "+idambito)
            downloadService.donwl(idambito)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }
    }
})();

(function() {
    'use strict';
    
    angular
    	.module('sideApp')
    	.factory('downloadService',downloadService);
    

    downloadService.$inject = ['$q', '$timeout', '$window','$http','$state','$resource'];
    //var downloadModule = angular.module('components.donwload', []);


        function downloadService($q, $timeout, $window,$http,$state,$resource) {
            var down ={
                	donwl:download,
                //	showDownloadPage:showDownloadPage
                };
        	
        	
            return  down;
            
            
            function download(name) {//descargar archivo

                    var defer = $q.defer();

                    $timeout(function() {
                            $window.location = 'apo/download/'+name;
                        }, 1000)
                        .then(function() {                        	
                            defer.resolve('success');
//                            $state.go('clases', null,{reload:false});
                        }, function() {
                            defer.reject('error');
                        });
                    return defer.promise;
                }
        }
        
//        function showDownloadPage () {//cargar alumnos
//            var resourceUrl =  'api/alumosdownload/';
//
//            return $resource(resourceUrl, {}, {
//                'query': { method: 'GET', isArray: true},
//                'get': {
//                    method: 'GET',
//                    transformResponse: function (data) {
//                        if (data) {
//                            data = angular.fromJson(data);
//                        }
//                        return data;
//                    }
//                },
//                'update': { method:'PUT' }
//            });
//        }
        
        
        
})();
(function() {
    'use strict';

    angular
        .module('sideApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('sideApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sideApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('sideApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('sideApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                backdrop: 'static',
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = false;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
	'use strict';

	var sideAlertError = {
			template : '<div class="alerts">' +
            		   		'<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
            		   			'<uib-alert type="{{alert.type}}" close="alert.close($ctrl.alerts)">{{ alert.msg }}</uib-alert>' +
            		   		'</div>' +
            		   	'</div>'+
            		   	'</br>'	+
            		   	'<div class="alerts">' +
        		   			'<div ng-repeat="alert in $ctrl.alerts2" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
        		   				'<uib-alert type="{{alert.type}}" close="alert.close($ctrl.alerts2)">{{ alert.msg }}</uib-alert>' +
        		   			'</div>' +
        		   		'</div>'+
        		   		'</br>'	+
            		   	'<div class="alerts">' +
        		   			'<div ng-repeat="alert in $ctrl.alerts3" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
        		   				'<uib-alert type="{{alert.type}}" close="alert.close($ctrl.alerts3)">{{ alert.msg }}</uib-alert>' +
        		   			'</div>' +
        		   		'</div>'
            		   		,
			controller: sideAlertErrorController
		};
	
	angular.module('sideApp')
	.component('sideAlertError', sideAlertError);
	
    sideAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function sideAlertErrorController ($scope, AlertService, $rootScope) {
    	var vm = this;

        vm.alerts = [];
        vm.alerts2 = [];
        vm.alerts3 = [];
        
        
        
		function addErrorAlert(message, key, data) {
			var array = message.split('.');
			angular.forEach(array, function(value, key) {
				if (value != null && value != '') {
					vm.alerts.push(AlertService.add({
						type : 'danger',
						msg : value,
						toast : AlertService.isToast(),
						scoped : true
					}, vm.alerts));
				}
			});
		}
		
		function addGoodAlert(message, key, data) {
			var array = message.split('.');
			angular.forEach(array, function(value, key) {
				if (value != null && value != '') {
					vm.alerts2.push(AlertService.add({
						type : 'success',
						msg : value,
						toast : AlertService.isToast(),
						scoped : true
					}, vm.alerts2));
				}
			});
		}
		
		function addClasesAlert(message, key, data) {
			var array = message.split('.');
			angular.forEach(array, function(value, key) {
				if (value != null && value != '') {
					vm.alerts3.push(AlertService.add({
						type : 'success',
						msg : value,
						toast : AlertService.isToast(),
						scoped : true
					}, vm.alerts3));
				}
			});
		}

        var cleanHttpErrorListener = $rootScope.$on('sideApp.httpError', function (event, httpResponse) {
        	var i;
            event.stopPropagation();
            var errorHeader = httpResponse.headers('X-sideApp-error');
            var entityKey = httpResponse.headers('X-sideApp-params');
            var errorHeader2 = httpResponse.headers('X-sideApp-good');
            var entityKey2 = httpResponse.headers('X-sideApp-paramsV2');
            var errorHeader3 = httpResponse.headers('X-sideApp-clases');
            var entityKey3 = httpResponse.headers('X-sideApp-paramsV3');
            
            switch (httpResponse.status) {
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;
            
            case 200:
                 if (errorHeader) {
                     var entityName = entityKey;
                     addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                 }
                 if (errorHeader2) {
                     var entityName = entityKey2;
                     addGoodAlert(errorHeader2, errorHeader2, {entityName: entityName});
                 }
                 if (errorHeader3) {
                     var entityName = entityKey3;
                     addGoodAlert(errorHeader3, errorHeader3, {entityName: entityName});
                 }
                 
            	break;

            case 400:
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                
                if (errorHeader2) {
                    var entityName = entityKey2;
                    addGoodAlert(errorHeader2, errorHeader2, {entityName: entityName});
                }
                if (errorHeader3) {
                    var entityName = entityKey3;
                    addGoodAlert(errorHeader3, errorHeader3, {entityName: entityName});
                }
                
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        var cleanHttpInfoListener = $rootScope.$on('sideApp.httpInfo', function (event, httpResponse) {
        	var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            case 200:
            	 var errorHeader = httpResponse.headers('X-sideApp-error');
                 var entityKey = httpResponse.headers('X-sideApp-params');
                 var errorHeader2 = httpResponse.headers('X-sideApp-good');
                 var entityKey2 = httpResponse.headers('X-sideApp-paramsV2');
                 var errorHeader3 = httpResponse.headers('X-sideApp-clases');
                 var entityKey3 = httpResponse.headers('X-sideApp-paramsV3');
                 if (errorHeader) {
                     var entityName = entityKey;
                     addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                 }
                 if (errorHeader2) {
                     var entityName = entityKey2;
                     addGoodAlert(errorHeader2, errorHeader2, {entityName: entityName});
                 }
                 if (errorHeader3) {
                     var entityName = entityKey3;
                     addGoodAlert(errorHeader3, errorHeader3, {entityName: entityName});
                 }
                 
            	break;

            default:
//                if (httpResponse.data && httpResponse.data.message) {
//                    addErrorAlert(httpResponse.data.message);
//                } else {
//                    addErrorAlert(angular.toJson(httpResponse));
//                }
            }
        	
        });
        
        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
            if(angular.isDefined(cleanHttpInfoListener) && cleanHttpInfoListener !== null){
            	cleanHttpInfoListener();
                vm.alerts = [];
            }
        });
    }
})();
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('sideApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: message,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('sideApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-sideApp-error');
                var entityKey = httpResponse.headers('X-sideApp-params');
                if (errorHeader) {
                    var entityName = entityKey;
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = convertedField.charAt(0).toUpperCase() + convertedField.slice(1);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce'];

        function getService ($timeout, $sce) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('sideApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('InstitucionesClases', InstitucionesClases);

    InstitucionesClases.$inject = ['$resource'];

    function InstitucionesClases ($resource) {
        var resourceUrl =  'apo/institucionesclases';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('clases', {
            parent: 'app',
            url: '/clases?page&sort&search&type',
            data: {
            	authorities: ['RESPONSABLE_SIDE','ADMINISTRATIVO_GENERAL_SIDE','ADMINISTRATIVO_BACHILLERATO_SIDE'],
                pageTitle: 'Administrar clases'
            },
            views: {
                'content@': {
                    templateUrl: 'app/clases/listadoclases.html',
                    controller: 'ClasesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                type: '1',
                indice : '1',
                ic: false,
                iic: '0',
                anio: '0',
                aniostr: '',
                modelo: '0',
                nivel: '0',
                centro: '0',
                ep: false
                
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        type: $stateParams.type,
                        indice: $stateParams.indice,
                        ic: $stateParams.ic,
                        iic: $stateParams.iic,
                        anio: $stateParams.anio,
                        aniostr: $stateParams.aniostr,
                        modelo: $stateParams.modelo,
                        nivel: $stateParams.nivel,
                        centro: $stateParams.centro,
                        ep: $stateParams.ep
                    };
                }]
            }
        })
        .state('clases.ambito', {
            parent: 'clases',
            url: '/clases/{id}/{idp}/{tiponivel}/{tipomodelo}/{idins}',
            data: {
            	authorities: ['RESPONSABLE_SIDE','ADMINISTRATIVO_GENERAL_SIDE','ADMINISTRATIVO_BACHILLERATO_SIDE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/ambito/crearambito.html',
                    controller: 'AmbitoController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClasesAmbitoService', function(ClasesAmbitoService) {
                        	return ClasesAmbitoService.obtener({id : $stateParams.id , idp : $stateParams.idp, tiponivel : $stateParams.tiponivel, tipomodelo : $stateParams.tipomodelo, idins :$stateParams.idins}).$promise;
                
                        }]
                    }
                }).result.then(function() {
                    $state.go('clases', null, { reload: 'clases' });
                }, function() {
                    $state.go('clases');
                });
            }]
        })
        .state('downloadPage', {
            parent: 'clases',
            url: '/downloadPage/{ambito}',
            data: {
            	authorities: ['RESPONSABLE_SIDE','ADMINISTRATIVO_GENERAL_SIDE','ADMINISTRATIVO_BACHILLERATO_SIDE'],
                pageTitle: 'Descargar reporte de alumnos evaluados'
            },
            views: {
                'content@': {
                    templateUrl: 'app/descargas/downloadpage.html',
                    controller: 'downloadfilecontroller',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                idambito: '$stateParams.ambito'
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('Clases', Clases);

    Clases.$inject = ['$resource'];

    function Clases ($resource) {
    	var resourceUrl =  'apo/profesores:search,:type,:indice,:ic,:iic,:anio,:modelo,:nivel,:centro,:ep/:id/:idp';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'obtener': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ClasesController', ClasesController);

    ClasesController.$inject = ['$scope', '$state', 'Clases', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ClasesAmbitoService','LoginService','downloadService','AniosEscolares','ReporteProfesorService','ReporteAlumnoService','Instituciones','Periodos','NivelesEducativosService','ModelosEducativosService'];

    function ClasesController ($scope, $state, Clases, ParseLinks, AlertService, pagingParams, paginationConstants,ClasesAmbitoService,LoginService,downloadService,AniosEscolares,ReporteProfesorService,ReporteAlumnoService,Instituciones,Periodos,NivelesEducativosService,ModelosEducativosService) {
        var vm = this;
        
       // vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        //vm.openDialog=openDialog;
        vm.download=download;
//        vm.descargarReporteAlumnos=descargarReporteAlumnos;
//        vm.descargarReporteProfesor=descargarReporteProfesor;
        vm.indicePeriodo=pagingParams.indice;
        vm.search=search;
        vm.type=pagingParams.type;
        vm.currentSearch=pagingParams.search;
        vm.anioSeleccionado=pagingParams.anio;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.institucionSelected=pagingParams.centro;
        vm.evaluacionesPendientes=pagingParams.ep;
        vm.intercurso=pagingParams.ic;
        vm.indiceIntercurso=pagingParams.iic;
        vm.periodos;
        vm.isNew = isNew;
        vm.limpiar = limpiar;
        vm.periodos;
        cargarDropdown();
        loadAll();
        
        
        $scope.$watchGroup(["vm.anioSeleccionado","vm.institucionSelected","vm.intercurso"],function(newValue,oldValue){
        	
        	if (newValue === oldValue) {
      	      return;
      	    }
        	
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                });
        	}
        	
        	if(vm.intercurso){
        		vm.indicePeriodo = 0;
        	}else{
        		vm.indiceIntercurso = 0;
        	}
	      	
        });
        
        function loadAll () {
        	vm.periodos = null;
        	if(vm.anioSeleccionado != null && vm.institucionSelected != null && vm.intercurso != null){
        		vm.periodos = Periodos.query({
            		anio: vm.anioSeleccionado,
            		dep: vm.institucionSelected,
            		ic: vm.intercurso
                });
        	}
        	
        	Clases.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro:vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.usuarios = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
        
        function download(idAmbito){
            downloadService.donwl(idAmbito)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            },onSuccess,{reload:false});
       	 function onSuccess(data, headers) {
             vm.links = ParseLinks.parse(headers('link'));
             vm.totalItems = headers('X-Total-Count');
             vm.queryCount = vm.totalItems;
             vm.usuarios = data;
             vm.page = pagingParams.page;
         }
        }
        
        function isNew(){
        	if( vm.usuarios.evaluacion.id ==null )
        		return true;
        	else
        		return false;
        }
        
        function cargarDropdown(){
        	vm.aniosEscolares=AniosEscolares.query();
        	vm.dependencias=Instituciones.query();
        	vm.niveles=NivelesEducativosService.getAll();
        	vm.modelos=ModelosEducativosService.getAll();
        }
        
        function limpiar() {
        	vm.modeloSeleccionado=null;
        }
        
        function search(){
        	
        	if(vm.anioSeleccionado==null )
        		return ;
        	
        	$state.transitionTo($state.$current, {
                page: 0,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                type: vm.type,
                indice: vm.indicePeriodo,
                ic: vm.intercurso,
                iic: vm.indiceIntercurso,
                anio: vm.anioSeleccionado,
                aniostr: vm.anioSeleccionado,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado,
                centro: vm.institucionSelected,
                ep: vm.evaluacionesPendientes,
            },onSuccess);
        	 function onSuccess(data, headers) {
                 vm.links = ParseLinks.parse(headers('link'));
                 vm.totalItems = headers('X-Total-Count');
                 vm.queryCount = vm.totalItems;
                 vm.usuarios = data;
                 vm.page = pagingParams.page;
             }
        	
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('sideInfoNotificationInterceptor', sideInfoNotificationInterceptor);

    sideInfoNotificationInterceptor.$inject = ['$q', 'AlertService','$rootScope'];

    function sideInfoNotificationInterceptor ($q, AlertService, $rootScope) {
        var service = {
        		response: response
        };

        return service;

        function response (response) {
            if (response.status == 200) {
                $rootScope.$emit('sideApp.httpInfo', response);
            }
            return response;
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-sideApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-sideApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('sideApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$document'];

    function authExpiredInterceptor($rootScope, $q, $injector, $document) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            } else if (response.status === 403 && response.config.method !== 'GET' && getCSRF() === '') {
                // If the CSRF token expired, then try to get a new CSRF token and retry the old request
                var $http = $injector.get('$http');
                return $http.get('/').finally(function() { return afterCSRFRenewed(response); });
            }
            return $q.reject(response);
        }

        function getCSRF() {
            var doc = $document[0];
            if (doc) {
                var name = 'CSRF-TOKEN=';
                var ca = doc.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') {c = c.substring(1);}

                    if (c.indexOf(name) !== -1) {
                        return c.substring(name.length, c.length);
                    }
                }
            }
            return '';
        }

        function afterCSRFRenewed(oldResponse) {
            if (getCSRF() !== '') {
                // retry the old request after the new CSRF-TOKEN is obtained
                var $http = $injector.get('$http');
                return $http(oldResponse.config);
            } else {
                // unlikely get here but reject with the old response any way and avoid infinite loop
                return $q.reject(oldResponse);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage',  '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage,  $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'side' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                $window.document.title = titleKey;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('sideApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        
        //enable CSRF
        $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';
        
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here
        $httpProvider.interceptors.push('sideInfoNotificationInterceptor');
        
        
        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('NuevoUsuarioController', NuevoUsuarioController);

    NuevoUsuarioController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Instituciones','BuscadorEmpleado','UsuariosATI'];

    function NuevoUsuarioController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Instituciones,BuscadorEmpleado,UsuariosATI) {
        var vm = this;
        vm.entity=entity;
        vm.criterio="";
        vm.clear = clear;
        vm.save = save;
        vm.institucionSelected=entity.institucion;
        vm.buscar=buscar;
        vm.setEmpleado=setEmpleado;
        vm.empleados=null;
        vm.idpersona=null;
        vm.valid=valid;
        cargarDropDown();
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
           vm.entity.institucion=vm.institucionSelected;
          //  if (vm.usuario.id !== null) {
           //     Usuario.update(vm.usuario, onSaveSuccess, onSaveError);
           // } else {
            UsuariosATI.save(vm.entity, onSaveSuccess, onSaveError);
         //   }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sideApp:usuarioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function cargarDropDown(){
        	vm.instituciones=Instituciones.query();
        }
        
        function buscar(){
        	if(vm.criterio!=null && vm.criterio.trim()!=""){
        	vm.empleados=BuscadorEmpleado.query({criterio : vm.criterio});
        	}
        }
        function setEmpleado(idPersonaEmpleado){
        	 vm.idpersona=idPersonaEmpleado;
        	 vm.entity.persona=idPersonaEmpleado;
        }
        function valid() {
        	if(vm.institucionSelected==null || vm.idpersona==null)
        		return false;
            return true;
        }
        

    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('PerfilDeleteController',PerfilDeleteController);

    PerfilDeleteController.$inject = ['$uibModalInstance', 'entity', 'UsuariosATI'];

    function PerfilDeleteController($uibModalInstance, entity, UsuariosATI) {
        var vm = this;

        vm.usuario = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	UsuariosATI.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('BuscadorEmpleado', BuscadorEmpleado);

    BuscadorEmpleado.$inject = ['$resource'];

    function BuscadorEmpleado ($resource) {
        var resourceUrl =  'apo/buscarpersona/:id:criterio';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('admgestor', {
            parent: 'app',
            url: '/admonusuariosgestor?page&sort&search',
            data: {
            	authorities: ['ATI_EVALUACION_DOCENTE'],
                pageTitle: 'Administrar Usuarios ATI'
            },
            views: {
                'content@': {
                    templateUrl: 'app/ati/admonusuariosgestor.html',
                    controller: 'UsuariosClasesController',
                    controllerAs: 'vm'
                }
            },
            params: {
                tipo: 71
                	,
            	page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('admperfilgestor', {
            parent: 'admgestor',
            url: '/new',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/ati/nuevousuario.html',
                    controller: 'NuevoUsuarioController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                institucion: null,
                                persona: null,
                                rol: 71,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('admgestor', null, { reload: 'admgestor' });
                }, function() {
                    $state.go('admgestor');
                });
            }]
        })
        .state('admgestor.delete', {
            parent: 'admgestor',
            url: '/{id}/delete',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/ati/deleteperfilconfirm.html',
                    controller: 'PerfilDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UsuariosATI', function(UsuariosATI) {
                            return UsuariosATI.get({id : $stateParams.id,tipo : 71}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('admgestor', null, { reload: 'admgestor' });
                }, function() {
                    $state.go('admgestor');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('UsuariosClasesController', UsuariosClasesController);

    UsuariosClasesController.$inject = ['$scope', '$state', 'UsuariosATI', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function UsuariosClasesController ($scope, $state, UsuariosATI, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
        	UsuariosATI.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                tipo: 71
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.usuarios = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ati', {
            parent: 'app',
            url: '/admonusuariosati?page&sort&search',
            data: {
            	authorities: ['ATI_EVALUACION_DOCENTE'],
                pageTitle: 'Administrar Usuarios ATI'
            },
            views: {
                'content@': {
                    templateUrl: 'app/ati/admonusuariosati.html',
                    controller: 'UsuariosATIController',
                    controllerAs: 'vm'
                }
            },
            params: {
                tipo: 69
                	,
            	page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('admonati', {
            parent: 'ati',
            url: '/new',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/ati/nuevousuario.html',
                    controller: 'NuevoUsuarioController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                institucion: null,
                                persona: null,
                                rol: 69,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ati', null, { reload: 'ati' });
                }, function() {
                    $state.go('ati');
                });
            }]
        })
        .state('admonati.delete', {
            parent: 'ati',
            url: '/{id}/delete',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/ati/deleteperfilconfirm.html',
                    controller: 'PerfilDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UsuariosATI', function(UsuariosATI) {
                            return UsuariosATI.get({id : $stateParams.id,tipo : 69}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ati', null, { reload: 'ati' });
                }, function() {
                    $state.go('ati');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('UsuariosATI', UsuariosATI);

    UsuariosATI.$inject = ['$resource'];

    function UsuariosATI ($resource) {
        var resourceUrl =  'apo/admonusuarios/:id/:tipo';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('UsuariosATIController', UsuariosATIController);

    UsuariosATIController.$inject = ['$scope', '$state', 'UsuariosATI', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function UsuariosATIController ($scope, $state, UsuariosATI, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
        	UsuariosATI.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                tipo: 69
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.usuarios = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('admeval', {
            parent: 'app',
            url: '/admonusuariosadmin?page&sort&search',
            data: {
            	authorities: ['ATI_EVALUACION_DOCENTE'],
                pageTitle: 'Administrar Usuarios ADMIN'
            },
            views: {
                'content@': {
                    templateUrl: 'app/ati/admonusuariosadmin.html',
                    controller: 'UsuariosAdminEvaluacionController',
                    controllerAs: 'vm'
                }
            },
            params: {
                tipo: 70
                	,
            	page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('admonevalua', {
            parent: 'admeval',
            url: '/new',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/ati/nuevousuario.html',
                    controller: 'NuevoUsuarioController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                institucion: null,
                                persona: null,
                                rol: 70,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('admeval', null, { reload: 'admeval' });
                }, function() {
                    $state.go('admeval');
                });
            }]
        })
        .state('admonevalua.delete', {
            parent: 'admeval',
            url: '/{id}/delete',
            data: {
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/ati/deleteperfilconfirm.html',
                    controller: 'PerfilDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UsuariosATI', function(UsuariosATI) {
                            return UsuariosATI.get({id : $stateParams.id,tipo : 70}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('admeval', null, { reload: 'admeval' });
                }, function() {
                    $state.go('admeval');
                });
            }]
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('UsuariosAdminEvaluacionController', UsuariosAdminEvaluacionController);

    UsuariosAdminEvaluacionController.$inject = ['$scope', '$state', 'UsuariosATI', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function UsuariosAdminEvaluacionController ($scope, $state, UsuariosATI, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
        	UsuariosATI.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                tipo: 70
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.usuarios = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('sideApp')
        .constant('VERSION', "1.0.0")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('anio', {
            parent: 'app',
            url: '/anioescolar?page&sort&search',
            data: {
            	authorities: [],
                pageTitle: 'Anio escolar'
            },
            views: {
                'content@': {
                    templateUrl: 'app/anioescolar/anioescolar.html',
                    controller: 'AnioEscolarController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
//        .state('usuario-detail', {
//            parent: 'entity',
//            url: '/usuario/{id}',
//            data: {
//                pageTitle: 'Usuario'
//            },
//            views: {
//                'content@': {
//                    templateUrl: 'app/entities/usuario/usuario-detail.html',
//                    controller: 'UsuarioDetailController',
//                    controllerAs: 'vm'
//                }
//            },
//            resolve: {
//                entity: ['$stateParams', 'Usuario', function($stateParams, Usuario) {
//                    return Usuario.get({id : $stateParams.id}).$promise;
//                }],
//                previousState: ["$state", function ($state) {
//                    var currentStateData = {
//                        name: $state.current.name || 'usuario',
//                        params: $state.params,
//                        url: $state.href($state.current.name, $state.params)
//                    };
//                    return currentStateData;
//                }]
//            }
//        })
//        .state('usuario-detail.edit', {
//            parent: 'usuario-detail',
//            url: '/detail/edit',
//            data: {
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/usuario/usuario-dialog.html',
//                    controller: 'UsuarioDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['Usuario', function(Usuario) {
//                            return Usuario.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('^', {}, { reload: false });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('usuario.new', {
//            parent: 'usuario',
//            url: '/new',
//            data: {
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/usuario/usuario-dialog.html',
//                    controller: 'UsuarioDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: function () {
//                            return {
//                                login: null,
//                                password: null,
//                                activo: null,
//                                id: null
//                            };
//                        }
//                    }
//                }).result.then(function() {
//                    $state.go('usuario', null, { reload: 'usuario' });
//                }, function() {
//                    $state.go('usuario');
//                });
//            }]
//        })
//        .state('usuario.edit', {
//            parent: 'usuario',
//            url: '/{id}/edit',
//            data: {
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/usuario/usuario-dialog.html',
//                    controller: 'UsuarioDialogController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg',
//                    resolve: {
//                        entity: ['Usuario', function(Usuario) {
//                            return Usuario.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('usuario', null, { reload: 'usuario' });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        })
//        .state('usuario.delete', {
//            parent: 'usuario',
//            url: '/{id}/delete',
//            data: {
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/usuario/usuario-delete-dialog.html',
//                    controller: 'UsuarioDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['Usuario', function(Usuario) {
//                            return Usuario.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('usuario', null, { reload: 'usuario' });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('AniosEscolares', AniosEscolares);

    AniosEscolares.$inject = ['$resource'];

    function AniosEscolares ($resource) {
        var resourceUrl =  'apo/aniosEscolares/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('AnioEscolarController', AnioEscolarController);

    AnioEscolarController.$inject = ['$scope', '$state', 'AnioEscolar', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AnioEscolarController ($scope, $state, AnioEscolar, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Usuario.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.usuarios = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('ClasesAmbitoService', ClasesAmbitoService);

    ClasesAmbitoService.$inject = ['$resource'];

    function ClasesAmbitoService ($resource) {
    	   var resourceUrl =  'apo/profesores/:id/:idp/:tiponivel/:tipomodelo/:idins';

           return $resource(resourceUrl, {}, {
               'query': { method: 'GET', isArray: true},
               'get': {
                   method: 'GET',
                   transformResponse: function (data) {
                       if (data) {
                           data = angular.fromJson(data);
                       }
                       return data;
                   }
               },
               'obtener': {
                   method: 'GET',
                   transformResponse: function (data) {
                       if (data) {
                           data = angular.fromJson(data);
                       }
                       return data;
                   }
               },
               'save': {
            	   url:'apo/profesores',
            	   method: 'POST',
                   transformResponse: function (data) {
                       if (data) {
                           data = angular.fromJson(data);
                       }
                       return data;
                   }
               },
               'update': { method:'PUT' },
               'getTipoNivel': {
            	   url:'apo/getTipoNivel',
            	   method: 'POST'
               }
           });
       }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('AmbitoController', AmbitoController);

    AmbitoController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance','entity','ClasesAmbitoService' ];

    function AmbitoController ($timeout, $scope, $stateParams, $uibModalInstance,entity,ClasesAmbitoService) {
        var vm = this;
        vm.tiponivel = $stateParams.tiponivel;
        vm.tipomodelo = $stateParams.tipomodelo;
        vm.idins = $stateParams.idins;
        vm.ambito = entity;
        vm.clear = clear;
        vm.save = save;
        vm.cancel = cancel;
        vm.name=null;
        vm.nivelToShow=nivelToShow();
        
        function nivelToShow () {
        	return ClasesAmbitoService.getTipoNivel(vm.tiponivel);
        }
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
//        console.log(vm.ambito);

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ambito.id !== null) {
            	ClasesAmbitoService.update(vm.ambito, onSaveSuccess, onSaveError);
            } else {
            	ClasesAmbitoService.save(vm.ambito, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sideApp:usuarioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();

(function() {
    'use strict';
    
    angular
        .module('sideApp')
        .controller('EvaluacionController', EvaluacionController);

    EvaluacionController.$inject = ['$scope', '$state', 'CuestionarioAlumnoService', 'ParseLinks', 'AlertService','NivelEducativoService'];

    function EvaluacionController ($scope, $state, CuestionarioAlumnoService, ParseLinks, AlertService,NivelEducativoService) {
    	var vm = this;
    	vm.show = 0;
    	vm.save = save;
		vm.resuelto = null;
		vm.validarPreguntayRespuestaDependiente = validarPreguntayRespuestaDependiente;
		vm.resetearResDePregDepediente = resetearResDePregDepediente;
		vm.deshabilitar = deshabilitar;
		vm.tipo = tipo;
    	vm.anterior = anterior;
    	vm.siguiente = siguiente;
    	vm.validarseccion = validarseccion;
		vm.validarCheck = validarCheck;
    	vm.valido = false;
		vm.validoCheck = false;
    	vm.mensaje = null;
		vm.mensajeCheck = null;
    	vm.preguntainvalida = [];
		vm.preguntainvalidaCheck = [];
    	vm.contain = contain;
    	vm.tiponivel = getNivelByPlan();
		vm.nivel = $state.params.nivPlan;
    	vm.idins = $state.params.idins;
		vm.msjCargando=true;
		vm.menu=menu;
		vm.modelo = $state.params.modPlan;
		
		loadCuestionario();
				
		function loadCuestionario(){
			CuestionarioAlumnoService.obtener({
			    		ambito : $state.params.ambito
			        }, onSuccess, onError); 
		} 
		
		function onSuccess(data, headers) {
			vm.msjCargando=true; 
		    vm.resuelto = data;
			
		}

		function onError(error) {  
			vm.msjCargando=false;         
			AlertService.error(error.data.message);
		}
        
        function getNivelByPlan(){
        	return NivelEducativoService.getNivelByPlanAlumno({
        		nivPlan : $state.params.nivPlan
            }, onSuccessNiv, onErrorNiv);
        }

		function onSuccessNiv(data, headers) {
		vm.tiponivel = data;
		}

		function onErrorNiv(error) {      
		AlertService.error(error.data.message);
		}
		
		function menu(){
			$state.go("docente");
		}
				
        function save() {
        	var grupo = vm.resuelto.grupoPreguntasForUI;
        	var cuestionario = vm.resuelto.cuestionarioResuelto;

			vm.validarseccion(grupo.length-1);
			vm.validarCheck(grupo.length-1);
			
			if(vm.valido && vm.validoCheck){
				for(var i = 0; i < grupo.length; i++){
				    for(var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++){
				    	for(var h = 0;h < cuestionario.respuestasPregunta.length; h++){
				    		if(cuestionario.respuestasPregunta[h].pregunta.id == grupo[i].preguntasWrapperForUI[j].pregunta.id){
				    			if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'RadioButton'){
				    				cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
				    			}
				    			if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'TextArea'){
				    				cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
				    			}
				    			if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'Escala'){
				    				cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
				    			}
								if(grupo[i].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'CheckBox'){
								    cuestionario.respuestasPregunta[h].respuestaSeleccionada=grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada;
								}
				    		}
				    	}
				    }
				}
				CuestionarioAlumnoService.save(cuestionario, onSaveSuccess, onSaveError);
			}
			
        }
		
		function resetearResDePregDepediente(preguntaId){
			var grupo = vm.resuelto.grupoPreguntasForUI;
			
			for(var i = 0; i < grupo.length; i++){
				for(var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++){
					if(grupo[i].preguntasWrapperForUI[j].pregunta.preguntaActivador !=null && 
						grupo[i].preguntasWrapperForUI[j].pregunta.preguntaActivador.id==preguntaId){
						// Inicio metodo recursivo	
						resetearResDePregDepediente(grupo[i].preguntasWrapperForUI[j].pregunta.id);
						// Fin metodo recursivo		
						grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada=null;
					}
				}
			}

		}
		
		function validarPreguntayRespuestaDependiente(idPregActivador,respuestaStringActivador,tipoPregunta){
			var grupo = vm.resuelto.grupoPreguntasForUI;
			
			var aux = false;
			
			for(var i = 0; i < grupo.length; i++){
				for(var j = 0; j < grupo[i].preguntasWrapperForUI.length; j++){
					if(grupo[i].preguntasWrapperForUI[j].pregunta.id == idPregActivador ){ 		
						if(grupo[i].preguntasWrapperForUI[j].pregunta.id == idPregActivador){
							if(tipoPregunta == 'CheckBox'){
								var boolVar = Boolean(respuestaStringActivador);
								if(grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == boolVar){
									aux=true;
									break;	
								}
							}else{
								if(grupo[i].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == respuestaStringActivador){
									aux=true;
									break;	
								}
							}
								
						}
					}		
				}
			}
			return aux;      	
		}
		
		function deshabilitar(preguntaid,preguntaActivador,opcionpreguntaactivador){
			var boolVar = true;
			if( (preguntaActivador == null && opcionpreguntaactivador == null) ||
				(   
					preguntaActivador != null && opcionpreguntaactivador != null &&
					vm.validarPreguntayRespuestaDependiente(preguntaActivador.id,opcionpreguntaactivador.respuestaString,preguntaActivador.tipoPregunta.tipoPregunta)
				) ){
					boolVar = false;
				}
			return boolVar;
		}
        
		function tipo(tipo){
			return typeof tipo;
		}
		
        function onSaveSuccess(result) {
            $scope.$emit('sideApp:usuarioUpdate', result);
            $state.go('alumno',{}, {reload: true});
        }
        
        function onSaveError(error) {
            AlertService.error(error.data.message);
            $state.go('alumno',{}, {reload: true});
        }
        
        function anterior(indice){
       		vm.show = indice;
       		vm.mensaje = null;
			vm.mensajeCheck = null;
       		vm.valido = null;
			vm.validoCheck = null;
        }
        function siguiente(indice){
        	vm.validarseccion(indice);
			vm.validarCheck(indice);
        	if(vm.valido && vm.validoCheck)
        		vm.show = indice+2;
        }
        
        function validarseccion(seccion){
        	var grupo = vm.resuelto.grupoPreguntasForUI;
        	var cuestionario = vm.resuelto.cuestionarioResuelto;
        	var valido = true;
        	var mensaje = null;
        	var k = 0;
        	vm.preguntainvalida = [];
        	var index =0;
        		for(var j = 0; j < grupo[seccion].preguntasWrapperForUI.length; j++){
        			for(var h=0; h < cuestionario.respuestasPregunta.length; h++){
        				if(grupo[seccion].preguntasWrapperForUI[j].pregunta.obligatoria && cuestionario.respuestasPregunta[h].pregunta.id==grupo[seccion].preguntasWrapperForUI[j].pregunta.id){
							if(grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == null ||
								(
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'boolean' &&
									    grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == false
								) ||
								(
									grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada != null &&
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'string' &&
									grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada.trim() == ''
								)
							){
        						valido = false;
        						vm.preguntainvalida[index] = grupo[seccion].preguntasWrapperForUI[j].pregunta.id;
        						index++;
        					}
        				}
        			}
        		}
        		if(!valido){
        			mensaje="No has contestado todas las preguntas de esta sección.";
				}
        		vm.valido = valido;
        		vm.mensaje = mensaje;
        }
        
		function validarCheck(seccion){
			var grupo = vm.resuelto.grupoPreguntasForUI;
			var min = grupo[seccion].grupoPreguntas.min;
			var max = grupo[seccion].grupoPreguntas.max;
			vm.preguntainvalidaCheck = [];
			if(min != null){
				var aux = 0;
				var cuestionario = vm.resuelto.cuestionarioResuelto;
				var valido = false;
				var mensaje = null;
				var index =0;
				for(var j = 0; j < grupo[seccion].preguntasWrapperForUI.length; j++){
					for(var h=0; h < cuestionario.respuestasPregunta.length; h++){
						if(cuestionario.respuestasPregunta[h].pregunta.id==grupo[seccion].preguntasWrapperForUI[j].pregunta.id &&
							grupo[seccion].preguntasWrapperForUI[j].pregunta.tipoPregunta.tipoPregunta == 'CheckBox'
						){
							vm.preguntainvalidaCheck[index] = grupo[seccion].preguntasWrapperForUI[j].pregunta.id;
							
							if(grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == null ||
								(
									typeof grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == 'boolean' &&
								    grupo[seccion].preguntasWrapperForUI[j].respuesta.respuestaSeleccionada == false
							 	) 
//								No considerar a las preguntas string en un check
							){
								index++;
							}else{
								aux++;
							}
						}
					}
				}
				
				var tp = grupo[seccion].preguntasWrapperForUI[0].pregunta.preguntaActivador.tipoPregunta.tipoPregunta;

				var idpa = grupo[seccion].preguntasWrapperForUI[0].pregunta.preguntaActivador.id;

				var opa = grupo[seccion].preguntasWrapperForUI[0].pregunta.opcionpreguntaactivador.respuestaString;
				
				var auxVal = validarPreguntayRespuestaDependiente(idpa,opa,tp);
				
				if(aux>=min && aux<=max || !auxVal){
					vm.preguntainvalidaCheck = [];
					valido = true;
				}else{
					mensaje = "Selecciona mínimo "+min+" y máximo "+max+" elementos";
				}
				
				vm.validoCheck = valido;
				vm.mensajeCheck = mensaje;
			}else{
				vm.validoCheck = true;
			}
		}
				
        function contain(idpregunta){
        	var invalido = false;
			var index = 0;
        	for(index = 0;index < vm.preguntainvalida.length; index++){
        		if(vm.preguntainvalida[index] == idpregunta){
        			invalido = true;
        			break;
        		}
        	}
			if(!invalido){
				for(index = 0;index < vm.preguntainvalidaCheck.length; index++){
					if(vm.preguntainvalidaCheck[index] == idpregunta){
				    	invalido = true;
				        break;
				    }
				}
			}
        	return invalido;
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('CuestionarioAlumnoService', CuestionarioAlumnoService);

    CuestionarioAlumnoService.$inject = ['$resource'];
    
    function CuestionarioAlumnoService ($resource) {
    	var resourceUrl = 'apo/evaluacion/:ambito/';
    	
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'obtener': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('alumno', {
            parent: 'app',
            url: '/alumno?page&sort&search',
            data: {
            	authorities: ['ALUMNO'],
                pageTitle: 'Mis Asignaturas - Evaluación Docente'
            },
            views: {
                'content@': {
                    templateUrl: 'app/alumno/clasesalumno.html',
                    controller: 'AlumnoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }]
            }
        })
        .state('evaluacion', {
            parent: 'alumno',
            url: '/evaluacion/{ambito}/{nivPlan}/{modPlan}/{indiceClase}/{isInterCursoClase}/{indiceInterCursoClase}/{idins}',
            data: {
            	authorities: ['ALUMNO'],
                pageTitle: 'Evaluación - Evaluación Docente'
            },
            views: {
                'content@': {
                    templateUrl: 'app/alumno/evaluacion.html',
                    controller: 'EvaluacionController',
                    controllerAs: 'vm'
                }
            },
            params: {
            	ambito: '$stateParams.ambito',
            	nivPlan: '$stateParams.nivPlan',
            	modPlan: '$stateParams.modPlan',
            	indiceClase: '$stateParams.indiceClase',
            	isInterCursoClase: '$stateParams.isInterCursoClase',
            	indiceInterCursoClase:'$stateParams.indiceInterCursoClase',
            	idins: '$stateParams.idins'
            }
        })
    }

})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('Alumno', Alumno);

    Alumno.$inject = ['$resource'];

    function Alumno ($resource) {
        var resourceUrl =  'apo/clasesalumno/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getTipoNivel': {
         	   url:'apo/getTipoNivel',
         	   method: 'POST'
            },
            'getPlan': {
          	   url:'apo/getPlan',
          	   method: 'GET',
          	   isArray: true,
          	   transformResponse: function (data) {
          		   if (data) {
                     data = angular.fromJson(data);
          		   }
          		   return data;
          	   }
             },
             'getAlumno': {
            	   url:'apo/getAlumno',
            	   method: 'GET',
            	   isArray: false,
            	   transformResponse: function (data) {
            		   if (data) {
                       data = angular.fromJson(data);
            		   }
            		   return data;
            	   }
               }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('AlumnoController', AlumnoController);

    AlumnoController.$inject = ['$scope', '$state', 'Alumno', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function AlumnoController ($scope, $state, Alumno, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.plan = plan();
        vm.alumno = alumno();
        vm.msjCerrado = false;
        
        loadAll();
//        var values = Object.keys(AlertService).map(function(it) { 
//        	   return AlertService[it]
//        	})
//        var evento = window.event;
//        console.log("esto hay:  "+values);
        function loadAll () {
        	Alumno.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.clases = data;
                vm.page = pagingParams.page;
                vm.msjCerrado=true;
            }
            function onError(error) {
                AlertService.error(error.data.message);
                vm.msjCerrado=false;
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
        
        function plan(){
        	return Alumno.getPlan();
        }
        
        function alumno(){
        	var aux = Alumno.getAlumno();
        	return aux;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;



        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                vm.user.langKey = 'en';
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Users'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }]
            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'side'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Application Metrics'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey,
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Logs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Health Checks'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('sideApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'API'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Configuration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Audits'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('TipoActividadesEvaluacion', TipoActividadesEvaluacion);

    TipoActividadesEvaluacion.$inject = ['$resource'];

    function TipoActividadesEvaluacion ($resource) {
        var resourceUrl =  'apo/tiposActividades/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('adminactividades', {
            parent: 'app',
            url: '/actividades?page&sort&search',
            data: {
            	authorities: ['ADMINISTRATIVO_GENERAL_SIDE','ADMINISTRATIVO_BACHILLERATO_SIDE'],
                pageTitle: 'Administrar actividades'
            },
            views: {
                'content@': {
                    templateUrl: 'app/actividadesevadoce/actividadesevaluaciondocente.html',
                    controller: 'ActividadesEvaDoceController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                anio: '0',
                institucion: '0',
                modelo: '0',
                nivel: '0'
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        anio: $stateParams.anio,
                        institucion: $stateParams.institucion,
                        modelo: $stateParams.modelo,
                        nivel: $stateParams.nivel,
                        rolGralSIDE : true
                    };
                }]
            }
        })
        .state('adminactividades.new', {
            parent: 'adminactividades',
            url: '/new',
            data: {
            	authorities: ['ADMINISTRATIVO_GENERAL_SIDE','ADMINISTRATIVO_BACHILLERATO_SIDE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/actividadesevadoce/actividades-dialog.html',
                    controller: 'ActividadEvaDoceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                            	id: null,
                            	tipoActividad: null,
                                institucion: null,
                                indicePeriodo: null,
                                anioEscolar: null,
                                inicio: null,
                                fin: null
                               
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('adminactividades', null, { reload: 'adminactividades' });
                }, function() {
                    $state.go('adminactividades');
                });
            }]
        })
        .state('adminactividades.edit', {
            parent: 'adminactividades',
            url: '/{id}/edit',
            data: {
            	authorities: ['ADMINISTRATIVO_GENERAL_SIDE','ADMINISTRATIVO_BACHILLERATO_SIDE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/actividadesevadoce/actividades-dialogEdit.html',
                    controller: 'ActividadEvaDoceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ActividadesEvaluacion', function(ActividadesEvaluacion) {
                            return ActividadesEvaluacion.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('adminactividades', null, { reload: 'adminactividades' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
//        .state('usuario.delete', {
//            parent: 'usuario',
//            url: '/{id}/delete',
//            data: {
//            },
//            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/entities/usuario/usuario-delete-dialog.html',
//                    controller: 'UsuarioDeleteController',
//                    controllerAs: 'vm',
//                    size: 'md',
//                    resolve: {
//                        entity: ['Usuario', function(Usuario) {
//                            return Usuario.get({id : $stateParams.id}).$promise;
//                        }]
//                    }
//                }).result.then(function() {
//                    $state.go('usuario', null, { reload: 'usuario' });
//                }, function() {
//                    $state.go('^');
//                });
//            }]
//        });
    }

})();

(function() {
    'use strict';
    angular
        .module('sideApp')
        .factory('ActividadesEvaluacion', ActividadesEvaluacion);

    ActividadesEvaluacion.$inject = ['$resource','DateUtils'];

    function ActividadesEvaluacion ($resource,DateUtils) {
        var resourceUrl =  'apo/actividades:id,:anio,:institucion,:modelo,:nivel';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
            	url:'apo/actividades/:id',
            	method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.inicio=DateUtils.convertDateTimeFromServer(data.inicio);
                        data.fin=DateUtils.convertDateTimeFromServer(data.fin);
                    }
                    
                    return data;
                }
            },
            'update': { 
            	url:'apo/actividades',
            	method:'PUT',
            	transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.inicio = DateUtils.convertDateTimeFromServer(copy.inicio);
                    copy.fin = DateUtils.convertLocalDateToServer(copy.fin);
                    data = angular.toJson(copy);
                    return data;
                }
            },
            'save': { 
            	url:'apo/actividades',
            	method:'POST' 
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ActividadesEvaDoceController', ActividadesEvaDoceController);

    ActividadesEvaDoceController.$inject = ['$scope', '$state', 'Principal', 'ActividadesEvaluacion', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants','AniosEscolares','Instituciones','NivelesEducativosService','ModelosEducativosService'];

    function ActividadesEvaDoceController ($scope, $state, Principal, ActividadesEvaluacion, ParseLinks, AlertService, pagingParams, paginationConstants,AniosEscolares,Instituciones,NivelesEducativosService,ModelosEducativosService) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search=search;
        vm.currentSearch=pagingParams.search;
        vm.anioSeleccionado = pagingParams.anio;
        vm.institucionSeleccionada = pagingParams.institucion;
        vm.modeloSeleccionado=pagingParams.modelo;
        vm.nivelSeleccionado=pagingParams.nivel;
        vm.rolGralSIDE=pagingParams.rolGralSIDE
        
        cargarDropdownAniosEscolares();
        cargarDropdownDependencia();
        cargarDropdownModeloNivelEducativo();
        loadAll();
        vm.limpiar = limpiar;

        function loadAll () {
        	ActividadesEvaluacion.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                search:  vm.currentSearch,
                anio: vm.anioSeleccionado,
                institucion : vm.institucionSeleccionada,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado	
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.actividades = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                anio: vm.anioSeleccionado,
                institucion : vm.institucionSeleccionada,
                modelo: vm.modeloSeleccionado,
                nivel: vm.nivelSeleccionado
            });
        }
        
        function cargarDropdownAniosEscolares(){
        	vm.aniosEscolares=AniosEscolares.query();
        }
        

		function cargarDropdownDependencia() {
//			console.log(vm.rolGralSIDE);
			if(vm.rolGralSIDE){
				vm.instituciones = Instituciones.query();
			}
//			vm.instituciones = Instituciones.query();
		}
		
		function cargarDropdownModeloNivelEducativo() {
			vm.niveles=NivelesEducativosService.getAll();
        	vm.modelos=ModelosEducativosService.getAll();
		}
		
		function limpiar() {
        	vm.modeloSeleccionado=null;
        }

		function search() {
			if (vm.anioSeleccionado == null)
				return;
			if (vm.institucionSeleccionada == null)
				return;
			
			$state.transitionTo($state.$current, {
				page : 0,
				sort : vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
				search : vm.currentSearch,
				anio : vm.anioSeleccionado,
				institucion : vm.institucionSeleccionada,
				modelo: vm.modeloSeleccionado,
	            nivel: vm.nivelSeleccionado
			}, onSuccess);
			
			function onSuccess(data, headers) {
				vm.links = ParseLinks.parse(headers('link'));
				vm.totalItems = headers('X-Total-Count');
				vm.queryCount = vm.totalItems;
				vm.actividades = data;
				vm.page = pagingParams.page;
			}
		}
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .directive('dateFormatter', ['DateUtils',
    function (DateUtils) {
        return {
            restrict: 'A',
            require: '^?ngModel',
            link: function postLink(scope, element, attrs, ctrls) {
            	if(ctrls != null){
//            		ctrls.$formatters.push(function(data) {
//            			console.log("loque hay en fecha " + data);
//            			var tiempoEnMiliSegundos = Date.parse(data);
//            			console.log("tiempoEnMiliSegundos " + tiempoEnMiliSegundos);
//            			data = new Date(tiempoEnMiliSegundos);
//            			console.log("nuevo data de milisegundos " + tiempoEnMiliSegundos);
//            			return data;
////	                  	  	console.log("$formatters.push " + data);
////	        				var out = new Date(data);
//////	                  	  	var out = DateUtils.convertLocalDateToServer(data);
////	            			console.log("$formatters.out =" + out);
////	            			return out;
//        		    });
                  	
//                  	console.log("ngModel es  " + ctrls);
//                  	ctrls.$parsers.push(function(data) {
//	                  	  console.log("parsers.push " + data);
//	                  	  var out = DateUtils.convertLocalDateToServer(data);
//	                      console.log("$parsers.out = " + out);
//	            		  return out;
//        		    });
            	}
                
            	
            	
            }
        };
    }
])
})();


(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ActividadEvaDoceDialogController', ActividadEvaDoceDialogController);

    ActividadEvaDoceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ActividadesEvaluacion', 'Instituciones','Periodos','TipoActividadesEvaluacion','AniosEscolares','NivelesEducativosService','ModelosEducativosService'];

    function ActividadEvaDoceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ActividadesEvaluacion, Instituciones,Periodos,TipoActividadesEvaluacion,AniosEscolares,NivelesEducativosService,ModelosEducativosService) {
        var vm = this;

        vm.actividad = entity;
//        console.log(vm.actividad);
        $scope.format = 'yyyy-MM-dd';
        vm.clear = clear;
        vm.save = save;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.selectedTipo;
        vm.institucionSelected;
        vm.anioSelected;
        vm.indicePeriodo;
        vm.intercurso;
        vm.limpiar = limpiar;
        vm.compararTipoActMEFI = compararTipoActMEFI;
        vm.tipoActAutoEva = "Autoevaluación de Profesores";
        vm.periodos;
        cargarDropDowns();
//        vm.counter = 0;
//        console.log(vm.actividad);
        $scope.$watchGroup(["vm.actividad.anioEscolar","vm.actividad.institucion","vm.actividad.intercurso"],function(newValue,oldValue){
        	if (newValue === oldValue) {
      	      return;
      	    }
      	 
//	      	console.log("El valor ha cambiado ");
//	      	console.log(newValue);
//	      	vm.counter++;	
//	      	console.log(vm.counter);
//	      	console.log(newValue[0]);
//	      	console.log(newValue[1]);
//	      	console.log(newValue[2]);
//        	console.log(vm.actividad);
        	
        	vm.periodos = null;
        	if(vm.actividad.anioEscolar != null && vm.actividad.institucion != null){
        		vm.periodos = Periodos.query({
            		anio: vm.actividad.anioEscolar.id,
            		dep: vm.actividad.institucion.id,
            		ic: vm.actividad.intercurso
                });
        	}
	      	
        });
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        
        function limpiar() {
        	vm.actividad.tipoActividad = null;
        	vm.actividad.institucion = null;
        	vm.actividad.anioEscolar = null;
        	vm.actividad.intercurso = false;
        	vm.actividad.inicio = null;
        	vm.actividad.fin = null;
        	vm.actividad.modeloEducativo = null;
        }
        
        function compararTipoActMEFI(texto){
        	texto = normalizar(texto);
        	
        	if (texto.indexOf(normalize('Autoevaluación de Profesores'))>=0) {
        	      return true;
        	    } else {
        	      return false;
        	    }
        	
        }
        
        function normalizar(texto){
        	texto = texto.replace(/[áàäâ]/g, "a");
        	texto = texto.replace(/[éèëê]/g, "e");
        	texto = texto.replace(/[íìïî]/g, "i");
        	texto = texto.replace(/[óòôö]/g, "o");
        	texto = texto.replace(/[úùüü]/g, "u");
        	texto = texto.toUpperCase();
        	return texto;
        }

        function save () {
            vm.isSaving = true;
            if (vm.actividad.id !== null) {
            	ActividadesEvaluacion.update(vm.actividad, onSaveSuccess, onSaveError);
            } else {
            	ActividadesEvaluacion.save(vm.actividad, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sideApp:actividadUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function cargarDropDowns(){
        	vm.dependencias=Instituciones.query();
        	vm.tiposActividades=TipoActividadesEvaluacion.query();
        	vm.aniosEscolares=AniosEscolares.query();
        	vm.nivelesEducativos=NivelesEducativosService.getAll();
        	
        	vm.modelosEducativos=ModelosEducativosService.getAll();
        }
        

    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth'];

    function SettingsController (Principal, Auth) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'Registration'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = [ '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('sideApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small>Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'Activation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('sideApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/actividadesevadoce/actividades-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUsuarioLabel">Crear Actividad</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!-- <p>{{ vm.actividad }}</p>\n\t\t<p>{{ vm.tipoActAutoEva }}</p> --><div class="form-group" ng-hide="vm.actividad.id"><!-- <p>{{vm.nivelesEducativos}}</p> --><label for="id">Nivel</label><select required class="form-control" ng-model="vm.actividad.nivelEducativo" ng-value="vm.actividad.nivelEducativo" ng-options="nivelEducativo for nivelEducativo in vm.nivelesEducativos" ng-change="vm.limpiar()"><option value="" selected="selected"></option></select></div><div class="form-group" ng-hide="vm.actividad.id "><label for="id">Modelo</label><select required class="form-control" ng-model="vm.actividad.modeloEducativo" ng-value="modeloEducativo" ng-options="modeloEducativo \n\t\t\t\t\t\t\tdisable when \n\t\t\t\t\t\t\tvm.actividad.nivelEducativo == null ||\n\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t(vm.actividad.nivelEducativo == \'Posgrado\' && modeloEducativo == \'MEyA\') ||\n\t\t\t\t\t\t\t\t\t(vm.actividad.nivelEducativo == \'Posgrado\' && modeloEducativo == \'MEFI\') ||\n\t\t\t\t\t\t\t\t\t(vm.actividad.nivelEducativo == \'Posgrado\' && modeloEducativo == \'MEFI 2\') \n\t\t\t\t\t\t\t\t) ||\n\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\tvm.actividad.nivelEducativo != \'Posgrado\' && modeloEducativo == \'No aplica\' \n\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\tfor modeloEducativo in vm.modelosEducativos"><option value="" selected="selected"></option></select></div><div class="form-group" ng-hide="vm.actividad.id"><label for="id">Tipo Actividad</label><select required class="form-control" ng-model="vm.actividad.tipoActividad" ng-value="tipoActividad.tipo" ng-options="tipoActividad.tipo \n\t\t\t\t\t\t\tdisable when \n\t\t\t\t\t\t\tvm.actividad.nivelEducativo == null ||\n\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t(vm.actividad.nivelEducativo == \'Licenciatura\' || vm.actividad.nivelEducativo == \'Posgrado\')&& \n\t\t\t\t\t\t\t\t(vm.actividad.modeloEducativo == null || vm.actividad.modeloEducativo == \'MEyA\' || vm.actividad.modeloEducativo == \'No aplica\') && \n\t\t\t\t\t\t\t\ttipoActividad.tipo == vm.tipoActAutoEva\n\t\t\t\t\t\t\t) \n\t\t\t\t\t\t\tfor tipoActividad in vm.tiposActividades"><option value="" selected="selected"></option></select></div><div class="form-group" ng-hide="vm.actividad.id"><label class="control-label" for="field_login">A&ntildeo Escolar</label><select required class="form-control" ng-model="vm.actividad.anioEscolar" ng-value="anioEscolar.descripcion" ng-options="anioEscolar.descripcion for anioEscolar in vm.aniosEscolares"><option value="" selected="selected"></option></select></div><div class="form-group" ng-hide="vm.actividad.id"><label class="control-label" for="fiel">Dependencia</label><select required class="form-control" ng-model="vm.actividad.institucion" ng-value="vm.actividad.institucion" ng-options="institucion.nombre+\' \'+institucion.abreviatura for institucion in vm.dependencias"><option value="" selected="selected"></option></select></div><div class="form-group" ng-hide="vm.actividad.id"><label><input type="checkbox" ng-model="vm.actividad.intercurso"> Intercurso</label></div><div ng-hide="vm.actividad.id"><div class="form-group" ng-hide="vm.actividad.intercurso"><label class="control-label" for="fiel">Periodo</label><select required class="form-control" ng-model="vm.actividad.indicePeriodo" ng-value="vm.actividad.indicePeriodo" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select><input type="hidden" ng-init="vm.actividad.indiceIntercurso = 0"></div><div class="form-group" ng-show="vm.actividad.intercurso"><label class="control-label" for="fiel">Periodo</label><select required class="form-control" ng-model="vm.actividad.indiceIntercurso" ng-value="vm.actividad.indiceIntercurso" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select><input type="hidden" ng-init="vm.actividad.indicePeriodo = 0"></div></div><div class="form-group"><label class="control-label" for="field_activo">Inicio</label><div class="input-group"><input required id="field_birth" type="text" class="form-control" name="birth" uib-datepicker-popup="{{format}}" ng-model="vm.actividad.inicio" is-open="vm.datePickerOpenStatus.birth"> <span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.openCalendar(\'birth\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_activo">Fin</label><div class="input-group"><input required id="field_die" type="text" class="form-control" name="die" uib-datepicker-popup="{{format}}" ng-model="vm.actividad.fin" is-open="vm.datePickerOpenStatus.die"> <span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.openCalendar(\'die\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancelar</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || (vm.actividad.indiceIntercurso == 0 && vm.actividad.indicePeriodo == 0)" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Guardar</span></button></div></div></form>');
$templateCache.put('app/actividadesevadoce/actividades-dialogEdit.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUsuarioLabel">Editar Actividad</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.actividad.id"><label for="id">Nivel</label><input type="text" class="form-control" id="id" name="nivEdu" ng-model="vm.actividad.nivelEducativo" value="vm.actividad.nivelEducativo" readonly="readonly"></div><div class="form-group" ng-show="vm.actividad.id"><label for="id">Modelo</label><input type="text" class="form-control" id="id" name="modEdu" ng-model="vm.actividad.modeloEducativo" value="vm.actividad.modeloEducativo" readonly="readonly"></div><div class="form-group" ng-show="vm.actividad.id"><label for="id">Tipo Actividad</label><input type="text" class="form-control" id="id" name="tipoAct" ng-model="vm.actividad.tipoActividad.tipo" value="vm.actividad.tipoActividad.tipo" readonly="readonly"></div><div class="form-group" ng-show="vm.actividad.id"><label for="id">A&ntildeo Escolar</label><input type="text" class="form-control" id="idanio" name="anio" ng-model="vm.actividad.anioEscolar.descripcion" ng-value="anioEscolar.descripcion" readonly="readonly"></div><div class="form-group" ng-show="vm.actividad.id"><label for="id">Dependencia</label><input type="text" class="form-control" id="iddepen" name="dependenc" ng-value="vm.actividad.institucion.nombre+\' \'+vm.actividad.institucion.abreviatura" readonly="readonly"></div><div class="form-group" ng-show="vm.actividad.id"><label><input type="checkbox" ng-model="vm.actividad.intercurso" disabled="disabled"> Intercurso</label></div><div ng-show="vm.actividad.id"><div class="form-group" ng-hide="vm.actividad.intercurso"><label class="control-label" for="fiel">Periodo</label><input type="text" class="form-control" id="idPeriodo1" name="indice" ng-model="vm.actividad.indicePeriodo" ng-value="vm.actividad.indicePeriodo" readonly="readonly"><!-- <select\n\t\t\t\t\trequired class="form-control" \n\t\t\t\t\tng-model="vm.actividad.indicePeriodo"\n\t\t\t\t\tng-value="vm.actividad.indicePeriodo"\n\t\t\t\t\tng-options="periodo for periodo in vm.periodos">\n\t\t\t\t\t<option value="" selected></option>\n\t\t\t\t</select> --></div><div class="form-group" ng-show="vm.actividad.intercurso"><label class="control-label" for="fiel">Periodo</label><input type="text" class="form-control" id="idPeriodo2" name="indiceIC" ng-model="vm.actividad.indiceIntercurso" ng-value="vm.actividad.indiceIntercurso" readonly="readonly"></div></div><div class="form-group"><label class="control-label" for="field_activo">Inicio</label><div class="input-group"><input required id="field_birth" type="text" class="form-control" name="birth" uib-datepicker-popup="{{format}}" ng-model="vm.actividad.inicio" is-open="vm.datePickerOpenStatus.birth"> <span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.openCalendar(\'birth\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_activo">Fin</label><div class="input-group"><input required id="field_die" type="text" class="form-control" name="die" uib-datepicker-popup="{{format}}" ng-model="vm.actividad.fin" is-open="vm.datePickerOpenStatus.die"> <span class="input-group-btn"><button type="button" class="btn btn-primary" ng-click="vm.openCalendar(\'die\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancelar</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Guardar</span></button></div></div></form>');
$templateCache.put('app/actividadesevadoce/actividadesevaluaciondocente.html','<div><h2>Actividades</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary btn-single" ui-sref="adminactividades.new"><span class="glyphicon glyphicon-plus"></span> <span>Crear Nueva Actividad</span></button></div></div></div><form class="form-search"><div><h4>Buscar por:</h4><div class="row"><div class="col-lg-offset-1 col-lg-6"><div class="form-group"><label class="control-label" for="fiel">Dependencia</label><select required class="form-control" ng-model="vm.institucionSeleccionada"><option ng-repeat=" institucion in vm.instituciones" value="{{institucion.id}}">{{institucion.nombre}} {{institucion.abreviatura}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-6 --><div class="col-lg-3"><div class="form-group"><label class="control-label">Nivel</label><select required class="form-control" ng-model="vm.nivelSeleccionado" ng-value="{{nivel}}" ng-options="nivel for nivel in vm.niveles" ng-change="vm.limpiar()"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --></div><!-- /.row --><div><div class="row"><div class="col-lg-offset-1 col-lg-2"><div class="form-group"><label class="control-label">Modelo</label><select required class="form-control" ng-model="vm.modeloSeleccionado" ng-value="{{modelo}}" ng-options="modelo \n\t\t\t\t\t\t\t\t\t\tdisable when \n\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == null || vm.nivelSeleccionado == 0) ||\n\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado == \'Posgrado\' &&\n\t\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEyA\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI 2\'\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t) ||\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado != \'Posgrado\' && modelo == \'No aplica\' \n\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\tfor modelo in vm.modelos"></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><label class="control-label">A&ntildeo Escolar</label><select required class="form-control" ng-model="vm.anioSeleccionado"><option ng-repeat="anioEscolar in vm.aniosEscolares" value="{{anioEscolar.id}}">{{anioEscolar.descripcion}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --><div class="col-lg-2"><div class="form-group"><br><button type="button" class="btn btn-primary" ng-click="vm.search()">Buscar</button></div><!-- /input-group --></div><!-- /.col-lg-2 --></div><!-- /.row --></div></div></form><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="anioEscolar.descripcion"><span>A&ntildeo Escolar</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="indicePeriodo"><span>Periodo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="indiceintercurso"><span>Intercurso</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="tipoActividad.tipo"><span>Tipo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="institucion.nombre"><span>Dependencia</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="inicio"><span>Inicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fin"><span>Fin</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="inicio"><span>Modelo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fin"><span>Nivel</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="actividad in vm.actividades track by actividad.id"><td>{{actividad.anioEscolar.descripcion}}</td><td>{{actividad.indicePeriodo}}</td><td>{{actividad.indiceIntercurso}}</td><td>{{actividad.tipoActividad.tipo}}</td><td>{{actividad.institucion.nombre +" "+actividad.institucion.abreviatura}}</td><td>{{actividad.inicio | date:\'yyyy-MM-dd \'}}</td><td>{{actividad.fin| date:\'yyyy-MM-dd \'}}</td><td>{{actividad.modeloEducativo}}</td><td>{{actividad.nivelEducativo}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><!-- <button type="submit"\n                                    ui-sref="usuario-detail({id:actividad.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button> --> <button type="submit" ui-sref="adminactividades.edit({id:actividad.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button><!--                             <button type="submit"\n                                    ui-sref="usuario.delete({id:actividad.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button> --></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/alumno/clasesalumno.html','<div><!-- Page Content --><div class="row"><div class="col-lg-12" ng-switch="vm.clases.length == 0"><div class="page-header"><h2 id="navbar">Mis asignaturas: {{vm.alumno.persona.nombres}} {{vm.alumno.persona.apellidoPaterno}} {{vm.alumno.persona.apellidoMaterno}}</h2></div><!-- <jhi-alert-error></jhi-alert-error> --><side-alert-error></side-alert-error><form class="form-horizontal"><div class="form-group separated"><div class="col-sm-4"><input type="text" ng-model="busquedaalumno" class="form-control" placeholder="Buscar por asignatura o instituci\xF3n"></div><!-- button type="submit" class="btn btn-default">Buscar</button --></div></form><div class="alert alert-info text-center" ng-show="vm.clases.length == 0">No tienes clases para evaluar.</div><div class="alert alert-info text-center" ng-show="vm.clases == null && vm.plan != \'\' && vm.msjCerrado">Se ha cerrado el periodo de evaluaci&oacuten.</div><div class="alert alert-info text-center" ng-show="vm.plan == \'\'">El alumno no cuenta con una inscripci&oacuten a un plan de estudios o no se encuentra activo.</div><table class="table table-striped table-hover"><!--\n                <thead>\n                  <tr>\n                    <th>Asignatura</th>\n                    <th>Opciones</th>\n                  </tr>\n                </thead>\n                --><tbody><tr ng-repeat="clase in vm.clases | filter: busquedaalumno track by clase.id"><!-- tr ng-repeat="clase in vm.clases | filter: busquedaalumno:{clase:{ institucion:{ nombre}},clase:{ asignaturaBase:{ nombre}}} track by clase.id" --><td><h4>{{clase.clase.asignaturaBase.nombre}}</h4><h6>{{clase.clase.institucion.nombre}} - {{clase.nombreCompletoNAA}}</h6><h6>{{clase.nivel}}, {{clase.modelo}}, {{clase.clase.grupo.grupo}}</h6><!-- <h6>indice {{clase.clase.periodoCurso.indice}}</h6>\n                    \t<h6>interCurso {{clase.clase.periodoCurso.interCurso}}</h6>\n                    \t<h6>indiceIntercurso {{clase.clase.periodoCurso.indiceIntercurso}}</h6> --></td><td class="vcenter"><div class="btn-group opciones-menu"><a ui-sref="evaluacion({\n                        ambito:clase.evaluacion.id,\n                        nivPlan:clase.nivel,\n                        modPlan:clase.modelo,\n                        indiceClase:clase.clase.periodoCurso.indice,\n                        isInterCursoClase:clase.clase.periodoCurso.interCurso,\n                        indiceInterCursoClase:clase.clase.periodoCurso.indiceIntercurso,\n                        idins:clase.clase.institucion.id\n                        })" class="btn btn-primary" ng-hide="clase.evaluacion.id == null">Evaluar profesor</a></div></td></tr></tbody></table></div></div><!-- /.row --></div>');
$templateCache.put('app/alumno/evaluacion.html','<div ng-show="vm.resuelto"><div class="row"><div class="col-lg-12"><section id="part-0" class="questionarie notice center-block" ng-show="vm.show==0 && vm.nivel == \'Bachiller\' && !(vm.idins == \'65\' || vm.idins == \'52\') "><p>Estimada y Estimado Estudiante:</p><p>El proceso de evaluaci\xF3n docente tiene por objetivo promover la mejora continua del profesorado de la UADY y con ello garantizar la calidad en tu proceso de formaci\xF3n. Por lo que, se solicita tu apoyo en dedicar unos minutos para responder el presente Instrumento de Evaluaci\xF3n Docente. Tu opini\xF3n es sumamente importante, por tanto, se te solicita expresarte con respeto, honestidad y objetividad, ya que contribuir\xE1 en identificar las fortalezas y \xE1reas de oportunidad de tus docentes, por lo que las respuestas que proporciones son totalmente confidenciales.</p><p>Agradecemos tu colaboraci\xF3n.</p><footer><p>Atentamente</p><p>Direcci\xF3n General de Desarrollo Acad\xE9mico</p><p>LUZ, CIENCIA Y VERDAD</p><a class="btn btn-primary next" ng-click="vm.show = 1">Siguiente</a></footer></section><section id="part-0" class="questionarie notice center-block" ng-show="vm.show==0 && vm.nivel == \'Licenciatura\' && vm.modelo == \'MEyA\' && !(vm.idins == \'65\' || vm.idins == \'52\') " style="text-align: justify"><p>Estimado Estudiante:</p><p>Por favor, dedica unos minutos para responder este instrumento. El objetivo de este proceso es promover la mejora continua de los profesores de la UADY y con ello garantizar la calidad en tu proceso de formaci\xF3n, por tanto te solicitamos contestes con la mayor sinceridad posible.</p><p>Agradecemos tu colaboraci\xF3n.</p><footer><p>Atentamente</p><p>Direcci\xF3n General de Desarrollo Acad\xE9mico</p><p>LUZ, CIENCIA Y VERDAD</p><a class="btn btn-primary next" ng-click="vm.show = 1">Siguiente</a></footer></section><section id="part-0" class="questionarie notice center-block" ng-show="vm.show==0 && vm.nivel == \'Licenciatura\' && vm.modelo != \'MEyA\' && !(vm.idins == \'65\' || vm.idins == \'52\') " style="text-align: justify"><p>Apreciable Estudiante:</p><p>Por favor, dedica unos minutos para responder este instrumento. El objetivo de esta evaluaci\xF3n es promover la <i>mejora continua en el desempe\xF1o docente</i> y con ello garantizar la calidad en tu proceso de formaci\xF3n, por tanto, te solicitamos contestes con la mayor sinceridad posible.</p><p>Agradecemos tu colaboraci\xF3n.</p><footer><p>Atentamente</p><p>LUZ, CIENCIA Y VERDAD</p><p>Direcci\xF3n General de Desarrollo Acad\xE9mico</p><a class="btn btn-primary next" ng-click="vm.show = 1">Siguiente</a></footer></section><section id="part-0" class="questionarie notice center-block" ng-show="vm.show==0 && vm.nivel != \'Posgrado\' && (vm.idins == \'65\' || vm.idins == \'52\') "><p>Apreciable Estudiante:</p><p>Por favor, dedica unos minutos para responder este instrumento. El objetivo de esta evaluaci\xF3n es promover la mejora continua del personal docente de la UADY y con ello garantizar la calidad en tu proceso formativo, por tanto, te solicitamos contestes con la mayor sinceridad posible.</p><p>Agradecemos tu colaboraci\xF3n.</p><footer><p>Atentamente</p><p>Direcci\xF3n General de Desarrollo Acad\xE9mico</p><p>LUZ, CIENCIA Y VERDAD</p><a class="btn btn-primary next" ng-click="vm.show = 1">Siguiente</a></footer></section><section id="part-0" class="questionarie notice center-block" ng-show="vm.show==0 && vm.nivel == \'Posgrado\' "><p>Estimado Estudiante:</p><p>Por favor, dedica unos minutos para responder este instrumento. El objetivo de este proceso es promover la mejora continua de los profesores de Posgrado de la UADY y con ello garantizar la calidad en tu proceso de formaci\xF3n, por tanto te solicitamos contestes con la mayor sinceridad posible.</p><p>Agradecemos tu colaboraci\xF3n.</p><footer><p>Atentamente</p><p>Coordinaci\xF3n General de Posgrado, Investigaci\xF3n y Vinculaci\xF3n</p><a class="btn btn-primary next" ng-click="vm.show = 1">Siguiente</a></footer></section><section id="part-0" class="questionarie notice center-block" ng-show="vm.show==0 && vm.nivel == \'Educaci\xF3n Continua Lic\' "><p>Apreciable Estudiante:</p><p>Por favor, dedica unos minutos para responder este instrumento. El objetivo es promover la mejora continua del personal docente de la UADY y con ello garantizar la calidad en tu proceso de formaci\xF3n, por tanto, te solicitamos contestes con la mayor sinceridad posible.</p><p>Agradecemos tu colaboraci\xF3n.</p><footer><p>Atentamente</p><p>Direcci\xF3n General de Desarrollo Acad\xE9mico</p><p>LUZ, CIENCIA Y VERDAD</p><a class="btn btn-primary next" ng-click="vm.show = 1">Siguiente</a></footer></section><form ng-submit="vm.save()" name="cuestionario"><section ng-repeat="grupo in vm.resuelto.grupoPreguntasForUI" id="part-{{ $index + 1 }}" class="questionarie" ng-show="vm.show==$index + 1"><div ng-switch="grupo.grupoPreguntas.cabecera"><header><p><strong>{{ grupo.grupoPreguntas.instrucciones }}</strong></p><h4 ng-if="grupo.grupoPreguntas.min != null"><strong>Selecciona m\xEDnimo {{ grupo.grupoPreguntas.min }} y m\xE1ximo {{ grupo.grupoPreguntas.max }} elementos</strong></h4><!-- INICIA: Escala multicolor 4 --><table ng-switch-when="escalamulticolor4" class="table table-bordered calificacion type-a"><!-- Se podra usar cuando subamos de version al angular ;-; --><!-- ng-switch-when="escalamulticolor4|escalamulticolor4MiDocente|escalamulticolor4DeQForma" ng-switch-when-separator="|"> --><tr><td>1</td><td>2</td><td>3</td><td>4</td></tr><tr><td class="calif-1">Casi nunca</td><td class="calif-2">A veces</td><td class="calif-3">Frecuentemente</td><td class="calif-4">Casi Siempre</td></tr></table><!-- TERMINA: Escala multicolor 4 --><!-- INICIA: Escala multicolor 4 MEyA--><table ng-switch-when="escalamulticolor4MEyA" class="table table-bordered calificacion type-a"><!-- Se podra usar cuando subamos de version al angular ;-; --><!-- ng-switch-when="escalamulticolor4|escalamulticolor4MiDocente|escalamulticolor4DeQForma" ng-switch-when-separator="|"> --><tr><td>1</td><td>2</td><td>3</td><td>4</td></tr><tr><td class="calif-1">Nunca</td><td class="calif-2">Casi Nunca</td><td class="calif-3">Casi Siempre</td><td class="calif-4">Siempre</td></tr></table><!-- TERMINA: Escala multicolor 4 MEyA--><!-- INICIA: Escala multicolor 4 MiDocenteCasiNunca--><table ng-switch-when="escalamulticolor4MiDocenteCasiNunca" class="table table-bordered calificacion type-a"><!-- Se podra usar cuando subamos de version al angular ;-; --><!-- ng-switch-when="escalamulticolor4|escalamulticolor4MiDocente|escalamulticolor4DeQForma" ng-switch-when-separator="|"> --><tr><td>1</td><td>2</td><td>3</td><td>4</td></tr><tr><td>Casi nunca</td><td>A veces</td><td>Frecuentemente</td><td>Casi Siempre</td></tr><tr><td class="calif-1">0-25%</td><td class="calif-2">26-50%</td><td class="calif-3">51-75%</td><td class="calif-4">76-100%</td></tr></table><!-- TERMINA: Escala multicolor 4 MiDocenteCasiNunca--><!-- INICIA: Escala multicolor 4 Mi Docente --><table ng-switch-when="escalamulticolor4MiDocente" class="table table-bordered calificacion type-a"><tr><td>1</td><td>2</td><td>3</td><td>4</td></tr><tr><td>DEFICIENTE</td><td>REGULAR</td><td>CONVENIENTE</td><td>EXCELENTE</td></tr><tr><td>Necesita mejorar</td><td>Es necesario modificar algunos elementos</td><td>Cumple con lo b\xE1sico</td><td>Cumple con todo lo requerido</td></tr><tr><td class="calif-1">0-25%</td><td class="calif-2">26-50%</td><td class="calif-3">51-75%</td><td class="calif-4">76-100%</td></tr></table><!-- TERMINA: Escala multicolor 4 Mi Docente --><!-- INICIA: Escala multicolor 4 De Q Forma --><table ng-switch-when="escalamulticolor4DeQForma" class="table table-bordered calificacion type-a"><tr><td>1</td><td>2</td><td>3</td><td>4</td></tr><tr><td>DEFICIENTE</td><td>REGULAR</td><td>CONVENIENTE</td><td>EXCELENTE</td></tr><tr><td>Necesita mejorar</td><td>Es necesario modificar algunos elementos</td><td>Cumple con lo b\xE1sico</td><td>Cumple con todo lo requerido</td></tr><tr><td class="calif-1">0-25%</td><td class="calif-2">26-50%</td><td class="calif-3">51-75%</td><td class="calif-4">76-100%</td></tr></table><!-- TERMINA: Escala multicolor 4 De Q Forma --><!-- INICIA: Escala amarillo 7 --><section ng-switch-when="escalaAmarillo7" class="example"><h5>Ejemplo: Flexible o R\xEDgido</h5><table class="table table-bordered calificacion type-b"><tr><td></td><td class="calif-1">1</td><td class="calif-2">2</td><td class="calif-3">3</td><td class="calif-4">4</td><td class="calif-5">5</td><td class="calif-6">6</td><td class="calif-7">7</td><td></td></tr><td>Flexible</td><td></td><td>x</td><td></td><td></td><td></td><td></td><td></td><td>R\xEDgido</td></table><h4 class="text-center">En este caso la respuesta indicar\xEDa que se considera MUY flexible.</h4></section><!-- TERMINA: Escala amarillo 7 --><!-- INICIA: Escala multicolor 3 --><table ng-switch-when="escalamulticolor3" class="table table-bordered calificacion type-c"><tr><td>1</td><td>2</td><td>3</td></tr><tr><td class="calif-1">Insatisfecho</td><td class="calif-2">Satisfecho</td><td class="calif-3">Muy satisfecho</td></tr></table><!-- TERMINA: Escala multicolor 3 --><!-- INICIA: Escala multicolor 3 SatisApr--><table ng-switch-when="escalamulticolor3SatisApr" class="table table-bordered calificacion type-c"><tr><td>1</td><td>2</td><td>3</td></tr><tr><td class="calif-1">Insatisfecho</td><td class="calif-2">Satisfecho</td><td class="calif-3">Muy satisfecho</td></tr></table><!-- TERMINA: Escala multicolor 3 SatisApr--><!-- INICIA: Escala multicolor 3 SatisMatRec--><table ng-switch-when="escalamulticolor3SatisMatRec" class="table table-bordered calificacion type-c"><tr><td>1</td><td>2</td><td>3</td></tr><tr><td class="calif-1">Insatisfecho</td><td class="calif-2">Satisfecho</td><td class="calif-3">Muy satisfecho</td></tr></table><!-- TERMINA: Escala multicolor 3 SatisMatRec--></header><h4 ng-switch-when="estandarMiDocente" class="tituloTablaEncuesta">\xBFMi docente\u2026</h4><h4 ng-switch-when="escalamulticolor3SatisApr" class="tituloTablaEncuesta">Satisfacci\xF3n con el aprendizaje del estudiante</h4><h4 ng-switch-when="escalamulticolor3SatisMatRec" class="tituloTablaEncuesta">Satisfacci\xF3n con materiales y recursos</h4><h4 ng-switch-when="escalamulticolor4MiDocente" class="tituloTablaEncuesta">\xBFMi docente\u2026</h4><h4 ng-switch-when="escalamulticolor4MiDocenteCasiNunca" class="tituloTablaEncuesta">Mi docente\u2026</h4><h4 ng-switch-when="escalamulticolor4DeQForma" class="tituloTablaEncuesta">\xBFDe qu\xE9 forma mi docente\u2026</h4><h4 ng-switch-default class="tituloTablaEncuesta"></h4></div><ol class="stripped-list container-fluid"><div ng-repeat="preguntaw in grupo.preguntasWrapperForUI"><li class="form-group" ng-class="{\'invalid\':vm.contain(preguntaw.pregunta.id) == true}"><div ng-switch="preguntaw.pregunta.tipoPregunta.tipoPregunta"><!-- INICIA: Pregunta tipo RADIOBUTTON --><div class="row" ng-switch-when="RadioButton"><div class="question col-sm-9">{{preguntaw.pregunta.preguntaString }}</div><div class="col-sm-3"><span ng-repeat="opcion in preguntaw.respuestasForUI"><label class="radio-label"><input type="radio" ng-model="preguntaw.respuesta.respuestaSeleccionada" name="{{preguntaw.respuesta.id}}" ng-value="opcion.respuestaString" tabindex="-1" ng-change="vm.resetearResDePregDepediente(preguntaw.pregunta.id)" ng-disabled="vm.deshabilitar(preguntaw.pregunta.id,preguntaw.pregunta.preguntaActivador,preguntaw.pregunta.opcionpreguntaactivador)" required> {{ opcion.respuestaString }}</label></span></div></div><!-- TERMINA: Pregunta tipo RADIOBUTTON --><!-- INICIA: Pregunta tipo CHECKBOX --><div class="row" ng-switch-when="CheckBox"><div class="question col-sm-9"><input type="checkbox" ng-model="preguntaw.respuesta.respuestaSeleccionada" ng-checked="preguntaw.respuesta.respuestaSeleccionada" name="{{preguntaw.respuesta.id}}" tabindex="-1" ng-change="vm.resetearResDePregDepediente(preguntaw.pregunta.id)" ng-disabled="vm.deshabilitar(preguntaw.pregunta.id,preguntaw.pregunta.preguntaActivador,preguntaw.pregunta.opcionpreguntaactivador)"><label class="checkbox-label">{{preguntaw.pregunta.preguntaString }}</label></div></div><!-- TERMINA: Pregunta tipo CHECKBOX --><!-- INICIA: Pregunta tipo ESCALA --><div class="row" ng-switch-when="Escala"><table class="table table-bordered calificacion type-b"><tr><td width="20%">{{ preguntaw.pregunta.preguntaString.split(\'#@\')[0] }}</td><td ng-repeat="opcion in preguntaw.respuestasForUI" class="calif-{{$index + 1}}"><label class="radio-label"><input type="radio" ng-model="preguntaw.respuesta.respuestaSeleccionada" name="{{preguntaw.respuesta.id}}" ng-value="opcion.respuestaString" tabindex="-1" required></label></td><td width="20%">{{ preguntaw.pregunta.preguntaString.split(\'#@\')[1] }}</td></tr></table></div><!-- TERMINA: Pregunta tipo ESCALA --><!-- INICIA: Pregunta tipo TEXTAREA --><div class="row" ng-switch-when="TextArea"><div class="question col-sm-12"><label>{{ preguntaw.pregunta.preguntaString }}</label></div><div class="col-sm-12"><textarea rows="4" cols="50" class="form-control" name="{{preguntaw.respuesta.id}}" maxlength="1000" ng-model="preguntaw.respuesta.respuestaSeleccionada" tabindex="-1" ng-disabled="vm.deshabilitar(preguntaw.pregunta.id,preguntaw.pregunta.preguntaActivador,preguntaw.pregunta.opcionpreguntaactivador)" required>\n\t\t\t\t\t\t\t\t\t\t\t</textarea></div></div><!-- TERMINA: Pregunta tipo TEXTAREA --><div class="row" ng-switch-default><div class="question col-sm-9"></div></div></div></li></div></ol><div ng-class="{\'alert alert-danger text-center\': vm.valido == false}" ng-show="vm.valido == false && vm.mensaje != null">{{vm.mensaje}}</div><div ng-class="{\'alert alert-danger text-center\': vm.validoCheck == false}" ng-show="vm.validoCheck == false && vm.mensajeCheck != null">{{vm.mensajeCheck}}</div><footer><a class="btn btn-primary next" ng-click="vm.anterior($index)">Anterior</a> <a class="btn btn-primary next" ng-click="vm.siguiente($index)" ng-if="!$last">Siguiente</a> <button type="submit" class="btn btn-primary next" ng-if="$last">Guardar</button></footer></section></form></div></div></div><br><div ng-show="vm.msjCargando && vm.resuelto==null"><div class="alert alert-info text-center">Cargando instrumento de evaluaci\xF3n...</div></div><br><div ng-hide="vm.msjCargando"><div class="alert alert-danger text-center">No hay Actividad de evaluaci&oacuten vigente.<br>Favor de comunicarse con el Responsable de Evaluaci&oacuten Docente de su Dependencia.</div><footer><div class="text-center"><a class="btn btn-primary next text-center" ng-click="vm.menu()">Regresar</a></div></footer></div>');
$templateCache.put('app/ambito/crearambito.html','<form class="form-horizontal" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-disabled="vm.isSaving" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Registrar clase a evaluar</h4></div><div class="modal-body" ng-show="vm.nivelToShow.nivelToShow == \'Licenciatura\' && (vm.tipomodelo == \'MEFI\' || vm.tipomodelo == \'MEFI_2\') && !(vm.idins == \'52\' || vm.idins == \'65\')"><jhi-alert-error></jhi-alert-error><!-- <label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="Obligatoria" ng-disabled="vm.isSaving" required> Obligatoria</label><br/>\n\t\t<label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="Optativa" ng-disabled="vm.isSaving" required> Optativa</label><br/>\n\t\t<label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="Libre" ng-disabled="vm.isSaving" required> Libre</label><br/> --><label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="licenciatura general" ng-disabled="vm.isSaving" required> General</label><br><label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="UAEV" ng-disabled="vm.isSaving" required> UAEV</label><br></div><div class="modal-body" ng-show="vm.nivelToShow.nivelToShow == \'Licenciatura\' && (vm.tipomodelo == \'MEFI\' || vm.tipomodelo == \'MEFI_2\') && (vm.idins == \'65\')"><jhi-alert-error></jhi-alert-error><p>Seleccione el tipo de evaluaci\xF3n:</p><label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="UAEV" ng-disabled="vm.isSaving" required> UAEV</label><br></div><div class="modal-body" ng-show="vm.nivelToShow.nivelToShow == \'Bachiller\' && (vm.tipomodelo == \'MEFI\' || vm.tipomodelo == \'MEFI_2\' || vm.tipomodelo == \'MEyA\' || vm.tipomodelo == \'MEYA\') && (vm.idins == \'52\')"><jhi-alert-error></jhi-alert-error><p>Seleccione el tipo de evaluaci\xF3n:</p><label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="UAEV" ng-disabled="vm.isSaving" required> UAEV</label><br></div><div class="modal-body" ng-show="vm.nivelToShow.nivelToShow == \'Bachiller\' && (vm.tipomodelo == \'MEFI\' || vm.tipomodelo == \'MEFI_2\' || vm.tipomodelo == \'MEyA\' || vm.tipomodelo == \'MEYA\') && !(vm.idins == \'52\')"><jhi-alert-error></jhi-alert-error><p>Seleccione el tipo de evaluaci\xF3n:</p><label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="Bachillerato" ng-disabled="vm.isSaving" required> Bachillerato</label><br></div><div class="modal-body" ng-show="vm.nivelToShow.nivelToShow == \'Licenciatura\' && !(vm.tipomodelo == \'MEFI\' || vm.tipomodelo == \'MEFI_2\') && !(vm.idins == \'52\' || vm.idins == \'65\')"><p>Seleccione el tipo de evaluaci\xF3n:</p><label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="Curso \xDAnico" ng-disabled="vm.isSaving" required> Curso \xDAnico</label><br></div><div class="modal-body" ng-show="vm.nivelToShow.nivelToShow == \'Posgrado\' "><p>Seleccione el tipo de evaluaci\xF3n:</p><label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="Regular" ng-disabled="vm.isSaving" required> Regular</label><br><label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="Virtual" ng-disabled="vm.isSaving" required> Virtual</label><br><!-- <label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="Seminario" ng-disabled="vm.isSaving" required> Seminario</label><br/> --></div><div class="modal-body" ng-show="vm.nivelToShow.nivelToShow == \'Educaci\xF3n Continua Lic\' "><p>Seleccione el tipo de evaluaci\xF3n:</p><label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="Mixto PII" ng-disabled="vm.isSaving" required> Mixto</label><br><label><input type="radio" ng-model="vm.ambito.formaDeEvaluar" name="tipo" value="Virtual PII" ng-disabled="vm.isSaving" required> Virtual</label><br></div><div class="modal-footer" ng-switch="vm.isSaving"><div class="alert alert-info" ng-switch-when="true">Generando evaluaciones, esto puede tardar unos minutos...</div><button type="submit" ng-disabled="vm.isSaving" class="btn btn-primary">Registrar</button></div></form>');
$templateCache.put('app/anioescolar/anioescolar.html','<div><h2>Usuarios</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!-- <button class="btn btn-primary" ui-sref="usuario.new" >\n                    <span class="glyphicon glyphicon-plus"></span>\n                    <span >\n                        Create new Usuario\n                    </span>\n                </button> --></div></div></div><br><div class="table-responsive"><!--         <table class="jh-table table table-striped">\n            <thead>\n                <tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()">\n                    <th jh-sort-by="id"><span>ID</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="password"><span>Password</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th jh-sort-by="activo"><span>Activo</span> <span class="glyphicon glyphicon-sort"></span></th>\n                    <th></th>\n                </tr>\n            </thead>\n            <tbody>\n                <tr ng-repeat="usuario in vm.usuarios track by usuario.id">\n                    <td><a ui-sref="usuario-detail({id:usuario.id})">{{usuario.id}}</a></td>\n                    <td>{{usuario.login}}</td>\n                    <td>{{usuario.password}}</td>\n                    <td>{{usuario.activo}}</td>\n                    <td class="text-right">\n                        <div class="btn-group flex-btn-group-container">\n                            <button type="submit"\n                                    ui-sref="usuario-detail({id:usuario.id})"\n                                    class="btn btn-info btn-sm">\n                                <span class="glyphicon glyphicon-eye-open"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="usuario.edit({id:usuario.id})"\n                                    class="btn btn-primary btn-sm">\n                                <span class="glyphicon glyphicon-pencil"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                            <button type="submit"\n                                    ui-sref="usuario.delete({id:usuario.id})"\n                                    class="btn btn-danger btn-sm">\n                                <span class="glyphicon glyphicon-remove-circle"></span>\n                                <span class="hidden-xs hidden-sm"></span>\n                            </button>\n                        </div>\n                    </td>\n                </tr>\n            </tbody>\n        </table> --> Hola mundo</div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/ati/admonusuariosadmin.html','<div><h2>Usuarios Adminstrador Evaluacion</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 head-button-group"><button class="btn btn-primary" ui-sref="admonevalua"><span class="glyphicon glyphicon-plus"></span> <span>Nuevo Usuario Administrador Evaluacion</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="usuario.login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Nombre</span> <span></span></th><th jh-sort-by="institucion.nombre"><span>Dependencia</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="usuario in vm.usuarios track by usuario.id"><!--  <td><a ui-sref="usuario-detail({id:usuario.id})">{{usuario.id}}</a></td> --><td>{{usuario.login}}</td><td>{{usuario.nombreCompletoNAA}}</td><td>{{usuario.perfil.institucion.nombre}}</td><td class="text-right"><button type="submit" ui-sref="admonevalua.delete({id:usuario.perfil.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/ati/admonusuariosati.html','<div><h2>Usuarios ATI</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 head-button-group"><button class="btn btn-primary" ui-sref="admonati"><span class="glyphicon glyphicon-plus"></span> <span>Nuevo Usuario ATI</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="usuario.login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Nombre</span> <span></span></th><th jh-sort-by="institucion.nombre"><span>Dependencia</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="usuario in vm.usuarios track by usuario.id"><!--  <td><a ui-sref="usuario-detail({id:usuario.id})">{{usuario.id}}</a></td> --><td>{{usuario.login}}</td><td>{{usuario.nombreCompletoNAA}}</td><td>{{usuario.perfil.institucion.nombre}}</td><td class="text-right"><button type="submit" ui-sref="admonati.delete({id:usuario.perfil.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/ati/admonusuariosgestor.html','<div><h2>Usuarios Gestores Academicos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 head-button-group"><button class="btn btn-primary" ui-sref="admperfilgestor"><span class="glyphicon glyphicon-plus"></span> <span>Nuevo Usuario Gestor Academico</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="usuario.login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th><th><span>Nombre</span> <span></span></th><th jh-sort-by="institucion.nombre"><span>Dependencia</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="usuario in vm.usuarios track by usuario.id"><!--  <td><a ui-sref="usuario-detail({id:usuario.id})">{{usuario.id}}</a></td> --><td>{{usuario.login}}</td><td>{{usuario.nombreCompletoNAA}}</td><td>{{usuario.perfil.institucion.nombre}} {{usuario.perfil.institucion.abreviatura}}</td><td class="text-right"><button type="submit" ui-sref="admgestor.delete({id:usuario.perfil.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/ati/deleteperfilconfirm.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.usuario.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirmaci\xF3n</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>\xBFEst\xE1s seguro de borrar este perfil del usuario?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancelar</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Eliminar</span></button></div></form>');
$templateCache.put('app/ati/nuevousuario.html','<form class="form-horizontal" name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUsuarioLabel">Nuevo Usuario</h4></div><jhi-alert-error></jhi-alert-error><div class="modal-body"><div class="form-group"><label class="col-sm-2 control-label">Nombre</label><div class="col-sm-5"><input type="text" ng-model="vm.criterio" class="form-control" placeholder="Nombre del empleado"></div><div class="col-sm-5"><button type="button" ng-click="vm.buscar()" class="btn btn-primary">Buscar</button></div></div><div class="form-group" ng-show="vm.empleados !=null"><label class="col-sm-2 control-label">Concidencias</label><div class="col-sm-10"><ul class="lista-usuarios"><li ng-class="{\'selected\': empleado.id == vm.idpersona.id}" ng-repeat="empleado in vm.empleados track by empleado.id" ng-click="vm.setEmpleado(empleado)">{{empleado.nombres}} {{empleado.apellidoPaterno}} {{empleado.apellidoMaterno}}</li></ul></div></div><div class="form-group"><label class="col-sm-2 control-label">Dependencia a asignar</label><div class="col-sm-5"><select class="form-control" ng-model="vm.institucionSelected" ng-value="institucion.nombre" ng-options="institucion.nombre+\' \'+institucion.abreviatura for institucion in vm.instituciones"></select></div></div><div></div></div><div class="modal-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving ||!vm.valid()" class="btn btn-primary">Crear Perfil</button></div></form>');
$templateCache.put('app/clases/listadoclases.html','<div><!-- Page Content --><div class="row"><div class="col-lg-12"><div class="page-header"><h2 id="navbar">Clases</h2><h4 ng-show="vm.anioSeleccionado">{{vm.anioSeleccionado.descripcion}}</h4></div><jhi-alert-error></jhi-alert-error><form class="form-search"><div><h4>Buscar por:</h4><div class="row"><div class="col-lg-offset-1 col-lg-6"><div class="form-group"><label class="control-label" for="fiel">Dependencia</label><select required class="form-control" ng-model="vm.institucionSelected"><option ng-repeat=" institucion in vm.dependencias" value="{{institucion.id}}">{{institucion.nombre}} {{institucion.abreviatura}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-6 --><div class="col-lg-3"><div class="form-group"><label class="control-label">Nivel</label><select required class="form-control" ng-model="vm.nivelSeleccionado" ng-value="{{nivel}}" ng-options="nivel for nivel in vm.niveles" ng-change="vm.limpiar()"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --></div><!-- /.row --><div class="row"><div class="col-lg-offset-1 col-lg-2"><div class="form-group"><label class="control-label">Modelo</label><select required class="form-control" ng-model="vm.modeloSeleccionado" ng-value="{{modelo}}" ng-options="modelo \n\t\t\t\t\t\t\t\t\t\tdisable when \n\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == null || vm.nivelSeleccionado == 0) ||\n\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado == \'Posgrado\' &&\n\t\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEyA\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI 2\'\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t) ||\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado != \'Posgrado\' && modelo == \'No aplica\' \n\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\tfor modelo in vm.modelos"></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><label class="control-label">A&ntildeo Escolar</label><select required class="form-control" ng-model="vm.anioSeleccionado"><option ng-repeat="anioEscolar in vm.aniosEscolares" value="{{anioEscolar.id}}">{{anioEscolar.descripcion}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --><div class="col-lg-2"><div class="input-group"><br><label><input type="checkbox" ng-model="vm.intercurso"> Intercurso</label></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-3"><div class="form-group"><label class="control-label" for="fiel">Periodo</label><!-- Periodo normal --><select class="form-control" ng-show="!vm.intercurso" required class="dropdown" ng-model="vm.indicePeriodo" ng-value="vm.indicePeriodo" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select><!-- Periodo intercurso --><select class="form-control" ng-show="vm.intercurso" required class="dropdown" ng-model="vm.indiceIntercurso" ng-value="vm.indiceIntercurso" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --></div><!-- /.row --><div class="row"><div class="col-lg-offset-1 col-lg-6"><div class="form-group"><input type="text" ng-model="vm.currentSearch" class="form-control" placeholder="Buscar por asignatura, profesor o grupo"></div><!-- /input-group --></div><!-- /.col-lg-6 --><div class="col-lg-2"><div class="form-group"><label><input type="checkbox" ng-model="vm.evaluacionesPendientes"> Por evaluar</label></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><button type="button" class="btn btn-primary" ng-click="vm.search()">Buscar</button></div><!-- /input-group --></div><!-- /.col-lg-2 --></div><!-- /.row --></div></form><table class="table table-striped table-hover"><tbody><tr ng-repeat="usuario in vm.usuarios"><td><h4>{{usuario.clase.asignaturaBase.nombre}}</h4><h6><label><div ng-switch="usuario.clase.tipoModelo"><div ng-switch-when="MEFI">{{ usuario.nivel.tipo }}, MEFI</div><div ng-switch-when="MEFI_2">{{ usuario.nivel.tipo }}, MEFI 2</div><div ng-switch-when="MEYA">{{ usuario.nivel.tipo }}, MEyA</div></div></label></h6><h6>{{usuario.nombreCompletoAAN}} - {{ usuario.clase.grupo.grupo }}</h6><h6>{{usuario.plan.abreviatura}}</h6></td><td class="vcenter"><ul class="btn-group opciones-menu"><li uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="obs-menu">Observaciones<!-- <b class="caret"></b> --></a></li><li uib-dropdown class="dropdown pointer" ng-switch="usuario.evaluacion.id == null"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="eval-menu"><span ng-switch-when="false" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-switch-when="true" class="glyphicon glyphicon-remove" aria-hidden="true"></span> Evaluaciones <b class="caret"></b></a><ul class="dropdown-menu multi-level" uib-dropdown-menu id="eval-menu"><li ng-switch-when="true"><a ui-sref="clases.ambito({id:usuario.clase.id,idp:usuario.profesor.persona.id,tiponivel:usuario.nivel.tipo,tipomodelo:usuario.clase.tipoModelo,idins:vm.institucionSelected})">Registrar Evaluaci\xF3n</a><!-- <a >Evaluaciones cerradas</a> --></li><li ng-switch-when="false"><a>Forma de evaluacion: "{{usuario.evaluacion.formaDeEvaluar}}"</a></li><!--li ng-switch-when="false">\n\t\t                                    <a >Ver autoevaluaci\xF3n del profesor</a>\n\t\t                                </li--><li ng-switch-when="false"><a ng-click="vm.download(usuario.evaluacion.id)">Descargar reporte de alumnos evaluados</a></li><li ng-switch-when="false"><a ui-sref="downloadPage({ambito:usuario.evaluacion.id})">Ver resumen de alumnos evaluados.</a></li><li ng-switch-when="false" ng-show="\n\t\t                                (usuario.nivel.tipo == \'Licenciatura\' && (usuario.clase.tipoModelo == \'MEFI\' || usuario.clase.tipoModelo == \'MEFI_2\')) \n\t\t                                || (usuario.nivel.tipo == \'Bachiller\')\n\t\t                                || (usuario.nivel.tipo == \'Educaci\xF3n Continua Lic\')"><div class="liautoevaluacion" ng-switch="usuario.hayAutoEvaluacionProfesor == true"><p><span ng-switch-when="true" class="glyphicon glyphicon-ok"></span> <span ng-switch-when="false" class="glyphicon glyphicon-remove"></span> Registro de autoevaluaci&oacuten.</p></div></li><!--   <li ng-switch-when="false">\n\t\t                                    <a ng-click="vm.descargarReporteAlumnos(usuario.evaluacion.id)">Descargar Datos de alumnos evaluados</a>\n\t\t                                </li>\n\t\t                                 <li ng-switch-when="false">\n\t\t                                    <a ng-click="vm.descargarReporteProfesor(usuario.evaluacion.id)">Descargar Datos del Profesor</a>\n\t\t                                </li> --></ul></li><li uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="obs-menu">Evidencias<!-- <b class="caret"></b> --></a></li></ul></td><jhi-alert></jhi-alert></tr></tbody></table></div></div><!-- /.row --><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/descargas/downloadpage.html','<br><a class="btn btn-primary" role="button" ng-click="vm.download()">Descargar reporte de alumnos evaluados</a><div><p class="resumAlums">{{ vm.alumosObtenidos.alumnosSI }} de {{ vm.alumosObtenidos.totalAlumnosEvaluacion }} ({{ vm.alumosObtenidos.alumnosSIPorcentaje }}%)</p></div><br><br><br><table class="table table-striped table-hover"><tbody><tr><th>Matricula</th><th>Nombre</th><th>Cuestionario contestado</th></tr><tr ng-repeat="alumno in vm.alumosObtenidos.alumnosEvalucionesLista"><td><h4>{{alumno.matriculaParteInvariable}}</h4></td><td><h4>{{alumno.nombreAlumno}}</h4></td><td><h4>{{alumno.cuestionarioContestado}}</h4></td></tr></tbody></table>');
$templateCache.put('app/docente/autoevaluacion.html','<div ng-show="vm.resuelto"><div class="row"><div class="col-lg-12"><section id="part-0" class="questionarie notice center-block" ng-show="vm.show==0 && vm.nivel == \'Bachiller\' && !(vm.idins == \'65\' || vm.idins == \'52\') "><p>Estimada y Estimado docente:</p><p>Agradecemos el tiempo que puedas dedicar a dar respuesta al presente instrumento de autoevaluaci\xF3n de tu pr\xE1ctica pedag\xF3gica a fin de que reflexiones sobre la manera en que desarrollas \xE9sta, para que identifiques tus posibles \xE1reas de oportunidad, de modo que puedas mejorar tu desempe\xF1o en el aula, siempre en busca de proporcionar una mejor experiencia educativa a tus estudiantes. Tus respuestas son totalmente confidenciales, por tanto, te solicitamos que contestes con la mayor sinceridad posible.</p><p>Agradecemos tu colaboraci\xF3n.</p><footer><p>Atentamente</p><p>Direcci\xF3n General de Desarrollo Acad\xE9mico</p><p>LUZ, CIENCIA Y VERDAD</p><a class="btn btn-primary next" ng-click="vm.show = 1">Siguiente</a></footer></section><section id="part-0" class="questionarie notice center-block" ng-show="vm.show==0 && vm.nivel == \'Licenciatura\' && vm.tipoauto == \'INSTRUMENTO DE AUTOEVALUACI\xD3N 1 LIC\' && !(vm.idins == \'65\' || vm.idins == \'52\') " style="text-align: justify"><p>Apreciable Docente:</p><p>Por favor dedique unos minutos para responder este instrumento.</p><p>Estas preguntas se responden <b>por cada asignatura</b>.</p><p>El objetivo es promover la <i>pr\xE1ctica reflexiva sobre su desempe\xF1o</i>.</p><p>Le pedimos que realice un an\xE1lisis \xE9tico y reflexivo sobre su pr\xE1ctica en este per\xEDodo que finaliza.</p><p>Agradecemos tu colaboraci\xF3n</p><footer><p>Atentamente</p><p>LUZ, CIENCIA Y VERDAD</p><p>Direcci\xF3n General de Desarrollo Acad\xE9mico</p><a class="btn btn-primary next" ng-click="vm.show = 1">Siguiente</a></footer></section><section id="part-0" class="questionarie notice center-block" ng-show="vm.show==0 && vm.nivel == \'Licenciatura\' && vm.tipoauto == \'INSTRUMENTO DE AUTOEVALUACI\xD3N 2 LIC\' && !(vm.idins == \'65\' || vm.idins == \'52\') " style="text-align: justify"><p>Apreciable Docente:</p><p>Por favor, dedique unos minutos para responder este instrumento.</p><p>Estas preguntas se responden <b>UNA sola vez</b> por per\xEDodo.</p><p>El objetivo es promover la <i>mejora continua de su pr\xE1ctica docente</i>, por tanto, pedimos sinceridad en su participaci\xF3n.</p><p>Este ejercicio tiene un car\xE1cter exploratorio y no determina una puntuaci\xF3n o ponderaci\xF3n para el personal docente.</p><footer><p>Atentamente</p><p>LUZ, CIENCIA Y VERDAD</p><p>Direcci\xF3n General de Desarrollo Acad\xE9mico</p><a class="btn btn-primary next" ng-click="vm.show = 1">Siguiente</a></footer></section><section id="part-0" class="questionarie notice center-block" ng-show="vm.show==0 && vm.tipoauto == \'INSTRUMENTO DE AUTOEVALUACI\xD3N UAEV\' "><p>Apreciable Profesor (a):</p><p>Por favor, dedique unos minutos para responder este instrumento. El objetivo de esta evaluaci\xF3n es promover la mejora continua y con ello garantizar la calidad en el proceso formativo, por tanto, le solicitamos conteste con la mayor sinceridad posible.</p><p>Agradecemos su colaboraci\xF3n.</p><footer><p>Atentamente</p><p>Direcci\xF3n General de Desarrollo Acad\xE9mico</p><p>LUZ, CIENCIA Y VERDAD</p><a class="btn btn-primary next" ng-click="vm.show = 1">Siguiente</a></footer></section><section id="part-0" class="questionarie notice center-block" ng-show="vm.show==0 && vm.nivel == \'Educaci\xF3n Continua Lic\' "><p>Apreciable Docente:</p><p>Por favor, dedique unos minutos para responder este instrumento.</p><p>El objetivo es promover la mejora continua y con ello garantizar la calidad en el proceso de formaci\xF3n, por tanto, le solicitamos conteste con la mayor sinceridad posible.</p><p>Agradecemos su colaboraci\xF3n.</p><footer><p>Atentamente</p><p>Direcci\xF3n General de Desarrollo Acad\xE9mico</p><p>LUZ, CIENCIA Y VERDAD</p><a class="btn btn-primary next" ng-click="vm.show = 1">Siguiente</a></footer></section><form ng-submit="vm.save()" name="cuestionario"><section ng-repeat="grupo in vm.resuelto.grupoPreguntasForUI" id="part-{{ $index + 1 }}" class="questionarie" ng-switch="grupo.grupoPreguntas.cabecera" ng-show="vm.show==$index + 1"><div ng-switch="grupo.grupoPreguntas.cabecera"><header><p><strong>{{ grupo.grupoPreguntas.instrucciones }}</strong></p><h4 ng-if="grupo.grupoPreguntas.min != null"><strong>Selecciona m\xEDnimo {{ grupo.grupoPreguntas.min }} y m\xE1ximo {{ grupo.grupoPreguntas.max }} elementos</strong></h4><!-- INICIA: Escala multicolor 4 --><table class="table table-bordered calificacion type-a" ng-switch-when="escalamulticolor4"><tr><td>1</td><td>2</td><td>3</td><td>4</td></tr><tr><td class="calif-1">Casi nunca</td><td class="calif-2">A veces</td><td class="calif-3">Frecuentemente</td><td class="calif-4">Casi Siempre</td></tr></table><!-- TERMINA: Escala multicolor 4 --><!-- INICIA: Escala multicolor 4 Para mi es --><table ng-switch-when="escalamulticolor4ParaMiEs" class="table table-bordered calificacion type-a"><tr><td>1</td><td>2</td><td>3</td><td>4</td></tr><tr><td class="calif-1">MUY DIF\xCDCIL</td><td class="calif-2">DIF\xCDCIL</td><td class="calif-3">F\xC1CIL</td><td class="calif-4">MUY F\xC1CIL</td></tr></table><!-- TERMINA: Escala multicolor 4 Para mi es --><!-- INICIA: Escala multicolor 4 Elaborar asig --><table ng-switch-when="escalamulticolor4ElaborarAsigParaMiEs" class="table table-bordered calificacion type-a"><tr><td>1</td><td>2</td><td>3</td><td>4</td></tr><tr><td class="calif-1">MUY DIF\xCDCIL</td><td class="calif-2">DIF\xCDCIL</td><td class="calif-3">F\xC1CIL</td><td class="calif-4">MUY F\xC1CIL</td></tr></table><!-- TERMINA: Escala multicolor 4 Elaborar asig --><!-- INICIA: Escala multicolor 4 Para mi fue --><table ng-switch-when="escalamulticolor4ParaMiFue" class="table table-bordered calificacion type-a"><tr><td>1</td><td>2</td><td>3</td><td>4</td></tr><tr><td class="calif-1">MUY DIF\xCDCIL</td><td class="calif-2">DIF\xCDCIL</td><td class="calif-3">F\xC1CIL</td><td class="calif-4">MUY F\xC1CIL</td></tr></table><!-- TERMINA: Escala multicolor 4 Elaborar asig --><!-- INICIA: Escala amarillo 7 --><section class="example" ng-switch-when="escalaAmarillo7"><h5>Ejemplo: Flexible o R\xEDgido</h5><table class="table table-bordered calificacion type-b"><tr><td></td><td class="calif-1">1</td><td class="calif-2">2</td><td class="calif-3">3</td><td class="calif-4">4</td><td class="calif-5">5</td><td class="calif-6">6</td><td class="calif-7">7</td><td></td></tr><td>Flexible</td><td></td><td>x</td><td></td><td></td><td></td><td></td><td></td><td>R\xEDgido</td></table><h4 class="text-center">En este caso la respuesta indicar\xEDa que se considera MUY flexible.</h4></section><!-- TERMINA: Escala amarillo 7 --><!-- INICIA: Escala multicolor 3 --><table class="table table-bordered calificacion type-c" ng-switch-when="escalamulticolor3"><tr><td>1</td><td>2</td><td>3</td></tr><tr><td class="calif-1">Insatisfecho</td><td class="calif-2">Satisfecho</td><td class="calif-3">Muy satisfecho</td></tr></table><!-- TERMINA: Escala multicolor 3 --></header><h4 ng-switch-when="escalamulticolor4ParaMiEs" class="tituloTablaEncuesta">Para m\xED, es ___________________</h4><h4 ng-switch-when="escalamulticolor4ElaborarAsigParaMiEs" class="tituloTablaEncuesta">Al elaborar la planeaci\xF3n de la asignatura, para m\xED es\u2026</h4><h4 ng-switch-when="escalamulticolor4ParaMiFue" class="tituloTablaEncuesta">Para m\xED fue\u2026</h4><h4 ng-switch-default class="tituloTablaEncuesta"></h4></div><ol class="stripped-list container-fluid"><div ng-repeat="preguntaw in grupo.preguntasWrapperForUI"><li class="form-group" ng-class="{\'invalid\':vm.contain(preguntaw.pregunta.id) == true}"><div ng-switch="preguntaw.pregunta.tipoPregunta.tipoPregunta"><!-- INICIA: Pregunta tipo RADIOBUTTON --><div class="row" ng-switch-when="RadioButton"><div class="question col-sm-9">{{ preguntaw.pregunta.preguntaString }}</div><div class="col-sm-3"><span ng-repeat="opcion in preguntaw.respuestasForUI"><label class="radio-label"><input type="radio" ng-model="preguntaw.respuesta.respuestaSeleccionada" name="{{preguntaw.respuesta.id}}" ng-value="opcion.respuestaString" tabindex="-1" ng-change="vm.resetearResDePregDepediente(preguntaw.pregunta.id)" ng-disabled="vm.deshabilitar(preguntaw.pregunta.id,preguntaw.pregunta.preguntaActivador,preguntaw.pregunta.opcionpreguntaactivador)" ng-required="!vm.deshabilitar(preguntaw.pregunta.id,preguntaw.pregunta.preguntaActivador,preguntaw.pregunta.opcionpreguntaactivador)"> {{ opcion.respuestaString }}</label></span></div></div><!-- TERMINA: Pregunta tipo RADIOBUTTON --><!-- INICIA: Pregunta tipo CHECKBOX --><div class="row" ng-switch-when="CheckBox"><div class="question col-sm-9"><input type="checkbox" ng-model="preguntaw.respuesta.respuestaSeleccionada" name="{{preguntaw.respuesta.id}}" tabindex="-1" ng-change="vm.resetearResDePregDepediente(preguntaw.pregunta.id)" ng-disabled="vm.deshabilitar(preguntaw.pregunta.id,preguntaw.pregunta.preguntaActivador,preguntaw.pregunta.opcionpreguntaactivador)"><label class="checkbox-label">{{preguntaw.pregunta.preguntaString }}</label></div></div><!-- TERMINA: Pregunta tipo CHECKBOX --><!-- INICIA: Pregunta tipo ESCALA --><div class="row" ng-switch-when="Escala"><table class="table calificacion calificacion-pregunta type-b"><tr><td width="20%">{{ preguntaw.pregunta.preguntaString.split(\'#@\')[0] }}</td><td ng-repeat="opcion in preguntaw.respuestasForUI" class="calif-{{$index + 1}}"><label class="radio-label"><input type="radio" ng-model="preguntaw.respuesta.respuestaSeleccionada" name="{{preguntaw.respuesta.id}}" ng-value="opcion.respuestaString" tabindex="-1" required></label></td><td width="20%">{{ preguntaw.pregunta.preguntaString.split(\'#@\')[1] }}</td></tr></table></div><!-- TERMINA: Pregunta tipo ESCALA --><!-- INICIA: Pregunta tipo TEXTAREA --><div class="row" ng-switch-when="TextArea"><div class="question col-sm-12"><label>{{ preguntaw.pregunta.preguntaString }}</label></div><div class="col-sm-12"><textarea rows="4" cols="50" class="form-control" name="{{preguntaw.respuesta.id}}" maxlength="1000" ng-model="preguntaw.respuesta.respuestaSeleccionada" tabindex="-1" ng-disabled="vm.deshabilitar(preguntaw.pregunta.id,preguntaw.pregunta.preguntaActivador,preguntaw.pregunta.opcionpreguntaactivador)" ng-required="!vm.deshabilitar(preguntaw.pregunta.id,preguntaw.pregunta.preguntaActivador,preguntaw.pregunta.opcionpreguntaactivador)">\n\t\t\t\t\t\t\t\t\t\t\t</textarea></div></div><!-- TERMINA: Pregunta tipo TEXTAREA --><div class="row" ng-switch-default><div class="question col-sm-9"></div></div></div></li></div></ol><div ng-class="{\'alert alert-danger text-center\': vm.valido == false}" ng-show="vm.valido == false && vm.mensaje != null">{{vm.mensaje}}</div><div ng-class="{\'alert alert-danger text-center\': vm.validoCheck == false}" ng-show="vm.validoCheck == false && vm.mensajeCheck != null">{{vm.mensajeCheck}}</div><footer><a class="btn btn-primary next" ng-click="vm.anterior($index)">Anterior</a> <a class="btn btn-primary next" ng-click="vm.siguiente($index)" ng-if="!$last">Siguiente</a> <button type="submit" class="btn btn-primary next" ng-if="$last" ng-disabled="cuestionario.$invalid">Guardar</button></footer></section></form></div></div><!-- /.row --></div><br><div ng-show="vm.msjCargando && vm.resuelto==null"><div class="alert alert-info text-center">Cargando instrumento de Autoevaluaci\xF3n...</div></div><br><div ng-hide="vm.msjCargando"><div class="alert alert-danger text-center">No hay Actividad de Autoevaluaci&oacuten vigente.<br>Favor de comunicarse con el Responsable de Evaluaci&oacuten Docente de su Dependencia.</div><footer><div class="text-center"><a class="btn btn-primary next text-center" ng-click="vm.menu()">Regresar</a></div></footer></div>');
$templateCache.put('app/docente/clasesdocente.html','<div><!-- Page Content --><div class="row"><div class="col-lg-12"><div class="page-header"><h2 id="navbar">Mis asignaturas</h2></div><jhi-alert-error></jhi-alert-error><form class="form-search"><div><h4>Buscar por:</h4><div class="row"><div class="col-lg-offset-1 col-lg-6"><div class="form-group"><label class="control-label" for="fiel">Dependencia</label><select required class="form-control" ng-model="vm.institucionSeleccionada"><option ng-repeat=" institucion in vm.dependencias" value="{{institucion.id}}">{{institucion.nombre}} {{institucion.abreviatura}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-6 --><div class="col-lg-3"><div class="form-group"><label class="control-label">Nivel</label><select required class="form-control" ng-model="vm.nivelSeleccionado" ng-value="{{nivel}}" ng-options="nivel for nivel in vm.niveles" ng-change="vm.limpiar()"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --></div><!-- /.row --><div class="row"><div class="col-lg-offset-1 col-lg-2"><div class="form-group"><label class="control-label">Modelo</label><select required class="form-control" ng-model="vm.modeloSeleccionado" ng-value="{{modelo}}" ng-options="modelo \n\t\t\t\t\t\t\t\t\t\tdisable when \n\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == null || vm.nivelSeleccionado == 0) ||\n\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado == \'Posgrado\' &&\n\t\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEyA\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI 2\'\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t) ||\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado != \'Posgrado\' && modelo == \'No aplica\' \n\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\tfor modelo in vm.modelos"></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><label class="control-label">A&ntildeo Escolar</label><select required class="form-control" ng-model="vm.anioSeleccionado"><option ng-repeat="anioEscolar in vm.aniosEscolares" value="{{anioEscolar.id}}">{{anioEscolar.descripcion}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --><div class="col-lg-2"><div class="input-group"><br><label><input type="checkbox" ng-model="vm.intercurso"> Intercurso</label></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><label class="control-label" for="fiel">Periodo</label><!-- Periodo normal --><select class="form-control" ng-show="!vm.intercurso" required class="dropdown" ng-model="vm.indicePeriodo" ng-value="vm.indicePeriodo" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select><!-- Periodo intercurso --><select class="form-control" ng-show="vm.intercurso" required class="dropdown" ng-model="vm.indiceIntercurso" ng-value="vm.indiceIntercurso" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><br><button type="button" class="btn btn-primary" ng-click="vm.search()">Buscar</button></div><!-- /input-group --></div><!-- /.col-lg-2 --></div><!-- /.row --></div></form><br><div class="alert alert-info text-center" ng-show="vm.clases.length == 0">No tienes clases para evaluar.</div><table class="table table-striped table-hover"><tbody><tr ng-repeat="clase in vm.clases | filter: busquedadocente track by clase.id"><td><h4>{{clase.clase.asignaturaBase.nombre}}</h4><h6>{{clase.clase.institucion.nombre }} - {{ clase.clase.grupo.grupo }}</h6><h6><label><div ng-switch="clase.clase.tipoModelo"><div ng-switch-when="MEFI">{{ clase.nivel.tipo }}, MEFI</div><div ng-switch-when="MEFI_2">{{ clase.nivel.tipo }}, MEFI 2</div><div ng-switch-when="MEYA">{{ clase.nivel.tipo }}, MEyA</div></div></label></h6><h6>{{clase.nombreCompletoAAN}}</h6><h6>{{clase.plan.abreviatura}}</h6></td><td class="vcenter"><ul class="btn-group opciones-menu"><li uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="obs-menu">Observaciones</a></li><li uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="obs-menu">Evaluaciones <b class="caret" ng-hide="clase.evaluacion.id == null"></b></a><ul class="dropdown-menu multi-level" uib-dropdown-menu id="obs-menu" ng-hide="clase.evaluacion.id == null"><li ng-show="\n\t\t\t\t\t\t\t\t\t\t(clase.nivel.tipo == \'Bachiller\' &&  clase.clase.institucion.id != 52)\n\t\t\t\t\t\t\t\t\t\t"><a ui-sref="autoevaluacion({\n\t\t\t\t\t\t\t\t\t\t\tambito:clase.evaluacion.id,\n\t\t\t\t\t\t\t\t\t\t\tprofesor:clase.profesor.persona.id,\n\t\t\t\t\t\t\t\t\t\t\tmodelo:clase.modeloEdu,\n\t\t\t\t\t\t\t\t\t\t\tnivel:clase.nivel.tipo,\n\t\t\t\t\t\t\t\t\t\t\tidins:clase.clase.institucion.id,\n\t\t\t\t\t\t\t\t\t\t\ttipoauto:\'INSTRUMENTO DE AUTOEVALUACI\xD3N BACH\'\n\t\t\t\t\t\t\t\t\t\t\t})"><span ng-show="clase.hayAutoEvaluacionProfesor" class="glyphicon glyphicon-ok"></span> <span ng-hide="clase.hayAutoEvaluacionProfesor" class="glyphicon glyphicon-remove"></span> Llenar autoevaluaci\xF3n</a></li><li ng-show="\n\t\t\t\t\t\t\t\t\t\t(clase.nivel.tipo == \'Licenciatura\' && (clase.clase.tipoModelo == \'MEFI\'||clase.clase.tipoModelo == \'MEFI_2\') && clase.evaluacion.formaDeEvaluar ==\'UAEV\') ||\n\t\t\t\t\t\t\t\t\t\t(clase.nivel.tipo == \'Bachiller\' &&  clase.clase.institucion.id == 52)\n\t\t\t\t\t\t\t\t\t\t"><a ui-sref="autoevaluacion({\n\t\t\t\t\t\t\t\t\t\t\tambito:clase.evaluacion.id,\n\t\t\t\t\t\t\t\t\t\t\tprofesor:clase.profesor.persona.id,\n\t\t\t\t\t\t\t\t\t\t\tmodelo:clase.modeloEdu,\n\t\t\t\t\t\t\t\t\t\t\tnivel:clase.nivel.tipo,\n\t\t\t\t\t\t\t\t\t\t\tidins:clase.clase.institucion.id,\n\t\t\t\t\t\t\t\t\t\t\ttipoauto:\'INSTRUMENTO DE AUTOEVALUACI\xD3N UAEV\'\n\t\t\t\t\t\t\t\t\t\t\t})"><span ng-show="clase.hayAutoEvaluacionProfesor" class="glyphicon glyphicon-ok"></span> <span ng-hide="clase.hayAutoEvaluacionProfesor" class="glyphicon glyphicon-remove"></span> Llenar autoevaluaci\xF3n</a></li><li ng-show="\n\t\t\t\t\t\t\t\t\t\t(clase.nivel.tipo == \'Licenciatura\' && (clase.clase.tipoModelo == \'MEFI\'||clase.clase.tipoModelo == \'MEFI_2\') &&  !(clase.evaluacion.formaDeEvaluar ==\'UAEV\'))\n\t\t\t\t\t\t\t\t\t\t"><a ui-sref="autoevaluacion({\n\t\t\t\t\t\t\t\t\t\t\tambito:clase.evaluacion.id,\n\t\t\t\t\t\t\t\t\t\t\tprofesor:clase.profesor.persona.id,\n\t\t\t\t\t\t\t\t\t\t\tmodelo:clase.modeloEdu,\n\t\t\t\t\t\t\t\t\t\t\tnivel:clase.nivel.tipo,\n\t\t\t\t\t\t\t\t\t\t\tidins:clase.clase.institucion.id,\n\t\t\t\t\t\t\t\t\t\t\ttipoauto:\'INSTRUMENTO DE AUTOEVALUACI\xD3N 1 LIC\'\n\t\t\t\t\t\t\t\t\t\t\t})"><span ng-show="clase.hayAutoEvaluacion1Profesor" class="glyphicon glyphicon-ok"></span> <span ng-hide="clase.hayAutoEvaluacion1Profesor" class="glyphicon glyphicon-remove"></span> Llenar autoevaluaci\xF3n 1</a></li><li ng-show="\n\t\t\t\t\t\t\t\t\t\t(clase.nivel.tipo == \'Licenciatura\' && (clase.clase.tipoModelo == \'MEFI\'||clase.clase.tipoModelo == \'MEFI_2\') &&  !(clase.evaluacion.formaDeEvaluar ==\'UAEV\'))\n\t\t\t\t\t\t\t\t\t\t"><a ui-sref="autoevaluacion({\n\t\t\t\t\t\t\t\t\t\t\tambito:clase.evaluacion.id,\n\t\t\t\t\t\t\t\t\t\t\tprofesor:clase.profesor.persona.id,\n\t\t\t\t\t\t\t\t\t\t\tmodelo:clase.modeloEdu,\n\t\t\t\t\t\t\t\t\t\t\tnivel:clase.nivel.tipo,\n\t\t\t\t\t\t\t\t\t\t\tidins:clase.clase.institucion.id,\n\t\t\t\t\t\t\t\t\t\t\ttipoauto:\'INSTRUMENTO DE AUTOEVALUACI\xD3N 2 LIC\'\n\t\t\t\t\t\t\t\t\t\t\t})"><span ng-show="clase.hayAutoEvaluacion2Profesor" class="glyphicon glyphicon-ok"></span> <span ng-hide="clase.hayAutoEvaluacion2Profesor" class="glyphicon glyphicon-remove"></span> Llenar autoevaluaci\xF3n 2</a></li><li ng-show="\n\t\t\t\t\t\t\t\t\t\t(clase.nivel.tipo == \'Educaci\xF3n Continua Lic\' && clase.evaluacion.formaDeEvaluar == \'Mixto PII\')\n\t\t\t\t\t\t\t\t\t\t"><a ui-sref="autoevaluacion({\n\t\t\t\t\t\t\t\t\t\t\tambito:clase.evaluacion.id,\n\t\t\t\t\t\t\t\t\t\t\tprofesor:clase.profesor.persona.id,\n\t\t\t\t\t\t\t\t\t\t\tmodelo:clase.modeloEdu,\n\t\t\t\t\t\t\t\t\t\t\tnivel:clase.nivel.tipo,\n\t\t\t\t\t\t\t\t\t\t\tidins:clase.clase.institucion.id,\n\t\t\t\t\t\t\t\t\t\t\ttipoauto:\'INSTRUMENTO MIXTA AUTOEVALUACI\xD3N PII\'\n\t\t\t\t\t\t\t\t\t\t\t})"><span ng-show="clase.hayAutoEvaluacionProfesor" class="glyphicon glyphicon-ok"></span> <span ng-hide="clase.hayAutoEvaluacionProfesor" class="glyphicon glyphicon-remove"></span> Llenar autoevaluaci\xF3n</a></li><li ng-show="\n\t\t\t\t\t\t\t\t\t\t(clase.nivel.tipo == \'Educaci\xF3n Continua Lic\' && clase.evaluacion.formaDeEvaluar == \'Virtual PII\')\n\t\t\t\t\t\t\t\t\t\t"><a ui-sref="autoevaluacion({\n\t\t\t\t\t\t\t\t\t\t\tambito:clase.evaluacion.id,\n\t\t\t\t\t\t\t\t\t\t\tprofesor:clase.profesor.persona.id,\n\t\t\t\t\t\t\t\t\t\t\tmodelo:clase.modeloEdu,\n\t\t\t\t\t\t\t\t\t\t\tnivel:clase.nivel.tipo,\n\t\t\t\t\t\t\t\t\t\t\tidins:clase.clase.institucion.id,\n\t\t\t\t\t\t\t\t\t\t\ttipoauto:\'INSTRUMENTO VIRTUAL AUTOEVALUACI\xD3N PII\'\n\t\t\t\t\t\t\t\t\t\t\t})"><span ng-show="clase.hayAutoEvaluacionProfesor" class="glyphicon glyphicon-ok"></span> <span ng-hide="clase.hayAutoEvaluacionProfesor" class="glyphicon glyphicon-remove"></span> Llenar autoevaluaci\xF3n</a></li></ul></li><li uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="obs-menu">Evidencias </a><!--\n\t\t                             <ul class="dropdown-menu multi-level" uib-dropdown-menu id="obs-menu">\n\t\t                                <li>\n\t\t                                    <a>Agregar observaci\xF3n +</a>\n\t\t                                </li>\n\t\t                            </ul> \n\t\t--></li></ul></td></tr></tbody></table></div></div><!-- /.row --></div>');
$templateCache.put('app/docente/misreportesevaluativos.html','<div><!-- Page Content --><div class="row"><div class="col-lg-12"><div class="page-header"><h2 id="navbar">Reportes Evaluativos</h2></div><jhi-alert-error></jhi-alert-error><form class="form-search"><div><h4>Buscar por:</h4><div class="row"><div class="col-lg-offset-1 col-lg-6"><div class="form-group"><label class="control-label" for="fiel">Dependencia</label><select required class="form-control" ng-model="vm.institucionSelected"><option ng-repeat=" institucion in vm.dependencias" value="{{institucion.id}}">{{institucion.nombre}} {{institucion.abreviatura}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-6 --><div class="col-lg-3"><div class="form-group"><label class="control-label">Nivel</label><select required class="form-control" ng-model="vm.nivelSeleccionado" ng-value="{{nivel}}" ng-options="nivel for nivel in vm.niveles" ng-change="vm.limpiar()"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --></div><!-- /.row --><div class="row"><div class="col-lg-offset-1 col-lg-2"><div class="form-group"><label class="control-label">Modelo</label><select required class="form-control" ng-model="vm.modeloSeleccionado" ng-value="{{modelo}}" ng-options="modelo \n\t\t\t\t\t\t\t\t\t\tdisable when \n\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == null || vm.nivelSeleccionado == 0) ||\n\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado == \'Posgrado\' &&\n\t\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEyA\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI 2\'\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t) ||\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado != \'Posgrado\' && modelo == \'No aplica\' \n\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\tfor modelo in vm.modelos"></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><label class="control-label">A&ntildeo Escolar</label><select required class="form-control" ng-model="vm.anioSeleccionado"><option ng-repeat="anioEscolar in vm.aniosEscolares" value="{{anioEscolar.id}}">{{anioEscolar.descripcion}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="input-group"><br><label><input type="checkbox" ng-model="vm.intercurso"> Intercurso</label></div><!-- /input-group --></div><!-- /.col-lg-3 --><div class="col-lg-2"><div class="form-group"><label class="control-label" for="fiel">Periodo</label><!-- Periodo normal --><select ng-show="!vm.intercurso" required class="form-control" ng-model="vm.indicePeriodo" ng-value="vm.indicePeriodo" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select><!-- Periodo intercurso --><select ng-show="vm.intercurso" required class="form-control" ng-model="vm.indiceIntercurso" ng-value="vm.indiceIntercurso" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><br><button type="button" class="btn btn-primary" ng-click="vm.search()">Buscar</button></div><!-- /input-group --></div><!-- /.col-lg-2 --></div><!-- /.row --></div></form><table class="table table-striped table-hover"><!--\n                <thead>\n                  <tr>\n                    <th>Asignatura</th>\n                    <th>Opciones</th>\n                  </tr>\n                </thead>\n                --><tbody><tr ng-repeat="wrapper in vm.wrappers | filter: {hayevaluaciones:busquedagestornoevaluados}| filter: busquedagestor track by wrapper.id"><td><h4>{{wrapper.asignatura.nombre}}</h4><h6><label><div><div>{{wrapper.formaDeEvaluar}}</div></div></label></h6><h6 ng-show="{{ wrapper.grupo.grupo != \'Sin grupo\'}}"><label><div><div>{{wrapper.grupo.grupo}}</div></div></label></h6><h6><label><div><div>{{wrapper.niveleducativo}},{{wrapper.modeloeducativo}}</div></div></label></h6><h6>{{wrapper.profesor.apellidoPaterno}} {{wrapper.profesor.apellidoMaterno}} {{wrapper.profesor.nombres}}</h6></td><td class="vcenter"><ul class="btn-group opciones-menu"><li uib-dropdown class="dropdown pointer" ng-switch="wrapper.hasReporte"><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="verReporteLI({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Libre\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="verReporteOO({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Optativa\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="verReporteOO({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Obligatoria\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="verReporteLic({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'licenciatura general\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="verReporteCU({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Curso \xDAnico\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="verReporteRegular({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Regular\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="verReporteVirtual({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Virtual\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="verReporteUAEV({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'UAEV\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="verReporteBachillerato({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Bachillerato\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="verreporteMixtoPII({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Mixto PII\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="verreporteVirtualPII({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Virtual PII\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte</a></li></ul></td><jhi-alert></jhi-alert></tr></tbody></table></div></div><!-- /.row --><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/docente/observacion-autoevaluacion.html','<div><!-- Page Content --><div class="row"><div class="col-lg-12"><div class="page-header"><h3>Autoevaluaci\uFFFDn de la sesi\uFFFDn observada</h3></div><form><h5>CARACTER\uFFFDSTICAS DEL PROFESOR</h5><div class="form-horizontal general-data"><div class="form-group"><label for="intitucion" class="col-sm-2 control-label">Instituci\uFFFDn:</label><div class="col-sm-10">Centro Docente</div></div><div class="form-group"><label for="pograma" class="col-sm-2 control-label">Programa Educativo:</label><div class="col-sm-10">Programa Educativo</div></div><div class="form-group"><label for="NombrePrf" class="col-sm-2 control-label">Profesor:</label><div class="col-sm-10">Nombre del Profesor</div></div></div><div class="instruction"><p><em><strong>Instrucciones.</strong> A continuaci\uFFFDn se presenta una serie de preguntas abiertas que permitir\uFFFD reflexionar sobre la sesi\uFFFDn donde fue observado. Conteste con la mayor sinceridad posible, analizando las situaciones vividas en el aula.</em></p></div><div class="form-group separated"><label for="pw">1. \uFFFDC\uFFFDmo se sinti\uFFFD en la sesi\uFFFDn?</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><div class="form-group separated"><label for="pw">2. \uFFFDLogr\uFFFD lo que esperaba?</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><div class="form-group separated"><label for="pw">3. \uFFFDQu\uFFFD modificar\uFFFDa?</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><h5>4. Describa las expresiones, reacciones o comportamientos que realiz\uFFFD durante la sesi\uFFFDn, que hayan llamado su atenci\uFFFDn respecto a\uFFFD</h5><div class="form-group separated"><label for="pw">Interacci\uFFFDn o comunicaci\uFFFDn con sus estudiantes:</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><div class="form-group separated"><label for="pw">Secuencia de la sesi\uFFFDn:</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><div class="form-group separated"><label for="pw">Estrategias y actividades implementadas:</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><div class="form-group separated"><label for="pw">Materiales y recursos utilizados:</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><div class="form-group separated"><label for="pw">5. Sugerencias que quisiera hacerle al observador</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><h5>CALENDARIZACI\uFFFDN</h5><h6>SESI\uFFFDN A OBSERVAR</h6><div class="form-inline"><div class="form-group form-group-sm"><label for="hora" class="control-label">Hora:</label><input type="time" class="form-control" id="hora"></div><div class="form-group form-group-sm"><label for="hora" class="control-label">Fecha:</label><input type="date" class="form-control" id="hora"></div><div class="form-group form-group-sm"><label for="hora" class="control-label">Lugar:</label><input type="text" class="form-control" id="hora"></div></div><h6>RETROALIMENTACI\uFFFDN</h6><div class="form-inline separated"><div class="form-group form-group-sm"><label for="hora" class="control-label">Hora:</label><input type="time" class="form-control" id="hora"></div><div class="form-group form-group-sm"><label for="hora" class="control-label">Fecha:</label><input type="date" class="form-control" id="hora"></div><div class="form-group form-group-sm"><label for="hora" class="control-label">Lugar:</label><input type="text" class="form-control" id="hora"></div></div><a type="submit" class="btn btn-default" href="index_profesor.html">Guardar</a></form></div></div><!-- /.row --></div>');
$templateCache.put('app/extracciondatos/extracciondatosportal.html','<div><!-- Page Content --><div class="row"><div class="col-lg-12"><div class="page-header"><h2 id="navbar">Extraci&oacuten de datos</h2></div><jhi-alert-error></jhi-alert-error><form class="form-search"><div><h4>Buscar por:</h4><div class="row"><div class="col-lg-offset-1 col-lg-6"><div class="form-group"><label class="control-label" for="fiel">Dependencia</label><select required class="form-control" ng-model="vm.institucionSelected"><option ng-repeat=" institucion in vm.dependencias" value="{{institucion.id}}">{{institucion.nombre}} {{institucion.abreviatura}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-6 --><div class="col-lg-3"><div class="form-group"><label class="control-label">Nivel</label><select required class="form-control" ng-model="vm.nivelSeleccionado" ng-value="{{nivel}}" ng-options="nivel for nivel in vm.niveles" ng-change="vm.limpiar()"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --></div><!-- /.row --><div class="row"><div class="col-lg-offset-1 col-lg-2"><div class="form-group"><label class="control-label">Modelo</label><select class="form-control" required class="dropdown" ng-model="vm.modeloSeleccionado" ng-value="{{modelo}}" ng-options="modelo \n\t\t\t\t\t\t\t\t\t\tdisable when \n\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == null || vm.nivelSeleccionado == 0) ||\n\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado == \'Posgrado\' &&\n\t\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEyA\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI 2\'\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t) ||\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado != \'Posgrado\' && modelo == \'No aplica\' \n\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\tfor modelo in vm.modelos"></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><label class="control-label">A&ntildeo Escolar</label><select required class="form-control" ng-model="vm.anioSeleccionado"><option ng-repeat="anioEscolar in vm.aniosEscolares" value="{{anioEscolar.id}}">{{anioEscolar.descripcion}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --><div class="col-lg-2"><div class="input-group"><br><label><input type="checkbox" ng-model="vm.intercurso"> Intercurso</label></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-3"><div class="form-group"><label class="control-label" for="fiel">Periodo</label><!-- Periodo normal --><select class="form-control" ng-show="!vm.intercurso" required class="dropdown" ng-model="vm.indicePeriodo" ng-value="vm.indicePeriodo" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select><!-- Periodo intercurso --><select class="form-control" ng-show="vm.intercurso" required class="dropdown" ng-model="vm.indiceIntercurso" ng-value="vm.indiceIntercurso" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --></div><!-- /.row --><div class="row"><div class="col-lg-offset-1 col-lg-6"><div class="form-group"><input type="text" ng-model="vm.currentSearch" class="form-control" placeholder="Buscar por asignatura o profesor"></div><!-- /input-group --></div><!-- /.col-lg-6 --><div class="col-lg-2"><div class="form-group"><br><label><input type="checkbox" ng-model="vm.evaluacionesPendientes"> Por evaluar</label></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><br><button type="button" class="btn btn-primary" ng-click="vm.search()">Buscar</button></div><!-- /input-group --></div><!-- /.col-lg-2 --></div><!-- /.row --></div></form><table class="table table-striped table-hover"><tbody><tr ng-repeat="usuario in vm.usuarios"><td><h4>{{usuario.clase.asignaturaBase.nombre}}</h4><h6><label><div ng-switch="usuario.clase.tipoModelo"><div ng-switch-when="MEFI">{{ usuario.nivel.tipo }}, MEFI</div><div ng-switch-when="MEFI_2">{{ usuario.nivel.tipo }}, MEFI 2</div><div ng-switch-when="MEYA">{{ usuario.nivel.tipo }}, MEyA</div></div></label></h6><h6>{{usuario.nombreCompletoAAN}} - {{ usuario.clase.grupo.grupo }}</h6></td><!-- td><h4>{{usuario}}</h4></td --><td class="vcenter"><ul class="btn-group opciones-menu"><li uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="obs-menu">Observaciones<!-- <b class="caret"></b> --></a></li><li uib-dropdown class="dropdown pointer" ng-switch="usuario.evaluacion.id == null"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="eval-menu"><span ng-switch-when="false" class="glyphicon glyphicon-ok" aria-hidden="true"></span> <span ng-switch-when="true" class="glyphicon glyphicon-remove" aria-hidden="true"></span> Evaluaciones <b class="caret"></b></a><ul class="dropdown-menu multi-level" uib-dropdown-menu id="eval-menu"><!-- <li ng-switch-when="true">\n\t                                   <a ui-sref="clases.ambito({id:usuario.clase.id,idp:usuario.profesor.persona.id})" >\n\t                                   Registrar Evaluaci\xF3n</a>\n\t                                <a >Evaluaciones cerradas</a>\n\t                                </li> --><li ng-switch-when="false"><a>Forma de evaluacion: "{{usuario.evaluacion.formaDeEvaluar}}"</a></li><!--li ng-switch-when="false">\n\t                                    <a >Ver autoevaluaci\xF3n del profesor</a>\n\t                                </li--><li ng-switch-when="false"><a ng-click="vm.download(usuario.evaluacion.id)">Descargar reporte de alumnos evaluados</a></li><li ng-switch-when="false"><a ui-sref="downloadPage({ambito:usuario.evaluacion.id})">Ver resumen de alumnos evaluados.</a></li><li ng-switch-when="false"><a ng-click="vm.descargarReporteAlumnos(usuario.evaluacion.id)">Descargar Datos de alumnos evaluados</a></li><li ng-switch-when="false"><a ng-switch="vm.esLicMEFI(usuario.nivel.tipo,usuario.clase.tipoModelo)" ng-click="vm.descargarReporteProfesor(usuario.evaluacion.id)">Descargar Datos del Profesor</a></li></ul></li><li uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="obs-menu">Evidencias<!-- <b class="caret"></b> --></a></li></ul></td><jhi-alert></jhi-alert></tr></tbody></table></div></div><!-- /.row --><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-1"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-10"><div class="page-header"><h2 id="navbar">Bienvenido</h2></div><!--  <p class="lead">This is your homepage</p> --><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true">Est\xE1s logueado como "{{vm.account.login}}".</div><div class="centrarTexto" ng-switch-when="false"><h4>Bienvenido al Sistema Institucional de Evaluaci\xF3n del Desempe\xF1o Docente</h4></div><div ng-switch-when="true" class="alert alert-info text-center" ng-show="vm.hasRol()==false">No tienes Perfiles Activos.</div><div><ul><li><a href="https://www.sicei.uady.mx/siceiweb/?rvn=1">\xBFOlvidaste tu contrase&ntildea?</a></li><li>En caso de dudas o comentarios dirigirse al correo <a href="mailto:evaluacion.docente@correo.uady.mx">evaluacion.docente@correo.uady.mx</a> .</li><li>Este sitio se ve mejor en Google Chrome y Firefox.</li></ul></div><div ng-switch-when="true"><h4>Roles<ul ng-repeat="rol in vm.rolesUsuario()"><li>{{rol}}</li></ul></h4></div></div></div></div></div>');
$templateCache.put('app/observaciones/observacion-evaluacion.html','<div><!-- Page Content --><div class="row"><div class="col-lg-12"><div class="page-header"><h3>Registro de la sesi\uFFFDn observada</h3></div><form><h5>CARACTER\uFFFDSTICAS DEL PROFESOR</h5><div class="form-horizontal general-data"><div class="form-group"><label for="intitucion" class="col-sm-2 control-label">Instituci\uFFFDn:</label><div class="col-sm-10">Centro Docente</div></div><div class="form-group"><label for="pograma" class="col-sm-2 control-label">Programa Educativo:</label><div class="col-sm-10">Programa Educativo</div></div><div class="form-group"><label for="NombrePrf" class="col-sm-2 control-label">Profesor:</label><div class="col-sm-10">Nombre del Profesor</div></div></div><h5>CARACTER\uFFFDSTICAS DE LA ASIGNATURA</h5><div class="general-data form-horizontal"><div class="form-group"><label for="asignatura" class="col-sm-2 control-label">Nombre:</label><div class="col-sm-10">Asignatura</div></div><div class="form-group"><label for="semestre" class="col-sm-2 control-label">Semestre:</label><div class="col-sm-10">Semestre</div></div><div class="form-group"><label for="pd" class="col-sm-2 control-label">Tipo:</label><div class="col-sm-10"><label class="radio-label"><input type="radio" id="obl" name="group2"> Obligatoria</label><label class="radio-label"><input type="radio" id="opt" name="group2"> Optativa</label><label class="radio-label"><input type="radio" id="ins" name="group2"> Institucional</label><label class="radio-label"><input type="radio" id="lib" name="group2"> Libre</label></div></div><div class="form-group"><label for="pd" class="col-sm-2 control-label">Naturaleza:</label><div class="col-sm-10"><label class="radio-label"><input type="radio" id="obl" name="group2"> Te\uFFFDrica</label><label class="radio-label"><input type="radio" id="opt" name="group2"> Pr\uFFFDctica</label><label class="radio-label"><input type="radio" id="ins" name="group2"> Te\uFFFDrica-Pr\uFFFDctica</label></div></div></div><div class="instruction"><p><em><strong>Instrucciones.</strong> A partir de la observaci\uFFFDn, valore las intervenciones, di\uFFFDlogos y acciones del profesor y registre en el apartado siguiente.</em></p></div><div class="form-group separated"><label for="pw">Intervenciones</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><div class="form-group separated"><label for="pw">Interacci\uFFFDn</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><div class="form-group separated"><label for="pw">Estructura - secuencia</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><div class="form-group separated"><label for="pw">Observaciones e imprevistos</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><label>CIRCUNSTANCIALES: (pueden o no estar presentes en la sesi\uFFFDn).</label><ol class="no-numbers stripped-list container-fluid"><li class="form-group row"><div class="question col-sm-10">Control para el manejo de conflictos o situaciones imprevistas</div><div class="col-sm-2"><label class="radio-label"><input type="radio" id="q1_1" name="q1"> S\uFFFD</label><label class="radio-label"><input type="radio" id="q1_2" name="q1"> No</label></div></li><li class="form-group row"><div class="question col-sm-10">Uso de materiales reales o did\uFFFDcticos, pertinentes y suficientes.</div><div class="col-sm-2"><label class="radio-label"><input type="radio" id="q1_1" name="q1"> S\uFFFD</label><label class="radio-label"><input type="radio" id="q1_2" name="q1"> No</label></div></li><li class="form-group row"><div class="question col-sm-10">uso de recursos acordes a las condiciones y posibilidades de los estudiantes</div><div class="col-sm-2"><label class="radio-label"><input type="radio" id="q1_1" name="q1"> S\uFFFD</label><label class="radio-label"><input type="radio" id="q1_2" name="q1"> No</label></div></li><li class="form-group row"><div class="question col-sm-10">el uso de instrumentos de evaluaci\uFFFDn para la reflexi\uFFFDn y la toma de decisiones.</div><div class="col-sm-2"><label class="radio-label"><input type="radio" id="q1_1" name="q1"> S\uFFFD</label><label class="radio-label"><input type="radio" id="q1_2" name="q1"> No</label></div></li><li class="form-group row"><div class="question col-sm-10">formas de evaluaci\uFFFDn (autoevaluaci\uFFFDn, coevaluaci\uFFFDn, heteroevaluaci\uFFFDn, con instrumentos, etc.)</div><div class="col-sm-2"><label class="radio-label"><input type="radio" id="q1_1" name="q1"> S\uFFFD</label><label class="radio-label"><input type="radio" id="q1_2" name="q1"> No</label></div></li><li class="form-group row"><div class="question col-sm-10">cuidado y control en el uso de recursos institucionales.</div><div class="col-sm-2"><label class="radio-label"><input type="radio" id="q1_1" name="q1"> S\uFFFD</label><label class="radio-label"><input type="radio" id="q1_2" name="q1"> No</label></div></li><li class="form-group row"><div class="question col-sm-10">supervisi\uFFFDn en el uso de las instalaciones o recursos institucionales por parte de los estudiantes.</div><div class="col-sm-2"><label class="radio-label"><input type="radio" id="q1_1" name="q1"> S\uFFFD</label><label class="radio-label"><input type="radio" id="q1_2" name="q1"> No</label></div></li><li class="form-group row"><div class="question col-sm-10">Promovi\uFFFD el uso de otros materiales o recursos que complementen la formaci\uFFFDn de los estudiantes.</div><div class="col-sm-2"><label class="radio-label"><input type="radio" id="q1_1" name="q1"> S\uFFFD</label><label class="radio-label"><input type="radio" id="q1_2" name="q1"> No</label></div></li></ol><h5>Describa por cada foco de atencion las fortalezas que presenta el profesor</h5><div class="form-group separated"><label for="pw">Interacci\uFFFDn o comunicaci\uFFFDn</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n            </textarea></div><div class="form-group separated"><label for="pw">Secuencia de la sesi\uFFFDn.</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n            </textarea></div><div class="form-group separated"><label for="pw">Estrategias y actividades</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n            </textarea></div><div class="form-group separated"><label for="pw">Materiales y recursos</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n            </textarea></div><h5>CALENDARIZACI\uFFFDN</h5><h6>SESI\uFFFDN A OBSERVAR</h6><div class="form-inline form-group"><div class="form-group form-group-sm"><label for="hora" class="control-label">Hora:</label><input type="time" class="form-control" id="hora"></div><div class="form-group form-group-sm"><label for="hora" class="control-label">Fecha:</label><input type="date" class="form-control" id="hora"></div><div class="form-group form-group-sm"><label for="hora" class="control-label">Lugar:</label><input type="text" class="form-control" id="hora"></div></div><h6>RETROALIMENTACI\uFFFDN</h6><div class="form-inline"><div class="form-group form-group-sm"><label for="hora" class="control-label">Hora:</label><input type="time" class="form-control" id="hora"></div><div class="form-group form-group-sm"><label for="hora" class="control-label">Fecha:</label><input type="date" class="form-control" id="hora"></div><div class="form-group form-group-sm"><label for="hora" class="control-label">Lugar:</label><input type="text" class="form-control" id="hora"></div></div><br><div class="instruction instruction"><p><em><strong>Instrucciones.</strong> Completa de acuerdo a la reflexi\uFFFDn realizada con el profesor.</em></p></div><h4>Compromisos del profesor</h4><h5>Meta a corto plazo</h5><div class="form-group separated"><label for="pw">Periodo aproximado</label><input type="text" id="ti" class="form-control"></div><div class="form-group separated"><label for="pw">Descripci\uFFFDn(Los compromisos deben ser concretos y observables a modo de dar claridad al profesor.)</label><textarea rows="4" cols="50" class="form-control" maxlength="1000"></textarea></div><div class="form-group separated"><label for="pw">Obstaculo</label><textarea rows="4" cols="50" class="form-control" maxlength="1000"></textarea></div><h5>Meta a Mediano plazo</h5><div class="form-group separated"><label for="pw">Periodo aproximado</label><input type="text" id="ti" class="form-control"></div><div class="form-group separated"><label for="pw">Descripci\uFFFDn (Los compromisos deben ser concretos y observables a modo de dar claridad al profesor.)</label><textarea rows="4" cols="50" class="form-control" maxlength="1000"></textarea></div><div class="form-group separated"><label for="pw">Obst\uFFFDculo</label><textarea rows="4" cols="50" class="form-control" maxlength="1000"></textarea></div><div class="form-group separated"><label for="pw">Anotaciones para el acompa\uFFFDamiento del profesor.</label><textarea rows="4" cols="50" class="form-control" maxlength="1000"></textarea></div></form></div></div><a class="btn btn-default" href="index_gestor.html">Guardar</a></div><!-- /.row -->');
$templateCache.put('app/observaciones/observacion-registro.html','<div><!-- Page Content --><div class="row"><div class="col-lg-12"><div class="page-header"><h3>Registro de la sesi\uFFFDn a observar</h3></div><form><h5>CARACTER\uFFFDSTICAS DEL PROFESOR</h5><div class="form-horizontal general-data"><div class="form-group"><label for="intitucion" class="col-sm-2 control-label">Instituci\uFFFDn:</label><div class="col-sm-10">Centro Docente</div></div><div class="form-group"><label for="programa" class="col-sm-2 control-label">Programa Educativo:</label><div class="col-sm-10">Programa Educativo</div></div><div class="form-group"><label for="NombrePrf" class="col-sm-2 control-label">Profesor:</label><div class="col-sm-10">Nombre del Profesor</div></div><div class="form-group"><label for="pd" class="col-sm-2 control-label">\uFFFDHa sido observado?</label><div class="col-sm-2"><label for="pw" class="radio-label"><input type="radio" id="si" name="group"> S\uFFFD</label><label for="wd" class="radio-label"><input type="radio" id="No" name="group"> No</label></div><label for="pd" class="col-sm-2 control-label">\uFFFDCu\uFFFDntas veces?</label><div class="col-sm-1 form-group-sm"><input type="text" id="veces" class="form-control"></div></div><div class="form-group"><label for="pw" class="col-sm-12 control-label">Tiempo aproximado impartiendo la asignatura</label><div class="col-sm-10"><textarea rows="1" cols="50" class="form-control" maxlength="1000"></textarea></div></div><div class="form-group"><label for="pw" class="col-sm-12 control-label">Experiencia y formaci\uFFFDn af\uFFFDn con la asignatura.</label><div class="col-sm-10"><textarea rows="4" cols="50" class="form-control" maxlength="1000"></textarea></div></div></div><h5>CARACTER\uFFFDSTICAS DE LA ASIGNATURA</h5><div class="general-data form-horizontal"><div class="form-group"><label for="asignatura" class="col-sm-2 control-label">Nombre:</label><div class="col-sm-10">Asignatura</div></div><div class="form-group"><label for="semestre" class="col-sm-2 control-label">Semestre:</label><div class="col-sm-10">Semestre</div></div><div class="form-group"><label for="pd" class="col-sm-2 control-label">Tipo:</label><div class="col-sm-10"><label class="radio-label"><input type="radio" id="obl" name="group2"> Obligatoria</label><label class="radio-label"><input type="radio" id="opt" name="group2"> Optativa</label><label class="radio-label"><input type="radio" id="ins" name="group2"> Institucional</label><label class="radio-label"><input type="radio" id="lib" name="group2"> Libre</label></div></div><div class="form-group"><label for="pd" class="col-sm-2 control-label">Naturaleza:</label><div class="col-sm-10"><label class="radio-label"><input type="radio" id="obl" name="group2"> Te\uFFFDrica</label><label class="radio-label"><input type="radio" id="opt" name="group2"> Pr\uFFFDctica</label><label class="radio-label"><input type="radio" id="ins" name="group2"> Te\uFFFDrica-Pr\uFFFDctica</label></div></div></div><h6>CARACTERISTICAS DEL CONTENIDO</h6><div class="form-group row"><label for="pd" class="col-sm-4 control-label">Periodo en el que se encuentra el contenido:</label><div class="col-sm-8"><label class="radio-label"><input type="radio" id="obl" name="group3"> Apertura</label><label class="radio-label"><input type="radio" id="opt" name="group3"> Desarrollo</label><label class="radio-label"><input type="radio" id="ins" name="group3"> Cierre</label></div><div class="col-sm-12"><textarea rows="4" cols="50" class="form-control" maxlength="1000"></textarea></div></div><h5>CARACTERISTICAS DE LA SESI\uFFFDN</h5><div class="form-group row"><label for="pw" class="col-sm-2">Meta de la sesi\uFFFDn:</label><div class="col-sm-10"><textarea rows="1" cols="50" class="form-control" maxlength="1000"></textarea></div></div><div class="form-group row"><label for="tse" class="col-sm-2">\uFFFDTiempo de la sesion?</label><div class="col-sm-2"><input type="text" class="form-control" id="time"></div></div><div class="form-group"><label for="pw">Estrategia:</label><textarea rows="4" cols="50" class="form-control" maxlength="1000"></textarea></div><div class="form-group"><label for="pw">Expectativa de logro:</label><textarea rows="4" cols="50" class="form-control" maxlength="1000"></textarea></div><div class="form-group"><label for="pw">Obstaculos:</label><textarea rows="4" cols="50" class="form-control" maxlength="1000"></textarea></div><div class="form-group"><label for="pw">Evidencias:</label><textarea rows="4" cols="50" class="form-control" maxlength="1000"></textarea></div><div class="form-group"><label>Sugerencias o reflexiones que apoyan el desarrollo de aprendizajes y/o competencias gen\uFFFDricas:</label><div class="checkbox"><label><input type="checkbox"> Se comunica en espa\uFFFDol en forma oral y escrita en sus intervenciones profesionales y en su vida personal, utilizando correctamente el idioma.</label></div><div class="checkbox"><label><input type="checkbox">Gestiona el conocimiento en sus intervenciones profesionales y en su vida personal, de manera pertinente.</label></div><div class="checkbox"><label><input type="checkbox"> Utiliza habilidades de investigaci\uFFFDn, en sus intervenciones profesionales con rigor cient\uFFFDfico</label></div><div class="checkbox"><label><input type="checkbox"> Aplica los conocimientos en sus intervenciones profesionales en su vida personal con pertinencia</label></div><div class="checkbox"><label><input type="checkbox"> Desarrolla su pensamiento en intervenciones profesionales y personales, de manera cr\uFFFDtica, reflexiva y creativa.</label></div><div class="checkbox"><label><input type="checkbox"> Establece relaciones interpersonales, en los \uFFFDmbitos en los que se desenvuelve, de manera positiva y respetuosa..</label></div><div class="checkbox"><label><input type="checkbox"> Trabaja bajo presi\uFFFDn de manera eficaz y eficientemente.</label></div></div><div class="form-group"><label for="pw">Expectativa ante la observaci\uFFFDn:</label><textarea rows="4" cols="50" class="form-control" maxlength="1000">\n        </textarea></div><h5>CALENDARIZACI\uFFFDN</h5><h6>SESI\uFFFDN A OBSERVAR</h6><div class="form-inline"><div class="form-group form-group-sm"><label for="hora" class="control-label">Hora:</label><input type="time" class="form-control" id="hora"></div><div class="form-group form-group-sm"><label for="hora" class="control-label">Fecha:</label><input type="date" class="form-control" id="hora"></div><div class="form-group form-group-sm"><label for="hora" class="control-label">Lugar:</label><input type="text" class="form-control" id="hora"></div></div><h6>RETROALIMENTACI\uFFFDN</h6><div class="form-inline separated"><div class="form-group form-group-sm"><label for="hora" class="control-label">Hora:</label><input type="time" class="form-control" id="hora"></div><div class="form-group form-group-sm"><label for="hora" class="control-label">Fecha:</label><input type="date" class="form-control" id="hora"></div><div class="form-group form-group-sm"><label for="hora" class="control-label">Lugar:</label><input type="text" class="form-control" id="hora"></div></div><a type="submit" class="btn btn-default" href="index_gestor.html">Guardar</a></form></div></div><!-- /.row --></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Activation</h1><div class="alert alert-success" ng-show="vm.success"><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Registration</h1><div class="alert alert-success" ng-show="vm.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="Your username" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Register</button></form><p></p><div class="alert alert-warning">If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2>Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th>IP Address</th><th>User agent</th><th>Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2>User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="Your first name" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="Your last name" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2>Audits</h2><div class="row"><div class="col-md-5"><h4>Filter by date</h4><p class="input-group"><span class="input-group-addon">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span>Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span>User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span>State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span>Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span>Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2>Configuration</h2><span>Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span>Prefix</span></th><th class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2>Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7">Service Name</th><th class="col-md-2 text-center">Status</th><th class="col-md-2 text-center">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td><span class="text-capitalize">{{ vm.baseName(health.name) }}</span> {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{ health.status }}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel"><span class="text-capitalize">{{ vm.baseName(vm.currentHealth.name) }}</span> {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4>Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left">Name</th><th class="col-md-6 text-left">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4>Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2>Logs</h2><p>There are {{ vm.loggers.length }} loggers.</p><span>Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span>Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span>Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2>Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span>Refresh</span></button></p><h3>JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b>Memory</b><p><span>Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span>Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span>Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span>Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span>Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b>Garbage collections</b><div class="row"><div class="col-md-9">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics">Updating...</div><h3>HTTP requests (events per second)</h3><p><span>Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span>Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Code</th><th>Count</th><th class="text-right">Mean</th><th class="text-right"><span>Average</span> (1 min)</th><th class="text-right"><span>Average</span> (5 min)</th><th class="text-right"><span>Average</span> (15 min)</th></tr></thead><tbody><tr><td>OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td>Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td>Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3>Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Service name</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3>Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th>Cache name</th><th class="text-right">Objects</th><th class="text-right">Hits</th><th class="text-right">Misses</th><th class="text-right">Eviction count</th><th class="text-right">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span>Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right">Count</th><th class="text-right">Mean</th><th class="text-right">Min</th><th class="text-right">p50</th><th class="text-right">p75</th><th class="text-right">p95</th><th class="text-right">p99</th><th class="text-right">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show">Show StackTrace</span> <span ng-show="show">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right">Blocked Time</th><th class="text-right">Blocked Count</th><th class="text-right">Waited Time</th><th class="text-right">Waited Count</th><th>Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span>User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span>Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span>First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span>Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span>Email</span></dt><dd>{{vm.user.email}}</dd><dt><span>Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span>Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span>Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span>Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span>Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span>Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label>ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label>Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span>Activated</span></label></div><div class="form-group"><label>Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2>Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span>Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span>ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span>Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span>Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th><span>Profiles</span></th><th jh-sort-by="createdDate"><span>Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span>Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span>Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" style="cursor: pointer">Activated</span></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Inicia Sesi\xF3n</h4></div><div class="modal-body"><div class="row"><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError"><strong>No se pudo iniciar sesi\xF3n.</strong> Por favor, revisa e int\xE9ntalo de nuevo.</div></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-info"><strong>Inicia sesi\xF3n con tu cuenta de SICEI.</strong></div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username">Usuario</label><input type="text" class="form-control" id="username" placeholder="Tu usuario" ng-model="vm.username"></div><div class="form-group"><label for="password">Contrase\xF1a</label><input type="password" class="form-control" id="password" placeholder="Tu contrase\xF1a" ng-model="vm.password"></div><button type="submit" class="btn btn-primary">Iniciar sesi\xF3n</button></form></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav id="main-menu" class="navbar navbar-default container" role="navigation"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button><h1 id="logo"><a href="#/" ng-click="vm.collapseNavbar()">UADY</a></h1></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm">Inicio</span></a></li><li><a ui-sref="adminactividades" ng-click="vm.collapseNavbar()" has-any-authority="ADMINISTRATIVO_GENERAL_SIDE, ADMINISTRATIVO_BACHILLERATO_SIDE"><span class="glyphicon glyphicon-calendar"></span>&nbsp; <span>Actividades</span></a></li><!-- <li has-authority="ATI_EVALUACION_DOCENTE" uib-dropdown class="dropdown pointer">\n\t\t\t\t<a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"> \n\t\t\t\t\t<span> \n\t\t\t\t\t\t<span class="glyphicon glyphicon-th-list"></span> \n\t\t\t\t\t\t<span class="hidden-sm"> Administrar usuarios </span> \n\t\t\t\t\t\t<b class="caret"></b>\n\t\t\t\t\t</span>\n\t\t\t\t</a>\n\t\t\t\t<ul class="dropdown-menu" uib-dropdown-menu>\n\t\t\t\t\t<li ui-sref-active="active">\n\t\t\t\t\t\t<a ui-sref="ati" ng-click="vm.collapseNavbar()"> \n\t\t\t\t\t\t\t<span class="glyphicon glyphicon-asterisk"></span>&nbsp; \n\t\t\t\t\t\t\t<span>ATI\'S</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li ui-sref-active="active">\n\t\t\t\t\t\t<a ui-sref="admgestor" ng-click="vm.collapseNavbar()"> \n\t\t\t\t\t\t\t<span class="glyphicon glyphicon-asterisk"></span>&nbsp; \n\t\t\t\t\t\t\t<span>Gestores Academicos</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li ui-sref-active="active">\n\t\t\t\t\t\t<a ui-sref="admeval" ng-click="vm.collapseNavbar()"> \n\t\t\t\t\t\t\t<span class="glyphicon glyphicon-asterisk"></span>&nbsp; \n\t\t\t\t\t\t\t<span>Administradores Evaluacion Docente</span>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t</li>\n\t\t\t\t\tjhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here\n\t\t\t\t</ul>\n\t\t\t</li> --><li has-any-authority="RESPONSABLE_SIDE, ADMINISTRATIVO_GENERAL_SIDE, PROFESOR, ADMINISTRATIVO_BACHILLERATO_SIDE" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-file"></span> <span class="hidden-sm">Reportes </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="reporteevaluativo" ng-click="vm.collapseNavbar()" has-any-authority="ADMINISTRATIVO_GENERAL_SIDE, ADMINISTRATIVO_BACHILLERATO_SIDE"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Reporte Evaluativo</span></a></li><li><a ui-sref="extracciondatos" ng-click="vm.collapseNavbar()" has-any-authority="ADMINISTRATIVO_GENERAL_SIDE, RESPONSABLE_SIDE, ADMINISTRATIVO_BACHILLERATO_SIDE"><span class="glyphicon glyphicon-calendar"></span>&nbsp; <span>Extracci&oacuten de Datos</span></a></li><li><a ui-sref="reporteprofesor" ng-click="vm.collapseNavbar()" has-authority="PROFESOR"><span class="glyphicon glyphicon-calendar"></span>&nbsp; <span>Mis Evaluaciones</span></a></li><li><a ui-sref="revision" ng-click="vm.collapseNavbar()" has-authority="RESPONSABLE_SIDE"><span class="glyphicon glyphicon-calendar"></span>&nbsp; <span>Revisar Evaluaciones</span></a></li><li><a ui-sref="reporteglobal" ng-click="vm.collapseNavbar()" has-authority="ADMINISTRATIVO_GENERAL_SIDE"><span class="glyphicon glyphicon-calendar"></span>&nbsp; <span>Reporte Global</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><!--   <li>\n                 \t<a ui-sref="extracciondatos" ng-click="vm.collapseNavbar()" has-authority="ADMINISTRATIVO_GENERAL_SIDE">\n                    \t<span class="glyphicon glyphicon-calendar"></span>&nbsp;\n                    \t<span>Extracci&oacuten de Datos</span>\n                    </a>\n                 </li> --><li><a ui-sref="clases" ng-click="vm.collapseNavbar()" has-any-authority="RESPONSABLE_SIDE, ADMINISTRATIVO_GENERAL_SIDE, ADMINISTRATIVO_BACHILLERATO_SIDE"><span class="glyphicon glyphicon-th-list"></span>&nbsp; <span>Clases</span></a></li><li><a ui-sref="docente" ng-click="vm.collapseNavbar()" has-authority="PROFESOR"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>Docente</span></a></li><li><a ui-sref="alumno" ng-click="vm.collapseNavbar()" has-authority="ALUMNO"><span class="glyphicon glyphicon-user"></span>&nbsp; <span>Estudiante</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span>Cerrar Sesi\xF3n</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span>Iniciar Sesi\xF3n</span></a></li></ul></div></nav>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div class="alert alert-danger">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1>Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/reportes/reporteGlobal/reporteglobal.html','<div><div class="row"><div class="col-lg-12"><div class="page-header"><h2 id="navbar">Reporte Global</h2></div><jhi-alert-error></jhi-alert-error><form class="form-search"><div><h4>Buscar por:</h4><div class="row"><div class="col-lg-offset-1 col-lg-6"><div class="form-group"><label class="control-label" for="fiel">Dependencia</label><select required class="form-control" ng-model="vm.institucionSelected"><option ng-repeat=" institucion in vm.dependencias" value="{{institucion.id}}">{{institucion.nombre}} {{institucion.abreviatura}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-6 --><div class="col-lg-3"><div class="form-group"><label class="control-label">Nivel</label><select required class="form-control" ng-model="vm.nivelSeleccionado" ng-value="{{nivel}}" ng-options="nivel for nivel in vm.niveles" ng-change="vm.limpiar()"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --></div><!-- /.row --><div class="row"><div class="col-lg-offset-1 col-lg-2"><div class="form-group"><label class="control-label">Modelo</label><select required class="form-control" ng-model="vm.modeloSeleccionado" ng-value="{{modelo}}" ng-options="modelo \n\t\t\t\t\t\t\t\t\t\tdisable when \n\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == null || vm.nivelSeleccionado == 0) ||\n\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Posgrado\' && modelo == \'MEyA\') ||\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Posgrado\' && modelo == \'MEFI\') ||\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Posgrado\' && modelo == \'MEFI 2\') ||\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Posgrado\' && modelo == \'No aplica\')  ||\n\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Licenciatura\' && modelo == \'MEyA\') ||\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Licenciatura\' && vm.institucionSelected !=65 && modelo == \'No aplica\') ||\n\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Licenciatura\' && vm.institucionSelected ==65 && modelo == \'MEyA\') ||\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Licenciatura\' && vm.institucionSelected ==65 && modelo == \'MEFI\') ||\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Licenciatura\' && vm.institucionSelected ==65 && modelo == \'MEFI 2\') ||\n\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Bachiller\' && vm.institucionSelected ==52 && modelo == \'MEyA\') ||\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Bachiller\' && vm.institucionSelected ==52 && modelo == \'MEFI\') ||\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Bachiller\' && vm.institucionSelected ==52 && modelo == \'MEFI 2\') ||\n\t\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == \'Bachiller\' && vm.institucionSelected !=52 && modelo == \'No aplica\') \n\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\tfor modelo in vm.modelos"></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><label class="control-label">A&ntildeo Escolar</label><select required class="form-control" ng-model="vm.anioSeleccionado"><option ng-repeat="anioEscolar in vm.aniosEscolares" value="{{anioEscolar.id}}">{{anioEscolar.descripcion}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --><div class="col-lg-2"><div class="input-group"><br><label><input type="checkbox" ng-model="vm.intercurso"> Intercurso</label></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><label class="control-label" for="fiel">Periodo</label><!-- Periodo normal --><select class="form-control" ng-show="!vm.intercurso" required class="dropdown" ng-model="vm.indicePeriodo" ng-value="vm.indicePeriodo" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select><!-- Periodo intercurso --><select class="form-control" ng-show="vm.intercurso" required class="dropdown" ng-model="vm.indiceIntercurso" ng-value="vm.indiceIntercurso" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><br><button type="button" class="btn btn-primary" ng-click="vm.download(vm.indicePeriodo,vm.intercurso,vm.indiceIntercurso,vm.anioSeleccionado,vm.modeloSeleccionado,vm.nivelSeleccionado,vm.institucionSelected)">Descargar</button></div><!-- /input-group --></div><!-- /.col-lg-2 --></div><!-- /.row --></div></form></div></div></div>');
$templateCache.put('app/reportes/reporteevaluativo/reporteevaluativo.html','<div><!-- Page Content --><div class="row"><div class="col-lg-12"><div class="page-header"><h2 id="navbar">Reportes</h2></div><jhi-alert-error></jhi-alert-error><form class="form-search"><div><h4>Buscar por:</h4><div class="row"><div class="col-lg-offset-1 col-lg-6"><div class="form-group"><label class="control-label" for="fiel">Dependencia</label><select required class="form-control" ng-model="vm.institucionSelected"><option ng-repeat=" institucion in vm.dependencias" value="{{institucion.id}}">{{institucion.nombre}} {{institucion.abreviatura}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-6 --><div class="col-lg-3"><div class="form-group"><label class="control-label">Nivel</label><select required class="form-control" ng-model="vm.nivelSeleccionado" ng-value="{{nivel}}" ng-options="nivel for nivel in vm.niveles" ng-change="vm.limpiar()"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --></div><!-- /.row --><div class="row"><div class="col-lg-offset-1 col-lg-2"><div class="form-group"><label class="control-label">Modelo</label><select required class="form-control" ng-model="vm.modeloSeleccionado" ng-value="{{modelo}}" ng-options="modelo \n\t\t\t\t\t\t\t\t\t\tdisable when \n\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == null || vm.nivelSeleccionado == 0) ||\n\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado == \'Posgrado\' &&\n\t\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEyA\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI 2\'\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t) ||\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado != \'Posgrado\' && modelo == \'No aplica\' \n\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\tfor modelo in vm.modelos"></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><label class="control-label">A&ntildeo Escolar</label><select required class="form-control" ng-model="vm.anioSeleccionado"><option ng-repeat="anioEscolar in vm.aniosEscolares" value="{{anioEscolar.id}}">{{anioEscolar.descripcion}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --><div class="col-lg-2"><div class="input-group"><br><label><input type="checkbox" ng-model="vm.intercurso"> Intercurso</label></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-3"><div class="form-group"><label class="control-label" for="fiel">Periodo</label><!-- Periodo normal --><select class="form-control" ng-show="!vm.intercurso" required class="dropdown" ng-model="vm.indicePeriodo" ng-options="periodo for periodo in vm.periodos"><option value=""></option></select><!-- Periodo intercurso --><select class="form-control" ng-show="vm.intercurso" required class="dropdown" ng-model="vm.indiceIntercurso" ng-options="periodo for periodo in vm.periodos"><option value=""></option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --></div><!-- /.row --><div class="row"><div class="col-lg-offset-1 col-lg-6"><div class="form-group"><input type="text" ng-model="vm.currentSearch" class="form-control" placeholder="Buscar por asignatura o profesor"></div><!-- /input-group --></div><!-- /.col-lg-6 --><div class="col-lg-1"><div class="form-group"><label><input type="checkbox" ng-model="vm.evaluacionesPendientes"> Por evaluar</label></div><!-- /input-group --></div><!-- /.col-lg-1 --><div class="col-lg-3"><div class="form-group"><button type="button" class="btn btn-primary" ng-click="vm.search()">Buscar</button> <button type="button" class="btn btn-primary" ng-click="vm.generarReportesMasivos()">Generar reportes</button></div><!-- /input-group --></div><!-- /.col-lg-2 --></div><!-- /.row --></div></form><table class="table table-striped table-hover"><tbody><tr ng-repeat="wrapper in vm.wrappers | filter: {hayevaluaciones:busquedagestornoevaluados}| filter: busquedagestor track by wrapper.id"><!-- tr ng-repeat="usuario in vm.usuarios | filter: {hayevaluaciones:busquedagestornoevaluados}| filter: busquedagestor:{nombreCompletoAAN,clase:{ asignaturaBase:{ nombre}}} track by usuario.id"--><!-- tr ng-repeat="usuario in vm.usuarios | filter: {hayevaluaciones:busquedagestornoevaluados}| filter: {clase:{ asignaturaBase:{ nombre:busquedagestor}}} track by usuario.id"--><!-- tr ng-repeat="usuario in vm.usuarios | filter: {hayevaluaciones:busquedagestornoevaluados} track by usuario.id" --><td><h4>{{wrapper.asignatura.nombre}}</h4><h6><label><div ng-switch="wrapper.clase.tipoModelo"><div ng-switch-when="MEFI">{{ wrapper.tipoN }}, MEFI</div><div ng-switch-when="MEFI_2">{{ wrapper.tipoN }}, MEFI 2</div><div ng-switch-when="MEYA">{{ wrapper.tipoN }}, MEyA</div></div></label></h6><h6>{{wrapper.nombreCompletoAAN}} - {{ wrapper.formaEvaluacion}} - {{ wrapper.clase.grupo.grupo }}</h6><h6>{{wrapper.plan}}</h6></td><!-- td><h4>{{usuario}}</h4></td --><td class="vcenter"><ul class="btn-group opciones-menu"><li uib-dropdown class="dropdown pointer" ng-switch="wrapper.hasReporte"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="eval-menu"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Reporte <b class="caret"></b></a><ul class="dropdown-menu multi-level" uib-dropdown-menu id="eval-menu"><li ng-switch-when="false"><a ui-sref="generarReporteOO({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Obligatoria\'}}">Generar Reporte Evaluativo OB </a><a ui-sref="generarReporteLic({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'licenciatura general\'}}">Generar Reporte Evaluativo licenciatura general </a><a ui-sref="generarReporteOO({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Optativa\'}}">Generar Reporte Evaluativo OP </a><a ui-sref="generarReporteLI({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Libre\'}}">Generar Reporte Evaluativo LI </a><a ui-sref="generarReporteCU({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Curso \xDAnico\'}}">Generar Reporte Evaluativo CU </a><a ui-sref="generarReporteRegular({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Regular\'}}">Generar Reporte Evaluativo Regular </a><a ui-sref="generarReporteVirtual({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Virtual\'}}">Generar Reporte Evaluativo Virtual </a><a ui-sref="generarReporteUAEV({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'UAEV\'}}">Generar Reporte Evaluativo UAEV </a><a ui-sref="generarReporteBachillerato({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Bachillerato\'}}">Generar Reporte Evaluativo Bachillerato </a><a ui-sref="generarReporteMixtoPII({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo,grupo:wrapper.clase.grupo.grupo})" ng-show="{{ wrapper.formaEvaluacion == \'Mixto PII\'}}">Generar Reporte Evaluativo Mixto PII </a><a ui-sref="generarReporteVirtualPII({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo,grupo:wrapper.clase.grupo.grupo})" ng-show="{{ wrapper.formaEvaluacion == \'Virtual PII\'}}">Generar Reporte Evaluativo Virtual PII </a><!-- <a >Evaluaciones cerradas</a> --></li><li ng-switch-when="true"><a ui-sref="generarReporteOO({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Obligatoria\'}}">Ver Reporte Evaluativo </a><a ui-sref="generarReporteOO({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Optativa\'}}">Ver Reporte Evaluativo </a><a ui-sref="generarReporteLic({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'licenciatura general\'}}">Ver Reporte Evaluativo </a><a ui-sref="generarReporteLI({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Libre\'}}">Ver Reporte Evaluativo </a><a ui-sref="generarReporteCU({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Curso \xDAnico\'}}">Ver Reporte Evaluativo CU </a><a ui-sref="generarReporteRegular({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Regular\'}}">Ver Reporte Evaluativo Regular </a><a ui-sref="generarReporteVirtual({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Virtual\'}}">Ver Reporte Evaluativo Virtual </a><a ui-sref="generarReporteUAEV({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'UAEV\'}}">Ver Reporte Evaluativo UAEV </a><a ui-sref="generarReporteBachillerato({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Bachillerato\'}}">Ver Reporte Evaluativo Bachillerato </a><a ui-sref="generarReporteMixtoPII({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo,grupo:wrapper.clase.grupo.id})" ng-show="{{ wrapper.formaEvaluacion == \'Mixto PII\'}}">Ver Reporte Evaluativo Mixto PII </a><a ui-sref="generarReporteVirtualPII({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo,grupo:wrapper.clase.grupo.id})" ng-show="{{ wrapper.formaEvaluacion == \'Virtual PII\'}}">Ver Reporte Evaluativo Virtual PII </a><a ui-sref="volvergenerarReporteOO({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Obligatoria\'}}">Volver a generar Reporte Evaluativo </a><a ui-sref="volvergenerarReporteOO({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Optativa\'}}">Volver a generar Reporte Evaluativo </a><a ui-sref="volvergenerarReporteLic({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'licenciatura general\'}}">Volver a generar Reporte Evaluativo </a><a ui-sref="volvergenerarReporteLI({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Libre\'}}">Volver a generar Reporte Evaluativo </a><a ui-sref="volvergenerarReporteCU({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Curso \xDAnico\'}}">Volver a generar Reporte Evaluativo CU </a><a ui-sref="volvergenerarReporteRegular({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Regular\'}}">Volver a generar Reporte Evaluativo Regular </a><a ui-sref="volvergenerarReporteVirtual({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Virtual\'}}">Volver a generar Reporte Evaluativo Virtual </a><a ui-sref="volvergenerarReporteUAEV({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'UAEV\'}}">Volver a generar Reporte Evaluativo UAEV </a><a ui-sref="volvergenerarReporteBachillerato({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo})" ng-show="{{ wrapper.formaEvaluacion == \'Bachillerato\'}}">Volver a generar Reporte Evaluativo Bachillerato </a><a ui-sref="volvergenerarReporteMixtoPII({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo,grupo:wrapper.clase.grupo.id})" ng-show="{{ wrapper.formaEvaluacion == \'Mixto PII\'}}">Volver a generar Reporte Evaluativo Mixto PII </a><a ui-sref="volvergenerarReporteVirtualPII({idA:wrapper.asignatura.id,idP:wrapper.profesor.id,idAnio:vm.anioSeleccionado,idIndice:vm.indicePeriodo,ic:vm.intercurso,iic:vm.indiceIntercurso,tipoEvaluacion:wrapper.formaEvaluacion,idDependencia:vm.institucionSelected,nivell:wrapper.tipoN,modeloo:wrapper.clase.tipoModelo,grupo:wrapper.clase.grupo.id})" ng-show="{{ wrapper.formaEvaluacion == \'Virtual PII\'}}">Volver a generar Reporte Evaluativo Virtual PII</a></li></ul></li></ul></td><jhi-alert></jhi-alert></tr></tbody></table></div></div><!-- /.row --><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/reportes/reporteevaluativoBachillerato/reporteevaluativoBachillerato.html','<div><!-- Page Content --><div class="page-header"><!--  <h2 id="navbar">Reporte Asignaturas de UAEV</h2> --><div class="text-center"><div class="title hidden-print clearfix" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><div class="pull-left form-inline"><label for="exampleInputName2">Fase del reporte:</label><select required class="mydropdown hidden-print" ng-model="vm.reporte.status" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><option value="editar" ng-show="{{vm.wrapper.tipoUser ==\'1\'}}">Edici&oacuten</option><option value="revisar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Revisi&oacuten</option><option value="liberar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Liberaci&oacuten</option></select></div><div class="pull-right"><button ng-disabled="vm.isSaving" ng-click="vm.save()" class="btn btn-warning btn-main hidden-print" type="submit" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><span class="glyphicon"></span>&nbsp;<span>Guardar/Actualizar</span></button> <a class="btn btn-primary text-center" ui-sref="reporteevaluativo">Regresar</a></div></div><div><a class="btn btn-primary next text-center hidden-print" ng-click="vm.print()">Imprimir Reporte</a></div></div></div><jhi-alert-error></jhi-alert-error><section style="text-align: center"><h4><div>UNIVERSIDAD AUT&OacuteNOMA DE YUCAT&AacuteN</div><div>Direcci&oacuten General de Desarrollo Acad&eacutemico</div><div>Coordinaci&oacuten General del Sistema de Educaci&oacuten Media Superior</div><br><br><div>Prepa</div><div>{{vm.reporte.institucion.nombre}}</div></h4></section><br><br><section style="text-align: center"><h4>DATOS GENERALES DEL PROFESORADO</h4></section><table class="table table-bordered type-a reportetable"><tr><th>Profesor</th><td>{{vm.reporte.profesor.nombres}} {{vm.reporte.profesor.apellidoPaterno}} {{vm.reporte.profesor.apellidoMaterno}}</td></tr><tr><th>Asignatura</th><td>{{vm.reporte.asignatura.nombre}}</td></tr><tr><th>No.Estudiantes que evaluaron</th><td>{{vm.reporte.totalAlumnos}} de {{vm.wrapper.numTotalAlumnos}}</td></tr><tr><th>Periodo</th><td>{{vm.wrapper.periodoEvaluacion}}</td></tr><tr><th>A&ntildeo escolar</th><td>{{vm.reporte.anioEscolar.descripcion}}</td></tr></table><br><br><div class="reportebody">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A continuaci&oacuten, se presentan los resultados de su evaluaci&oacuten de desempe&ntildeo docente del periodo acorde a la percepci&oacuten de los estudiantes y su autoevaluaci&oacuten. En este informe se presenta la media y el nivel de desempe&ntildeo (ver anexo 1 para la descripci&oacuten de los niveles de desempe&ntildeo) obtenidos en cada dimensi&oacuten evaluada (ver anexo 2 para la descripci&oacuten de las dimensiones).<br></div><br><br><div class="reportebody"><h4 style="background-color: #ffb60f; color: white; text-align: center; font-size: 15px; padding: 11px">SECCI&OacuteN I. CONCENTRADO DE LAS MEDIAS POR DIMENSI&OacuteN EVALUADA</h4><br><br><table class="table table-bordered"><tr><th>Estrategias de ense&ntildeanza y aprendizaje</th><th>Media (1-4)</th><th>Nivel de desempe&ntildeo</th></tr><tr><td>Estudiantes</td><td>{{ vm.dosDecimales(vm.reporte.estEnzE) }}</td><td>{{ vm.nivelObtenido(vm.dosDecimales(vm.reporte.estEnzE)) }}</td></tr><tr><td>Autoevaluaci&oacuten</td><td>{{ vm.dosDecimales(vm.reporte.estEnzP) }}</td><td>{{ vm.nivelObtenido(vm.dosDecimales(vm.reporte.estEnzP)) }}</td></tr></table><br><table class="table table-bordered"><tr><th>Competencia Socioemocional</th><th>Media (1-4)</th><th>Nivel de desempe&ntildeo</th></tr><tr><td>Estudiantes</td><td>{{ vm.dosDecimales(vm.reporte.compSocioE) }}</td><td>{{ vm.nivelObtenido(vm.dosDecimales(vm.reporte.compSocioE)) }}</td></tr><tr><td>Autoevaluaci&oacuten</td><td>{{ vm.dosDecimales(vm.reporte.compSocioP) }}</td><td>{{ vm.nivelObtenido(vm.dosDecimales(vm.reporte.compSocioP)) }}</td></tr></table><br><table class="table table-bordered"><tr><th>Competencia evaluativa</th><th>Media (1-4)</th><th>Nivel de desempe&ntildeo</th></tr><tr><td>Estudiantes</td><td>{{ vm.dosDecimales(vm.reporte.compEvE) }}</td><td>{{ vm.nivelObtenido(vm.dosDecimales(vm.reporte.compEvE)) }}</td></tr><tr><td>Autoevaluaci&oacuten</td><td>{{ vm.dosDecimales(vm.reporte.compEvP) }}</td><td>{{ vm.nivelObtenido(vm.dosDecimales(vm.reporte.compEvP)) }}</td></tr></table><br><table class="table table-bordered"><tr><th>Ambientes de aprendizaje</th><th>Media (1-4)</th><th>Nivel de desempe&ntildeo</th></tr><tr><td>Estudiantes</td><td>{{ vm.dosDecimales(vm.reporte.ampAprE) }}</td><td>{{ vm.nivelObtenido(vm.dosDecimales(vm.reporte.ampAprE)) }}</td></tr><tr><td>Autoevaluaci&oacuten</td><td>{{ vm.dosDecimales(vm.reporte.ampAprP) }}</td><td>{{ vm.nivelObtenido(vm.dosDecimales(vm.reporte.ampAprP)) }}</td></tr></table><br><table class="table table-bordered"><tr><th>Manejo de recursos did&aacutecticos y tecnol&oacutegicos</th><th>Media (1-4)</th><th>Nivel de desempe&ntildeo</th></tr><tr><td>Estudiantes</td><td>{{ vm.dosDecimales(vm.reporte.manRecDyTE) }}</td><td>{{ vm.nivelObtenido(vm.dosDecimales(vm.reporte.manRecDyTE)) }}</td></tr><tr><td>Autoevaluaci&oacuten</td><td>{{ vm.dosDecimales(vm.reporte.manRecDyTP) }}</td><td>{{ vm.nivelObtenido(vm.dosDecimales(vm.reporte.manRecDyTP)) }}</td></tr></table></div><br><div class="reportebody"><h4 style="background-color: #ffb60f; color: white; text-align: center; font-size: 15px; padding: 11px">SECCI&OacuteN II. COMENTARIOS DE LOS ESTUDIANTES</h4><br><p align="center"><b>Actividades realizadas que favorecieron el aprendizaje</b></p><p>A trav\xE9s de los comentarios recuperados del Instrumento por parte del estudiantado, se obtuvieron las siguientes respuestas</p><br><div class="title" style="text-align: center"><div class="title" style="text-align: left">Respuestas</div><div><textarea rows="{{vm.wrapper.actsRealizadasE.length==0?0:vm.wrapper.actsRealizadasE.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="actsRealizadasE" ng-model="vm.wrapper.actsRealizadasE" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.actsRealizadasE}}</textarea></div></div><br><p align="center"><b>Actividades sugeridas para mejorar el aprendizaje</b></p><p>A trav\xE9s de los comentarios recuperados del Instrumento por parte del estudiantado, se obtuvieron las siguientes propuestas</p><br><div class="title" style="text-align: center"><div class="title" style="text-align: left">Respuestas</div><div><textarea rows="{{vm.wrapper.actsSugeridasE.length==0?0:vm.wrapper.actsSugeridasE.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="actsSugeridasE" ng-model="vm.wrapper.actsSugeridasE" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.actsSugeridasE}}</textarea></div></div></div><br><div class="reportebody"><h4 style="text-align: center">Descripci&oacuten de los niveles de desempe&ntildeo</h4><br><br><table class="table table-bordered"><tr><th>Rango en media</th><th>Nivel de desempe&ntildeo</th><th>Descripci&oacuten</th></tr><tr><td>3.72-4</td><td><strong>Sobresaliente</strong></td><td>El profesorado demuestra un desempe&ntildeo superior al promedio en cada dimensi&oacuten evaluada, lo que denota un alto compromiso con su desarrollo profesional e identidad institucional de acuerdo al perfil deseable del profesorado de la UADY.</td></tr><tr><td>3.27-3.71</td><td><strong>Satisfactorio</strong></td><td>El profesorado demuestra un desempe&ntildeo acorde a las dimensiones evaluadas, lo que denota compromiso con su desarrollo profesional e identidad institucional de acuerdo al perfil deseable del profesorado de la UADY.</td></tr><tr><td>2.94-3.26</td><td><strong>Suficiente</strong></td><td>El profesorado cumple con el desempe&ntildeo esperado, sin embargo, demuestra oportunidades de mejora en algunas dimensiones evaluadas, por lo que se sugiere considerar estrategias y acciones que denoten compromiso con su desarrollo profesional e identidad institucional de acuerdo con el perfil deseable del profesorado de la UADY.</td></tr><tr><td>1-2.93</td><td><strong>Necesita mejorar</strong></td><td>El profesorado cumple parcialmente con el desempe&ntildeo esperado, demuestra necesidades de capacitaci&oacuten y/o actualizaci&oacuten, adem&aacutes requiere seguimiento a su desempe&ntildeo docente, por lo que se sugiere considerar estrategias y acciones que denoten compromiso con su desarrollo profesional e identidad institucional de acuerdo con el perfil deseable del profesorado de la UADY.</td></tr></table></div><br><div class="reportebody"><h4 style="text-align: center">Descripci&oacuten de las dimensiones evaluadas</h4><br><br><table class="table table-bordered"><tr><th>Dimensi&oacuten</th><th>Definici&oacuten</th></tr><tr><td><strong>1. Estrategias de ense&ntildeanza y aprendizaje</strong></td><td>Esta dimensi&oacuten hace referencia a los procedimientos y recursos que docentes y estudiantes emplean para lograr aprendizajes significativos.</td></tr><tr><td><strong>2.Competencia socioemocional</strong></td><td>Son aquellas acciones que implementa el profesorado para promover la motivaci&oacuten del estudiante, as&iacute como favorecer relaciones de respeto con otros y hacia la sociedad con la finalidad de permitir el desarrollo integral.</td></tr><tr><td><strong>3. Competencia evaluativa</strong></td><td>Esta dimensi&oacuten del desempe&ntildeo docente hace referencia a las acciones y procesos que el profesorado emprende para conocer el nivel de logro de las competencias desarrolladas por el estudiantado en determinados contenidos.</td></tr><tr><td><strong>4. Ambientes de aprendizaje</strong></td><td>Esta dimensi&oacuten del desempe&ntildeo docente hace referencia a la manera en que el profesorado promueve la creaci&oacuten de un clima propicio para el desarrollo del proceso formativo dentro y fuera del sal&oacuten de clase.</td></tr><tr><td><strong>5. Manejo de recursos did&aacutecticos y tecnol&oacutegicos</strong></td><td>Esta dimensi&oacuten del desempe&ntildeo docente hace referencia a las habilidades y conocimientos que posee el profesorado para la implementaci&oacuten pr&aacutectico pedag&oacutegica de las TIC y otros materiales innovadores para mejorar el proceso de ense&ntildeanza y aprendizaje.</td></tr></table></div></div>');
$templateCache.put('app/reportes/reporteevaluativoCU/reporteevaluativoCU.html','<div><!-- Page Content --><div class="page-header"><div class="text-center"><div class="title hidden-print clearfix" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><div class="pull-left form-inline"><label for="exampleInputName2">Fase del reporte:</label><select required class="form-control hidden-print" ng-model="vm.reporte.status" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><option value="editar" ng-show="{{vm.wrapper.tipoUser ==\'1\'}}">Edici&oacuten</option><option value="revisar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Revisi&oacuten</option><option value="liberar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Liberaci&oacuten</option></select></div><div class="pull-right"><button ng-disabled="vm.isSaving" ng-click="vm.save()" class="btn btn-warning btn-main hidden-print" type="submit" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><span class="glyphicon"></span>&nbsp;<span>Guardar/Actualizar</span></button> <a class="btn btn-primary text-center" ui-sref="reporteevaluativo">Regresar</a></div></div><div><a class="btn btn-primary next text-center hidden-print" ng-click="vm.print()">Imprimir Reporte</a></div></div></div><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><section style="text-align: center"><h4><div>UNIVERSIDAD AUT&OacuteNOMA DE YUCAT&AacuteN</div><div>Direcci&oacuten General de Desarrollo Acad&eacutemico</div><div>Departamento de Innovaci&oacuten e Investigaci&oacuten Educativa</div><div>PROGRAMA INSTITUCIONAL DE EVALUACI&OacuteN DEL DESEMPE&NtildeO DOCENTE</div><br><br><div>{{vm.reporte.institucion.padre.nombre}}</div><div>{{vm.reporte.institucion.nombre}}</div></h4></section><br><br><table class="table table-bordered type-a reportetable"><tr><th>Profesor</th><td>{{vm.reporte.profesor.nombres}} {{vm.reporte.profesor.apellidoPaterno}} {{vm.reporte.profesor.apellidoMaterno}}</td></tr><tr><th>Asignatura</th><td>{{vm.reporte.asignatura.nombre}}</td></tr><tr><th>No.Estudiantes que evaluaron</th><td>{{vm.reporte.numEstudiantes}} de {{vm.wrapper.numTotalAlumnos}}</td></tr><tr><th>Periodo</th><td>{{vm.wrapper.periodoEvaluacion}}</td></tr><tr><th>A&ntildeo escolar</th><td>{{vm.reporte.anioEscolar.descripcion}}</td></tr></table><br><br><div class="reportebody"><strong>CONTENIDO DE LAS SECCIONES</strong><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;El instrumento que se administr&oacute estuvo constituido por 27 preguntas que se clasifican para su interpretaci&oacuten, en las siguientes categor&iacuteas:<br><div class="title">I. Cumplimiento</div>* En esta categor&iacutea se desea conocer el cumplimiento en la asistencia y puntualidad del profesor a las clases programadas, as&iacute como de la presentaci&oacuten del programa de curso y la aclaraci&oacuten de dudas de los estudiantes.<br><div class="title">II. Planeaci&oacuten</div>* Esta categor&iacutea tiene como objetivo evaluar la forma en la que el profesor aprovecha el tiempo asignado a sus clases, al igual que si el profesor da a conocer los objetivos y prop&oacutesitos de cada sesi&oacuten.<br><div class="title">III. Estrategias did&aacutecticas</div>* Esta categor&iacutea eval&uacutea la efectividad del docente para que sus estudiantes adquieran conocimientos, habilidades y actitudes relevantes; esto mediante el uso adecuado de estrategias did&aacutecticas.<br><div class="title">IV. Actitud del profesor</div>* Esta categor&iacutea eval&uacutea el cumplimiento del docente respecto a los objetivos formativos de la universidad, as&iacute como la apreciaci&oacuten de su comportamiento &eacuteatico en el aula y fuera de ella.<br><div class="title">V. Comunicaci&oacuten</div>* Esta categor&iacutea eval&uacutea el dominio de habilidades comunicativas del profesor.<br><div class="title">VI. Evaluaci&oacuten de los aprendizajes</div>* Esta categor&iacutea eval&uacutea la oportunidad, coherencia y justicia con la que el profesor eval&uacutea los aprendizajes de los estudiantes.<br><div class="title">VII. Espec&iacuteficas de cada &aacuterea de conocimiento</div>* Esta categor&iacutea eval&uacutea el grado de conocimiento y dominio de los temas de la asignatura.<br><div class="title">VIII.Satisfacci&oacuten</div>* Esta categor&iacutea eval&uacutea el desempe&ntildeo del profesor a lo largo del curso, as&iacute como la satisfacci&oacuten por los aprendizajes logrados por parte de los estudiantes.<br></div><br><div class="reportebody"><strong>I. NIVEL DE DESEMPE&NtildeO POR CATEGOR&IacuteA.</strong><br><br><table class="table table-bordered type-a"><tr><th><h3>PROMEDIO GLOBAL</h3></th><th><h3>{{ vm.wrapper.globalMedia }}</h3></th><th><h3>{{ vm.wrapper.globalPorcentaje}}%</h3></th><th><h3>{{ vm.nivelObtenido(vm.wrapper.globalMedia) }}</h3></th></tr></table><br><br><table class="table table-bordered type-a"><tr><th>Categor&iacutea</th><th>Media</th><th>Porcentaje</th><th>Nivel obtenido</th></tr><tr><td>I. Cumplimiento</td><td>{{ vm.wrapper.mediaCumplimiento}}</td><td>{{ vm.wrapper.promedioCumplimiento}}%</td><td>{{ vm.nivelObtenido(vm.wrapper.mediaCumplimiento) }}</td></tr><tr><td>II. Planeaci&oacuten</td><td>{{ vm.wrapper.mediaPlaneacion }}</td><td>{{ vm.wrapper.promedioPlaneacion}}%</td><td>{{ vm.nivelObtenido(vm.wrapper.mediaPlaneacion) }}</td></tr><tr><td>III. Estrategias did&aacutecticas</td><td>{{ vm.wrapper.mediaEstrategiasDidacticas }}</td><td>{{ vm.wrapper.promedioEstrategiasDidacticas}}%</td><td>{{ vm.nivelObtenido(vm.wrapper.mediaEstrategiasDidacticas) }}</td></tr><tr><td>IV. Actitud del profesor</td><td>{{ vm.wrapper.mediaActitudDelProfesor }}</td><td>{{ vm.wrapper.promedioActitudDelProfesor}}%</td><td>{{ vm.nivelObtenido(vm.wrapper.mediaActitudDelProfesor) }}</td></tr><tr><td>V. Comunicaci&oacuten</td><td>{{ vm.wrapper.mediaComunicacion }}</td><td>{{ vm.wrapper.promedioComunicacion}}%</td><td>{{ vm.nivelObtenido(vm.wrapper.mediaComunicacion) }}</td></tr><tr><td>VI. Evaluaci&oacuten de los aprendizajes</td><td>{{ vm.wrapper.mediaEvaluacionAprendizajes }}</td><td>{{ vm.wrapper.promedioEvaluacionAprendizajes}}%</td><td>{{ vm.nivelObtenido(vm.wrapper.mediaEvaluacionAprendizajes) }}</td></tr><tr><td>VII. Espec&iacuteficas del &aacuterea de conocimiento</td><td>{{ vm.wrapper.mediaEspecificasAreaConocimiento }}</td><td>{{ vm.wrapper.promedioEspecificasAreaConocimiento}}%</td><td>{{ vm.nivelObtenido(vm.wrapper.mediaEspecificasAreaConocimiento) }}</td></tr></table><br></div><br><div id="desempeniocategoria" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><br><div class="reportebody"><strong>II. SATISFACCI&OacuteN</strong><br><br><table class="table table-bordered type-a"><tr><th>Categor&iacutea</th><th>SI</th><th>NO</th></tr><tr><td>1.\tConsidero que aprend&iacute con el profesor</td><td>{{ vm.reporte.aprendiconprofesorSI }}%</td><td>{{ vm.reporte.aprendiconprofesorNO }}%</td></tr><tr><td>2.\tEstoy satisfecho con la labor docente del profesor</td><td>{{ vm.reporte.satisfechalaborprofesorSI }}%</td><td>{{ vm.reporte.satisfechalaborprofesorNO }}%</td></tr><tr><td>3.\tVolver&iacutea a tomar otro curso con el mismo profesor</td><td>{{ vm.reporte.volvertomarcursoprofesorSI }}%</td><td>{{ vm.reporte.volvertomarcursoprofesorNO }}%</td></tr><tr><td>4.\tEl profesor cumpli&oacute con mis expectativas</td><td>{{ vm.reporte.profesorcumplioexpectativasSI }}%</td><td>{{ vm.reporte.profesorcumplioexpectativasNO }}%</td></tr></table></div><div class="reportebody"><strong>IV. COMENTARIOS.</strong><br><br><div class="title" style="text-align: center">Estudiantes<br><br><div class="title" style="text-align: left">Fortalezas:</div><div><textarea rows="{{vm.wrapper.comentario1.length==0?0:vm.wrapper.comentario1.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="fortalezaEstudiante" ng-model="vm.wrapper.comentario1" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario1}}</textarea></div><div class="title" style="text-align: left">&Aacutereas de mejora:</div><div><textarea rows="{{vm.wrapper.comentario2.length==0?0:vm.wrapper.comentario2.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="sugerenciasEstudiante" ng-model="vm.wrapper.comentario2" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario2}}</textarea></div><div class="title" style="text-align: left">Comentarios generales:</div><div><textarea rows="{{vm.wrapper.comentario3.length==0?0:vm.wrapper.comentario3.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="comentariosEstudiante" ng-model="vm.wrapper.comentario3" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario3}}</textarea></div></div></div><br><br></div>');
$templateCache.put('app/reportes/reporteevaluativoLI/reporteevaluativoLI.html','<div><!-- Page Content --><div class="page-header"><div class="text-center"><div class="title hidden-print clearfix" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><div class="pull-left form-inline"><label for="exampleInputName2">Fase del reporte:</label><select required class="form-control hidden-print" ng-model="vm.reporte.status" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><option value="editar" ng-show="{{vm.wrapper.tipoUser ==\'1\'}}">Edici&oacuten</option><option value="revisar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Revisi&oacuten</option><option value="liberar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Liberaci&oacuten</option></select></div><div class="pull-right"><button ng-disabled="vm.isSaving" ng-click="vm.save()" class="btn btn-warning btn-main hidden-print" type="submit" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><span class="glyphicon"></span>&nbsp;<span>Guardar/Actualizar</span></button> <a class="btn btn-primary text-center" ui-sref="reporteevaluativo">Regresar</a></div></div><div><a class="btn btn-primary next text-center hidden-print" ng-click="vm.print()">Imprimir Reporte</a></div></div></div><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><section style="text-align: center"><h4><div>UNIVERSIDAD AUT&OacuteNOMA DE YUCAT&AacuteN</div><div>Direcci&oacuten General de Desarrollo Acad&eacutemico</div><div>Departamento de Innovaci&oacuten e Investigaci&oacuten Educativa</div><div>PROGRAMA INSTITUCIONAL DE EVALUACI&OacuteN DEL DESEMPE&NtildeO DOCENTE</div><br><br><div>{{vm.reporte.institucion.padre.nombre}}</div><div>{{vm.reporte.institucion.nombre}}</div></h4></section><br><br><table class="table table-bordered type-a reportetable"><tr><th>Profesor</th><td>{{vm.reporte.profesor.nombres}} {{vm.reporte.profesor.apellidoPaterno}} {{vm.reporte.profesor.apellidoMaterno}}</td></tr><tr><th>Asignatura</th><td>{{vm.reporte.asignatura.nombre}}</td></tr><tr><th>No.Estudiantes que evaluaron</th><td>{{vm.reporte.numEstudiantes}} de {{vm.wrapper.numTotalAlumnos}}</td></tr><tr><th>Periodo</th><td>{{vm.wrapper.periodoEvaluacion}}</td></tr><tr><th>A&ntildeo escolar</th><td>{{vm.reporte.anioEscolar.descripcion}}</td></tr></table><br><br><div class="reportebody"><strong>CONTENIDO DE LAS SECCIONES</strong><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;El documento reporta la opini&oacuten proveniente de los estudiantes y del mismo profesor ante su desempe&ntildeo docente. Los resultados corresponden al per&iacuteodo se&ntildealado, distribuidos en 3 secciones:<br><div class="title">I. Dimensi&oacuten de desempe&ntildeo</div>* Resultados cuantitativos presentados en dos dimensiones que manifiestan las competencias seleccionadas para evaluar el desempe&ntildeo docente frente a grupo.<br><div class="title">II. Satisfacci&oacuten</div>* Resultados cuantitativos a partir de la conformidad ante el desempe&ntildeo del profesor en la asignatura.<br><div class="title">III. Comentarios</div>* Resultados cualitativos que describen fortalezas y sugerencias para la mejora del desempe&ntildeo del profesor.</div><br><div class="reportebody"><strong>I. RESULTADOS POR DIMENSIONES.</strong><br><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A partir de las 32 competencias declaradas en el perfil del Profesor UADY (UADY, 2012), se realiz&oacute una selecci&oacuten de cinco competencias que evidencian el trabajo docente frente a grupo en las Asignaturas Libres. Con ello se han establecido dos dimensiones a trav&eacutes de las cu&aacuteles se evaluar&aacute el desempe&ntildeo del profesor (Ver Anexo A).<br><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Los resultados se obtienen con la Media de una escala de 4 opciones (1=Casi nunca a 4= Casi siempre) y se realiza una conversi&oacuten a 100.</div><br><br><div class="reportebody" style="text-decoration: underline"><strong>DIMENSI&OacuteN: INTERACCI&OacuteN</strong></div><br><div id="iteraccion" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><div class="reportebody"><div>Desde la perspectiva de los estudiantes:</div><br><table class="table table-bordered type-a"><tr><th></th><th>Estudiante</th></tr><tr><td>Es respetuoso cuando se expresa de otros docentes o compa&ntildeeros de trabajo</td><td>{{ vm.round(vm.reporte.respetuosoOtrosDocentes)}} %</td></tr><tr><td>Est&aacute comprometido con sus actividades como docente</td><td>{{ vm.round(vm.reporte.comprometido)}} %</td></tr></table></div><div class="reportebody" style="text-decoration: underline"><strong>DIMENSI&OacuteN: PROCESO DE ENSE&NtildeANZA Y APRENDIZAJE</strong></div><br><br><div id="dimensionii" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><br><br><br><div class="reportebody"><strong>II. SATISFACCI&OacuteN</strong><br><br><div style="text-align: center">INS = Insatisfecho SAT = Satisfecho MSA = Muy Satisfecho</div><br><table class="table table-bordered type-a"><tr><th>Items</th><th>INS</th><th>SAT</th><th>MSA</th><th>Profesor</th></tr><tr><td>1. Con las competencias que se han desarrollado en esta asignatura</td><td>{{ vm.round(vm.reporte.insatisfechoCompetencias)}} %</td><td>{{ vm.round(vm.reporte.satisfechoCompetencias)}} %</td><td>{{ vm.round(vm.reporte.muySatisfechoCompetencias)}} %</td><td ng-show="{{vm.reporte.valorCompetenciasProfesor !=null}}">{{ vm.reporte.valorCompetenciasProfesor}}</td><td ng-show="{{vm.reporte.valorCompetenciasProfesor ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr><tr><td>2. Con el desempe&ntildeo del profesor</td><td>{{ vm.round(vm.reporte.insatisfechoDesempenio)}} %</td><td>{{ vm.round(vm.reporte.satisfechoDesempenio)}} %</td><td>{{ vm.round(vm.reporte.muySatisfechoDesempenio)}} %</td><td ng-show="{{vm.reporte.valorDesempenioProfesor !=null}}">{{ vm.reporte.valorDesempenioProfesor}}</td><td ng-show="{{vm.reporte.valorDesempenioProfesor ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr><tr><td>3. Con las actividades como docentes</td><td></td><td></td><td></td><td ng-show="{{vm.reporte.valorActividadesDocente !=null}}">{{vm.reporte.valorActividadesDocente}}</td><td ng-show="{{vm.reporte.valorActividadesDocente ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr></table><br><table class="table table-bordered type-a"><tr><th></th><th>Si</th><th>No</th></tr><tr><td>4. Recomendar a otro estudiante, tomar la asignatura con este profesor</td><td>{{ vm.round(vm.reporte.recomendarProfesorSi)}} %</td><td>{{ vm.round(vm.reporte.recomendarProfesorNo)}} %</td></tr><tr><td colspan="3">Razones Si<br><textarea rows="{{vm.wrapper.comentario1.length==0?0:vm.wrapper.comentario1.split(\'\\n\').length + 8}}" cols="50" class="form-control" name="comentario1" ng-model="vm.wrapper.comentario1" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario1}}</textarea></td></tr><tr><td colspan="3">Razones No<br><textarea rows="{{vm.wrapper.comentario2.length==0?0:vm.wrapper.comentario2.split(\'\\n\').length + 4}}" cols="50" class="form-control" name="comentario2" ng-model="vm.wrapper.comentario2" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario2}}</textarea></td></tr></table></div><br><div class="reportebody"><strong>III. COMENTARIOS.</strong><br><br><div class="title" style="text-align: center">Profesor<br><br><div class="title" style="text-align: left">Fortalezas:</div><div><textarea rows="{{vm.wrapper.comentario3.length==0?0:vm.wrapper.comentario3.split(\'\\n\').length + 2}}" cols="50" class="form-control" name="fortalezaProfesor" ng-model="vm.wrapper.comentario3" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario3}}</textarea></div><div class="title" style="text-align: left">Sugerencias:</div><div><textarea rows="{{vm.wrapper.comentario4.length==0?0:vm.wrapper.comentario4.split(\'\\n\').length + 2}}" cols="50" class="form-control" name="comentario4" ng-model="vm.wrapper.comentario4" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario4}}</textarea></div></div><div class="title" style="text-align: center">Estudiantes<br><br><div class="title" style="text-align: left">Fortalezas:</div><div><textarea rows="{{vm.wrapper.comentario5.length==0?0:vm.wrapper.comentario5.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="fortalezaEstudiante" ng-model="vm.wrapper.comentario5" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario5}}</textarea></div><div class="title" style="text-align: left">Sugerencias:</div><div><textarea rows="{{vm.wrapper.comentario6.length==0?0:vm.wrapper.comentario6.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="sugerenciasEstudiante" ng-model="vm.wrapper.comentario6" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario6}}</textarea></div><div class="title" style="text-align: left">Comentarios:</div><div><textarea rows="{{vm.wrapper.comentario7.length==0?0:vm.wrapper.comentario7.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="comentario7" ng-model="vm.wrapper.comentario7" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario7}}</textarea></div></div></div><br><br><div class="reportebody"><h4 style="text-align: center">Anexo A.</h4><br><br>*Competencias consideradas para evaluar el desempe&ntildeo docente.<table class="table table-bordered"><tr><th>Criterios</th><th>Competencias del Perfil del profesor UADY</th><th>Dimensiones</th></tr><tr><td>Respeto</td><td><strong>Competencia 2.</strong> Manifiesta un comportamiento hacia las personas con &eacutetica y tolerancia.</td><td rowspan="2">Interacci&oacuten</td></tr><tr><td>Relaci&oacuten</td><td><strong>Competencia 4.</strong> Manifiesta identidad institucional hacia las personas en congruencia con la filosof&iacutea de la Universidad.<br><strong>Competencia 6.</strong> Crea ambientes de aprendizaje en su pr&aacutectica docente, adecuados con las necesidades de sus estudiantes.<br></td></tr><tr><td>T&eacutecnicas y medios de calificaci&oacuten</td><td><strong>Competencia 20.</strong> Incorpora diferentes t&eacutecnicas y medios en la evaluaci&oacuten del proceso para el desarrollo adecuado de las competencias.</td><td rowspan="2">Proceso de Ense&ntildeanza y aprendizaje</td></tr><tr><td>Evaluaci&oacuten</td><td><strong>Competencia 21.</strong> Utiliza la evaluaci&oacuten de producto en el desarrollo de las competencias del estudiantado, de manera objetiva, como evidencia de su nivel de dominio</td></tr><tr style="text-align: center"><td><strong>4 CRITERIOS</strong></td><td><strong>5 COMPETENCIAS</strong></td><td><strong>2 DIMENSIONES</strong></td></tr></table></div><br><footer style="text-align: right" class="reportebody">UADY (2012). Modelo Educativo para la Formaci&oacuten Integral. Universidad Aut&oacutenoma de Yucat&aacuten.<br>PDI (2014-2022). Plan de Desarrollo Institucional. Universidad Aut&oacutenoma de Yucat&aacuten.</footer></div>');
$templateCache.put('app/reportes/reporteevaluativoLic/reporteevaluativoLic.html','<div><!-- Page Content --><div class="page-header"><div class="text-center"><div class="title hidden-print clearfix" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><div class="pull-left form-inline"><label for="exampleInputName2">Fase del reporte:</label><select required class="form-control hidden-print" ng-model="vm.reporte.status" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><option value="editar" ng-show="{{vm.wrapper.tipoUser ==\'1\'}}">Edici&oacuten</option><option value="revisar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Revisi&oacuten</option><option value="liberar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Liberaci&oacuten</option></select></div><div class="pull-right"><button ng-disabled="vm.isSaving" ng-click="vm.save()" class="btn btn-warning btn-main hidden-print" type="submit" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><span class="glyphicon"></span>&nbsp;<span>Guardar/Actualizar</span></button> <a class="btn btn-primary text-center" ui-sref="reporteevaluativo">Regresar</a></div></div><div><a class="btn btn-primary next text-center hidden-print" ng-click="vm.print()">Imprimir Reporte</a></div></div></div><jhi-alert-error></jhi-alert-error><section style="text-align: center"><h4><div>UNIVERSIDAD AUT&OacuteNOMA DE YUCAT&AacuteN</div><div>Direcci&oacuten General de Desarrollo Acad&eacutemico</div><div>Departamento de Innovaci&oacuten e Investigaci&oacuten Educativa</div><div>PROGRAMA INSTITUCIONAL DE EVALUACI&OacuteN DEL DESEMPE&NtildeO DOCENTE</div><br><br><div>{{vm.reporte.institucion.padre.nombre}}</div><div>{{vm.reporte.institucion.nombre}}</div></h4></section><br><br><table class="table table-bordered type-a reportetable"><tr><th>Docente</th><td>{{vm.reporte.profesor.nombres}} {{vm.reporte.profesor.apellidoPaterno}} {{vm.reporte.profesor.apellidoMaterno}}</td></tr><tr><th>Asignatura</th><td>{{vm.reporte.asignatura.nombre}}</td></tr><tr><th>Participantes</th><td>{{vm.reporte.totalalumnos}} de {{vm.wrapper.numTotalAlumnos}}</td></tr><tr><th>Per&iacuteodo escolar</th><td>{{vm.wrapper.periodoEvaluacion}}</td></tr><tr><th>A&ntildeo escolar</th><td>{{vm.reporte.anioEscolar.descripcion}}</td></tr></table><br><br><div class="reportebody"><strong>Resultados generales desde la precepci&oacuten del estudiantado</strong><br><br><table class="table table-bordered type-a"><tr><th></th><th></th><th></th></tr><tr><td>Presentaci&oacuten de la asignatura</td><td>{{ vm.reporte.presasigprom_gral }}%</td><td>{{ vm.reporte.pesentacionasigvalor_gral }}</td></tr><tr><td>Proceso de ense&ntildeanza y aprendizaje</td><td>{{ vm.reporte.procesoenzapr_gral }}%</td><td>{{ vm.reporte.procesoenzaprvalor_gral }}</td></tr><tr><td>Adecuada Interacci&oacuten y ambientes de aprendizaje</td><td>{{ vm.reporte.adecuadainteyamapren_gral }}%</td><td>{{ vm.reporte.adecuadainteyamaprenvalor_gral }}</td></tr></table><i>*Por presentaci&oacuten, los decimales se omiten. No obstante, al considerar todos los decimales, suman 100%.</i><br></div><div class="reportebody"><h4>I. PRESENTACI&OacuteN DE LA ASIGNATURA</h4><br><table class="table table-bordered type-a"><tr><th rowspan="2"></th><th colspan="2">Estudiantado</th><th rowspan="2">Docente</th></tr><tr><th>SI</th><th>NO</th></tr><tr><td>1. \xBFPresent&oacute la planeaci&oacuten de la asignatura?</td><td>{{ vm.reporte.presentoplaneacionsi_e }}%</td><td>{{ vm.reporte.presentoplaneacionno_e }}%</td><td>{{ vm.reporte.presentoplaneacion_p }}</td></tr><tr><td>2. \xBFExplic&oacute la din&aacutemica de la asignatura (forma de trabajo)</td><td>{{ vm.reporte.explicodinaasigsi_e }}%</td><td>{{ vm.reporte.explicodinaasigno_e }}%</td><td>{{ vm.reporte.explicodinaasig_p }}</td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th rowspan="1"></th><th colspan="2">Estudiantado</th><th rowspan="2">Docente</th></tr><tr><th style="text-align: left">\xBFMi docente\u2026</th><th>%</th><th>Calidad</th></tr><tr><td>3. explica c&oacutemo se desarrolla la (s) competencia (s) a trav&eacutes de las actividades de aprendizaje?</td><td>{{ vm.reporte.presasigprom3_e }}%</td><td>{{ vm.reporte.presasigprom3valor_e }}</td><td>{{ vm.reporte.presasigprom3_p }}</td></tr><tr><td>4. explica la utilidad de los contenidos al campo laboral?</td><td>{{ vm.reporte.presasigprom4_e }}%</td><td>{{ vm.reporte.presasigprom4valor_e }}</td><td>{{ vm.reporte.presasigprom4_p }}</td></tr><tr><td>5. establece los mecanismos de comunicaci&oacuten para mantenerse en contacto?</td><td>{{ vm.reporte.presasigprom5_e }}%</td><td>{{ vm.reporte.presasigprom5valor_e }}</td><td>{{ vm.reporte.presasigprom5_p }}</td></tr><tr><td>6. explica los recursos o materiales que se utilizar&aacuten durante la asignatura?</td><td>{{ vm.reporte.presasigprom6_e }}%</td><td>{{ vm.reporte.presasigprom6valor_e }}</td><td>{{ vm.reporte.presasigprom6_p }}</td></tr><tr><td style="text-align: right">Promedio</td><td>{{ vm.reporte.presasigprom_gral }}%</td><td>{{ vm.reporte.pesentacionasigvalor_gral }}</td><td></td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="1"></th><th colspan="1">Docente</th></tr><tr><td>7. \xBFElabor&oacute la planeaci&oacuten de la asignatura?</td><td>{{ vm.reporte.elaboroplanasig_p }}</td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="1" style="text-align: left">Al elaborar la planeaci&oacuten de la asignatura, para m&iacute es\u2026</th><th colspan="2">Docente</th></tr><tr><td>8. establecer estrategias de evaluaci&oacuten?</td><td>{{ vm.reporte.establecerestrev_p }}</td></tr><tr><td>9. elaborar instrumentos de evaluaci&oacuten?</td><td>{{ vm.reporte.elabinsev_p }}</td></tr><tr><td>10. elegir actividades que se vinculen con el campo laboral</td><td>{{ vm.reporte.elegiractsvincamlab_p }}</td></tr></table><br></div><div class="reportebody"><h4>II. PROCESO DE ENSE&NtildeANZA Y APRENDIZAJE</h4><br><table class="table table-bordered type-a"><tr><th rowspan="2"></th><th colspan="2">Estudiantado</th></tr><tr><th>%</th><th>Calidad</th></tr><tr><td>Estrategias de ense&ntildeanza y aprendizaje</td><td>{{ vm.reporte.estraenzaprenprom_e }}%</td><td>{{ vm.reporte.estraenzaprenvalorprom_e }}</td></tr><tr><td>Estrategias de evaluaci&oacuten</td><td>{{ vm.reporte.estraevprom_e }}%</td><td>{{ vm.reporte.estraevvalorprom_e }}</td></tr><tr><td style="text-align: right">Promedio</td><td>{{ vm.reporte.procesoenzapr_gral }}%</td><td>{{ vm.reporte.procesoenzaprvalor_gral }}</td></tr></table><br></div><br><div id="iteraccion" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><br><div id="estrategias" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><div class="reportebody"><h4>III. INTERACCI&oacuteN Y AMBIENTES DE APRENDIZAJE</h4><br><table class="table table-bordered type-a"><tr><th rowspan="2"></th><th colspan="2">Estudiantado</th></tr><tr><th>%</th><th>Frecuencia</th></tr><tr><td>Estrategias de ense&ntildeanza y aprendizaje</td><td>{{ vm.reporte.persdocyestprom }}%</td><td>{{ vm.reporte.persdocyestvalorprom_e }}</td></tr><tr><td>Estrategias de evaluaci&oacuten</td><td>{{ vm.reporte.persestuprom }}%</td><td>{{ vm.reporte.persestuvalorprom }}</td></tr><tr><td style="text-align: right">Promedio</td><td>{{ vm.reporte.adecuadainteyamapren_gral }}%</td><td>{{ vm.reporte.adecuadainteyamaprenvalor_gral }}</td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th rowspan="2"></th><th colspan="2">Estudiantado</th><th rowspan="2">Docente</th></tr><tr><th>%</th><th>Frecuencia</th></tr><tr><td>1. adec&uacutea su ense&ntildeanza a partir de las necesidades y caracter&iacutesticas del grupo</td><td>{{ vm.reporte.persdocyest1_e }}%</td><td>{{ vm.reporte.persdocyest1valor_e }}</td><td>{{ vm.reporte.persdocyest1_p }}</td></tr><tr><td>2. establece igualdad entre mujeres y hombres</td><td>{{ vm.reporte.persdocyest2_e }}%</td><td>{{ vm.reporte.persdocyest2valor_e }}</td><td>{{ vm.reporte.persdocyest2_p }}</td></tr><tr><td>3. fomenta los valores de ciudadan&iacutea impulsando la tolerancia, respeto y equidad</td><td>{{ vm.reporte.persdocyest3_e }}%</td><td>{{ vm.reporte.persdocyest3valor_e }}</td><td>{{ vm.reporte.persdocyest3_p }}</td></tr><tr><td>4. fomenta valores de cultura de paz (di&aacutelogo, negociaci&oacuten, consenso)</td><td>{{ vm.reporte.persdocyest4_e }}%</td><td>{{ vm.reporte.persdocyest4valor_e }}</td><td>{{ vm.reporte.persdocyest4_p }}</td></tr><tr><td>5. utiliza diferentes herramientas para favorecer la comunicaci&oacuten con el estudiantado (chat, mensajer&iacutea, correo institucional, etc.)</td><td>{{ vm.reporte.persdocyest5_e }}%</td><td>{{ vm.reporte.persdocyest5valor_e }}</td><td>{{ vm.reporte.persdocyest5_p }}</td></tr><tr><td>6. valora las capacidades y saberes de las personas que participan en la asignatura</td><td>{{ vm.reporte.persdocyest7_e }}%</td><td>{{ vm.reporte.persdocyest7valor_e }}</td><td>{{ vm.reporte.persdocyest7_p }}</td></tr><tr><td style="text-align: right">Promedio</td><td>{{ vm.reporte.persdocyestprom }}%</td><td>{{ vm.reporte.persdocyestvalorprom_e }}</td><td></td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th rowspan="2"></th><th colspan="2">Estudiantado</th></tr><tr><th>%</th><th>Frecuencia</th></tr><tr><td>8. aprovecha el tiempo para desarrollar aprendizajes</td><td>{{ vm.reporte.persestuprom8_e }}%</td><td>{{ vm.reporte.persestuprom8valor_e }}</td></tr><tr><td>9. brinda indicaciones claras para fortalecer los aprendizajes</td><td>{{ vm.reporte.persestuprom9_e }}%</td><td>{{ vm.reporte.persestuprom9valor_e }}</td></tr><tr><td>10. muestra respeto al dirigirse a los estudiantes</td><td>{{ vm.reporte.persestuprom10_e }}%</td><td>{{ vm.reporte.persestuprom10valor_e }}</td></tr><tr><td>11. muestra respeto ante las creencias e ideolog&iacuteas del grupo</td><td>{{ vm.reporte.persestuprom11_e }}%</td><td>{{ vm.reporte.persestuprom11valor_e }}</td></tr><tr><td>12. muestra conductas &eacuteticas y responsables</td><td>{{ vm.reporte.persestuprom12_e }}%</td><td>{{ vm.reporte.persestuprom12valor_e }}</td></tr><tr><td>13. resuelve dudas o inquietudes</td><td>{{ vm.reporte.persestuprom13_e }}%</td><td>{{ vm.reporte.persestuprom13valor_e }}</td></tr><tr><td style="text-align: right">Promedio</td><td>{{ vm.reporte.persestuprom }}%</td><td>{{ vm.reporte.persestuvalorprom }}</td></tr></table><br></div><div class="reportebody"><br><h4>IV. SATISFACCI&OacuteN</h4><table class="table table-bordered type-a"><tr><th colspan="1"></th><th colspan="1">Docente</th></tr><tr><td>11. En general, \xBFest&aacute satisfecho con el dise&ntildeo de su asignatura?</td><td>{{ vm.reporte.satisdiseasig_p }}</td></tr><tr><td>Apoyos o recursos podr&iacutean fortalecer su asignatura</td><td><textarea rows="{{vm.autoheight(\'idapoyosRecFortAsig_p\')}}" id="idapoyosRecFortAsig_p" cols="50" class="form-control" name="apoyosRecFortAsig_p" ng-model="vm.wrapper.apoyosRecFortAsig_p" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.apoyosRecFortAsig_p }}\n\t\t\t\t</textarea></td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th rowspan="2"></th><th colspan="2">Estudiantado</th></tr><tr><th>Si</th><th>No</th></tr><tr><td>1. \xBFEst&aacutes satisfecho con la forma de trabajar la asignatura?</td><td>{{ vm.reporte.satiformatrabasigsi_e }}%</td><td>{{ vm.reporte.satiformatrabasigno_e }}%</td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Razones por que SI</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idsatiFormaTrabAsigRazonesSi_e\')}}" id="idsatiFormaTrabAsigRazonesSi_e" cols="50" class="form-control" name="satiFormaTrabAsigRazonesSi_e" ng-model="vm.wrapper.satiFormaTrabAsigRazonesSi_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.satiFormaTrabAsigRazonesSi_e }}\n\t\t\t\t</textarea></td></tr></table></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Razones por que NO</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idsatiFormaTrabAsigRazonesNo_e\')}}" id="idsatiFormaTrabAsigRazonesNo_e" cols="50" class="form-control" name="satiFormaTrabAsigRazonesNo_e" ng-model="vm.wrapper.satiFormaTrabAsigRazonesNo_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.satiFormaTrabAsigRazonesNo_e }}\n\t\t\t\t</textarea></td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th rowspan="2"></th><th colspan="2">Estudiantado</th></tr><tr><th>Si</th><th>No</th></tr><tr><td>2. \xBFEst&aacutes satisfecho con las actividades de aprendizaje que realizaste durante la asignatura?</td><td>{{ vm.reporte.satisactsaprsi_e }}%</td><td>{{ vm.reporte.satisactsaprno_e }}%</td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Razones por que SI</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idsatisActsAprRazonesSi_e\')}}" id="idsatisActsAprRazonesSi_e" cols="50" class="form-control" name="satisActsAprRazonesSi_e" ng-model="vm.wrapper.satisActsAprRazonesSi_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.satisActsAprRazonesSi_e }}\n\t\t\t\t</textarea></td></tr></table></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Razones por que NO</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idsatisActsAprRazonesNo_e\')}}" id="idsatisActsAprRazonesNo_e" cols="50" class="form-control" name="satisActsAprRazonesNo_e" ng-model="vm.wrapper.satisActsAprRazonesNo_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.satisActsAprRazonesNo_e }}\n\t\t\t\t</textarea></td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th rowspan="2"></th><th colspan="2">Estudiantado</th></tr><tr><th>Si</th><th>No</th></tr><tr><td>3. \xBFRecomendar&iacuteas a otro (a) estudiante, cursar la asignatura con este (a) docente</td><td>{{ vm.reporte.reccurasigsi_e }}%</td><td>{{ vm.reporte.reccurasigno_e }}%</td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Razones por que SI</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idrecCurAsigRazonesSi_e\')}}" id="idrecCurAsigRazonesSi_e" cols="50" class="form-control" name="recCurAsigRazonesSi_e" ng-model="vm.wrapper.recCurAsigRazonesSi_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.recCurAsigRazonesSi_e }}\n\t\t\t\t</textarea></td></tr></table></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Razones por que NO</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idrecCurAsigRazonesNo_e\')}}" id="idrecCurAsigRazonesNo_e" cols="50" class="form-control" name="recCurAsigRazonesNo_e" ng-model="vm.wrapper.recCurAsigRazonesNo_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.recCurAsigRazonesNo_e }}\n\t\t\t\t</textarea></td></tr></table><br></div><br><div class="reportebody"><h4>4. Recomendaciones para mejorar el desempe&ntildeo docente</h4></div><div id="materias" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">5. Recomendaciones estudiantado</th></tr><tr><td>Dominio de contenidos</td><td><textarea rows="{{vm.autoheight(\'iddomiConttxt_e\')}}" cols="50" class="form-control" name="domiConttxt_e" id="iddomiConttxt_e" ng-model="vm.wrapper.domiConttxt_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.domiConttxt_e }}\n\t\t\t\t</textarea></td></tr><tr><td>Forma de evaluar</td><td><textarea rows="{{vm.autoheight(\'idformaEvtxt_e\')}}" id="idformaEvtxt_e" cols="50" class="form-control" name="formaEvtxt_e" ng-model="vm.wrapper.formaEvtxt_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.formaEvtxt_e }}\n\t\t\t\t</textarea></td></tr><tr><td>Forma de trabajo de la asignatura</td><td><textarea rows="{{vm.autoheight(\'idformTrbAsigtxt_e\')}}" id="idformTrbAsigtxt_e" cols="50" class="form-control" name="formTrbAsigtxt_e" ng-model="vm.wrapper.formTrbAsigtxt_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.formTrbAsigtxt_e }}\n\t\t\t\t</textarea></td></tr><tr><td>Materiales de apoyo</td><td><textarea rows="{{vm.autoheight(\'idmatApoytxt_e\')}}" id="idmatApoytxt_e" cols="50" class="form-control" name="matApoytxt_e" ng-model="vm.wrapper.matApoytxt_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.matApoytxt_e }}\n\t\t\t\t</textarea></td></tr><tr><td>Planeaci&oacuten de la asignatura</td><td><textarea rows="{{vm.autoheight(\'idplanAsigtxt_e\')}}" id="idplanAsigtxt_e" cols="50" class="form-control" name="planAsigtxt_e" ng-model="vm.wrapper.planAsigtxt_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.planAsigtxt_e }}\n\t\t\t\t</textarea></td></tr><tr><td>Relaciones con el grupo</td><td><textarea rows="{{vm.autoheight(\'idrelaGrpotxt_e\')}}" id="idrelaGrpotxt_e" cols="50" class="form-control" name="relaGrpotxt_e" ng-model="vm.wrapper.relaGrpotxt_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.relaGrpotxt_e }}\n\t\t\t\t</textarea></td></tr><tr><td>Utilidad para el campo laboral</td><td><textarea rows="{{vm.autoheight(\'idutiCampLabtxt_e\')}}" id="idutiCampLabtxt_e" cols="50" class="form-control" name="utiCampLabtxt_e" ng-model="vm.wrapper.utiCampLabtxt_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.utiCampLabtxt_e }}\n\t\t\t\t</textarea></td></tr><tr><td>Conducta &eacutetica y profesional</td><td><textarea rows="{{vm.autoheight(\'idconducEticYProftxt_e\')}}" id="idconducEticYProftxt_e" cols="50" class="form-control" name="conducEticYProftxt_e" ng-model="vm.wrapper.conducEticYProftxt_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.conducEticYProftxt_e }}\n\t\t\t\t</textarea></td></tr></table><br></div><div class="reportebody"><br><h4>V. VINCULACI&OacuteN</h4><table class="table table-bordered type-a"><tr><th colspan="1"></th><th colspan="1">Docente</th></tr><tr><td>1. Durante este per&iacuteodo, \xBFha participado otro (a) docente en la implementaci&oacuten de su (s) asignatura (s)?</td><td>{{ vm.reporte.participootrodocente_p }}</td></tr><tr><td>Tipo de participaci&oacuten:</td><td>{{ vm.reporte.tipoparti1_p }}</td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="1"></th><th colspan="1">Docente</th></tr><tr><td>2. Durante este per&iacuteodo, \xBFse realiz&oacute alg&uacuten trabajo colaborativo con profesores de otras asignaturas?</td><td>{{ vm.reporte.trabcolotrodocente_p }}</td></tr><tr><td>Asignatura donde realiz&oacute la colaboraci&oacuten:</td><td>{{ vm.reporte.asigdonderealcol_p }}</td></tr><tr><td>Tipo de participaci&oacuten:</td><td>{{ vm.reporte.tipoparti2_p }}</td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="1"></th><th colspan="1">Docente</th></tr><tr><td>3. Durante este per&iacuteodo, \xBFha realizado alguna colaboraci&oacuten con profesores de otras dependencias o instituciones (dentro o fuera de la UADY) para la implementaci&oacuten de su (s) asignatura (s)?</td><td>{{ vm.reporte.colabprofotrasdep_p }}</td></tr><tr><td>Beneficios para el estudiantado:</td><td>{{ vm.reporte.benefiestu_p }}</td></tr><tr><td>Tipo de participaci&oacuten:</td><td>{{ vm.reporte.formacolb_p }}</td></tr></table><br></div><div class="reportebody"><br><h4>VI. FORMACI&OacuteN DOCENTE</h4><table class="table table-bordered type-a"><tr><th colspan="1"></th><th colspan="1">Docente</th></tr><tr><td>1. En el per&iacuteodo inmediato anterior, \xBFparticip&oacute en alg&uacuten curso o taller de habilitaci&oacuten o capacitaci&oacuten?</td><td>{{ vm.reporte.participocurso_p }}</td></tr><tr><td>N&uacutemero de cursos concluidos:</td><td>{{ vm.reporte.cuantoscursosconcl_p }}</td></tr><tr><td>Tipo de cursos en los que particip&oacute:</td><td>{{ vm.reporte.tipocurso_p }}</td></tr><tr><td>Los cursos fueron ofertados por:</td><td>{{ vm.reporte.cursoofertadopor_p }}</td></tr><tr><td>C&oacutemo se enter&oacute de la oferta</td><td>{{ vm.reporte.comoentero_p }}</td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="1"></th><th colspan="1">Docente</th></tr><tr><td>2. \xBFLe gustar&iacutea participar en procesos de habilitaci&oacuten o capacitaci&oacuten?</td><td>{{ vm.reporte.partircapa }}</td></tr><tr><td>3. \xBFCuenta con disponibilidad para participar en espacios de formaci&oacuten o capacitaci&oacuten, en el pr&oacuteximo per&iacuteodo escolar?</td><td>{{ vm.reporte.disponetiempoparticapa_p }}</td></tr><tr><td>Razones:</td><td>{{ vm.reporte.razonesno_p }}</td></tr></table><br></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="1"></th><th colspan="1">Docente</th></tr><tr><td>4. \xBFQu&eacute opciones prefiere al participar en los cursos de habilitaci&oacuten o capacitaci&oacuten?</td><td>{{ vm.reporte.opcionesprefieresparti_p }}</td></tr><tr><td>Modalidad preferida</td><td>{{ vm.reporte.modpre_p }}</td></tr><tr><td>Temas de inter&eacutes</td><td>{{ vm.reporte.temainteres_p }}</td></tr></table><br></div></div>');
$templateCache.put('app/reportes/reporteevaluativoMixtoPII/reporteevaluativoMixtoPII.html','<div><!-- Page Content --><div class="page-header"><div class="text-center"><div class="title hidden-print clearfix" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><div class="pull-left form-inline"><label for="exampleInputName2">Fase del reporte:</label><select required class="form-control hidden-print" ng-model="vm.reporte.status" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><option value="editar" ng-show="{{vm.wrapper.tipoUser ==\'1\'}}">Edici&oacuten</option><option value="revisar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Revisi&oacuten</option><option value="liberar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Liberaci&oacuten</option></select></div><div class="pull-right"><button ng-disabled="vm.isSaving" ng-click="vm.save()" class="btn btn-warning btn-main hidden-print" type="submit" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><span class="glyphicon"></span>&nbsp;<span>Guardar/Actualizar</span></button> <a class="btn btn-primary text-center" ui-sref="reporteevaluativo">Regresar</a></div></div><div><a class="btn btn-primary next text-center hidden-print" ng-click="vm.print()">Imprimir Reporte</a></div></div></div><jhi-alert-error></jhi-alert-error><section style="text-align: center"><h4><div>Direcci&oacuten General de Desarrollo Acad&eacutemico</div><div>PROGRAMA DE EVALUACI&OacuteN</div><div>PROGRAMA INSTITUCIONAL DE INGL&EacuteS</div><br><br></h4></section><table class="table table-bordered type-a reportetable"><tr><th>Profesor</th><td>{{vm.reporte.profesor.nombres}} {{vm.reporte.profesor.apellidoPaterno}} {{vm.reporte.profesor.apellidoMaterno}}</td></tr><tr><th>Per&iacuteodo que se eval&uacutea</th><td>{{vm.wrapper.periodoEvaluacion}}</td></tr><tr><th>No. de participantes que evaluaron</th><td>{{vm.reporte.totalalumnos}} de {{vm.wrapper.numTotalAlumnos}}</td></tr><tr><th>Asignatura</th><td>{{vm.reporte.asignatura.nombre}}</td></tr><tr><th>Grupo</th><td>{{vm.reporte.grupo.grupo}}</td></tr><tr><th>Modalidad</th><td>{{vm.reporte.formaDeEvaluar}}</td></tr><tr><th>A&ntildeo escolar</th><td>{{vm.reporte.anioEscolar.descripcion}}</td></tr></table><br><br><div class="reportebody"><h4>1. Interacci&oacuten estudiante - docente</h4><br><div id="iteraccion1" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><div id="iteraccion2" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br></div><div class="reportebody"><h4>2. Estrategias de ense&ntildeanza</h4><br><div id="estrategias1" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><div id="estrategias2" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br></div><div class="reportebody"><h4>3. Estrategias de evaluaci\xF3n</h4><br><div id="estrategias3" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br></div><div class="reportebody"><h4>4. Satisfacci&oacuten</h4><br><br><div style="text-align: center">INS = Insatisfecho SAT = Satisfecho MSA = Muy Satisfecho</div><br><table class="table table-bordered type-a"><tr><th rowspan="2">Satisfacci\xF3n con el aprendizaje del estudiante</th><th colspan="3">Estudiantes</th></tr><tr><th>INS</th><th>SAT</th><th>MSA</th></tr><tr><td>1. Con el desarrollo de la competencia para hablar en el idioma ingl\xE9s.</td><td>{{ vm.round(vm.reporte.hablains_e)}} %</td><td>{{ vm.round(vm.reporte.hablasat_e)}} %</td><td>{{ vm.round(vm.reporte.hablamsa_e)}} %</td></tr><tr><td>2. Con el desarrollo de la competencia para escuchar en el idioma ingl\xE9s.</td><td>{{ vm.round(vm.reporte.escucharins_e)}} %</td><td>{{ vm.round(vm.reporte.escucharsat_e)}} %</td><td>{{ vm.round(vm.reporte.escucharmsa_e)}} %</td></tr><tr><td>3. Con el desarrollo de la competencia para leer en el idioma ingl\xE9s.</td><td>{{ vm.round(vm.reporte.leerins_e)}} %</td><td>{{ vm.round(vm.reporte.leersat_e)}} %</td><td>{{ vm.round(vm.reporte.leermsa_e)}} %</td></tr><tr><td>4. Con el desarrollo de la competencia para escribir en el idioma ingl\xE9s.</td><td>{{ vm.round(vm.reporte.escribirins_e)}} %</td><td>{{ vm.round(vm.reporte.escribirsat_e)}} %</td><td>{{ vm.round(vm.reporte.escribirmsa_e)}} %</td></tr></table><br><table class="table table-bordered type-a"><tr><th rowspan="2">Satisfacci\xF3n con materiales y recursos</th><th colspan="3">Estudiantes</th></tr><tr><th>INS</th><th>SAT</th><th>MSA</th></tr><tr><td>1. Con los contenidos del libro (student book).</td><td>{{ vm.round(vm.reporte.contenidolibroins_e)}} %</td><td>{{ vm.round(vm.reporte.contenidolibrosat_e)}} %</td><td>{{ vm.round(vm.reporte.contenidolibromsa_e)}} %</td></tr><tr><td>2. Con la variedad de ejercicios de lectura, orales, auditivos y escritos que se realizan en las sesiones presenciales.</td><td>{{ vm.round(vm.reporte.variedadejepresenins_e)}} %</td><td>{{ vm.round(vm.reporte.variedadejepresensat_e)}} %</td><td>{{ vm.round(vm.reporte.variedadejepresenmsa_e)}} %</td></tr><tr><td>3. Con los recursos y materiales proporcionados por tu docente (teacher).</td><td>{{ vm.round(vm.reporte.recurmatdocins_e)}} %</td><td>{{ vm.round(vm.reporte.recurmatdocsat_e)}} %</td><td>{{ vm.round(vm.reporte.recurmatdocmsa_e)}} %</td></tr><tr><td>4. Con los recursos digitales utilizados por tu teacher (video, presentaciones, etc.).</td><td>{{ vm.round(vm.reporte.recurdigdocins_e)}} %</td><td>{{ vm.round(vm.reporte.recurdigdocsat_e)}} %</td><td>{{ vm.round(vm.reporte.recurdigdocmsa_e)}} %</td></tr><tr><td>5. Con los talleres y clubes de conversaci\xF3n en el Centro de Auto-Acceso.</td><td>{{ vm.round(vm.reporte.tallerclubcaains_e)}} %</td><td>{{ vm.round(vm.reporte.tallerclubcaasat_e)}} %</td><td>{{ vm.round(vm.reporte.tallerclubcaamsa_e)}} %</td></tr><tr><td>6. Con las actividades de aprendizaje en la plataforma UADY Virtual.</td><td>{{ vm.round(vm.reporte.actsuadyvirtualins_e)}} %</td><td>{{ vm.round(vm.reporte.actsuadyvirtualsat_e)}} %</td><td>{{ vm.round(vm.reporte.actsuadyvirtualmsa_e)}} %</td></tr></table><br></div><br><div class="reportebody"><h4>5. Comentarios</h4><br><table class="table table-bordered type-a"><tr><th rowspan="2">\xBFRecomendar\xEDas a estudiantes tomar el curso con tu docente de forma presencial?</th><th>Si</th><th>No</th></tr><tr><td>{{ vm.reporte.recodocentesi }}%</td><td>{{ vm.reporte.recodocenteno }}%</td></tr></table></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Razones por que SI</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idrazonessi_e\')}}" id="idrazonessi_e" cols="50" class="form-control" name="razonessi_e" ng-model="vm.wrapper.razonessi_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.razonessi_e }}\n\t\t\t\t</textarea></td></tr></table></div><br><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Razones por que NO</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idrazonesno_e\')}}" id="idrazonesno_e" cols="50" class="form-control" name="razonesno_e" ng-model="vm.wrapper.razonesno_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.razonesno_e }}\n\t\t\t\t</textarea></td></tr></table><br></div><br><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Comentarios de los estudiantes para mejorar el PII</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idcommejorarpii_e\')}}" id="idcommejorarpii_e" cols="50" class="form-control" name="commejorarpii_e" ng-model="vm.wrapper.commejorarpii_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.commejorarpii_e }}\n\t\t\t\t</textarea></td></tr></table><br></div><br><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Condiciones que podr\xEDan favorecer su desempe&ntildeo en los cursos del PII (docente)</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idcondfavdesem_p\')}}" id="idcondfavdesem_p" cols="50" class="form-control" name="condfavdesem_p" ng-model="vm.wrapper.condfavdesem_p" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.condfavdesem_p }}\n\t\t\t\t</textarea></td></tr></table><br></div><br><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Comentarios del docente para mejorar el PII</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idcommejorarpii_p\')}}" id="idcommejorarpii_p" cols="50" class="form-control" name="commejorarpii_p" ng-model="vm.wrapper.commejorarpii_p" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.commejorarpii_p }}\n\t\t\t\t</textarea></td></tr></table><br></div><br></div>');
$templateCache.put('app/reportes/reporteevaluativoOO/reporteevaluativoOO.html','<div><!-- Page Content --><div class="page-header"><div class="text-center"><div class="title hidden-print clearfix" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><div class="pull-left form-inline"><label for="exampleInputName2">Fase del reporte:</label><select required class="form-control hidden-print" ng-model="vm.reporte.status" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><option value="editar" ng-show="{{vm.wrapper.tipoUser ==\'1\'}}">Edici&oacuten</option><option value="revisar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Revisi&oacuten</option><option value="liberar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Liberaci&oacuten</option></select></div><div class="pull-right"><button ng-disabled="vm.isSaving" ng-click="vm.save()" class="btn btn-warning btn-main hidden-print" type="submit" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><span class="glyphicon"></span>&nbsp;<span>Guardar/Actualizar</span></button> <a class="btn btn-primary text-center" ui-sref="reporteevaluativo">Regresar</a></div></div><div><a class="btn btn-primary next text-center hidden-print" ng-click="vm.print()">Imprimir Reporte</a></div></div></div><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><section style="text-align: center"><h4><div>UNIVERSIDAD AUT&OacuteNOMA DE YUCAT&AacuteN</div><div>Direcci&oacuten General de Desarrollo Acad&eacutemico</div><div>Departamento de Innovaci&oacuten e Investigaci&oacuten Educativa</div><div>PROGRAMA INSTITUCIONAL DE EVALUACI&OacuteN DEL DESEMPE&NtildeO DOCENTE</div><br><br><div>{{vm.reporte.institucion.padre.nombre}}</div><div>{{vm.reporte.institucion.nombre}}</div></h4></section><br><br><table class="table table-bordered type-a reportetable"><tr><th>Profesor</th><td>{{vm.reporte.profesor.nombres}} {{vm.reporte.profesor.apellidoPaterno}} {{vm.reporte.profesor.apellidoMaterno}}</td></tr><tr><th>Asignatura</th><td>{{vm.reporte.asignatura.nombre}}</td></tr><tr><th>No.Estudiantes que evaluaron</th><td>{{vm.reporte.numEstudiantes}} de {{vm.wrapper.numTotalAlumnos}}</td></tr><tr><th>Periodo</th><td>{{vm.wrapper.periodoEvaluacion}}</td></tr><tr><th>A&ntildeo escolar</th><td>{{vm.reporte.anioEscolar.descripcion}}</td></tr></table><br><br><div class="reportebody"><strong>CONTENIDO DE LAS SECCIONES</strong><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;El documento reporta la opini&oacuten proveniente de los estudiantes y del mismo profesor ante su desempe&ntildeo docente. Los resultados corresponden al per&iacuteodo se&ntildealado, distribuidos en 4 secciones:<br><div class="title">I. Dimensi&oacuten de desempe&ntildeo</div>* Resultados cuantitativos presentados en dos dimensiones que manifiestan las competencias seleccionadas para evaluar el desempe&ntildeo docente frente a grupo.<br><div class="title">II. Valores Universitarios</div>* Resultados cuantitativos obtenidos de un diferencial sem&aacutentico para cada uno de los valores establecidos en el Plan de Desarrollo Institucional (PDI, 2014-2022).<br><div class="title">III. Satisfacci&oacuten</div>* Resultados cuantitativos a partir de la conformidad ante el desempe&ntildeo del profesor en la asignatura.<br><div class="title">IV. Comentarios</div>* Resultados cualitativos que describen fortalezas y sugerencias para la mejora del desempe&ntildeo del profesor.</div><br><div class="reportebody"><strong>I. RESULTADOS POR DIMENSIONES.</strong><br><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;A partir de las 32 competencias declaradas en el perfil del Profesor UADY (UADY, 2012), se realiz&oacute una selecci&oacuten de ocho competencias que evidencian el trabajo docente frente a grupo en las Asignaturas Obligatorias y Optativas. Con ello se han establecido dos dimensiones a trav&eacutes de las cu&aacuteles se evaluar&aacute el desempe&ntildeo del profesor (Ver Anexo A).<br><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Los resultados se obtienen con la Media de una escala de 4 opciones (1=Casi nunca a 4= Casi siempre) y se realiza una conversi&oacuten a 100.</div><br><br><div class="reportebody" style="text-decoration: underline"><strong>DIMENSI&OacuteN: INTERACCI&OacuteN</strong></div><br><div id="iteraccion" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><div class="reportebody"><div>Desde la perspectiva de los estudiantes:</div><br><table class="table table-bordered type-a"><tr><th></th><th>Estudiante</th></tr><tr><td>Es respetuoso cuando se expresa de otros docentes o compa&ntildeeros de trabajo</td><td>{{ vm.round(vm.reporte.respetuosoOtrosDocentes)}} %</td></tr><tr><td>Est&aacute comprometido con sus actividades como docente</td><td>{{ vm.round(vm.reporte.comprometido)}} %</td></tr></table></div><br><div class="reportebody" style="text-decoration: underline"><strong>DIMENSI&OacuteN: PROCESO DE ENSE&NtildeANZA Y APRENDIZAJE</strong></div><br><div id="tic" style="min-width: 310px; max-width: 800px; height: 250px; margin: 0 auto"></div><div id="estrategias" style="min-width: 310px; max-width: 800px; height: 400px; margin: 0 auto"></div><div id="tecnicas" style="min-width: 310px; max-width: 800px; height: 300px; margin: 0 auto"></div><div id="evaluacion" style="min-width: 310px; max-width: 800px; height: 300px; margin: 0 auto"></div><br><br><div class="reportebody"><strong>II. VALORES UNIVERSITARIOS.</strong><br><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;La Universidad, como parte de los fundamentos de su quehacer cotidiano, declara en el Plan de Desarrollo Institucional (2014 - 2022) los valores que caracterizan el desempe&ntildeo de quienes la conforman (Ver Anexo B).<br><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Los resultados que a continuaci&oacuten se presentan se obtuvieron a trav&eacutes de un diferencial sem&aacutentico de 7 niveles y con la Media se presenta un comparativo entre lo se&ntildealado por el profesor, el estudiante y el grupo de profesores del semestre, a trav&eacutes de una conversi&oacuten a 100.</div><br><div id="valores" style="min-width: 310px; max-width: 800px; height: 400px; margin: 0 auto"></div><div class="reportebody"><table class="table table-bordered type-a reportebody"><tr><td></td><td>Rigor Academico</td><td>Equitativo</td><td>Humilde</td><td>Respetuoso</td><td>Legal</td><td>Tolerante</td><td>Responsable social</td><td>Honesto</td><td>Etico</td></tr><tr><td>Estudiantes</td><td>{{ vm.round(vm.reporte.rigoerAcademicoEstudiantes)}}</td><td>{{ vm.round(vm.reporte.equitativoEstudiantes)}}</td><td>{{ vm.round(vm.reporte.humildeEstudiantes)}}</td><td>{{ vm.round(vm.reporte.respetuosoEstudiantes)}}</td><td>{{ vm.round(vm.reporte.legalEstudiantes)}}</td><td>{{ vm.round(vm.reporte.toleranteEstudiantes)}}</td><td>{{ vm.round(vm.reporte.responsableSocialEstudiantes)}}</td><td>{{ vm.round(vm.reporte.honestoEstudiantes)}}</td><td>{{ vm.round(vm.reporte.eticoEstudiantes)}}</td></tr><tr><td>Autoevaluaci&oacuten</td><td>{{ vm.round(vm.reporte.rigorAcademicoProfesor)}}</td><td>{{ vm.round(vm.reporte.equitativoProfesor)}}</td><td>{{ vm.round(vm.reporte.humildeProfesor)}}</td><td>{{ vm.round(vm.reporte.respetuosoProfesor)}}</td><td>{{ vm.round(vm.reporte.legalProfesor)}}</td><td>{{ vm.round(vm.reporte.toleranteProfesor)}}</td><td>{{ vm.round(vm.reporte.responsableSocialProfesor)}}</td><td>{{ vm.round(vm.reporte.honestoProfesor)}}</td><td>{{ vm.round(vm.reporte.eticoProfesor)}}</td></tr></table></div><br><br><div class="reportebody"><strong>III. SATISFACCI&OacuteN</strong><br><br><div style="text-align: center">INS = Insatisfecho SAT = Satisfecho MSA = Muy Satisfecho</div><br><table class="table table-bordered type-a"><tr><th rowspan="2">Items</th><th colspan="3">Alumnos</th><th colspan="3" ng-show="{{(vm.reporte.valorCompetenciasProfesor !=null) && (vm.isVersion2())}}">Profesor</th><th colspan="3" rowspan="2" ng-show="{{(vm.reporte.valorCompetenciasProfesor !=null) && !(vm.isVersion2())}}">Profesor</th></tr><tr><th>INS</th><th>SAT</th><th>MSA</th><th ng-show="{{(vm.reporte.valorCompetenciasProfesor !=null) && (vm.isVersion2())}}">INS</th><th ng-show="{{(vm.reporte.valorCompetenciasProfesor !=null) && (vm.isVersion2())}}">SAT</th><th ng-show="{{(vm.reporte.valorCompetenciasProfesor !=null) && (vm.isVersion2())}}">MSA</th></tr><tr><td>1. Con las competencias que se han desarrollado en esta asignatura</td><td>{{ vm.round(vm.reporte.insatisfechoCompetencias)}} %</td><td>{{ vm.round(vm.reporte.satisfechoCompetencias)}} %</td><td>{{ vm.round(vm.reporte.muySatisfechoCompetencias)}} %</td><td ng-show="{{(vm.reporte.valorCompetenciasProfesor !=null) && (vm.isVersion2())}}">{{ vm.insatisfechoCompetenciasProfesor() }} %</td><td ng-show="{{(vm.reporte.valorCompetenciasProfesor !=null) && (vm.isVersion2())}}">{{ vm.satisfechoCompetenciasProfesor() }} %</td><td ng-show="{{(vm.reporte.valorCompetenciasProfesor !=null) && (vm.isVersion2())}}">{{ vm.muysatisfechoCompetenciasProfesor() }} %</td><td colspan="3" ng-show="{{(vm.reporte.valorCompetenciasProfesor !=null) && !(vm.isVersion2())}}">{{ vm.reporte.valorCompetenciasProfesor }}</td><td colspan="3" ng-show="{{vm.reporte.valorCompetenciasProfesor ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr><tr><td>2. Con el desempe&ntildeo del profesor</td><td>{{ vm.round(vm.reporte.insatisfechoDesempenio)}} %</td><td>{{ vm.round(vm.reporte.satisfechoDesempenio)}} %</td><td>{{ vm.round(vm.reporte.muySatisfechoDesempenio)}} %</td><td ng-show="{{(vm.reporte.valorDesempenioProfesor !=null) && (vm.isVersion2())}}">{{ vm.insatisfechoDesempenioProfesor() }} %</td><td ng-show="{{(vm.reporte.valorDesempenioProfesor !=null) && (vm.isVersion2())}}">{{ vm.satisfechoDesempenioProfesor() }} %</td><td ng-show="{{(vm.reporte.valorDesempenioProfesor !=null) && (vm.isVersion2())}}">{{ vm.muysatisfechoDesempenioProfesor() }} %</td><td colspan="3" ng-show="{{(vm.reporte.valorDesempenioProfesor !=null) && !(vm.isVersion2())}}">{{ vm.reporte.valorDesempenioProfesor }}</td><td colspan="3" ng-show="{{vm.reporte.valorDesempenioProfesor ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr><tr><td>3. Con las actividades como docentes</td><td></td><td></td><td></td><td ng-show="{{(vm.reporte.valorActividadesDocente !=null) && (vm.isVersion2())}}">{{vm.insatisfechoActividadesDocenteProfesor() }} %</td><td ng-show="{{vm.reporte.valorActividadesDocente !=null}} && (vm.isVersion2())">{{vm.satisfechoActividadesDocenteProfesor() }} %</td><td ng-show="{{vm.reporte.valorActividadesDocente !=null}} && (vm.isVersion2())">{{vm.muysatisfechoActividadesDocenteProfesor() }} %</td><td colspan="3" ng-show="{{(vm.reporte.valorActividadesDocente !=null) && !(vm.isVersion2())}}">{{ vm.reporte.valorActividadesDocente }}</td><td colspan="3" ng-show="{{vm.reporte.valorActividadesDocente ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr></table><br><table class="table table-bordered type-a"><tr><th></th><th>Si</th><th>No</th></tr><tr><td>4. Recomendar a otro estudiante, tomar la asignatura con este profesor</td><td>{{ vm.round(vm.reporte.recomendarProfesorSi)}} %</td><td>{{ vm.round(vm.reporte.recomendarProfesorNo)}} %</td></tr><tr><td colspan="3">Razones Si<br><textarea rows="{{vm.wrapper.comentario1.length==0?0:vm.wrapper.comentario1.split(\'\\n\').length + 8}}" cols="50" class="form-control" name="comentario1" ng-model="vm.wrapper.comentario1" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario1}}</textarea></td></tr><tr><td colspan="3">Razones No<br><textarea rows="{{vm.wrapper.comentario2.length==0?0:vm.wrapper.comentario2.split(\'\\n\').length + 2}}" cols="50" class="form-control" name="comentario2" ng-model="vm.wrapper.comentario2" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario2}}</textarea></td></tr></table></div><br><div class="reportebody"><strong>IV. COMENTARIOS.</strong><br><br><div class="title" style="text-align: center">Profesor<br><br><div class="title" style="text-align: left">Fortalezas:</div><div><textarea rows="{{vm.wrapper.comentario3.length==0?0:vm.wrapper.comentario3.split(\'\\n\').length + 2}}" cols="50" class="form-control" name="fortalezaProfesor" ng-model="vm.wrapper.comentario3" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario3}}</textarea></div><div class="title" style="text-align: left">Sugerencias:</div><div><textarea rows="{{vm.wrapper.comentario4.length==0?0:vm.wrapper.comentario4.split(\'\\n\').length + 2}}" cols="50" class="form-control" name="comentario4" ng-model="vm.wrapper.comentario4" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario4}}</textarea></div></div><div class="title" style="text-align: center">Estudiantes<br><br><div class="title" style="text-align: left">Fortalezas:</div><div><textarea rows="{{vm.wrapper.comentario5.length==0?0:vm.wrapper.comentario5.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="fortalezaEstudiante" ng-model="vm.wrapper.comentario5" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario5}}</textarea></div><div class="title" style="text-align: left">Sugerencias:</div><div><textarea rows="{{vm.wrapper.comentario6.length==0?0:vm.wrapper.comentario6.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="sugerenciasEstudiante" ng-model="vm.wrapper.comentario6" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario6}}</textarea></div><div class="title" style="text-align: left">Comentarios:</div><div><textarea rows="{{vm.wrapper.comentario7.length==0?0:vm.wrapper.comentario7.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="comentario7" ng-model="vm.wrapper.comentario7" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario7}}</textarea></div></div></div><br><br><div class="reportebody"><h4 style="text-align: center">Anexo A.</h4><br><br>*Competencias consideradas para evaluar el desempe&ntildeo docente.<table class="table table-bordered"><tr><th>Criterios</th><th>Competencias del Perfil del profesor UADY</th><th>Dimensiones</th></tr><tr><td>Respeto</td><td><strong>Competencia 2.</strong> Manifiesta un comportamiento hacia las personas con &eacutetica y tolerancia.</td><td rowspan="2">Interacci&oacuten</td></tr><tr><td>Relaci&oacuten</td><td><strong>Competencia 4.</strong> Manifiesta identidad institucional hacia las personas en congruencia con la filosof&iacutea de la Universidad.<br><strong>Competencia 6.</strong> Crea ambientes de aprendizaje en su pr&aacutectica docente, adecuados con las necesidades de sus estudiantes.<br><strong>Competencia 11.</strong> Promueve el aprendizaje aut&oacutenomo en el estudiante de manera continua.<br></td></tr><tr><td>TIC</td><td><strong>Competencia 14.</strong> Utiliza las tecnolog&iacuteas de informaci&oacuten y comunicaci&oacuten como recurso did&aacutectico en su ejercicio docente de manera pertinente.</td><td rowspan="4">Proceso de Ense&ntildeanza y aprendizaje</td></tr><tr><td>Estrategias</td><td><strong>Competencia 12.</strong> Organiza secuencias did&aacutecticas en el proceso de ense&ntildeanza y aprendizaje, congruentes con las competencias a desarrollar y sus contenidos.<br><strong>Competencia 6.</strong> Crea ambientes de aprendizaje en su pr&aacutectica docente, adecuados con las necesidades de sus estudiantes.<br></td></tr><tr><td>T&eacutecnicas y medios de calificaci&oacuten</td><td><strong>Competencia 20.</strong> Incorpora diferentes t&eacutecnicas y medios en la evaluaci&oacuten del proceso para el desarrollo adecuado de las competencias.</td></tr><tr><td>Evaluaci&oacuten</td><td><strong>Competencia 21.</strong> Utiliza la evaluaci&oacuten de producto en el desarrollo de las competencias del estudiantado, de manera objetiva, como evidencia de su nivel de dominio</td></tr><tr style="text-align: center"><td><strong>6 CRITERIOS</strong></td><td><strong>8 COMPETENCIAS</strong></td><td><strong>2 DIMENSIONES</strong></td></tr></table></div><br><div class="reportebody"><h4 style="text-align: center">Anexo B.</h4><br><br><div>*Los valores que en la Universidad Aut&oacutenoma de Yucat&aacuten se declaran como fundamento<br>- <strong>Competencia 2.</strong> Manifiesta un comportamiento hacia las personas con &eacutetica y tolerancia.<br>- <strong>Competencia 3.</strong> Promueve los valores universitarios en el ejercicio de su pr&aacutectica de manera constante.<br>- <strong>Competencia 4.</strong> Manifiesta identidad institucional hacia las personas en congruencia con la filosof&iacutea de la Universidad.</div><br>(PDI 2014 - 2022 / UADY, 2012).<table class="table table-bordered"><tr><th>Valores</th><th>Descripci&oacuten establecida en el PDI</th></tr><tr><td>Equidad y calidad</td><td>Conforman un binomio indisoluble de valores de la responsabilidad social de la UADY. Implican ofrecer igualdad de oportunidades educativas socialmente relevantes y de buena calidad para la formaci&oacuten de los j&oacutevenes y promover acciones que mejoren las condiciones de bienestar y limiten las situaciones de exclusi&oacuten social.</td></tr><tr><td>La responsabilidad social Universitaria</td><td>Como un modo permanente de operar de todas las funciones universitarias. Promueve el desarrollo de competencias centradas en el desarrollo sostenible, cuidado ambiental y participaci&oacuten social.</td></tr><tr><td>Rigor acad&eacutemico</td><td>Representa para los universitarios el compromiso con la precisi&oacuten y seriedad en el desarrollo de todas las tareas en la b&uacutesqueda permanente de lo verdadero.</td></tr><tr><td>legalidad</td><td>Como el marco irrenunciable de comportamiento, en el cual la comunidad universitaria desarrolla sus actividades en estricto apego a la normativa institucional y a las leyes aplicables.</td></tr><tr><td>Etica y respeto</td><td>Como premisas de la actitud de los universitarios en el desempe&ntildeo de sus actividades. Es en un ambiente de respeto y &eacutetica en el que se pueden formar ciudadanos socialmente comprometidos.</td></tr><tr><td>Honestidad</td><td>Entendida como el soporte institucional fundamental de las virtudes que deben distinguir a la Instituci&oacuten.</td></tr><tr><td>Humildad</td><td>La actitud de los universitarios para no presumir de sus logros y reconocer sus fracasos y debilidades en el cumplimiento de sus funciones.</td></tr><tr><td>Tolerancia</td><td>Constituye el s&oacutelido fundamento de toda comunidad que se desarrolla arm&oacutenicamente y en paz. Significa el reconocimiento y apreciaci&oacuten de los dem&aacutes, la capacidad de convivir con otros y de escucharlos.</td></tr></table></div><footer style="text-align: right" class="reportebody">UADY (2012). Modelo Educativo para la Formaci&oacuten Integral. Universidad Aut&oacutenoma de Yucat&aacuten.<br>PDI (2014-2022). Plan de Desarrollo Institucional. Universidad Aut&oacutenoma de Yucat&aacuten.</footer></div>');
$templateCache.put('app/reportes/reporteevaluativoUAEV/reporteevaluativoUAEV.html','<div><!-- Page Content --><div class="page-header"><div class="text-center"><div class="title hidden-print clearfix" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><div class="pull-left form-inline"><label for="exampleInputName2">Fase del reporte:</label><select required class="form-control hidden-print" ng-model="vm.reporte.status" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><option value="editar" ng-show="{{vm.wrapper.tipoUser ==\'1\'}}">Edici&oacuten</option><option value="revisar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Revisi&oacuten</option><option value="liberar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Liberaci&oacuten</option></select></div><div class="pull-right"><button ng-disabled="vm.isSaving" ng-click="vm.save()" class="btn btn-warning btn-main hidden-print" type="submit" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><span class="glyphicon"></span>&nbsp;<span>Guardar/Actualizar</span></button> <a class="btn btn-primary text-center" ui-sref="reporteevaluativo">Regresar</a></div></div><div><a class="btn btn-primary next text-center hidden-print" ng-click="vm.print()">Imprimir Reporte</a></div></div></div><jhi-alert-error></jhi-alert-error><section style="text-align: center"><h4><div>UNIVERSIDAD AUT&OacuteNOMA DE YUCAT&AacuteN</div><div>Direcci&oacuten General de Desarrollo Acad&eacutemico</div><div>Departamento de Innovaci&oacuten e Investigaci&oacuten Educativa</div><div>PROGRAMA INSTITUCIONAL DE EVALUACI&OacuteN DEL DESEMPE&NtildeO DOCENTE</div><br><br><div>{{vm.reporte.institucion.padre.nombre}}</div><div>{{vm.reporte.institucion.nombre}}</div></h4></section><br><br><table class="table table-bordered type-a reportetable"><tr><th>Profesor</th><td>{{vm.reporte.profesor.nombres}} {{vm.reporte.profesor.apellidoPaterno}} {{vm.reporte.profesor.apellidoMaterno}}</td></tr><tr><th>Asignatura</th><td>{{vm.reporte.asignatura.nombre}}</td></tr><tr><th>No.Estudiantes que evaluaron</th><td>{{vm.reporte.totalAlumnos}} de {{vm.wrapper.numTotalAlumnos}}</td></tr><tr><th>Periodo</th><td>{{vm.wrapper.periodoEvaluacion}}</td></tr><tr><th>A&ntildeo escolar</th><td>{{vm.reporte.anioEscolar.descripcion}}</td></tr></table><br><br><div class="reportebody"><strong>CONTENIDO DE LAS SECCIONES</strong><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;El documento reporta la opini&oacuten proveniente del estudiantado y del personal docente evaluado. Los resultados corresponden al per&iacuteodo se&ntildealado, distribuidos en 3 secciones:<br><div class="title">I. Desempe&ntildeo del profesor</div>* Resultados cuantitativos presentados en dos dimensiones que manifiestan los aspectos para evaluar el desempe&ntildeo docente.<br><ul><li>Interacci&oacuten<ul><li>Relaci&oacuten profesor \u2013 estudiante</li></ul></li><li>Proceso ense&ntildeanza y aprendizaje<ul><li>Estrategias</li><li>Materiales y recursos</li><li>Estrategias de evaluaci&oacuten</li></ul></li></ul><div class="title">II. Satisfacci&oacuten</div>* Resultados cuantitativos a partir de la conformidad ante el desempe&ntildeo del personal docente en la asignatura.<br><div class="title">III. Comentarios y opiniones</div>* Resultados cualitativos que describen fortalezas y sugerencias para la mejora del desempe&ntildeo del profesor.</div><br><br><div class="reportebody"><strong>I.\tDesempe&ntildeo del profesor.</strong><br><strong>1.\tInteracci&oacuten</strong><br><br><strong>Respuestas del estudiantado</strong></div><br><div id="iteraccion" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><div class="reportebody"><strong>Respuestas del personal docente</strong><br><br></div><div class="reportebody"><div class="title">Estrategias para identificar las necesidades o recursos para aprender de manera independiente, en esta asignatura</div><div><textarea rows="{{vm.wrapper.sugerencias_p.length==0?0:vm.wrapper.sugerencias_p.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="sugerencias_p" ng-model="vm.wrapper.sugerencias_p" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.sugerencias_p}}</textarea></div></div><br><div class="reportebody"><strong>2.\tEstrategias de ense&ntildeanza y aprendizaje</strong></div><br><div id="estrategias" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><div class="reportebody"><strong>3.\tMateriales y recursos de ense&ntildeanza</strong></div><br><div id="materias" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><div class="reportebody"><strong>4.\tEstrategias de evaluaci&oacuten</strong></div><br><div id="evaluacion" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><br><div class="reportebody"><strong>II.\tSatisfacci&oacuten</strong><br><br><div style="text-align: center">INS = Insatisfecho, SAT = Satisfecho, MSA = Muy Satisfecho</div><br><table class="table table-bordered type-a"><tr><th rowspan="2"></th><th colspan="3">Estudiantado</th><th colspan="3" ng-show="{{(vm.reporte.competenciasDesarrEstuINS_p !=null) }}">Autoevaluaci&oacuten</th></tr><tr><th>INS</th><th>SAT</th><th>MSA</th><th>INS</th><th>SAT</th><th>MSA</th></tr><tr><td>1.\tCon las competencias que se han desarrollado en esta asignatura</td><td>{{ vm.round(vm.reporte.competenciasDesarrolladoAsignaturaINS_e) }} %</td><td>{{ vm.round(vm.reporte.competenciasDesarrolladoAsignaturaSAT_e) }} %</td><td>{{ vm.round(vm.reporte.competenciasDesarrolladoAsignaturaMSA_e) }} %</td><td>{{ vm.round(vm.reporte.competenciasDesarrEstuINS_p) }} %</td><td>{{ vm.round(vm.reporte.competenciasDesarrEstuSAT_p) }} %</td><td>{{ vm.round(vm.reporte.competenciasDesarrEstuMSA_p) }} %</td><td colspan="3" ng-show="{{vm.reporte.competenciasDesarrEstuINS_p ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr><tr><td>2.\tCon el seguimiento a las dudas o comentarios</td><td>{{ vm.round(vm.reporte.seguiDudasComenINS_e)}} %</td><td>{{ vm.round(vm.reporte.seguiDudasComenSAT_e)}} %</td><td>{{ vm.round(vm.reporte.seguiDudasComenMSA_e)}} %</td><td>{{ vm.round(vm.reporte.seguimientoDudasINS_p) }} %</td><td>{{ vm.round(vm.reporte.seguimientoDudasSAT_p) }} %</td><td>{{ vm.round(vm.reporte.seguimientoDudasMSA_p) }} %</td><td colspan="3" ng-show="{{vm.reporte.seguimientoDudasINS_p ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr><tr><td>3.\tCon el tiempo que se utiliza para atender dudas</td><td>{{ vm.round(vm.reporte.tiempoUtilizaAtenderDudasINS_e) }} %</td><td>{{ vm.round(vm.reporte.tiempoUtilizaAtenderDudasSAT_e) }} %</td><td>{{ vm.round(vm.reporte.tiempoUtilizaAtenderDudasMSA_e) }} %</td><td>{{ vm.round(vm.reporte.tiempoUtilizoAtenderDudasINS_p) }} %</td><td>{{ vm.round(vm.reporte.tiempoUtilizoAtenderDudasSAT_p) }} %</td><td>{{ vm.round(vm.reporte.tiempoUtilizoAtenderDudasMSA_p) }} %</td><td colspan="3" ng-show="{{vm.reporte.tiempoUtilizoAtenderDudasINS_p ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr><tr><td>4.\tCon la participaci\xF3n docente en el aula virtual</td><td>{{ vm.round(vm.reporte.participDocenteAulaVINS_e) }} %</td><td>{{ vm.round(vm.reporte.participDocenteAulaVSAT_e) }} %</td><td>{{ vm.round(vm.reporte.participDocenteAulaVMSA_e) }} %</td><td>{{ vm.round(vm.reporte.participacionAulaVirtualINS_p) }} %</td><td>{{ vm.round(vm.reporte.participacionAulaVirtualSAT_p) }} %</td><td>{{ vm.round(vm.reporte.participacionAulaVirtualMSA_p) }} %</td><td colspan="3" ng-show="{{vm.reporte.participacionAulaVirtualINS_p ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr><tr><td>5.\tCon los recursos y materiales utilizados</td><td>{{ vm.round(vm.reporte.recursosMateUtiINS_e) }} %</td><td>{{ vm.round(vm.reporte.recursosMateUtiSAT_e) }} %</td><td>{{ vm.round(vm.reporte.recursosMateUtiMSA_e) }} %</td><td>{{ vm.round(vm.reporte.recursosMaterialesUtilizadosINS_p) }} %</td><td>{{ vm.round(vm.reporte.recursosMaterialesUtilizadosSAT_p) }} %</td><td>{{ vm.round(vm.reporte.recursosMaterialesUtilizadosMSA_p) }} %</td><td colspan="3" ng-show="{{vm.reporte.recursosMaterialesUtilizadosINS_p ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr><tr><td>6.\tCon el apoyo docente en el proceso de aprendizaje</td><td>{{ vm.round(vm.reporte.apoyoDocenteProcesoAprenINS_e) }} %</td><td>{{ vm.round(vm.reporte.apoyoDocenteProcesoAprenSAT_e) }} %</td><td>{{ vm.round(vm.reporte.apoyoDocenteProcesoAprenMSA_e) }} %</td><td>{{ vm.round(vm.reporte.apoyoBrinProcAprenEstuINS_p) }} %</td><td>{{ vm.round(vm.reporte.apoyoBrinProcAprenEstuSAT_p) }} %</td><td>{{ vm.round(vm.reporte.apoyoBrinProcAprenEstuMSA_p) }} %</td><td colspan="3" ng-show="{{vm.reporte.apoyoBrinProcAprenEstuINS_p ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr><tr><td>7.\tCon el desempe\xF1o docente</td><td>{{ vm.round(vm.reporte.desempeniooDocenteINS_e) }} %</td><td>{{ vm.round(vm.reporte.desempeniooDocenteSAT_e) }} %</td><td>{{ vm.round(vm.reporte.desempeniooDocenteMSA_e) }} %</td><td>{{ vm.round(vm.reporte.desempenioDocenteINS_p) }} %</td><td>{{ vm.round(vm.reporte.desempenioDocenteSAT_p) }} %</td><td>{{ vm.round(vm.reporte.desempenioDocenteMSA_p) }} %</td><td colspan="3" ng-show="{{vm.reporte.desempenioDocenteINS_p ==null}}">No se tiene registro de autoevaluaci&oacuten</td></tr></table></div><div class="reportebody"><strong>III. Comentarios y opiniones</strong><br><br><table class="table table-bordered type-a"><tr><th></th><th>Si</th><th>No</th></tr><tr><td>Recomendar a otro estudiante, cursar la asignatura con este (a) profesor (a)</td><td>{{ vm.round(vm.reporte.recomendarProfesorSi_e)}} %</td><td>{{ vm.round(vm.reporte.recomendarProfesorNo_e)}} %</td></tr><tr><td colspan="3">Razones Si<br><textarea rows="{{vm.wrapper.razonSi_e.length==0?0:vm.wrapper.razonSi_e.split(\'\\n\').length + 8}}" cols="50" class="form-control" name="razonesSi" ng-model="vm.wrapper.razonSi_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.razonSi_e}}</textarea></td></tr><tr><td colspan="3">Razones No<br><textarea rows="{{vm.wrapper.razonNo_e.length==0?0:vm.wrapper.razonNo_e.split(\'\\n\').length + 2}}" cols="50" class="form-control" name="razonesNo" ng-model="vm.wrapper.razonNo_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.razonNo_e}}</textarea></td></tr></table><br><div class="title" style="text-align: left">Fortalezas</div><div><textarea rows="{{vm.wrapper.fortalezas_e.length==0?0:vm.wrapper.fortalezas_e.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="fortaleza_e" ng-model="vm.wrapper.fortalezas_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.fortalezas_e}}</textarea></div><div class="title" style="text-align: left">&Aacutereas de mejora:</div><div><textarea rows="{{vm.wrapper.sugerencias_e.length==0?0:vm.wrapper.sugerencias_e.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="sugerencias_e" ng-model="vm.wrapper.sugerencias_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.sugerencias_e}}</textarea></div><div class="title" style="text-align: left">Comentarios generales estudiantado</div><div><textarea rows="{{vm.wrapper.comentarios_e.length==0?0:vm.wrapper.comentarios_e.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="comentarios_e" ng-model="vm.wrapper.comentarios_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentarios_e}}</textarea></div><div class="title" style="text-align: left">Comentarios generales del personal docente</div><div><textarea rows="{{vm.wrapper.comentarios_p.length==0?0:vm.wrapper.comentarios_p.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="comentarios_p" ng-model="vm.wrapper.comentarios_p" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentarios_p}}</textarea></div><br><br><br><br></div></div>');
$templateCache.put('app/reportes/reporteevaluativoVirtual/reporteevaluativoVirtual.html','<div><!-- Page Content --><div class="page-header"><div class="text-center"><div class="title hidden-print clearfix" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><div class="pull-left form-inline"><label for="exampleInputName2">Fase del reporte:</label><select required class="form-control hidden-print" ng-model="vm.reporte.status" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><option value="editar" ng-show="{{vm.wrapper.tipoUser ==\'1\'}}">Edici&oacuten</option><option value="revisar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Revisi&oacuten</option><option value="liberar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Liberaci&oacuten</option></select></div><div class="pull-right"><button ng-disabled="vm.isSaving" ng-click="vm.save()" class="btn btn-warning btn-main hidden-print" type="submit" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><span class="glyphicon"></span>&nbsp;<span>Guardar/Actualizar</span></button> <a class="btn btn-primary text-center" ui-sref="reporteevaluativo">Regresar</a></div></div><div><a class="btn btn-primary next text-center hidden-print" ng-click="vm.print()">Imprimir Reporte</a></div></div></div><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><section style="text-align: center"><h4><div>UNIVERSIDAD AUT&OacuteNOMA DE YUCAT&AacuteN</div><div>Direcci&oacuten General de Desarrollo Acad&eacutemico</div><div>Departamento de Innovaci&oacuten e Investigaci&oacuten Educativa</div><div>PROGRAMA INSTITUCIONAL DE EVALUACI&OacuteN DEL DESEMPE&NtildeO DOCENTE</div><br><br><div>{{vm.reporte.institucion.padre.nombre}}</div><div>{{vm.reporte.institucion.nombre}}</div></h4></section><br><br><table class="table table-bordered type-a reportetable"><tr><th>Profesor</th><td>{{vm.reporte.profesor.nombres}} {{vm.reporte.profesor.apellidoPaterno}} {{vm.reporte.profesor.apellidoMaterno}}</td></tr><tr><th>Asignatura</th><td>{{vm.reporte.asignatura.nombre}}</td></tr><tr><th>No.Estudiantes que evaluaron</th><td>{{vm.reporte.totalalumnos}} de {{vm.wrapper.numTotalAlumnos}}</td></tr><tr><th>Periodo</th><td>{{vm.wrapper.periodoEvaluacion}}</td></tr><tr><th>A&ntildeo escolar</th><td>{{vm.reporte.anioEscolar.descripcion}}</td></tr></table><br><br><div class="reportebody"><strong>CONTENIDO DE LAS SECCIONES</strong><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;El instrumento que se administr&oacute estuvo constituido por 30 preguntas que se clasifican para su interpretaci&oacuten, en las siguientes categor&iacuteas:<br><div class="title">I. Dimensiones</div><ul><li>Identidad institucional</li><li>Ambientes de aprendizaje</li><li>Evaluaci\xF3n</li></ul><br><div class="title">II. Satisfacci&oacuten</div>* Esta categor&iacutea eval&uacutea el desempe&ntildeo del profesor a lo largo del curso, as&iacute como la satisfacci&oacuten por los aprendizajes logrados por parte de los estudiantes.<br><div class="title">III. Comentarios</div>* Opini&oacuten del estudiante en relaci&oacuten a las fortalezas y &aacutereas de mejora del profesor.<br></div><br><div class="reportebody"><strong>I. NIVEL DE DESEMPE&NtildeO POR CATEGOR&IacuteA.</strong><br><br><h4>1.\tIdentidad institucional.</h4><div id="identidadinstitucionalVir" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><h4>2.\tAmbientes de aprendizaje.</h4><div id="ambientesaprendizajeVir" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><h4>3.\tEvaluaci&oacuten.</h4><div id="evaluacionVir" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div></div><div class="reportebody"><strong>II. SATISFACCI&OacuteN</strong><br><div style="text-align: center">INS = Insatisfecho SAT = Satisfecho MSA = Muy Satisfecho</div><br><table class="table table-bordered type-a"><tr><th>Items</th><th>INS</th><th>SAT</th><th>MSA</th></tr><tr><td>1.\tCon la identidad institucional demostrada por el profesor.</td><td>{{ vm.reporte.identidadinstiprofINS}} %</td><td>{{ vm.reporte.identidadinstiprofSAT}} %</td><td>{{ vm.reporte.identidadinstiprofMSA}} %</td></tr><tr><td>2.\tCon las competencias desarrolladas a partir del trabajo con el profesor.</td><td>{{ vm.reporte.competdesaINS}} %</td><td>{{ vm.reporte.competdesaSAT}} %</td><td>{{ vm.reporte.competdesaMSA}} %</td></tr><tr><td>3.\tCon el desempe\xF1o del profesor.</td><td>{{ vm.reporte.desempprofesorINS}} %</td><td>{{ vm.reporte.desempprofesorSAT}} %</td><td>{{ vm.reporte.desempprofesorMSA}} %</td></tr></table><br><table class="table table-bordered type-a"><tr><th></th><th>Si</th><th>No</th></tr><tr><td>4.\tRecomendar a otro estudiante tomar la asignatura con este profesor.</td><td>{{ vm.reporte.recomiendasprofesorsi }} %</td><td>{{ vm.reporte.recomiendasprofesorno }} %</td></tr><tr><td colspan="3">Razones Si<br><textarea rows="{{vm.wrapper.comentario1.length==0?0:vm.wrapper.comentario1.split(\'\\n\').length + 8}}" cols="50" class="form-control" name="comentario1" ng-model="vm.wrapper.comentario1" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario1}}</textarea></td></tr><tr><td colspan="3">Razones No<br><textarea rows="{{vm.wrapper.comentario2.length==0?0:vm.wrapper.comentario2.split(\'\\n\').length + 2}}" cols="50" class="form-control" name="comentario2" ng-model="vm.wrapper.comentario2" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario2}}</textarea></td></tr></table><div><div class="reportebody"><strong>III. COMENTARIOS</strong><br><div class="title" style="text-align: center">Estudiantes<br><br><div class="title" style="text-align: left">Fortalezas:</div><div><textarea rows="{{vm.wrapper.comentario3.length==0?0:vm.wrapper.comentario3.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="fortalezaEstudiante" ng-model="vm.wrapper.comentario3" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario3}}</textarea></div><div class="title" style="text-align: left">&Aacutereas de mejora:</div><div><textarea rows="{{vm.wrapper.comentario4.length==0?0:vm.wrapper.comentario4.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="sugerenciasEstudiante" ng-model="vm.wrapper.comentario4" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario4}}</textarea></div><div class="title" style="text-align: left">Comentarios generales:</div><div><textarea rows="{{vm.wrapper.comentario5.length==0?0:vm.wrapper.comentario5.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="comentario5" ng-model="vm.wrapper.comentario5" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario5}}</textarea></div></div><div></div></div></div></div></div>');
$templateCache.put('app/reportes/reporteevaluativoRegular/reporteevaluativoRegular.html','<div><!-- Page Content --><div class="page-header"><!--  <h2 id="navbar">Reporte Asignaturas Curso \xDAnico</h2> --><div class="text-center"><div class="title hidden-print clearfix" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><div class="pull-left form-inline"><label for="exampleInputName2">Fase del reporte:</label><select required class="form-control hidden-print" ng-model="vm.reporte.status" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><option value="editar" ng-show="{{vm.wrapper.tipoUser ==\'1\'}}">Edici&oacuten</option><option value="revisar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Revisi&oacuten</option><option value="liberar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Liberaci&oacuten</option></select></div><div class="pull-right"><button ng-disabled="vm.isSaving" ng-click="vm.save()" class="btn btn-warning btn-main hidden-print" type="submit" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><span class="glyphicon"></span>&nbsp;<span>Guardar/Actualizar</span></button> <a class="btn btn-primary text-center" ui-sref="reporteevaluativo">Regresar</a></div></div><div><a class="btn btn-primary next text-center hidden-print" ng-click="vm.print()">Imprimir Reporte</a></div></div></div><jhi-alert-error></jhi-alert-error><section style="text-align: center"><h4><div>UNIVERSIDAD AUT&OacuteNOMA DE YUCAT&AacuteN</div><div>Direcci&oacuten General de Desarrollo Acad&eacutemico</div><div>Departamento de Innovaci&oacuten e Investigaci&oacuten Educativa</div><div>PROGRAMA INSTITUCIONAL DE EVALUACI&OacuteN DEL DESEMPE&NtildeO DOCENTE</div><br><br><div>{{vm.reporte.institucion.padre.nombre}}</div><div>{{vm.reporte.institucion.nombre}}</div></h4></section><br><br><table class="table table-bordered type-a reportetable"><tr><th>Profesor</th><td>{{vm.reporte.profesor.nombres}} {{vm.reporte.profesor.apellidoPaterno}} {{vm.reporte.profesor.apellidoMaterno}}</td></tr><tr><th>Asignatura</th><td>{{vm.reporte.asignatura.nombre}}</td></tr><tr><th>No.Estudiantes que evaluaron</th><td>{{vm.reporte.totalalumnos}} de {{vm.wrapper.numTotalAlumnos}}</td></tr><tr><th>Periodo</th><td>{{vm.wrapper.periodoEvaluacion}}</td></tr><tr><th>A&ntildeo escolar</th><td>{{vm.reporte.anioEscolar.descripcion}}</td></tr></table><br><br><div class="reportebody"><strong>CONTENIDO DE LAS SECCIONES</strong><br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;El instrumento que se administr&oacute estuvo constituido por 30 preguntas que se clasifican para su interpretaci&oacuten, en las siguientes categor&iacuteas:<br><div class="title">I. Dimensiones</div><ul><li>Identidad institucional</li><li>Ambientes de aprendizaje</li><li>Evaluaci\xF3n</li></ul><br><div class="title">II. Satisfacci&oacuten</div>* Esta categor&iacutea eval&uacutea el desempe&ntildeo del profesor a lo largo del curso, as&iacute como la satisfacci&oacuten por los aprendizajes logrados por parte de los estudiantes.<br><div class="title">III. Comentarios</div>* Opini&oacuten del estudiante en relaci&oacuten a las fortalezas y &aacutereas de mejora del profesor.<br></div><br><div class="reportebody"><strong>I. NIVEL DE DESEMPE&NtildeO POR CATEGOR&IacuteA.</strong><br><br><h4>1.\tIdentidad institucional.</h4><div id="identidadinstitucionalReg" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><h4>2.\tAmbientes de aprendizaje.</h4><div id="ambientesaprendizajeReg" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><h4>3.\tEvaluaci&oacuten.</h4><div id="evaluacionReg" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div></div><div class="reportebody"><strong>II. SATISFACCI&OacuteN</strong><br><div style="text-align: center">INS = Insatisfecho SAT = Satisfecho MSA = Muy Satisfecho</div><br><table class="table table-bordered type-a"><tr><th>Items</th><th>INS</th><th>SAT</th><th>MSA</th></tr><tr><td>1.\tCon la identidad institucional demostrada por el profesor.</td><td>{{ vm.reporte.identidadinstuprofesorINS}} %</td><td>{{ vm.reporte.identidadinstuprofesorSAT}} %</td><td>{{ vm.reporte.identidadinstuprofesorMSA}} %</td></tr><tr><td>2.\tCon las competencias desarrolladas a partir del trabajo con el profesor.</td><td>{{ vm.reporte.competenciadesarolladasINS}} %</td><td>{{ vm.reporte.competenciadesarolladasSAT}} %</td><td>{{ vm.reporte.competenciadesarolladasMSA}} %</td></tr><tr><td>3.\tCon el desempe\xF1o del profesor.</td><td>{{ vm.reporte.desempenioprofesorINS}} %</td><td>{{ vm.reporte.desempenioprofesorSAT}} %</td><td>{{ vm.reporte.desempenioprofesorMSA}} %</td></tr></table><br><table class="table table-bordered type-a"><tr><th></th><th>Si</th><th>No</th></tr><tr><td>4.\tRecomendar a otro estudiante tomar la asignatura con este profesor.</td><td>{{ vm.reporte.recomiendasprofesorsi }} %</td><td>{{ vm.reporte.recomiendasprofesorno }} %</td></tr><tr><td colspan="3">Razones Si<br><textarea rows="{{vm.wrapper.comentario1.length==0?0:vm.wrapper.comentario1.split(\'\\n\').length + 8}}" cols="50" class="form-control" name="comentario1" ng-model="vm.wrapper.comentario1" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario1}}</textarea></td></tr><tr><td colspan="3">Razones No<br><textarea rows="{{vm.wrapper.comentario2.length==0?0:vm.wrapper.comentario2.split(\'\\n\').length + 2}}" cols="50" class="form-control" name="comentario2" ng-model="vm.wrapper.comentario2" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario2}}</textarea></td></tr></table><div><div class="reportebody"><strong>III. COMENTARIOS</strong><br><div class="title" style="text-align: center">Estudiantes<br><br><div class="title" style="text-align: left">Fortalezas:</div><div><textarea rows="{{vm.wrapper.comentario3.length==0?0:vm.wrapper.comentario3.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="fortalezaEstudiante" ng-model="vm.wrapper.comentario3" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario3}}</textarea></div><div class="title" style="text-align: left">&Aacutereas de mejora:</div><div><textarea rows="{{vm.wrapper.comentario4.length==0?0:vm.wrapper.comentario4.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="sugerenciasEstudiante" ng-model="vm.wrapper.comentario4" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario4}}</textarea></div><div class="title" style="text-align: left">Comentarios generales:</div><div><textarea rows="{{vm.wrapper.comentario5.length==0?0:vm.wrapper.comentario5.split(\'\\n\').length + 6}}" cols="50" class="form-control" name="comentario5" ng-model="vm.wrapper.comentario5" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> {{vm.wrapper.comentario5}}</textarea></div></div><div></div></div></div></div></div>');
$templateCache.put('app/reportes/reporteevaluativoVirtualPII/reporteevaluativoVirtualPII.html','<div><!-- Page Content --><div class="page-header"><div class="text-center"><div class="title hidden-print clearfix" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><div class="pull-left form-inline"><label for="exampleInputName2">Fase del reporte:</label><select required class="form-control hidden-print" ng-model="vm.reporte.status" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><option value="editar" ng-show="{{vm.wrapper.tipoUser ==\'1\'}}">Edici&oacuten</option><option value="revisar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Revisi&oacuten</option><option value="liberar" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}">Liberaci&oacuten</option></select></div><div class="pull-right"><button ng-disabled="vm.isSaving" ng-click="vm.save()" class="btn btn-warning btn-main hidden-print" type="submit" ng-show="{{vm.wrapper.tipoUser ==\'2\' || vm.wrapper.tipoUser ==\'1\'}}"><span class="glyphicon"></span>&nbsp;<span>Guardar/Actualizar</span></button> <a class="btn btn-primary text-center" ui-sref="reporteevaluativo">Regresar</a></div></div><div><a class="btn btn-primary next text-center hidden-print" ng-click="vm.print()">Imprimir Reporte</a></div></div></div><jhi-alert-error></jhi-alert-error><section style="text-align: center"><h4><div>Direcci&oacuten General de Desarrollo Acad&eacutemico</div><div>PROGRAMA DE EVALUACI&OacuteN</div><div>PROGRAMA INSTITUCIONAL DE INGL&EacuteS</div><br><br></h4></section><table class="table table-bordered type-a reportetable"><tr><th>Profesor</th><td>{{vm.reporte.profesor.nombres}} {{vm.reporte.profesor.apellidoPaterno}} {{vm.reporte.profesor.apellidoMaterno}}</td></tr><tr><th>Per&iacuteodo que se eval&uacutea</th><td>{{vm.wrapper.periodoEvaluacion}}</td></tr><tr><th>No. de participantes que evaluaron</th><td>{{vm.reporte.totalalumnos}} de {{vm.wrapper.numTotalAlumnos}}</td></tr><tr><th>Asignatura</th><td>{{vm.reporte.asignatura.nombre}}</td></tr><tr><th>Grupo</th><td>{{vm.reporte.grupo.grupo}}</td></tr><tr><th>Modalidad</th><td>{{vm.reporte.formaDeEvaluar}}</td></tr><tr><th>A&ntildeo escolar</th><td>{{vm.reporte.anioEscolar.descripcion}}</td></tr></table><br><br><div class="reportebody"><h4>1. Interacci&oacuten estudiante - docente</h4><br><div id="iteraccion1" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br><div id="iteraccion2" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br></div><div class="reportebody"><h4>2. Estrategias de ense&ntildeanza</h4><br><div id="estrategias2" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br></div><div class="reportebody"><h4>3. Estrategias de evaluaci\xF3n</h4><br><div id="estrategias3" style="min-width: 310px; max-width: 800px; height: 500px; margin: 0 auto"></div><br></div><div class="reportebody"><h4>4. Satisfacci&oacuten</h4><br><br><div style="text-align: center">INS = Insatisfecho SAT = Satisfecho MSA = Muy Satisfecho</div><br><table class="table table-bordered type-a"><tr><th rowspan="2">Satisfacci\xF3n con el aprendizaje del estudiante</th><th colspan="3">Estudiantes</th></tr><tr><th>INS</th><th>SAT</th><th>MSA</th></tr><tr><td>1. Con el desarrollo de la competencia para hablar en el idioma ingl\xE9s.</td><td>{{ vm.round(vm.reporte.hablains_e)}} %</td><td>{{ vm.round(vm.reporte.hablasat_e)}} %</td><td>{{ vm.round(vm.reporte.hablamsa_e)}} %</td></tr><tr><td>2. Con el desarrollo de la competencia para escuchar en el idioma ingl\xE9s.</td><td>{{ vm.round(vm.reporte.escucharins_e)}} %</td><td>{{ vm.round(vm.reporte.escucharsat_e)}} %</td><td>{{ vm.round(vm.reporte.escucharmsa_e)}} %</td></tr><tr><td>3. Con el desarrollo de la competencia para leer en el idioma ingl\xE9s.</td><td>{{ vm.round(vm.reporte.leerins_e)}} %</td><td>{{ vm.round(vm.reporte.leersat_e)}} %</td><td>{{ vm.round(vm.reporte.leermsa_e)}} %</td></tr><tr><td>4. Con el desarrollo de la competencia para escribir en el idioma ingl\xE9s.</td><td>{{ vm.round(vm.reporte.escribirins_e)}} %</td><td>{{ vm.round(vm.reporte.escribirsat_e)}} %</td><td>{{ vm.round(vm.reporte.escribirmsa_e)}} %</td></tr></table><br><table class="table table-bordered type-a"><tr><th rowspan="2">Satisfacci\xF3n con materiales y recursos</th><th colspan="3">Estudiantes</th></tr><tr><th>INS</th><th>SAT</th><th>MSA</th></tr><tr><td>1. Con los contenidos del curso.</td><td>{{ vm.round(vm.reporte.contenidoscursoins_e)}} %</td><td>{{ vm.round(vm.reporte.contenidoscursosat_e)}} %</td><td>{{ vm.round(vm.reporte.contenidoscursomsa_e)}} %</td></tr><tr><td>2. Con la claridad de las instrucciones en las actividades.</td><td>{{ vm.round(vm.reporte.caridinstrucins_e)}} %</td><td>{{ vm.round(vm.reporte.caridinstrucsat_e)}} %</td><td>{{ vm.round(vm.reporte.caridinstrucmsa_e)}} %</td></tr><tr><td>3. Con la variedad de ejercicios auditivos y de lectura.</td><td>{{ vm.round(vm.reporte.variedejaudlecins_e)}} %</td><td>{{ vm.round(vm.reporte.variedejaudlecsat_e)}} %</td><td>{{ vm.round(vm.reporte.variedejaudlecmsa_e)}} %</td></tr><tr><td>4. Con la variedad de ejercicios orales y escritos.</td><td>{{ vm.round(vm.reporte.variedejorescrins_e)}} %</td><td>{{ vm.round(vm.reporte.variedejorescrsat_e)}} %</td><td>{{ vm.round(vm.reporte.variedejorescrmsa_e)}} %</td></tr><tr><td>5. Con los recursos y materiales proporcionados.</td><td>{{ vm.round(vm.reporte.recmatpropins_e)}} %</td><td>{{ vm.round(vm.reporte.recmatpropsat_e)}} %</td><td>{{ vm.round(vm.reporte.recmatpropmsa_e)}} %</td></tr><tr><td>6. Con la cantidad de actividades en el curso.</td><td>{{ vm.round(vm.reporte.cantactsins_e)}} %</td><td>{{ vm.round(vm.reporte.cantactssat_e)}} %</td><td>{{ vm.round(vm.reporte.cantactsmsa_e)}} %</td></tr><tr><td>7. Con los tiempos de entrega de las actividades.</td><td>{{ vm.round(vm.reporte.tiempoentractsins_e)}} %</td><td>{{ vm.round(vm.reporte.tiempoentractssat_e)}} %</td><td>{{ vm.round(vm.reporte.tiempoentractsmsa_e)}} %</td></tr><tr><td>8. Con la ubicaci\xF3n, disposici\xF3n, colores, tama\xF1o y tipo de letra utilizadas en la plataforma.</td><td>{{ vm.round(vm.reporte.ubidispoins_e)}} %</td><td>{{ vm.round(vm.reporte.ubidisposat_e)}} %</td><td>{{ vm.round(vm.reporte.ubidispomsa_e)}} %</td></tr></table><br></div><br><div class="reportebody"><h4>5. Comentarios</h4><br><table class="table table-bordered type-a"><tr><th rowspan="2">\xBFRecomendar\xEDas a estudiantes tomar el curso con tu docente de forma virtual?</th><th>Si</th><th>No</th></tr><tr><td>{{ vm.reporte.recodocentesi }}%</td><td>{{ vm.reporte.recodocenteno }}%</td></tr></table></div><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Razones por que SI</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idrazonessi_e\')}}" id="idrazonessi_e" cols="50" class="form-control" name="razonessi_e" ng-model="vm.wrapper.razonessi_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.razonessi_e }}\n\t\t\t\t</textarea></td></tr></table></div><br><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Razones por que NO</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idrazonesno_e\')}}" id="idrazonesno_e" cols="50" class="form-control" name="razonesno_e" ng-model="vm.wrapper.razonesno_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.razonesno_e }}\n\t\t\t\t</textarea></td></tr></table><br></div><br><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Comentarios de los estudiantes para mejorar el PII</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idcommejorarpii_e\')}}" id="idcommejorarpii_e" cols="50" class="form-control" name="commejorarpii_e" ng-model="vm.wrapper.commejorarpii_e" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.commejorarpii_e }}\n\t\t\t\t</textarea></td></tr></table><br></div><br><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Condiciones que podr\xEDan favorecer su desempe&ntildeo en los cursos del PII (docente)</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idcondfavdesem_p\')}}" id="idcondfavdesem_p" cols="50" class="form-control" name="condfavdesem_p" ng-model="vm.wrapper.condfavdesem_p" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.condfavdesem_p }}\n\t\t\t\t</textarea></td></tr></table><br></div><br><div class="reportebody"><br><table class="table table-bordered type-a"><tr><th colspan="2" style="text-align: left">Comentarios del docente para mejorar el PII</th></tr><tr><td><textarea rows="{{vm.autoheight(\'idcommejorarpii_p\')}}" id="idcommejorarpii_p" cols="50" class="form-control" name="commejorarpii_p" ng-model="vm.wrapper.commejorarpii_p" tabindex="-1" ng-readonly="{{vm.reporte.status!=\'editar\'?true:false}}" required> \n\t\t\t\t\t{{ vm.wrapper.commejorarpii_p }}\n\t\t\t\t</textarea></td></tr></table><br></div><br></div>');
$templateCache.put('app/reportes/revision/misrevisionesevaluativos.html','<div><!-- Page Content --><div class="row"><div class="col-lg-12"><div class="page-header"><h2 id="navbar">Revisar Reportes Evaluativos</h2></div><jhi-alert-error></jhi-alert-error><form class="form-search"><div><h4>Buscar por:</h4><div class="row"><div class="col-lg-offset-1 col-lg-6"><div class="form-group"><label class="control-label" for="fiel">Dependencia</label><select required class="form-control" ng-model="vm.institucionSelected"><option ng-repeat=" institucion in vm.dependencias" value="{{institucion.id}}">{{institucion.nombre}} {{institucion.abreviatura}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-6 --><div class="col-lg-3"><div class="form-group"><label class="control-label">Nivel</label><select required class="form-control" ng-model="vm.nivelSeleccionado" ng-value="{{nivel}}" ng-options="nivel for nivel in vm.niveles" ng-change="vm.limpiar()"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-3 --></div><!-- /.row --><div class="row"><div class="col-lg-offset-1 col-lg-2"><div class="form-group"><label class="control-label">Modelo</label><select required class="form-control" ng-model="vm.modeloSeleccionado" ng-value="{{modelo}}" ng-options="modelo \n\t\t\t\t\t\t\t\t\t\tdisable when \n\t\t\t\t\t\t\t\t\t\t(vm.nivelSeleccionado == null || vm.nivelSeleccionado == 0) ||\n\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado == \'Posgrado\' &&\n\t\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEyA\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI\' ||\n\t\t\t\t\t\t\t\t\t\t\t\t\tmodelo == \'MEFI 2\'\n\t\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t\t) ||\n\t\t\t\t\t\t\t\t\t\t\t(\n\t\t\t\t\t\t\t\t\t\t\t\tvm.nivelSeleccionado != \'Posgrado\' && modelo == \'No aplica\' \n\t\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\t)\n\t\t\t\t\t\t\t\t\t\tfor modelo in vm.modelos"></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><label class="control-label">A&ntildeo Escolar</label><select required class="form-control" ng-model="vm.anioSeleccionado"><option ng-repeat="anioEscolar in vm.aniosEscolares" value="{{anioEscolar.id}}">{{anioEscolar.descripcion}}</option></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="input-group"><br><label><input type="checkbox" ng-model="vm.intercurso"> Intercurso</label></div><!-- /input-group --></div><!-- /.col-lg-3 --><div class="col-lg-2"><div class="form-group"><label class="control-label" for="fiel">Periodo</label><!-- Periodo normal --><select ng-show="!vm.intercurso" required class="form-control" ng-model="vm.indicePeriodo" ng-value="vm.indicePeriodo" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select><!-- Periodo intercurso --><select ng-show="vm.intercurso" required class="form-control" ng-model="vm.indiceIntercurso" ng-value="vm.indiceIntercurso" ng-options="periodo for periodo in vm.periodos"><option value="" selected="selected"></option></select></div><!-- /input-group --></div><!-- /.col-lg-2 --><div class="col-lg-2"><div class="form-group"><br><button type="button" class="btn btn-primary" ng-click="vm.search()">Buscar</button></div><!-- /input-group --></div><!-- /.col-lg-2 --></div><!-- /.row --></div></form><table class="table table-striped table-hover"><tbody><tr ng-repeat="wrapper in vm.wrappers | filter: {hayevaluaciones:busquedagestornoevaluados}| filter: busquedagestor track by wrapper.id"><td><h4>{{wrapper.asignatura.nombre}}</h4><h6><label><div><div>{{wrapper.formaDeEvaluar}}</div></div></label></h6><h6><label><div><div>{{wrapper.niveleducativo}}, {{wrapper.modeloeducativo}}</div></div></label></h6><h6>{{wrapper.profesor.apellidoPaterno}} {{wrapper.profesor.apellidoMaterno}} {{wrapper.profesor.nombres}}</h6><!-- No se le va a poner grupo ya que este dato esta en ambito y no se puede traer muy facilmente desde reporte\n\t                \t \t ademas de que si todos los datos son iguales excepto el grupo esto no importa ya que es el mismo reporte --><!-- <h6>{{wrapper}}</h6> --></td><td class="vcenter"><ul class="btn-group opciones-menu"><li uib-dropdown class="dropdown pointer" ng-switch="wrapper.hasReporte"><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="revisionReporteCU({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Curso \xDAnico\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte CU<!-- <b class="caret"></b> --> </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="revisionReporteLI({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Libre\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte LI<!-- <b class="caret"></b> --> </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="revisionReporteOO({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Optativa\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte Op<!-- <b class="caret"></b> --> </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="revisionReporteOO({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Obligatoria\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte Ob<!-- <b class="caret"></b> --> </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="revisionReporteUAEV({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'UAEV\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte UAEV<!-- <b class="caret"></b> --> </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="revisionReporteRegular({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Regular\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte Regular<!-- <b class="caret"></b> --> </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="revisionReporteVirtual({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Virtual\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte Virtual<!-- <b class="caret"></b> --> </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="revisionReporteBachillerato({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'Bachillerato\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte Bachillerato<!-- <b class="caret"></b> --> </a><a class="dropdown-toggle" uib-dropdown-toggle ui-sref="revisionReporteLic({id:wrapper.id})" id="eval-menu" ng-show="{{ wrapper.formaDeEvaluar == \'licenciatura general\'}}"><span ng-switch-when="true" class="glyphicon glyphicon-ok" aria-hidden="true"></span> Ver Reporte Licenciatura General<!-- <b class="caret"></b> --></a></li></ul></td><jhi-alert></jhi-alert></tr></tbody></table></div></div><!-- /.row --><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pager></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1>Reset password</h1><div class="alert alert-danger" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p>Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p>Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="New password" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="Confirm the new password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1>Reset your password</h1><div class="alert alert-danger" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p>Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p>Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="Your e-mail" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary">Reset</button></form></div></div></div>');}]);})();